
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireac32"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireac32"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gN3J6", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $c3941cf54d4aa4ba$export$77cea355fa80b5f4);

var $dUP5u = parcelRequire("dUP5u");

var $fgwAY = parcelRequire("fgwAY");

var $lzR1Z = parcelRequire("lzR1Z");

var $lrpjn = parcelRequire("lrpjn");

var $1Dr3d = parcelRequire("1Dr3d");

var $dFWVS = parcelRequire("dFWVS");

var $iQsM4 = parcelRequire("iQsM4");
var $c3941cf54d4aa4ba$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $c3941cf54d4aa4ba$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $dUP5u.SafeSubscriber)(observerOrNext, error, complete);
        (0, $iQsM4.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $dUP5u.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $lzR1Z.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $lrpjn.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $1Dr3d.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $c3941cf54d4aa4ba$var$isObserver(value) {
    return value && (0, $dFWVS.isFunction)(value.next) && (0, $dFWVS.isFunction)(value.error) && (0, $dFWVS.isFunction)(value.complete);
}
function $c3941cf54d4aa4ba$var$isSubscriber(value) {
    return value && value instanceof (0, $dUP5u.Subscriber) || $c3941cf54d4aa4ba$var$isObserver(value) && (0, $fgwAY.isSubscription)(value);
}

});
parcelRegister("dUP5u", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $a21822406e53a1a5$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $a21822406e53a1a5$export$94eeb6a328cab6c7);

var $1Znhr = parcelRequire("1Znhr");

var $dFWVS = parcelRequire("dFWVS");

var $fgwAY = parcelRequire("fgwAY");

var $1Dr3d = parcelRequire("1Dr3d");

var $ZIGxP = parcelRequire("ZIGxP");

var $QfuEL = parcelRequire("QfuEL");

var $lMJIa = parcelRequire("lMJIa");

var $7hZdR = parcelRequire("7hZdR");

var $iQsM4 = parcelRequire("iQsM4");
var $a21822406e53a1a5$export$60959659b2c22881 = function(_super) {
    (0, $1Znhr.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $fgwAY.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $a21822406e53a1a5$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $a21822406e53a1a5$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $lMJIa.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $lMJIa.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $lMJIa.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $fgwAY.Subscription));
var $a21822406e53a1a5$var$_bind = Function.prototype.bind;
function $a21822406e53a1a5$var$bind(fn, thisArg) {
    return $a21822406e53a1a5$var$_bind.call(fn, thisArg);
}
var $a21822406e53a1a5$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
        else $a21822406e53a1a5$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $a21822406e53a1a5$export$94eeb6a328cab6c7 = function(_super) {
    (0, $1Znhr.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $dFWVS.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $1Dr3d.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $a21822406e53a1a5$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $a21822406e53a1a5$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $a21822406e53a1a5$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $a21822406e53a1a5$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($a21822406e53a1a5$export$60959659b2c22881);
function $a21822406e53a1a5$var$handleUnhandledError(error) {
    if ((0, $1Dr3d.config).useDeprecatedSynchronousErrorHandling) (0, $iQsM4.captureError)(error);
    else (0, $ZIGxP.reportUnhandledError)(error);
}
function $a21822406e53a1a5$var$defaultErrorHandler(err) {
    throw err;
}
function $a21822406e53a1a5$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $1Dr3d.config).onStoppedNotification;
    onStoppedNotification && (0, $7hZdR.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $a21822406e53a1a5$export$88d395d20619a0af = {
    closed: true,
    next: (0, $QfuEL.noop),
    error: $a21822406e53a1a5$var$defaultErrorHandler,
    complete: (0, $QfuEL.noop)
};

});
parcelRegister("1Znhr", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $172d8be976204b2c$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $172d8be976204b2c$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $172d8be976204b2c$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $172d8be976204b2c$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $172d8be976204b2c$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $172d8be976204b2c$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $172d8be976204b2c$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $172d8be976204b2c$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $172d8be976204b2c$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $172d8be976204b2c$var$extendStatics = function(d, b) {
    $172d8be976204b2c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $172d8be976204b2c$var$extendStatics(d, b);
};
function $172d8be976204b2c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $172d8be976204b2c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $172d8be976204b2c$export$18ce0697a983be9b = function() {
    $172d8be976204b2c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $172d8be976204b2c$export$18ce0697a983be9b.apply(this, arguments);
};
function $172d8be976204b2c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $172d8be976204b2c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $172d8be976204b2c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $172d8be976204b2c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $172d8be976204b2c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $172d8be976204b2c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $172d8be976204b2c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $172d8be976204b2c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $172d8be976204b2c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $172d8be976204b2c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $172d8be976204b2c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $172d8be976204b2c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $172d8be976204b2c$export$45d3717a4c69092e(o, m, p);
}
function $172d8be976204b2c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $172d8be976204b2c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $172d8be976204b2c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($172d8be976204b2c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $172d8be976204b2c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $172d8be976204b2c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $172d8be976204b2c$export$10c90e4f7922046c(v) {
    return this instanceof $172d8be976204b2c$export$10c90e4f7922046c ? (this.v = v, this) : new $172d8be976204b2c$export$10c90e4f7922046c(v);
}
function $172d8be976204b2c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $172d8be976204b2c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $172d8be976204b2c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $172d8be976204b2c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $172d8be976204b2c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $172d8be976204b2c$export$19a8beecd37a4c45 === "function" ? $172d8be976204b2c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $172d8be976204b2c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $172d8be976204b2c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $172d8be976204b2c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $172d8be976204b2c$export$45d3717a4c69092e(result, mod, k);
    }
    $172d8be976204b2c$var$__setModuleDefault(result, mod);
    return result;
}
function $172d8be976204b2c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $172d8be976204b2c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $172d8be976204b2c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $172d8be976204b2c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $172d8be976204b2c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $172d8be976204b2c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $172d8be976204b2c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $172d8be976204b2c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $172d8be976204b2c$export$2e2bcd8739ae039 = {
    __extends: $172d8be976204b2c$export$a8ba968b8961cb8a,
    __assign: $172d8be976204b2c$export$18ce0697a983be9b,
    __rest: $172d8be976204b2c$export$3c9a16f847548506,
    __decorate: $172d8be976204b2c$export$29e00dfd3077644b,
    __param: $172d8be976204b2c$export$d5ad3fd78186038f,
    __metadata: $172d8be976204b2c$export$f1db080c865becb9,
    __awaiter: $172d8be976204b2c$export$1050f835b63b671e,
    __generator: $172d8be976204b2c$export$67ebef60e6f28a6,
    __createBinding: $172d8be976204b2c$export$45d3717a4c69092e,
    __exportStar: $172d8be976204b2c$export$f33643c0debef087,
    __values: $172d8be976204b2c$export$19a8beecd37a4c45,
    __read: $172d8be976204b2c$export$8d051b38c9118094,
    __spread: $172d8be976204b2c$export$afc72e2116322959,
    __spreadArrays: $172d8be976204b2c$export$6388937ca91ccae8,
    __spreadArray: $172d8be976204b2c$export$1216008129fb82ed,
    __await: $172d8be976204b2c$export$10c90e4f7922046c,
    __asyncGenerator: $172d8be976204b2c$export$e427f37a30a4de9b,
    __asyncDelegator: $172d8be976204b2c$export$bbd80228419bb833,
    __asyncValues: $172d8be976204b2c$export$e3b29a3d6162315f,
    __makeTemplateObject: $172d8be976204b2c$export$4fb47efe1390b86f,
    __importStar: $172d8be976204b2c$export$c21735bcef00d192,
    __importDefault: $172d8be976204b2c$export$da59b14a69baef04,
    __classPrivateFieldGet: $172d8be976204b2c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $172d8be976204b2c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $172d8be976204b2c$export$81fdc39f203e4e04,
    __addDisposableResource: $172d8be976204b2c$export$88ac25d8e944e405,
    __disposeResources: $172d8be976204b2c$export$8f076105dc360e92
};

});

parcelRegister("dFWVS", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $9f4cd17d3bfb739b$export$f6e2535fb5126e54);
function $9f4cd17d3bfb739b$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}

});

parcelRegister("fgwAY", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $b1d1a261220cb194$export$f55210826850c514);
$parcel$export(module.exports, "EMPTY_SUBSCRIPTION", () => $b1d1a261220cb194$export$610f9c3ca1a38dd8);
$parcel$export(module.exports, "isSubscription", () => $b1d1a261220cb194$export$4f9221cbada3c4fc);

var $1Znhr = parcelRequire("1Znhr");

var $dFWVS = parcelRequire("dFWVS");

var $aQn3b = parcelRequire("aQn3b");

var $ebAl1 = parcelRequire("ebAl1");
var $b1d1a261220cb194$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $1Znhr.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $dFWVS.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $aQn3b.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $1Znhr.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $b1d1a261220cb194$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $aQn3b.UnsubscriptionError)) errors = (0, $1Znhr.__spreadArray)((0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(errors)), (0, $1Znhr.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $aQn3b.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $b1d1a261220cb194$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $ebAl1.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $ebAl1.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $b1d1a261220cb194$export$610f9c3ca1a38dd8 = $b1d1a261220cb194$export$f55210826850c514.EMPTY;
function $b1d1a261220cb194$export$4f9221cbada3c4fc(value) {
    return value instanceof $b1d1a261220cb194$export$f55210826850c514 || value && "closed" in value && (0, $dFWVS.isFunction)(value.remove) && (0, $dFWVS.isFunction)(value.add) && (0, $dFWVS.isFunction)(value.unsubscribe);
}
function $b1d1a261220cb194$var$execFinalizer(finalizer) {
    if ((0, $dFWVS.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("aQn3b", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $7e50a408673c5151$export$c9648b76fd580c34);

var $jaWRE = parcelRequire("jaWRE");
var $7e50a408673c5151$export$c9648b76fd580c34 = (0, $jaWRE.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});

});
parcelRegister("jaWRE", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $df5c9cb6183aeff9$export$128a15b65d1b6041);
function $df5c9cb6183aeff9$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("ebAl1", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $a53e47be1b60c3c3$export$dae3f38077fc36c0);
function $a53e47be1b60c3c3$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("1Dr3d", function(module, exports) {

$parcel$export(module.exports, "config", () => $130e6ab1a4f4ab41$export$e506a1d27d1eaa20);
var $130e6ab1a4f4ab41$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("ZIGxP", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $0b985c2ba288a978$export$ebf645db02d3e99f);

var $1Dr3d = parcelRequire("1Dr3d");

var $7hZdR = parcelRequire("7hZdR");
function $0b985c2ba288a978$export$ebf645db02d3e99f(err) {
    (0, $7hZdR.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $1Dr3d.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("7hZdR", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $54e99c791bb8207c$export$365aa6bd3c788e3d);

var $1Znhr = parcelRequire("1Znhr");
var $54e99c791bb8207c$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $54e99c791bb8207c$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $1Znhr.__spreadArray)([
            handler,
            timeout
        ], (0, $1Znhr.__read)(args)));
        return setTimeout.apply(void 0, (0, $1Znhr.__spreadArray)([
            handler,
            timeout
        ], (0, $1Znhr.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $54e99c791bb8207c$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("QfuEL", function(module, exports) {

$parcel$export(module.exports, "noop", () => $09d0e01f28fdde08$export$8793edee2d425525);
function $09d0e01f28fdde08$export$8793edee2d425525() {}

});

parcelRegister("lMJIa", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $fdc189fd52d09f69$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $fdc189fd52d09f69$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $fdc189fd52d09f69$export$ff9346b0d1d30313);
var $fdc189fd52d09f69$export$b7f97edb34bc1f87 = function() {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $fdc189fd52d09f69$export$dd472c3d8fe5a85a(error) {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $fdc189fd52d09f69$export$ff9346b0d1d30313(value) {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $fdc189fd52d09f69$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("iQsM4", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $db83674f177e2fa2$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $db83674f177e2fa2$export$3e205fbb5df021e0);

var $1Dr3d = parcelRequire("1Dr3d");
var $db83674f177e2fa2$var$context = null;
function $db83674f177e2fa2$export$d974811edc77eafa(cb) {
    if ((0, $1Dr3d.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$db83674f177e2fa2$var$context;
        if (isRoot) $db83674f177e2fa2$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $db83674f177e2fa2$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $db83674f177e2fa2$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $db83674f177e2fa2$export$3e205fbb5df021e0(err) {
    if ((0, $1Dr3d.config).useDeprecatedSynchronousErrorHandling && $db83674f177e2fa2$var$context) {
        $db83674f177e2fa2$var$context.errorThrown = true;
        $db83674f177e2fa2$var$context.error = err;
    }
}

});


parcelRegister("lzR1Z", function(module, exports) {

$parcel$export(module.exports, "observable", () => $fb5600b8b605d96c$export$5ab46cbf6120b33a);
var $fb5600b8b605d96c$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRegister("lrpjn", function(module, exports) {

$parcel$export(module.exports, "pipe", () => $f9bfc0ec752e7991$export$a4627e546088548d);
$parcel$export(module.exports, "pipeFromArray", () => $f9bfc0ec752e7991$export$71f88a61afaa14d7);

var $hYEnO = parcelRequire("hYEnO");
function $f9bfc0ec752e7991$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $f9bfc0ec752e7991$export$71f88a61afaa14d7(fns);
}
function $f9bfc0ec752e7991$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $hYEnO.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("hYEnO", function(module, exports) {

$parcel$export(module.exports, "identity", () => $d1675d7b83173212$export$f0954fd7d5368655);
function $d1675d7b83173212$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("2eJo6", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function e(t, n, r) {
            function s(o, u) {
                if (!n[o]) {
                    if (!t[o]) {
                        var a = undefined;
                        if (!u && a) return a(o, !0);
                        if (i) return i(o, !0);
                        var f = new Error("Cannot find module '" + o + "'");
                        throw f.code = "MODULE_NOT_FOUND", f;
                    }
                    var l = n[o] = {
                        exports: {}
                    };
                    t[o][0].call(l.exports, function(e) {
                        var n = t[o][1][e];
                        return s(n ? n : e);
                    }, l, l.exports, e, t, n, r);
                }
                return n[o].exports;
            }
            var i = undefined;
            for(var o = 0; o < r.length; o++)s(r[o]);
            return s;
        }
        return e;
    })()({
        1: [
            function(require1, module1, exports) {
                "use strict";
                function deepcopy(value) {
                    if (!(!!value && typeof value == "object")) return value;
                    if (Object.prototype.toString.call(value) == "[object Date]") return new Date(value.getTime());
                    if (Array.isArray(value)) return value.map(deepcopy);
                    var result = {};
                    Object.keys(value).forEach(function(key) {
                        result[key] = deepcopy(value[key]);
                    });
                    return result;
                }
                module1.exports = deepcopy;
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                /**
 * Expose `parse`.
 */ module1.exports = parse;
                /**
 * Tests for browser support.
 */ var innerHTMLBug = false;
                var bugTestDiv;
                if (typeof document !== "undefined") {
                    bugTestDiv = document.createElement("div");
                    // Setup
                    bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
                    // Make sure that link elements get serialized correctly by innerHTML
                    // This requires a wrapper element in IE
                    innerHTMLBug = !bugTestDiv.getElementsByTagName("link").length;
                    bugTestDiv = undefined;
                }
                /**
 * Wrap map from jquery.
 */ var map = {
                    legend: [
                        1,
                        "<fieldset>",
                        "</fieldset>"
                    ],
                    tr: [
                        2,
                        "<table><tbody>",
                        "</tbody></table>"
                    ],
                    col: [
                        2,
                        "<table><tbody></tbody><colgroup>",
                        "</colgroup></table>"
                    ],
                    // for script/link/style tags to work in IE6-8, you have to wrap
                    // in a div with a non-whitespace character in front, ha!
                    _default: innerHTMLBug ? [
                        1,
                        "X<div>",
                        "</div>"
                    ] : [
                        0,
                        "",
                        ""
                    ]
                };
                map.td = map.th = [
                    3,
                    "<table><tbody><tr>",
                    "</tr></tbody></table>"
                ];
                map.option = map.optgroup = [
                    1,
                    '<select multiple="multiple">',
                    "</select>"
                ];
                map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [
                    1,
                    "<table>",
                    "</table>"
                ];
                map.polyline = map.ellipse = map.polygon = map.circle = map.text = map.line = map.path = map.rect = map.g = [
                    1,
                    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">',
                    "</svg>"
                ];
                /**
 * Parse `html` and return a DOM Node instance, which could be a TextNode,
 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
 * instance, depending on the contents of the `html` string.
 *
 * @param {String} html - HTML string to "domify"
 * @param {Document} doc - The `document` instance to create the Node for
 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
 * @api private
 */ function parse(html, doc) {
                    if ("string" != typeof html) throw new TypeError("String expected");
                    // default to the global `document` object
                    if (!doc) doc = document;
                    // tag name
                    var m = /<([\w:]+)/.exec(html);
                    if (!m) return doc.createTextNode(html);
                    html = html.replace(/^\s+|\s+$/g, ""); // Remove leading/trailing whitespace
                    var tag = m[1];
                    // body support
                    if (tag == "body") {
                        var el = doc.createElement("html");
                        el.innerHTML = html;
                        return el.removeChild(el.lastChild);
                    }
                    // wrap map
                    var wrap = map[tag] || map._default;
                    var depth = wrap[0];
                    var prefix = wrap[1];
                    var suffix = wrap[2];
                    var el = doc.createElement("div");
                    el.innerHTML = prefix + html + suffix;
                    while(depth--)el = el.lastChild;
                    // one element
                    if (el.firstChild == el.lastChild) return el.removeChild(el.firstChild);
                    // several elements
                    var fragment = doc.createDocumentFragment();
                    while(el.firstChild)fragment.appendChild(el.removeChild(el.firstChild));
                    return fragment;
                }
            },
            {}
        ],
        3: [
            function(require1, module1, exports) {
                // get successful control from form and assemble into object
                // http://www.w3.org/TR/html401/interact/forms.html#h-17.13.2
                // types which indicate a submit action and are not successful controls
                // these will be ignored
                var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;
                // node names which could be successful controls
                var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;
                // Matches bracket notation.
                var brackets = /(\[[^\[\]]*\])/g;
                // serializes form fields
                // @param form MUST be an HTMLForm element
                // @param options is an optional argument to configure the serialization. Default output
                // with no options specified is a url encoded string
                //    - hash: [true | false] Configure the output type. If true, the output will
                //    be a js object.
                //    - serializer: [function] Optional serializer function to override the default one.
                //    The function takes 3 arguments (result, key, value) and should return new result
                //    hash and url encoded str serializers are provided with this module
                //    - disabled: [true | false]. If true serialize disabled fields.
                //    - empty: [true | false]. If true serialize empty fields
                function serialize(form, options) {
                    if (typeof options != "object") options = {
                        hash: !!options
                    };
                    else if (options.hash === undefined) options.hash = true;
                    var result = options.hash ? {} : "";
                    var serializer = options.serializer || (options.hash ? hash_serializer : str_serialize);
                    var elements = form && form.elements ? form.elements : [];
                    //Object store each radio and set if it's empty or not
                    var radio_store = Object.create(null);
                    for(var i = 0; i < elements.length; ++i){
                        var element = elements[i];
                        // ingore disabled fields
                        if (!options.disabled && element.disabled || !element.name) continue;
                        // ignore anyhting that is not considered a success field
                        if (!k_r_success_contrls.test(element.nodeName) || k_r_submitter.test(element.type)) continue;
                        var key = element.name;
                        var val = element.value;
                        // we can't just use element.value for checkboxes cause some browsers lie to us
                        // they say "on" for value when the box isn't checked
                        if ((element.type === "checkbox" || element.type === "radio") && !element.checked) val = undefined;
                        // If we want empty elements
                        if (options.empty) {
                            // for checkbox
                            if (element.type === "checkbox" && !element.checked) val = "";
                            // for radio
                            if (element.type === "radio") {
                                if (!radio_store[element.name] && !element.checked) radio_store[element.name] = false;
                                else if (element.checked) radio_store[element.name] = true;
                            }
                            // if options empty is true, continue only if its radio
                            if (!val && element.type == "radio") continue;
                        } else {
                            // value-less fields are ignored unless options.empty is true
                            if (!val) continue;
                        }
                        // multi select boxes
                        if (element.type === "select-multiple") {
                            val = [];
                            var selectOptions = element.options;
                            var isSelectedOptions = false;
                            for(var j = 0; j < selectOptions.length; ++j){
                                var option = selectOptions[j];
                                var allowedEmpty = options.empty && !option.value;
                                var hasValue = option.value || allowedEmpty;
                                if (option.selected && hasValue) {
                                    isSelectedOptions = true;
                                    // If using a hash serializer be sure to add the
                                    // correct notation for an array in the multi-select
                                    // context. Here the name attribute on the select element
                                    // might be missing the trailing bracket pair. Both names
                                    // "foo" and "foo[]" should be arrays.
                                    if (options.hash && key.slice(key.length - 2) !== "[]") result = serializer(result, key + "[]", option.value);
                                    else result = serializer(result, key, option.value);
                                }
                            }
                            // Serialize if no selected options and options.empty is true
                            if (!isSelectedOptions && options.empty) result = serializer(result, key, "");
                            continue;
                        }
                        result = serializer(result, key, val);
                    }
                    // Check for all empty radio buttons and serialize them with key=""
                    if (options.empty) {
                        for(var key in radio_store)if (!radio_store[key]) result = serializer(result, key, "");
                    }
                    return result;
                }
                function parse_keys(string) {
                    var keys = [];
                    var prefix = /^([^\[\]]*)/;
                    var children = new RegExp(brackets);
                    var match = prefix.exec(string);
                    if (match[1]) keys.push(match[1]);
                    while((match = children.exec(string)) !== null)keys.push(match[1]);
                    return keys;
                }
                function hash_assign(result, keys, value) {
                    if (keys.length === 0) {
                        result = value;
                        return result;
                    }
                    var key = keys.shift();
                    var between = key.match(/^\[(.+?)\]$/);
                    if (key === "[]") {
                        result = result || [];
                        if (Array.isArray(result)) result.push(hash_assign(null, keys, value));
                        else {
                            // This might be the result of bad name attributes like "[][foo]",
                            // in this case the original `result` object will already be
                            // assigned to an object literal. Rather than coerce the object to
                            // an array, or cause an exception the attribute "_values" is
                            // assigned as an array.
                            result._values = result._values || [];
                            result._values.push(hash_assign(null, keys, value));
                        }
                        return result;
                    }
                    // Key is an attribute name and can be assigned directly.
                    if (!between) result[key] = hash_assign(result[key], keys, value);
                    else {
                        var string = between[1];
                        // +var converts the variable into a number
                        // better than parseInt because it doesn't truncate away trailing
                        // letters and actually fails if whole thing is not a number
                        var index = +string;
                        // If the characters between the brackets is not a number it is an
                        // attribute name and can be assigned directly.
                        if (isNaN(index)) {
                            result = result || {};
                            result[string] = hash_assign(result[string], keys, value);
                        } else {
                            result = result || [];
                            result[index] = hash_assign(result[index], keys, value);
                        }
                    }
                    return result;
                }
                // Object/hash encoding serializer.
                function hash_serializer(result, key, value) {
                    var matches = key.match(brackets);
                    // Has brackets? Use the recursive assignment function to walk the keys,
                    // construct any missing objects in the result tree and make the assignment
                    // at the end of the chain.
                    if (matches) {
                        var keys = parse_keys(key);
                        hash_assign(result, keys, value);
                    } else {
                        // Non bracket notation can make assignments directly.
                        var existing = result[key];
                        // If the value has been assigned already (for instance when a radio and
                        // a checkbox have the same name attribute) convert the previous value
                        // into an array before pushing into it.
                        //
                        // NOTE: If this requirement were removed all hash creation and
                        // assignment could go through `hash_assign`.
                        if (existing) {
                            if (!Array.isArray(existing)) result[key] = [
                                existing
                            ];
                            result[key].push(value);
                        } else result[key] = value;
                    }
                    return result;
                }
                // urlform encoding serializer
                function str_serialize(result, key, value) {
                    // encode newlines as \r\n cause the html spec says so
                    value = value.replace(/(\r)?\n/g, "\r\n");
                    value = encodeURIComponent(value);
                    // spaces should be '+' rather than '%20'.
                    value = value.replace(/%20/g, "+");
                    return result + (result ? "&" : "") + encodeURIComponent(key) + "=" + value;
                }
                module1.exports = serialize;
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                var domify = require1("domify");
                var serialize = require1("form-serialize");
                var cloneDeep = require1("deep-clone-simple");
                // Build DOM elements for the structure of the dialog
                var buildDialogForm = function buildDialogForm(options) {
                    var form = document.createElement("form");
                    form.classList.add("vex-dialog-form");
                    var message = document.createElement("div");
                    message.classList.add("vex-dialog-message");
                    message.appendChild(options.message instanceof window.Node ? options.message : domify(options.message));
                    var input = document.createElement("div");
                    input.classList.add("vex-dialog-input");
                    input.appendChild(options.input instanceof window.Node ? options.input : domify(options.input));
                    form.appendChild(message);
                    form.appendChild(input);
                    return form;
                };
                // Take an array of buttons (see the default buttons below) and turn them into DOM elements
                var buttonsToDOM = function buttonsToDOM(buttons) {
                    var domButtons = document.createElement("div");
                    domButtons.classList.add("vex-dialog-buttons");
                    for(var i = 0; i < buttons.length; i++){
                        var button = buttons[i];
                        var domButton = document.createElement("button");
                        domButton.type = button.type;
                        domButton.textContent = button.text;
                        domButton.className = button.className;
                        domButton.classList.add("vex-dialog-button");
                        if (i === 0) domButton.classList.add("vex-first");
                        else if (i === buttons.length - 1) domButton.classList.add("vex-last");
                        // Attach click listener to button with closure
                        (function(button) {
                            domButton.addEventListener("click", (function(e) {
                                if (button.click) button.click.call(this, e);
                            }).bind(this));
                        }).bind(this)(button);
                        domButtons.appendChild(domButton);
                    }
                    return domButtons;
                };
                var plugin = function plugin(vex) {
                    // Define the API first
                    var dialog = {
                        // Plugin name
                        name: "dialog",
                        // Open
                        open: function open(opts) {
                            var options = Object.assign({}, cloneDeep(this.defaultOptions), opts);
                            // `message` is unsafe internally, so translate
                            // safe default: HTML-escape the message before passing it through
                            if (options.unsafeMessage && !options.message) options.message = options.unsafeMessage;
                            else if (options.message) options.message = vex._escapeHtml(options.message);
                            // Build the form from the options
                            var form = options.unsafeContent = buildDialogForm(options);
                            // Open the dialog
                            var dialogInstance = vex.open(options);
                            if (options.yesText !== "") options.buttons[0].text = options.yesText;
                            if (options.noText !== "") options.buttons[1].text = options.noText;
                            // Quick comment - these options and appending buttons and everything
                            // would preferably be done _before_ opening the dialog. However, since
                            // they rely on the context of the vex instance, we have to do them
                            // after. A potential future fix would be to differentiate between
                            // a "created" vex instance and an "opened" vex instance, so any actions
                            // that rely on the specific context of the instance can do their stuff
                            // before opening the dialog on the page.
                            // Override the before close callback to also pass the value of the form
                            var beforeClose = options.beforeClose && options.beforeClose.bind(dialogInstance);
                            dialogInstance.options.beforeClose = (function dialogBeforeClose() {
                                // Only call the callback once - when the validation in beforeClose, if present, is true
                                var shouldClose = beforeClose ? beforeClose() : true;
                                if (shouldClose) options.callback(this.value || false);
                                // Return the result of beforeClose() to vex
                                return shouldClose;
                            }).bind(dialogInstance);
                            // Append buttons to form with correct context
                            form.appendChild(buttonsToDOM.call(dialogInstance, options.buttons));
                            // Attach form to instance
                            dialogInstance.form = form;
                            // Add submit listener to form
                            form.addEventListener("submit", options.onSubmit.bind(dialogInstance));
                            // Optionally focus the first input in the form
                            if (options.focusFirstInput) {
                                var el = dialogInstance.contentEl.querySelector("button, input, select, textarea");
                                if (el) el.focus();
                            }
                            // For chaining
                            return dialogInstance;
                        },
                        // Alert
                        alert: function(options) {
                            // Allow string as message
                            if (typeof options === "string") options = {
                                message: options
                            };
                            options = Object.assign({}, cloneDeep(this.defaultOptions), cloneDeep(this.defaultAlertOptions), options);
                            return this.open(options);
                        },
                        // Confirm
                        confirm: function(options) {
                            if (typeof options !== "object" || typeof options.callback !== "function") throw new Error("dialog.confirm(options) requires options.callback.");
                            options = Object.assign({}, cloneDeep(this.defaultOptions), cloneDeep(this.defaultConfirmOptions), options);
                            return this.open(options);
                        },
                        // Prompt
                        prompt: function(options) {
                            if (typeof options !== "object" || typeof options.callback !== "function") throw new Error("dialog.prompt(options) requires options.callback.");
                            var defaults = Object.assign({}, cloneDeep(this.defaultOptions), cloneDeep(this.defaultPromptOptions));
                            var dynamicDefaults = {
                                unsafeMessage: '<label for="vex">' + vex._escapeHtml(options.label || defaults.label) + "</label>",
                                input: '<input name="vex" type="text" class="vex-dialog-prompt-input" placeholder="' + vex._escapeHtml(options.placeholder || defaults.placeholder) + '" value="' + vex._escapeHtml(options.value || defaults.value) + '" />'
                            };
                            options = Object.assign(defaults, dynamicDefaults, options);
                            // Pluck the value of the "vex" input field as the return value for prompt's callback
                            // More closely mimics "window.prompt" in that a single string is returned
                            var callback = options.callback;
                            options.callback = function promptCallback(value) {
                                if (typeof value === "object") {
                                    var keys = Object.keys(value);
                                    value = keys.length ? value[keys[0]] : "";
                                }
                                callback(value);
                            };
                            return this.open(options);
                        }
                    };
                    // Now define any additional data that's not the direct dialog API
                    dialog.buttons = {
                        YES: {
                            text: "OK",
                            type: "submit",
                            className: "vex-dialog-button-primary",
                            click: function yesClick() {
                                this.value = true;
                            }
                        },
                        NO: {
                            text: "Cancel",
                            type: "button",
                            className: "vex-dialog-button-secondary",
                            click: function noClick() {
                                this.value = false;
                                this.close();
                            }
                        }
                    };
                    dialog.defaultOptions = {
                        callback: function() {},
                        afterOpen: function() {},
                        message: "",
                        input: "",
                        yesText: "",
                        noText: "",
                        buttons: [
                            dialog.buttons.YES,
                            dialog.buttons.NO
                        ],
                        showCloseButton: false,
                        onSubmit: function onDialogSubmit(e) {
                            e.preventDefault();
                            if (this.options.input) this.value = serialize(this.form, {
                                hash: true
                            });
                            return this.close();
                        },
                        focusFirstInput: true
                    };
                    dialog.defaultAlertOptions = {
                        buttons: [
                            dialog.buttons.YES
                        ]
                    };
                    dialog.defaultPromptOptions = {
                        label: "Prompt:",
                        placeholder: "",
                        value: ""
                    };
                    dialog.defaultConfirmOptions = {};
                    return dialog;
                };
                module1.exports = plugin;
            },
            {
                "deep-clone-simple": 1,
                "domify": 2,
                "form-serialize": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("8oAsx", function(module, exports) {

var $9KgKE = parcelRequire("9KgKE");
var $61ccd8b1d925c233$require$EventEmitter = $9KgKE.EventEmitter;
module.exports = function() {
    var tapTempo = new $61ccd8b1d925c233$require$EventEmitter();
    var timeout = 2000;
    var times = [];
    var lastTime = null;
    var lastDifference = null;
    tapTempo.tap = function() {
        var time = Date.now();
        if (lastTime) {
            lastDifference = time - lastTime;
            times.push(lastDifference);
            refresh();
        }
        lastTime = time;
        beginTimeout();
        tapTempo.emit("tap");
    };
    function refresh() {
        if (times.length > 2) {
            var average = times.reduce(function(result, t) {
                return result += t;
            }) / times.length;
            var bpm = 1 / (average / 1000) * 60;
            tapTempo.emit("tempo", bpm);
        }
    }
    var timer = null;
    function beginTimeout() {
        clearTimeout(timer);
        timer = setTimeout(function() {
            times = [
                lastDifference
            ];
            lastTime = null;
        }, timeout);
    }
    return tapTempo;
};

});
parcelRegister("9KgKE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $7185676dc7ed1f58$var$R = typeof Reflect === "object" ? Reflect : null;
var $7185676dc7ed1f58$var$ReflectApply = $7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.apply === "function" ? $7185676dc7ed1f58$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $7185676dc7ed1f58$var$ReflectOwnKeys;
if ($7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.ownKeys === "function") $7185676dc7ed1f58$var$ReflectOwnKeys = $7185676dc7ed1f58$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $7185676dc7ed1f58$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $7185676dc7ed1f58$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $7185676dc7ed1f58$var$EventEmitter() {
    $7185676dc7ed1f58$var$EventEmitter.init.call(this);
}
module.exports = $7185676dc7ed1f58$var$EventEmitter;
module.exports.once = $7185676dc7ed1f58$var$once;
// Backwards-compat with node 0.10.x
$7185676dc7ed1f58$var$EventEmitter.EventEmitter = $7185676dc7ed1f58$var$EventEmitter;
$7185676dc7ed1f58$var$EventEmitter.prototype._events = undefined;
$7185676dc7ed1f58$var$EventEmitter.prototype._eventsCount = 0;
$7185676dc7ed1f58$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $7185676dc7ed1f58$var$defaultMaxListeners = 10;
function $7185676dc7ed1f58$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($7185676dc7ed1f58$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $7185676dc7ed1f58$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $7185676dc7ed1f58$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $7185676dc7ed1f58$var$defaultMaxListeners = arg;
    }
});
$7185676dc7ed1f58$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$7185676dc7ed1f58$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $7185676dc7ed1f58$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $7185676dc7ed1f58$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $7185676dc7ed1f58$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $7185676dc7ed1f58$var$_getMaxListeners(this);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $7185676dc7ed1f58$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $7185676dc7ed1f58$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$7185676dc7ed1f58$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $7185676dc7ed1f58$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $7185676dc7ed1f58$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $7185676dc7ed1f58$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, false);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.on = $7185676dc7ed1f58$var$EventEmitter.prototype.addListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, true);
};
function $7185676dc7ed1f58$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $7185676dc7ed1f58$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $7185676dc7ed1f58$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.once = function once(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.on(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.prependListener(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$7185676dc7ed1f58$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $7185676dc7ed1f58$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.off = $7185676dc7ed1f58$var$EventEmitter.prototype.removeListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $7185676dc7ed1f58$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $7185676dc7ed1f58$var$unwrapListeners(evlistener) : $7185676dc7ed1f58$var$arrayClone(evlistener, evlistener.length);
}
$7185676dc7ed1f58$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, true);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, false);
};
$7185676dc7ed1f58$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $7185676dc7ed1f58$var$listenerCount.call(emitter, type);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.listenerCount = $7185676dc7ed1f58$var$listenerCount;
function $7185676dc7ed1f58$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $7185676dc7ed1f58$var$ReflectOwnKeys(this._events) : [];
};
function $7185676dc7ed1f58$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $7185676dc7ed1f58$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $7185676dc7ed1f58$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $7185676dc7ed1f58$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("6dWku", function(module, exports) {
"use strict";

var $dw85r = parcelRequire("dw85r");

var $7CoNB = parcelRequire("7CoNB");

var $bRJxa = parcelRequire("bRJxa");

var $cLsUq = parcelRequire("cLsUq");

var $1i5cH = parcelRequire("1i5cH");
var $488133ff5bd488e2$require$instrument = $1i5cH.default;

var $iFU5r = parcelRequire("iFU5r");

var $DSqxu = parcelRequire("DSqxu");

var $d3zJK = parcelRequire("d3zJK");

var $XfAip = parcelRequire("XfAip");

var $jjnZg = parcelRequire("jjnZg");
var $488133ff5bd488e2$require$obj = $jjnZg.obj;

var $gsDht = parcelRequire("gsDht");
var $488133ff5bd488e2$require$measureToBeatLength = $gsDht.measureToBeatLength;
// actions
const $488133ff5bd488e2$var$set = (key, value)=>(state)=>$488133ff5bd488e2$require$obj.patch(state, key, value);
const $488133ff5bd488e2$var$toggle = (key)=>(state)=>$488133ff5bd488e2$require$obj.patch(state, key, !$488133ff5bd488e2$require$obj.sub(state, key));
const $488133ff5bd488e2$var$toggleUI = (editor)=>(state)=>$488133ff5bd488e2$require$obj.patch(state, [
            "ui",
            editor
        ], !state.ui[editor]);
const $488133ff5bd488e2$var$ping = ()=>(state)=>state;
const $488133ff5bd488e2$var$initial = Object.assign({
    ui: {
        mediaLibrary: true,
        patches: true,
        instrument: true,
        sequencer: true,
        midiMap: true
    },
    myo: {
        on: false,
        reverse: false,
        osc: {}
    },
    wrlds: {
        on: false,
        port: 8888,
        mode: 0,
        threshold: 50,
        rotation: []
    }
});
const $488133ff5bd488e2$var$changesMap = {
    studio: [
        [
            [
                "tick",
                "index"
            ],
            [
                "tickIndex"
            ]
        ]
    ],
    sequencer: [],
    instrument: [],
    session: [
        [
            "tracks",
            (tracks)=>tracks.map((track)=>Object.assign({
                        input: {
                            device: -1,
                            channel: track.type === "seq" ? 10 : 1
                        },
                        inst: $488133ff5bd488e2$require$instrument.initial
                    }, track))
        ]
    ],
    pianoRoll: []
};
// todo merge loaded state
const $488133ff5bd488e2$var$load = (content)=>(state)=>$488133ff5bd488e2$require$obj.patch(Object.keys($488133ff5bd488e2$var$changesMap).reduce((changes, key)=>changes.concat([
                [
                    key,
                    key
                ]
            ], $488133ff5bd488e2$var$changesMap[key].map((change)=>change.map((ch)=>ch instanceof Array || typeof ch === "string" ? [].concat(key, ch) : ch))), []).map((changes)=>(console.log(changes), changes)).reduce((state, changes)=>$488133ff5bd488e2$require$obj.patch(state, changes[0], changes[1] instanceof Function ? changes[1]($488133ff5bd488e2$require$obj.sub(content, changes[0])) : $488133ff5bd488e2$require$obj.sub(content, changes[1]) || $488133ff5bd488e2$require$obj.sub(state, changes[1])), state), [
            "studio",
            "playing"
        ], false);
const $488133ff5bd488e2$var$clear = ()=>$488133ff5bd488e2$var$load($488133ff5bd488e2$var$initial);
const $488133ff5bd488e2$var$change = (section, prop, val)=>(state)=>$488133ff5bd488e2$require$obj.patch(state, [
            section
        ].concat(prop), val);
module.exports = {
    initial: $488133ff5bd488e2$var$initial,
    viewport: // children
    $dw85r,
    layout: $7CoNB,
    studio: $bRJxa,
    instrument: $488133ff5bd488e2$require$instrument,
    mediaLibrary: $d3zJK,
    session: $cLsUq,
    sequencer: $iFU5r,
    pianoRoll: {
        initial: $XfAip.actions.initial
    },
    midiMap: $DSqxu,
    set: // actions
    $488133ff5bd488e2$var$set,
    toggle: $488133ff5bd488e2$var$toggle,
    toggleUI: $488133ff5bd488e2$var$toggleUI,
    ping: $488133ff5bd488e2$var$ping,
    load: $488133ff5bd488e2$var$load,
    clear: $488133ff5bd488e2$var$clear,
    change: $488133ff5bd488e2$var$change
};

});
parcelRegister("dw85r", function(module, exports) {
"use strict";
const $9d74895ed2ed58ed$var$initial = {
    screen: {
        width: 800,
        height: 600,
        size: "lg"
    },
    mouse: {
        x: 400,
        y: 300
    }
};
module.exports = {
    initial: $9d74895ed2ed58ed$var$initial
};

});

parcelRegister("7CoNB", function(module, exports) {
"use strict";
const $58bf51979d9dc47b$var$initial = {
    mediaLibrary: {
        visible: false,
        dim: {
            width: 280,
            height: "100%"
        },
        pos: {
            col: 0,
            row: 0
        }
    },
    instrument: {
        visible: true,
        dim: {
            width: 320,
            height: "100%"
        },
        pos: {
            col: 1,
            row: 0
        }
    },
    session: {
        visible: true,
        dim: {
            width: 520,
            height: "100%"
        },
        pos: {
            col: 2,
            row: 0
        }
    },
    sequencer: {
        visible: true,
        dim: {
            width: 560
        },
        pos: {
            col: 3,
            row: 0
        }
    },
    pianoRoll: {
        visible: true,
        dim: {
            width: 560,
            height: 600
        },
        pos: {
            col: 3,
            row: 1
        }
    },
    midiKeyboard: {
        visible: true,
        dim: {
            width: 560
        },
        pos: {
            col: 3,
            row: 2
        }
    },
    midiMap: {
        visible: true,
        dim: {
            width: 600,
            height: "100%"
        },
        pos: {
            col: 4,
            row: 0
        }
    }
};
module.exports = {
    initial: $58bf51979d9dc47b$var$initial
};

});

parcelRegister("bRJxa", function(module, exports) {
"use strict";

var $jjnZg = parcelRequire("jjnZg");
var $8a37f70c3ae3d92c$require$obj = $jjnZg.obj;

var $gsDht = parcelRequire("gsDht");
var $8a37f70c3ae3d92c$require$measureToBeatLength = $gsDht.measureToBeatLength;
var $8a37f70c3ae3d92c$require$calculateProgress = $gsDht.calculateProgress;

var $46DUK = parcelRequire("46DUK");
var $8a37f70c3ae3d92c$require$reanchor = $46DUK.reanchor;
var $8a37f70c3ae3d92c$require$derivePosition = $46DUK.derivePosition;
var $8a37f70c3ae3d92c$require$MODIFIER = $46DUK.MODIFIER;
parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $8a37f70c3ae3d92c$require$context = $ekqew.context;
const $8a37f70c3ae3d92c$var$initial = {
    bpm: 120,
    measure: "4/4",
    beatLength: 16,
    barsLength: 1,
    startAudioTime: false,
    playing: false,
    recording: false,
    startTime: null,
    cycleOffset: 0,
    cycleBase: 0,
    tick: {
        index: -1,
        time: 0,
        bar: 0,
        elapsed: -1,
        tracks: [
            {
                index: -1
            },
            {
                index: -1
            },
            {
                index: -1
            },
            {
                index: -1
            }
        ]
    },
    volume: 0.4,
    channels: [
        {
            instr: "sampler",
            name: "Sampler 1",
            volume: 0.4,
            props: {}
        },
        {
            instr: "basicSynth",
            name: "Basic Synth 1",
            volume: 0.4,
            props: {}
        },
        {
            instr: "basicSynth",
            name: "Basic Synth 2",
            volume: 0.4,
            props: {}
        }
    ]
};
/** Sync derived transport position into state (UI / recording). */ const $8a37f70c3ae3d92c$var$syncTick = (tick)=>(state)=>$8a37f70c3ae3d92c$require$obj.patch(state, [
            "studio",
            "tick"
        ], tick);
const $8a37f70c3ae3d92c$var$play = ()=>(state)=>{
        const wasPlaying = state.studio.playing;
        const now = $8a37f70c3ae3d92c$require$context.currentTime;
        if (wasPlaying) {
            const anchors = $8a37f70c3ae3d92c$require$reanchor(state.studio, now);
            const tick = $8a37f70c3ae3d92c$require$derivePosition(Object.assign({}, state.studio, {
                playing: true,
                ...anchors
            }), state.sequencer, state.session, now);
            return $8a37f70c3ae3d92c$require$obj.patch(state, "studio", {
                playing: false,
                startTime: anchors.startTime,
                cycleOffset: anchors.cycleOffset,
                tick: tick
            });
        }
        const resuming = state.studio.startTime != null;
        const pianoCh = state.session.selection.piano[0];
        const pianoBar = state.studio.tick.tracks[pianoCh] && state.studio.tick.tracks[pianoCh].bar;
        return $8a37f70c3ae3d92c$require$obj.patch(state, "studio", {
            playing: true,
            startTime: now,
            cycleOffset: resuming ? state.studio.cycleOffset : 0,
            cycleBase: resuming ? state.studio.cycleBase : pianoBar ?? state.studio.tick.bar ?? 0
        });
    };
const $8a37f70c3ae3d92c$var$record = ()=>(state)=>$8a37f70c3ae3d92c$require$obj.patch(state, "studio", {
            recording: !state.studio.recording
        });
const $8a37f70c3ae3d92c$var$stop = ()=>(state)=>$8a37f70c3ae3d92c$require$obj.patch(state, "studio", {
            playing: false,
            recording: false,
            startTime: null,
            cycleOffset: 0
        });
const $8a37f70c3ae3d92c$var$change = (prop, val)=>(state)=>{
        if (state.studio.playing && prop === "bpm") {
            const now = $8a37f70c3ae3d92c$require$context.currentTime;
            return $8a37f70c3ae3d92c$require$obj.patch(state, "studio", {
                bpm: val,
                startTime: now,
                cycleOffset: $8a37f70c3ae3d92c$require$calculateProgress(state.studio.startTime, now, state.studio.cycleOffset, state.studio.bpm, state.studio.beatLength, $8a37f70c3ae3d92c$require$MODIFIER)
            });
        }
        let next = $8a37f70c3ae3d92c$require$obj.patch(state, [
            "studio",
            prop
        ], val);
        if (prop === "measure") next = $8a37f70c3ae3d92c$require$obj.patch(next, "studio", {
            beatLength: $8a37f70c3ae3d92c$require$measureToBeatLength(next.studio.measure)
        });
        if (next.studio.playing && prop === "measure") {
            const now = $8a37f70c3ae3d92c$require$context.currentTime;
            const beatLength = next.studio.beatLength;
            next = $8a37f70c3ae3d92c$require$obj.patch(next, "studio", {
                startTime: now,
                cycleOffset: $8a37f70c3ae3d92c$require$calculateProgress(state.studio.startTime, now, state.studio.cycleOffset, state.studio.bpm, state.studio.beatLength, $8a37f70c3ae3d92c$require$MODIFIER)
            });
        }
        return next;
    };
const $8a37f70c3ae3d92c$var$next = ()=>(state)=>$8a37f70c3ae3d92c$require$obj.patch(state, [
            "studio",
            "tick"
        ], {
            bar: state.studio.tick.bar < state.sequencer.barsLength - 1 ? state.studio.tick.bar + 1 : 0,
            tracks: state.session.tracks.map((track, _i)=>Object.assign({}, state.studio.tick.tracks[_i] || {}, {
                    bar: state.studio.tick.tracks[_i].bar < track.measures[state.session.active[_i]].barsLength - 1 ? state.studio.tick.tracks[_i].bar + 1 : 0
                }))
        });
const $8a37f70c3ae3d92c$var$prev = ()=>(state)=>$8a37f70c3ae3d92c$require$obj.patch(state, [
            "studio",
            "tick"
        ], {
            bar: state.studio.tick.bar > 0 ? state.studio.tick.bar - 1 : state.sequencer.barsLength - 1,
            tracks: state.session.tracks.map((track, _i)=>Object.assign({}, state.studio.tick.tracks[_i] || {}, {
                    bar: state.studio.tick.tracks[_i].bar > 0 ? state.studio.tick.tracks[_i].bar - 1 : track.measures[state.session.active[_i]].barsLength - 1
                }))
        });
/** @deprecated use syncTick via transport service */ const $8a37f70c3ae3d92c$var$tick = (time = $8a37f70c3ae3d92c$require$context.currentTime)=>(state)=>{
        const tickData = $8a37f70c3ae3d92c$require$derivePosition(state.studio, state.sequencer, state.session, time);
        return $8a37f70c3ae3d92c$require$obj.patch(state, [
            "studio",
            "tick"
        ], tickData);
    };
module.exports = {
    initial: $8a37f70c3ae3d92c$var$initial,
    play: $8a37f70c3ae3d92c$var$play,
    record: $8a37f70c3ae3d92c$var$record,
    stop: $8a37f70c3ae3d92c$var$stop,
    change: $8a37f70c3ae3d92c$var$change,
    syncTick: $8a37f70c3ae3d92c$var$syncTick,
    tick: $8a37f70c3ae3d92c$var$tick,
    next: $8a37f70c3ae3d92c$var$next,
    prev: $8a37f70c3ae3d92c$var$prev,
    MODIFIER: $8a37f70c3ae3d92c$require$MODIFIER
};

});
parcelRegister("jjnZg", function(module, exports) {
/**
 * @module iblokz-data
 * @description Immutable data manipulation utilities for JavaScript
 * @version 1.5.0
 */ /**
 * Object utilities for immutable operations
 * @type {Object}
 */ 
var $f30cz = parcelRequire("f30cz");

var $llUvA = parcelRequire("llUvA");

var $054Xj = parcelRequire("054Xj");

var $cMwYg = parcelRequire("cMwYg");
module.exports = {
    obj: $f30cz,
    arr: $llUvA,
    str: $054Xj,
    fn: $cMwYg
};

});
parcelRegister("f30cz", function(module, exports) {
"use strict";
/**
 * Creates an object with a single key-value pair.
 * @param {string} k - The key
 * @param {*} v - The value
 * @returns {Object} An object with the single key-value pair
 * @example
 * keyValue('name', 'John') // => { name: 'John' }
 */ const $02d3bb03c028877b$var$keyValue = (k, v)=>({
        [k]: v
    });
/**
 * Checks if a value is a plain object literal (not an array, null, or other object type).
 * @param {*} o - The value to check
 * @returns {boolean} True if the value is a plain object literal
 * @example
 * isLiteral({}) // => true
 * isLiteral([]) // => false
 * isLiteral(null) // => false
 */ const $02d3bb03c028877b$var$isLiteral = (o)=>typeof o === "object" && o !== null && o.constructor === Object;
/**
 * Creates a shallow clone of an object, preserving its prototype.
 * @param {Object} o - The object to clone
 * @returns {Object} A shallow clone of the object
 * @example
 * const obj = { a: 1, b: 2 };
 * const cloned = clone(obj);
 * cloned.a = 3;
 * console.log(obj.a) // => 1 (original unchanged)
 */ const $02d3bb03c028877b$var$clone = (o)=>Object.assign(Object.create(Object.getPrototypeOf(o) || {}), o);
/**
 * Gets a nested value from an object using a path.
 * @param {Object} o - The source object
 * @param {string|Array<string>} p - The path (string key or array of keys for nested access)
 * @returns {*} The value at the path, or undefined if not found
 * @example
 * sub({ a: { b: { c: 1 } } }, ['a', 'b', 'c']) // => 1
 * sub({ a: 1 }, 'a') // => 1
 * sub({ a: 1 }, 'b') // => undefined
 */ const $02d3bb03c028877b$var$sub = (o, p)=>o === undefined || o === null ? undefined : p instanceof Array ? p.length > 1 ? $02d3bb03c028877b$var$sub(o[p[0]], p.slice(1)) : o[p[0]] : o[p];
/**
 * Immutably updates a value in an object at a given path.
 * For nested paths, creates intermediate objects as needed.
 * If the value at the path is a literal object and v is also a literal object, they are merged.
 * @param {Object} o - The source object
 * @param {string|Array<string>} k - The path (string key or array of keys for nested updates)
 * @param {*} v - The value to set
 * @returns {Object} A new object with the value updated at the path
 * @example
 * patch({ a: 1 }, 'b', 2) // => { a: 1, b: 2 }
 * patch({ a: { b: 1 } }, ['a', 'c'], 2) // => { a: { b: 1, c: 2 } }
 * patch({ a: { b: 1 } }, 'a', { c: 2 }) // => { a: { b: 1, c: 2 } } (merged)
 */ const $02d3bb03c028877b$var$patch = (o, k, v)=>Object.assign($02d3bb03c028877b$var$clone(o), k instanceof Array ? $02d3bb03c028877b$var$keyValue(k[0], k.length > 1 ? $02d3bb03c028877b$var$patch(o[k[0]] || {}, k.slice(1), v) : $02d3bb03c028877b$var$isLiteral(o[k[0]]) && Object.assign($02d3bb03c028877b$var$clone(o[k[0]]), v) || v) : $02d3bb03c028877b$var$keyValue(k, $02d3bb03c028877b$var$isLiteral(o[k]) && Object.assign($02d3bb03c028877b$var$clone(o[k]), v) || v));
/**
 * Reduces an object to a single value by iterating over its keys.
 * Similar to Array.reduce, but for objects.
 * @param {Object} o - The object to reduce
 * @param {Function} reduceFn - The reducer function (accumulator, key, value, index, originalObject) => newAccumulator
 * @param {*} [initial] - The initial accumulator value (defaults to first property value)
 * @returns {*} The final accumulated value
 * @example
 * reduce({ a: 1, b: 2, c: 3 }, (sum, key, val) => sum + val, 0) // => 6
 */ const $02d3bb03c028877b$var$reduce = (o, reduceFn, initial)=>Object.keys(o).reduce((accumulator, key, index)=>reduceFn(accumulator, key, o[key], index, o), typeof initial === "undefined" ? o[Object.keys(o)[0]] // to confirm with the array reduce spec in this case the firts property is used
     : initial);
/**
 * Immutably maps over an object's values.
 * @param {Object} o - The source object
 * @param {Function} mapFn - The mapping function (key, value, index, originalObject) => newValue
 * @returns {Object} A new object with mapped values
 * @example
 * map({ a: 1, b: 2 }, (k, v) => v * 2) // => { a: 2, b: 4 }
 */ const $02d3bb03c028877b$var$map = (o, mapFn)=>$02d3bb03c028877b$var$reduce(o, (o2, key, value, index)=>$02d3bb03c028877b$var$patch(o2, key, mapFn(key, value, index, o)), {});
/**
 * Immutably filters an object's properties based on a predicate.
 * @param {Object} o - The source object
 * @param {Function} filterFn - The filter predicate (key, value, index, originalObject) => boolean
 * @returns {Object} A new object with only properties that pass the predicate
 * @example
 * filter({ a: 1, b: 2, c: 3 }, (k, v) => v > 1) // => { b: 2, c: 3 }
 */ const $02d3bb03c028877b$var$filter = (o, filterFn)=>$02d3bb03c028877b$var$reduce(o, (o2, key, value, index)=>filterFn(key, value, index, o) ? $02d3bb03c028877b$var$patch(o2, key, value) : o2, {});
/**
 * Recursively traverses an object tree and applies a function to leaf values.
 * Non-literal values (primitives, arrays, etc.) are transformed by the function.
 * @param {Object} tree - The object tree to traverse
 * @param {Function} fn - The function to apply to leaf values (key, value, index, parent) => newValue
 * @returns {Object} A new object tree with transformed leaf values
 * @example
 * traverse({ a: { b: 1 }, c: 2 }, (k, v) => v * 2) // => { a: { b: 2 }, c: 4 }
 */ const $02d3bb03c028877b$var$traverse = (tree, fn)=>Object.keys(tree).reduce((o, key, index)=>$02d3bb03c028877b$var$patch(o, key, $02d3bb03c028877b$var$isLiteral(tree[key]) ? $02d3bb03c028877b$var$traverse(tree[key], fn) : fn(key, tree[key], index, tree)), {});
/**
 * Chains multiple method calls on an object.
 * @param {Object} o - The object to call methods on
 * @param {Array<Array>} chain - Array of [methodName, ...args] tuples
 * @returns {*} The result of the final method call
 * @example
 * chainCall([1, 2, 3], [['map', x => x * 2], ['filter', x => x > 2]]) // => [4, 6]
 */ const $02d3bb03c028877b$var$chainCall = (o, chain)=>chain.reduce((o, [prop, ...args])=>o[prop](...args), o);
/**
 * Pattern matching utility that returns a value based on matching a value to cases.
 * Supports nested array paths for partial matching and a 'default' case.
 * @param {*} value - The value to match (can be a string, array path, etc.)
 * @param {Object} cases - Object with cases to match against (supports 'default' key)
 * @returns {*} The matched case value, or false if no match
 * @example
 * _switch('a', { a: 1, b: 2, default: 0 }) // => 1
 * _switch('c', { a: 1, b: 2, default: 0 }) // => 0
 * _switch(['a', 'b'], { a: { b: 1 } }) // => 1
 */ const $02d3bb03c028877b$var$_switch = (value, cases)=>$02d3bb03c028877b$var$sub(cases, value) && $02d3bb03c028877b$var$sub(cases, value)["default"] || $02d3bb03c028877b$var$sub(cases, value) || value instanceof Array && value.length > 1 && $02d3bb03c028877b$var$_switch(value.slice(0, value.length - 1), cases) || cases["default"] || false;
module.exports = {
    keyValue: $02d3bb03c028877b$var$keyValue,
    isLiteral: $02d3bb03c028877b$var$isLiteral,
    clone: $02d3bb03c028877b$var$clone,
    sub: $02d3bb03c028877b$var$sub,
    patch: $02d3bb03c028877b$var$patch,
    reduce: $02d3bb03c028877b$var$reduce,
    map: $02d3bb03c028877b$var$map,
    filter: $02d3bb03c028877b$var$filter,
    traverse: $02d3bb03c028877b$var$traverse,
    chainCall: $02d3bb03c028877b$var$chainCall,
    switch: $02d3bb03c028877b$var$_switch
};

});

parcelRegister("llUvA", function(module, exports) {
"use strict";
/**
 * Immutably adds an item to an array (returns a new array).
 * @param {Array} arr - The source array
 * @param {*} item - The item to add
 * @returns {Array} A new array with the item added at the end
 * @example
 * add([1, 2, 3], 4) // => [1, 2, 3, 4]
 */ const $f8b7648db1f1c5a5$var$add = (arr, item)=>[].concat(arr, [
        item
    ]);
/**
 * Immutably removes the first occurrence of an item from an array.
 * If the item is not found, returns the original array.
 * @param {Array} arr - The source array
 * @param {*} item - The item to remove
 * @returns {Array} A new array with the item removed, or the original array if not found
 * @example
 * remove([1, 2, 3, 2], 2) // => [1, 3, 2]
 * remove([1, 2, 3], 4) // => [1, 2, 3]
 */ const $f8b7648db1f1c5a5$var$remove = (arr, item)=>arr.indexOf(item) > -1 ? [].concat(arr.slice(0, arr.indexOf(item)), arr.slice(arr.indexOf(item) + 1)) : arr;
/**
 * Immutably toggles an item in an array (adds if not present, removes if present).
 * @param {Array} arr - The source array
 * @param {*} item - The item to toggle
 * @returns {Array} A new array with the item toggled
 * @example
 * toggle([1, 2, 3], 2) // => [1, 3]
 * toggle([1, 2, 3], 4) // => [1, 2, 3, 4]
 */ const $f8b7648db1f1c5a5$var$toggle = (arr, item)=>arr.indexOf(item) > -1 ? $f8b7648db1f1c5a5$var$remove(arr, item) : $f8b7648db1f1c5a5$var$add(arr, item);
/**
 * Checks if an array or comma-separated string contains an element.
 * @param {Array|string} a - The array or comma-separated string to check
 * @param {*} el - The element to look for
 * @returns {boolean} True if the element is found, false otherwise
 * @example
 * contains([1, 2, 3], 2) // => true
 * contains('a,b,c', 'b') // => true
 * contains([1, 2, 3], 4) // => false
 */ const $f8b7648db1f1c5a5$var$contains = (a, el)=>[].concat(typeof a === "string" && a.split(",") || a instanceof Array && a || []).indexOf(el) > -1;
module.exports = {
    add: $f8b7648db1f1c5a5$var$add,
    remove: $f8b7648db1f1c5a5$var$remove,
    toggle: $f8b7648db1f1c5a5$var$toggle,
    contains: $f8b7648db1f1c5a5$var$contains
};

});

parcelRegister("054Xj", function(module, exports) {
"use strict";
/**
 * Capitalizes the first character of a string.
 * @param {string} chunk - The string to capitalize
 * @returns {string} The capitalized string
 * @example
 * capitalize('hello') // => 'Hello'
 */ const $00f44fd4f3d3ff8c$var$capitalize = (chunk)=>chunk.charAt(0).toUpperCase() + chunk.slice(1);
/**
 * Converts a string to camelCase from a delimited format.
 * @param {string} str - The string to convert
 * @param {string} [glue='_'] - The delimiter to split on
 * @returns {string} The camelCase string
 * @example
 * toCamelCase('hello_world') // => 'helloWorld'
 * toCamelCase('hello-world', '-') // => 'helloWorld'
 */ const $00f44fd4f3d3ff8c$var$toCamelCase = (str, glue = "_")=>str.split(glue).map((chunk, i)=>i === 0 ? chunk : $00f44fd4f3d3ff8c$var$capitalize(chunk)).join("");
/**
 * Converts a camelCase string to a delimited format.
 * @param {string} str - The camelCase string to convert
 * @param {string} [glue='_'] - The delimiter to use
 * @returns {string} The delimited string in lowercase
 * @example
 * fromCamelCase('helloWorld') // => 'hello_world'
 * fromCamelCase('helloWorld', '-') // => 'hello-world'
 */ const $00f44fd4f3d3ff8c$var$fromCamelCase = (str, glue = "_")=>str.replace(/([A-Z])/g, " $1").split(" ").map((chunk)=>chunk.toLowerCase()).join(glue);
/**
 * Converts a singular word to its plural form (basic English rules).
 * @param {string} str - The singular word
 * @returns {string} The plural form
 * @example
 * singularToPlural('category') // => 'categories'
 * singularToPlural('user') // => 'users'
 */ const $00f44fd4f3d3ff8c$var$singularToPlural = (str)=>str.replace(/y$/, "ie").concat("s");
/**
 * Converts a plural word to its singular form (basic English rules).
 * @param {string} str - The plural word
 * @returns {string} The singular form
 * @example
 * pluralToSingular('categories') // => 'category'
 * pluralToSingular('users') // => 'user'
 */ const $00f44fd4f3d3ff8c$var$pluralToSingular = (str)=>str.replace(/ies$/, "y").replace(/s$/, "");
/**
 * Converts a string to a document ID format (typically used for database foreign keys).
 * @param {string} str - The string to convert
 * @param {string} [glue='_'] - The delimiter in the input string
 * @param {string} [suffix='Id'] - The suffix to append
 * @param {string} [prefix=''] - The prefix to prepend
 * @returns {string} The document ID string
 * @example
 * toDocumentId('user_roles') // => 'userRoleId'
 * toDocumentId('categories', '_', 'ID', 'ref') // => 'refCategoryID'
 */ const $00f44fd4f3d3ff8c$var$toDocumentId = (str, glue = "_", suffix = "Id", prefix = "")=>prefix.concat($00f44fd4f3d3ff8c$var$pluralToSingular($00f44fd4f3d3ff8c$var$toCamelCase(str, glue)), suffix);
module.exports = {
    capitalize: $00f44fd4f3d3ff8c$var$capitalize,
    toCamelCase: $00f44fd4f3d3ff8c$var$toCamelCase,
    fromCamelCase: $00f44fd4f3d3ff8c$var$fromCamelCase,
    singularToPlural: $00f44fd4f3d3ff8c$var$singularToPlural,
    pluralToSingular: $00f44fd4f3d3ff8c$var$pluralToSingular,
    toDocumentId: $00f44fd4f3d3ff8c$var$toDocumentId
};

});

parcelRegister("cMwYg", function(module, exports) {
"use strict";

var $f30cz = parcelRequire("f30cz");
/**
 * Creates a left-to-right function composition pipeline.
 * The first function can accept multiple arguments; the remaining functions must be unary.
 * @param {Function} a - The first function in the pipeline (can accept multiple arguments)
 * @param {...Function} fns - The remaining functions to pipe through (each takes one argument)
 * @returns {Function} A function that passes the result through each function from left to right
 * @example
 * const addOne = x => x + 1;
 * const double = x => x * 2;
 * const addOneThenDouble = pipe(addOne, double);
 * addOneThenDouble(3) // => 8 (3 + 1 = 4, 4 * 2 = 8)
 */ const $94e38b133e22c353$var$pipe = (a, ...fns)=>(...args)=>fns.reduce((res, fn)=>fn(res), a(...args));
/**
 * Creates a right-to-left function composition.
 * The rightmost function can accept multiple arguments; the remaining functions must be unary.
 * @param {...Function} fns - Functions to compose (executed right to left)
 * @returns {Function} A function that passes the result through each function from right to left
 * @example
 * const addOne = x => x + 1;
 * const double = x => x * 2;
 * const doubleThenAddOne = compose(addOne, double);
 * doubleThenAddOne(3) // => 7 (3 * 2 = 6, 6 + 1 = 7)
 */ const $94e38b133e22c353$var$compose = (...fns)=>$94e38b133e22c353$var$pipe(fns.slice(-1).pop(), ...fns.reverse().slice(1));
// switch for backwards compatibility
module.exports = {
    compose: $94e38b133e22c353$var$compose,
    pipe: $94e38b133e22c353$var$pipe,
    switch: $f30cz.switch
};

});


parcelRegister("gsDht", function(module, exports) {
"use strict";
const $bfbdbb3ad7872723$var$measureToBeatLength = (measure)=>measure.split("/").map((v)=>parseInt(v, 10)).reduce((p, v, i)=>i === 0 ? p * v : p / v, 16);
const $bfbdbb3ad7872723$var$bpmToTime = (bpm)=>60 / parseInt(bpm, 10) / 4;
/**
 * Progress within the current cycle (0–1).
 * @param {number} startTime - Start time of the process (AudioContext time)
 * @param {number} currentTime - Current time (e.g. context.currentTime)
 * @param {number} cycleOffset - (0–1) fraction offset within the cycle at start
 * @param {number} bpm - BPM
 * @param {number} segments - Number of segments in the cycle (e.g. beatLength for one bar)
 * @param {number} modifier - Modifier of the cycle (default 1)
 * @returns {number} Progress 0–1 within current cycle
 */ const $bfbdbb3ad7872723$var$calculateProgress = (startTime, currentTime, cycleOffset, bpm, segments = 12, modifier = 1)=>(cycleOffset + (currentTime - startTime) % ($bfbdbb3ad7872723$var$bpmToTime(bpm) * segments * modifier) / ($bfbdbb3ad7872723$var$bpmToTime(bpm) * segments * modifier)) % 1;
/**
 * Cycle (bar) index since start.
 * @param {number} startTime - Start time of the process
 * @param {number} currentTime - Current time
 * @param {number} cycleOffset - (0–1) fraction offset at start
 * @param {number} bpm - BPM
 * @param {number} segments - Segments per cycle (e.g. beatLength)
 * @param {number} modifier - Modifier (default 1)
 * @returns {number} Cycle index (bar index)
 */ const $bfbdbb3ad7872723$var$calculateCycle = (startTime, currentTime, cycleOffset, bpm, segments = 12, modifier = 1)=>Math.floor(cycleOffset + (currentTime - startTime) / ($bfbdbb3ad7872723$var$bpmToTime(bpm) * segments * modifier));
module.exports = {
    measureToBeatLength: $bfbdbb3ad7872723$var$measureToBeatLength,
    bpmToTime: $bfbdbb3ad7872723$var$bpmToTime,
    calculateProgress: $bfbdbb3ad7872723$var$calculateProgress,
    calculateCycle: $bfbdbb3ad7872723$var$calculateCycle
};

});

parcelRegister("46DUK", function(module, exports) {

$parcel$export(module.exports, "MODIFIER", () => $2fd6af19468844a4$export$41152710a75660f);
$parcel$export(module.exports, "stepIndex", () => $2fd6af19468844a4$export$c826f14a77e71f1c);
$parcel$export(module.exports, "barIndex", () => $2fd6af19468844a4$export$d1c611333a94fb48);
$parcel$export(module.exports, "derivePosition", () => $2fd6af19468844a4$export$3c4d9141e4c8c47f);
$parcel$export(module.exports, "reanchor", () => $2fd6af19468844a4$export$275c86e416247674);
$parcel$export(module.exports, "stepTimeOffset", () => $2fd6af19468844a4$export$2acc82a4de3ee6c1);
parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");

var $gsDht = parcelRequire("gsDht");
const $2fd6af19468844a4$export$41152710a75660f = 1;
const $2fd6af19468844a4$export$c826f14a77e71f1c = (progress, beatLength)=>Math.min(beatLength - 1, Math.floor(progress * beatLength));
const $2fd6af19468844a4$export$d1c611333a94fb48 = (cycle, barsLength)=>(cycle % barsLength + barsLength) % barsLength;
const $2fd6af19468844a4$export$3c4d9141e4c8c47f = (studio, sequencer, session, now = (0, $ekqew.context).currentTime)=>{
    const { startTime: startTime, cycleOffset: cycleOffset, bpm: bpm, beatLength: beatLength, playing: playing, cycleBase: cycleBase = 0 } = studio;
    const barsLength = sequencer.barsLength || 1;
    if (!playing || startTime === null) return studio.tick;
    const segments = beatLength;
    const progress = (0, $gsDht.calculateProgress)(startTime, now, cycleOffset, bpm, segments, $2fd6af19468844a4$export$41152710a75660f);
    const cycle = (0, $gsDht.calculateCycle)(startTime, now, cycleOffset, bpm, segments, $2fd6af19468844a4$export$41152710a75660f);
    const index = $2fd6af19468844a4$export$c826f14a77e71f1c(progress, beatLength);
    const bar = $2fd6af19468844a4$export$d1c611333a94fb48(cycle + cycleBase, barsLength);
    const elapsed = (cycle + cycleBase) * beatLength + index;
    const tracks = session.tracks.map((track, _i)=>{
        const trackBarsLength = track.measures[session.active[_i]] && track.measures[session.active[_i]].barsLength || 1;
        return {
            index: index,
            bar: $2fd6af19468844a4$export$d1c611333a94fb48(cycle + cycleBase, trackBarsLength)
        };
    });
    return {
        index: index,
        bar: bar,
        elapsed: elapsed,
        time: now,
        tracks: tracks
    };
};
const $2fd6af19468844a4$export$f0476a65b4ffc42e = (startTime, cycleOffset, bpm, beatLength, cycle, step)=>{
    const stepDuration = (0, $gsDht.bpmToTime)(bpm) * $2fd6af19468844a4$export$41152710a75660f;
    const cycleStart = startTime - cycleOffset * beatLength * stepDuration + cycle * beatLength * stepDuration;
    return cycleStart + step * stepDuration;
};
const $2fd6af19468844a4$export$275c86e416247674 = (studio, now = (0, $ekqew.context).currentTime)=>{
    const { startTime: startTime, cycleOffset: cycleOffset, bpm: bpm, beatLength: beatLength } = studio;
    return {
        startTime: now,
        cycleOffset: (0, $gsDht.calculateProgress)(startTime, now, cycleOffset, bpm, beatLength, $2fd6af19468844a4$export$41152710a75660f)
    };
};
const $2fd6af19468844a4$export$2acc82a4de3ee6c1 = (progress, beatLength, quantize = 0.25)=>{
    const idx = $2fd6af19468844a4$export$c826f14a77e71f1c(progress, beatLength);
    const fractional = progress * beatLength - idx;
    return Math.round(fractional / quantize) * quantize;
};
var $2fd6af19468844a4$export$2e2bcd8739ae039 = {
    MODIFIER: $2fd6af19468844a4$export$41152710a75660f,
    stepIndex: $2fd6af19468844a4$export$c826f14a77e71f1c,
    stepTimeOffset: $2fd6af19468844a4$export$2acc82a4de3ee6c1,
    barIndex: $2fd6af19468844a4$export$d1c611333a94fb48,
    derivePosition: $2fd6af19468844a4$export$3c4d9141e4c8c47f,
    absoluteStepTime: $2fd6af19468844a4$export$f0476a65b4ffc42e,
    reanchor: $2fd6af19468844a4$export$275c86e416247674
};

});
parcelRegister("cl3AY", function(module, exports) {

$parcel$export(module.exports, "create", () => $8fba3c27b5ab14c3$export$185802fd694ee1f5);
$parcel$export(module.exports, "update", () => $8fba3c27b5ab14c3$export$722fbec263ad908a);
$parcel$export(module.exports, "connect", () => $8fba3c27b5ab14c3$export$64605811ab45167f);
$parcel$export(module.exports, "disconnect", () => $8fba3c27b5ab14c3$export$37dfea93db2e14ed);
$parcel$export(module.exports, "reroute", () => $8fba3c27b5ab14c3$export$b5477be75f21f626);
$parcel$export(module.exports, "chain", () => $8fba3c27b5ab14c3$export$e08e3b67e392101e);
$parcel$export(module.exports, "unchain", () => $8fba3c27b5ab14c3$export$f9c86b1eb891c539);
$parcel$export(module.exports, "start", () => $8fba3c27b5ab14c3$export$b3571188c770cc5a);
$parcel$export(module.exports, "stop", () => $8fba3c27b5ab14c3$export$fa6813432f753b0d);
$parcel$export(module.exports, "schedule", () => $8fba3c27b5ab14c3$export$60974f670aa8d75e);
$parcel$export(module.exports, "noteToFrequency", () => $8fba3c27b5ab14c3$export$3e4adc039be3c924);
$parcel$export(module.exports, "vco", () => $8fba3c27b5ab14c3$export$a2755ad1bca0bb8);
$parcel$export(module.exports, "vcf", () => $8fba3c27b5ab14c3$export$c56c739ec3b331c7);
$parcel$export(module.exports, "lfo", () => $8fba3c27b5ab14c3$export$a54aef16459aa083);
$parcel$export(module.exports, "vca", () => $8fba3c27b5ab14c3$export$d3d4d7bcba414a20);
$parcel$export(module.exports, "adsr", () => $8fba3c27b5ab14c3$export$4b5ed91d52436736);
$parcel$export(module.exports, "noteOn", () => $8fba3c27b5ab14c3$export$e03a6f121205184b);
$parcel$export(module.exports, "noteOff", () => $8fba3c27b5ab14c3$export$a6328a4d8d615e7a);
$parcel$export(module.exports, "context", () => (parcelRequire("ekqew")).context);
$parcel$export(module.exports, "sampler", () => (parcelRequire("fbcJ7")));
/**
 * @module iblokz-audio
 * @description Web Audio API utilities and engine for building reactive audio applications
 * @version 0.1.0
 */ 
var $ekqew = parcelRequire("ekqew");

var $4HJwV = parcelRequire("4HJwV");

var $kXaMP = parcelRequire("kXaMP");

var $9y3ap = parcelRequire("9y3ap");

var $fbcJ7 = parcelRequire("fbcJ7");
/**
 * Creates an audio node of the specified type
 * @param {string} type - Node type (vco, vca, vcf, lfo, reverb, adsr)
 * @param {Object} [prefs={}] - Node preferences
 * @param {AudioContext} [ctx=context] - Audio context (defaults to global context)
 * @returns {Object} Audio node object
 */ const $8fba3c27b5ab14c3$export$185802fd694ee1f5 = (type, prefs = {}, ctx = (0, $ekqew.context))=>Object.assign({}, (({
        vco: ()=>({
                output: (0, $ekqew.create)("oscillator")
            }),
        vca: ()=>({
                through: (0, $ekqew.create)("gain")
            }),
        vcf: ()=>({
                through: (0, $ekqew.create)("biquadFilter")
            }),
        lfo: ()=>$kXaMP.create(prefs),
        reverb: ()=>$4HJwV.create(prefs),
        adsr: ()=>$9y3ap.create(prefs)
    })[type] || (()=>({})))(), {
        type: type,
        out: []
    });
/**
 * Converts a cutoff value (0-1) to frequency in Hz
 * @param {number} cutoff - Cutoff value (0-1)
 * @returns {number} Frequency in Hz
 */ const $8fba3c27b5ab14c3$var$cutoffToFreq = (cutoff)=>{
    const minValue = 40;
    const maxValue = (0, $ekqew.context).sampleRate / 2;
    // Logarithm (base 2) to compute how many octaves fall in the range.
    var numberOfOctaves = Math.log(maxValue / minValue) / Math.LN2;
    // Compute a multiplier from 0 to 1 based on an exponential scale.
    var multiplier = Math.pow(2, numberOfOctaves * (cutoff - 1.0));
    // Get back to the frequency value between min and max.
    return maxValue * multiplier;
};
/**
 * Updates an audio node with new preferences
 * @param {Object} node - The audio node to update
 * @param {Object} prefs - New preferences
 * @returns {Object} Updated node
 */ const $8fba3c27b5ab14c3$export$722fbec263ad908a = (node, prefs)=>{
    const updaters = {
        vco: ()=>((0, $ekqew.isSet)(prefs.type) && (0, $ekqew.set)(node.output, "type", prefs.type), (0, $ekqew.isSet)(prefs.freq) && (0, $ekqew.set)(node.output.frequency, "value", prefs.freq), (0, $ekqew.isSet)(prefs.detune) && (0, $ekqew.set)(node.output.detune, "value", prefs.detune), Object.assign(node, {
                prefs: prefs
            })),
        vca: ()=>((0, $ekqew.isSet)(prefs.gain) && (0, $ekqew.set)(node.through.gain, "value", prefs.gain), Object.assign(node, {
                prefs: prefs
            })),
        vcf: ()=>((0, $ekqew.isSet)(prefs.type) && (0, $ekqew.set)(node.through, "type", prefs.type), (0, $ekqew.isSet)(prefs.cutoff) && (0, $ekqew.schedule)(node.through, "frequency", [
                $8fba3c27b5ab14c3$var$cutoffToFreq(prefs.cutoff)
            ], [
                (0, $ekqew.context).currentTime + 0.0001
            ]), (0, $ekqew.isSet)(prefs.resonance) && (0, $ekqew.schedule)(node.through, "Q", [
                prefs.resonance * 30
            ], [
                (0, $ekqew.context).currentTime + 0.0001
            ]), Object.assign(node, {
                prefs: prefs
            })),
        reverb: ()=>$4HJwV.update(node, prefs),
        adsr: ()=>$9y3ap.update(node, prefs),
        lfo: ()=>$kXaMP.update(node, prefs)
    };
    const updater = updaters[node.type];
    return updater ? updater() : node;
};
/**
 * Connects two audio nodes
 * @param {Object} node1 - Source node
 * @param {Object|AudioParam} node2 - Destination node or AudioParam
 * @returns {Object} Source node with updated out array
 */ const $8fba3c27b5ab14c3$export$64605811ab45167f = (node1, node2)=>!(node1.out && node1.out.indexOf(node2) > -1) ? ((0, $ekqew.connect)(// input
    (0, $ekqew.isGet)(node1.output) || (0, $ekqew.isGet)(node1.through) || (0, $ekqew.isSet)(node1.connect) && node1, // output
    node2 instanceof AudioParam && node2 || (0, $ekqew.isGet)(node2.input) || (0, $ekqew.isGet)(node2.through) || node2), Object.assign({}, node1, {
        out: [].concat(node1.out || [], [
            node2
        ])
    })) : node1;
/**
 * Disconnects two audio nodes
 * @param {Object} node1 - Source node
 * @param {Object|AudioParam} [node2] - Destination node (optional, disconnects all if omitted)
 * @returns {Object} Source node with updated out array
 */ const $8fba3c27b5ab14c3$export$37dfea93db2e14ed = (node1, node2)=>node1.out && node1.out.indexOf(node2) > -1 ? ((0, $ekqew.disconnect)(// input
    (0, $ekqew.isGet)(node1.output) || (0, $ekqew.isGet)(node1.through) || (0, $ekqew.isSet)(node1.connect) && node1, // output
    node2 instanceof AudioParam && node2 || (0, $ekqew.isGet)(node2.input) || (0, $ekqew.isGet)(node2.through) || node2), Object.assign({}, node1, {
        out: [].concat(node1.out.slice(0, node1.out.indexOf(node2)), node1.out.slice(node1.out.indexOf(node2) + 1))
    })) : typeof node2 === "undefined" ? node1.out.reduce((node1, prevNode)=>$8fba3c27b5ab14c3$export$37dfea93db2e14ed(node1, prevNode), node1) : node1;
/**
 * Reroutes a node from its current destination to a new one
 * @param {Object} node1 - Source node
 * @param {Object} node2 - New destination node
 * @returns {Object} Updated source node
 */ const $8fba3c27b5ab14c3$export$b5477be75f21f626 = (node1, node2)=>node1.out && node1.out.indexOf(node2) === -1 ? $8fba3c27b5ab14c3$export$64605811ab45167f($8fba3c27b5ab14c3$export$37dfea93db2e14ed(node1), node2) : node1;
/**
 * Chains multiple audio nodes together
 * @param {...Object} nodes - Nodes to chain
 * @returns {Object} First node in chain
 */ const $8fba3c27b5ab14c3$export$e08e3b67e392101e = (...nodes)=>(nodes.forEach((n, i)=>(0, $ekqew.isSet)(nodes[i + 1]) && $8fba3c27b5ab14c3$export$64605811ab45167f(n, nodes[i + 1])), nodes[0]);
/**
 * Unchains multiple audio nodes
 * @param {...Object} nodes - Nodes to unchain
 * @returns {Object} First node
 */ const $8fba3c27b5ab14c3$export$f9c86b1eb891c539 = (...nodes)=>(nodes.slice().reverse().forEach((n, i)=>(0, $ekqew.isSet)(nodes[i - 1]) && $8fba3c27b5ab14c3$export$37dfea93db2e14ed(nodes[i - 1], n)), nodes[0]);
/**
 * Starts an audio node (oscillator, buffer source, or LFO)
 * @param {Object} node - The node to start
 * @param {...*} args - Additional arguments (time, etc.)
 * @returns {Object} The node
 */ const $8fba3c27b5ab14c3$export$b3571188c770cc5a = (node, ...args)=>(node.type === "lfo" ? $kXaMP.start(node, ...args) : node.source ? node.source.start(...args) : node.output.start(...args), node);
/**
 * Stops an audio node
 * @param {Object} node - The node to stop
 * @param {...*} args - Additional arguments (time, etc.)
 * @returns {Object} The node
 */ const $8fba3c27b5ab14c3$export$fa6813432f753b0d = (node, ...args)=>(node.source ? node.source.stop(...args) : node.output.stop(...args), node);
/**
 * Schedules parameter changes on an audio node
 * @param {Object} node - The audio node
 * @param {string} pref - Parameter name
 * @param {Array<number>} values - Array of values
 * @param {Array<number>} times - Array of times
 * @returns {void}
 */ const $8fba3c27b5ab14c3$export$60974f670aa8d75e = (node, pref, values, times)=>values.length === 1 ? node.through[pref].setValueAtTime(values[0], times[0]) : (node.through[pref].setValueCurveAtTime(new Float32Array(values.slice(0, 2)), times[0], times[1]), values.length > 2 && $8fba3c27b5ab14c3$export$60974f670aa8d75e(node, pref, values.slice(1), [
        times[0] + times[1]
    ].concat(times.slice(2))));
/**
 * Converts a musical note to frequency in Hz
 * @param {string} note - Note name (e.g., 'C4', 'A#3', 'Bb5')
 * @returns {number} Frequency in Hz
 */ const $8fba3c27b5ab14c3$export$3e4adc039be3c924 = function(note) {
    var notes = [
        "A",
        "A#",
        "B",
        "C",
        "C#",
        "D",
        "D#",
        "E",
        "F",
        "F#",
        "G",
        "G#"
    ];
    var keyNumber;
    var octave;
    if (note.length === 3) octave = note.charAt(2);
    else octave = note.charAt(1);
    keyNumber = notes.indexOf(note.slice(0, -1));
    if (keyNumber < 3) keyNumber = keyNumber + 12 + (octave - 1) * 12 + 1;
    else keyNumber = keyNumber + (octave - 1) * 12 + 1;
    return 440 * Math.pow(2, (keyNumber - 49) / 12);
};
// Convenience factory functions
const $8fba3c27b5ab14c3$export$a2755ad1bca0bb8 = (prefs)=>$8fba3c27b5ab14c3$export$722fbec263ad908a($8fba3c27b5ab14c3$export$185802fd694ee1f5("vco", {}, (0, $ekqew.context)), prefs);
const $8fba3c27b5ab14c3$export$c56c739ec3b331c7 = (prefs)=>$8fba3c27b5ab14c3$export$722fbec263ad908a($8fba3c27b5ab14c3$export$185802fd694ee1f5("vcf", {}, (0, $ekqew.context)), prefs);
const $8fba3c27b5ab14c3$export$a54aef16459aa083 = (prefs)=>$8fba3c27b5ab14c3$export$722fbec263ad908a($8fba3c27b5ab14c3$export$185802fd694ee1f5("lfo", {}, (0, $ekqew.context)), prefs);
const $8fba3c27b5ab14c3$export$d3d4d7bcba414a20 = (prefs)=>$8fba3c27b5ab14c3$export$722fbec263ad908a($8fba3c27b5ab14c3$export$185802fd694ee1f5("vca", {}, (0, $ekqew.context)), prefs);
const $8fba3c27b5ab14c3$export$4b5ed91d52436736 = (prefs)=>$8fba3c27b5ab14c3$export$185802fd694ee1f5("adsr", prefs, (0, $ekqew.context));
// Re-export noteOn/noteOff from adsr for convenience
const $8fba3c27b5ab14c3$export$e03a6f121205184b = $9y3ap.noteOn;
const $8fba3c27b5ab14c3$export$a6328a4d8d615e7a = $9y3ap.noteOff;

});
parcelRegister("ekqew", function(module, exports) {

$parcel$export(module.exports, "context", () => $a6e7484bf28693a9$export$a078c61943f9dbbe);
$parcel$export(module.exports, "set", () => $a6e7484bf28693a9$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "isSet", () => $a6e7484bf28693a9$export$6750766a7c7ec627);
$parcel$export(module.exports, "isGet", () => $a6e7484bf28693a9$export$6d699abd4274ded4);
$parcel$export(module.exports, "create", () => $a6e7484bf28693a9$export$185802fd694ee1f5);
$parcel$export(module.exports, "connect", () => $a6e7484bf28693a9$export$64605811ab45167f);
$parcel$export(module.exports, "disconnect", () => $a6e7484bf28693a9$export$37dfea93db2e14ed);
$parcel$export(module.exports, "chain", () => $a6e7484bf28693a9$export$e08e3b67e392101e);
$parcel$export(module.exports, "duration", () => $a6e7484bf28693a9$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "chData", () => $a6e7484bf28693a9$export$fe30e442dba82fb5);
$parcel$export(module.exports, "schedule", () => $a6e7484bf28693a9$export$60974f670aa8d75e);
/**
 * Core Web Audio API utilities
 * @module core
 */ /**
 * Web Audio API context instance
 * @type {AudioContext}
 */ const $a6e7484bf28693a9$export$a078c61943f9dbbe = new (typeof window !== "undefined" && (window.AudioContext || window.webkitAudioContext || window.mozAudioContext || window.oAudioContext || window.msAudioContext))();
/**
 * Sets a property on an object
 * @param {Object} o - The object
 * @param {string} k - The key
 * @param {*} v - The value
 * @returns {Object} The object
 */ const $a6e7484bf28693a9$export$adaa4cf7ef1b65be = (o, k, v)=>o[k] = v;
/**
 * Checks if a value is set (not undefined)
 * @param {*} v - The value to check
 * @returns {boolean} True if value is set
 */ const $a6e7484bf28693a9$export$6750766a7c7ec627 = (v)=>v !== undefined;
/**
 * Gets a value if it's set, otherwise returns null
 * @param {*} v - The value
 * @returns {*} The value or null
 */ const $a6e7484bf28693a9$export$6d699abd4274ded4 = (v)=>$a6e7484bf28693a9$export$6750766a7c7ec627(v) ? v : null;
/**
 * Applies properties from one object to another
 * @param {Object} o1 - Target object
 * @param {Object} o2 - Source object
 * @returns {Object} The target object
 */ const $a6e7484bf28693a9$var$apply = (o1, o2)=>Object.keys(o2).reduce((o, k)=>$a6e7484bf28693a9$export$adaa4cf7ef1b65be(o, k, o2[k]), o1);
/**
 * Creates a Web Audio API node
 * @param {string} type - Node type (oscillator, gain, biquadFilter, etc.)
 * @param {...*} args - Additional arguments for node creation
 * @returns {AudioNode} The created node
 */ const $a6e7484bf28693a9$export$185802fd694ee1f5 = (type, ...args)=>({
        oscillator: ()=>$a6e7484bf28693a9$export$a078c61943f9dbbe.createOscillator(...args),
        gain: ()=>$a6e7484bf28693a9$export$a078c61943f9dbbe.createGain(...args),
        biquadFilter: ()=>$a6e7484bf28693a9$export$a078c61943f9dbbe.createBiquadFilter(...args),
        convolver: ()=>$a6e7484bf28693a9$export$a078c61943f9dbbe.createConvolver(...args),
        buffer: ()=>$a6e7484bf28693a9$export$a078c61943f9dbbe.createBuffer(...args),
        bufferSource: ()=>$a6e7484bf28693a9$export$a078c61943f9dbbe.createBufferSource(...args)
    })[type]();
/**
 * Updates a node with new preferences
 * @param {AudioNode} node - The node to update
 * @param {Object} prefs - Preferences object
 * @returns {AudioNode} The updated node
 */ const $a6e7484bf28693a9$export$722fbec263ad908a = (node, prefs)=>$a6e7484bf28693a9$var$apply(node, prefs);
/**
 * Connects two audio nodes
 * @param {AudioNode} n1 - Source node
 * @param {AudioNode} n2 - Destination node
 * @returns {AudioNode} The source node
 */ const $a6e7484bf28693a9$export$64605811ab45167f = (n1, n2)=>(n1.connect(n2), n1);
/**
 * Disconnects two audio nodes
 * @param {AudioNode} n1 - Source node
 * @param {AudioNode} n2 - Destination node (optional, disconnects all if omitted)
 * @returns {AudioNode} The source node
 */ const $a6e7484bf28693a9$export$37dfea93db2e14ed = (n1, n2)=>{
    // since there is no way to determine if they are connected
    try {
        if (n2 !== undefined) n1.disconnect(n2);
        else n1.disconnect();
    } catch (err) {
        console.log(err);
    }
    return n1;
};
/**
 * Chains multiple audio nodes together
 * @param {...AudioNode} nodes - Nodes to chain
 * @returns {AudioNode} The first node
 */ const $a6e7484bf28693a9$export$e08e3b67e392101e = (...nodes)=>(nodes.forEach((n, i)=>$a6e7484bf28693a9$export$6750766a7c7ec627(nodes[i + 1]) && $a6e7484bf28693a9$export$64605811ab45167f(n, nodes[i + 1])), nodes[0]);
/**
 * Unchains multiple audio nodes
 * @param {...AudioNode} nodes - Nodes to unchain
 * @returns {AudioNode} The first node
 */ const $a6e7484bf28693a9$export$f9c86b1eb891c539 = (...nodes)=>(nodes.slice().reverse().forEach((n, i)=>$a6e7484bf28693a9$export$6750766a7c7ec627(nodes[i - 1]) && $a6e7484bf28693a9$export$37dfea93db2e14ed(nodes[i - 1], n)), nodes[0]);
/**
 * Converts seconds to sample duration
 * @param {number} seconds - Duration in seconds
 * @returns {number} Duration in samples
 */ const $a6e7484bf28693a9$export$1f34108aa9eb96ab = (seconds)=>$a6e7484bf28693a9$export$a078c61943f9dbbe.sampleRate * seconds;
/**
 * Gets channel data from an audio buffer
 * @param {AudioBuffer} node - The audio buffer
 * @param {...*} args - Additional arguments
 * @returns {Float32Array} Channel data
 */ const $a6e7484bf28693a9$export$fe30e442dba82fb5 = (node, ...args)=>node.getChannelData(...args);
/**
 * Schedules parameter changes on an audio node
 * @param {AudioNode} node - The audio node
 * @param {string} pref - Parameter name
 * @param {Array<number>} values - Array of values
 * @param {Array<number>} times - Array of times
 * @returns {void}
 */ const $a6e7484bf28693a9$export$60974f670aa8d75e = (node, pref, values, times)=>values.length === 1 ? node[pref].setValueAtTime(values[0], times[0]) : (node[pref].setValueCurveAtTime(new Float32Array(values.slice(0, 2)), times[0], times[1]), values.length > 2 && $a6e7484bf28693a9$export$60974f670aa8d75e(node, pref, values.slice(1), [
        times[0] + times[1]
    ].concat(times.slice(2))));

});

parcelRegister("4HJwV", function(module, exports) {

$parcel$export(module.exports, "create", () => $36ce7eec0176b992$export$185802fd694ee1f5);
$parcel$export(module.exports, "update", () => $36ce7eec0176b992$export$722fbec263ad908a);
/**
 * Reverb Effect
 * @module effects/reverb
 */ 
var $ekqew = parcelRequire("ekqew");
/**
 * Builds an impulse response buffer for reverb
 * @param {Object} params - Impulse parameters
 * @param {number} params.seconds - Duration of impulse in seconds
 * @param {number} params.decay - Decay factor
 * @returns {AudioBuffer} The impulse response buffer
 */ const $36ce7eec0176b992$var$buildImpulse = ({ seconds: seconds, decay: decay })=>{
    const impulse = (0, $ekqew.create)("buffer", 2, (0, $ekqew.duration)(seconds), (0, $ekqew.context).sampleRate);
    const channelData = [
        (0, $ekqew.chData)(impulse, 0),
        (0, $ekqew.chData)(impulse, 1)
    ];
    for(let i = 0; i < (0, $ekqew.duration)(seconds); i++){
        channelData[0][i] = (Math.random() * 2 - 1) * Math.pow(1 - i / (0, $ekqew.duration)(seconds), decay);
        channelData[1][i] = (Math.random() * 2 - 1) * Math.pow(1 - i / (0, $ekqew.duration)(seconds), decay);
    }
    return impulse;
};
/**
 * Creates a reverb effect node
 * @param {Object} prefs - Reverb preferences
 * @param {number} [prefs.seconds=3] - Reverb duration in seconds
 * @param {number} [prefs.decay=2] - Reverb decay factor
 * @param {number} [prefs.wet=0] - Wet signal level (0-1)
 * @param {number} [prefs.dry=1] - Dry signal level (0-1)
 * @returns {Object} Reverb node with input, output, effect (ConvolverNode), wet, and dry gain nodes
 */ const $36ce7eec0176b992$export$185802fd694ee1f5 = (prefs)=>[
        {
            prefs: Object.assign({
                seconds: 3,
                decay: 2,
                wet: 0,
                dry: 1
            }, prefs),
            input: (0, $ekqew.create)("gain"),
            output: (0, $ekqew.create)("gain"),
            effect: (0, $ekqew.create)("convolver"),
            wet: (0, $ekqew.create)("gain"),
            dry: (0, $ekqew.create)("gain")
        }
    ].map((n)=>((0, $ekqew.chain)(n.input, n.dry, n.output), (0, $ekqew.chain)(n.input, n.effect, n.wet, n.output), (0, $ekqew.set)(n.dry.gain, "value", n.prefs.dry), (0, $ekqew.set)(n.wet.gain, "value", n.prefs.wet), (0, $ekqew.set)(n.effect, "buffer", $36ce7eec0176b992$var$buildImpulse(n.prefs)), n)).pop();
/**
 * Updates reverb preferences
 * @param {Object} n - Reverb node
 * @param {Object} prefs - New preferences
 * @returns {Object} Updated reverb node
 */ const $36ce7eec0176b992$export$722fbec263ad908a = (n, prefs)=>((n.prefs.seconds !== prefs.seconds || n.prefs.decay !== prefs.decay) && (0, $ekqew.set)(n.effect, "buffer", $36ce7eec0176b992$var$buildImpulse(Object.assign({}, n.prefs, prefs))), n.prefs.dry !== prefs.dry && (0, $ekqew.set)(n.dry.gain, "value", prefs.dry), n.prefs.wet !== prefs.wet && (0, $ekqew.set)(n.wet.gain, "value", prefs.wet), (0, $ekqew.set)(n, "prefs", Object.assign({}, n.prefs, prefs)), n);

});

parcelRegister("kXaMP", function(module, exports) {

$parcel$export(module.exports, "create", () => $f411af568050b193$export$185802fd694ee1f5);
$parcel$export(module.exports, "update", () => $f411af568050b193$export$722fbec263ad908a);
$parcel$export(module.exports, "start", () => $f411af568050b193$export$b3571188c770cc5a);
/**
 * Low-Frequency Oscillator
 * @module effects/lfo
 */ 
var $ekqew = parcelRequire("ekqew");
/**
 * Creates a Low-Frequency Oscillator (LFO)
 * @param {Object} prefs - LFO preferences
 * @param {string} [prefs.type='sawtooth'] - Waveform type (sine, square, sawtooth, triangle)
 * @param {number} [prefs.frequency=5] - LFO frequency in Hz
 * @param {number} [prefs.gain=15] - LFO gain/amplitude
 * @returns {Object} LFO node with effect (OscillatorNode), output (GainNode), and prefs
 */ const $f411af568050b193$export$185802fd694ee1f5 = (prefs)=>[
        {
            prefs: Object.assign({
                type: "sawtooth",
                frequency: 5,
                gain: 15
            }, prefs),
            effect: (0, $ekqew.create)("oscillator"),
            output: (0, $ekqew.create)("gain")
        }
    ].map((n)=>((0, $ekqew.chain)(n.effect, n.output), (0, $ekqew.set)(n.effect.frequency, "value", n.prefs.frequency), (0, $ekqew.set)(n.output.gain, "value", n.prefs.gain), (0, $ekqew.set)(n.effect, "type", n.prefs.type), n)).pop();
/**
 * Updates LFO preferences
 * @param {Object} n - LFO node
 * @param {Object} prefs - New preferences
 * @returns {Object} Updated LFO node
 */ const $f411af568050b193$export$722fbec263ad908a = (n, prefs)=>((0, $ekqew.set)(n, "prefs", Object.assign({}, n.prefs, prefs)), (0, $ekqew.set)(n.effect.frequency, "value", n.prefs.frequency), (0, $ekqew.set)(n.output.gain, "value", n.prefs.gain), (0, $ekqew.set)(n.effect, "type", n.prefs.type), n);
/**
 * Starts the LFO oscillator
 * @param {Object} n - LFO node
 * @param {...*} args - Additional arguments (unused, for API consistency)
 * @returns {Object} The LFO node
 */ const $f411af568050b193$export$b3571188c770cc5a = (n, ...args)=>(n.effect.start(), n);

});

parcelRegister("9y3ap", function(module, exports) {

$parcel$export(module.exports, "create", () => $6f39bee75467f859$export$185802fd694ee1f5);
$parcel$export(module.exports, "update", () => $6f39bee75467f859$export$722fbec263ad908a);
$parcel$export(module.exports, "noteOn", () => $6f39bee75467f859$export$e03a6f121205184b);
$parcel$export(module.exports, "noteOff", () => $6f39bee75467f859$export$a6328a4d8d615e7a);
/**
 * ADSR Envelope Generator
 * @module controls/adsr
 */ 
var $ekqew = parcelRequire("ekqew");
/**
 * Creates an ADSR envelope generator
 * @param {Object} prefs - Envelope preferences
 * @param {number} [prefs.volume=0.41] - Maximum volume
 * @param {number} [prefs.attack=0.31] - Attack time in seconds
 * @param {number} [prefs.decay=0.16] - Decay time in seconds
 * @param {number} [prefs.sustain=0.8] - Sustain level (0-1)
 * @param {number} [prefs.release=0.21] - Release time in seconds
 * @returns {Object} ADSR node with through (GainNode) and prefs
 */ const $6f39bee75467f859$export$185802fd694ee1f5 = (prefs)=>[
        {
            prefs: Object.assign({
                volume: 0.41,
                attack: 0.31,
                decay: 0.16,
                sustain: 0.8,
                release: 0.21
            }, prefs),
            through: (0, $ekqew.create)("gain")
        }
    ].map((n)=>((0, $ekqew.set)(n.through.gain, "value", 0), n)).pop();
/**
 * Updates ADSR preferences
 * @param {Object} n - ADSR node
 * @param {Object} prefs - New preferences
 * @returns {Object} Updated ADSR node
 */ const $6f39bee75467f859$export$722fbec263ad908a = (n, prefs)=>((0, $ekqew.set)(n, "prefs", Object.assign({}, n.prefs, prefs)), n);
/**
 * Triggers note on (attack/decay/sustain phase)
 * @param {Object} node - ADSR node
 * @param {number} velocity - Note velocity (0-1)
 * @param {number} [time] - Start time (defaults to current time)
 * @returns {Object} The ADSR node
 */ const $6f39bee75467f859$export$e03a6f121205184b = (node, velocity, time)=>{
    const now = (0, $ekqew.context).currentTime;
    time = (time || now) + 0.0001;
    node.through.gain.cancelScheduledValues(0);
    const changes = [].concat(// attack
    node.prefs.attack > 0 ? [
        [
            0,
            time
        ],
        [
            velocity * node.prefs.volume,
            node.prefs.attack
        ]
    ] : [
        [
            velocity * node.prefs.volume,
            time
        ]
    ], // decay
    node.prefs.decay > 0 ? [
        [
            node.prefs.sustain * velocity * node.prefs.volume,
            node.prefs.decay
        ]
    ] : []).reduce((a, c)=>[
            [].concat(a[0], c[0]),
            [].concat(a[1], c[1])
        ], [
        [],
        []
    ]);
    (0, $ekqew.schedule)(node.through, "gain", changes[0], changes[1]);
    return node;
};
/**
 * Triggers note off (release phase)
 * @param {Object} node - ADSR node
 * @param {number} [time] - Release time (defaults to current time)
 * @returns {Object} The ADSR node
 */ const $6f39bee75467f859$export$a6328a4d8d615e7a = (node, time)=>{
    const now = (0, $ekqew.context).currentTime;
    time = time || now + 0.0001;
    setTimeout(()=>(node.through.gain.cancelScheduledValues(0), node.through.gain.setValueCurveAtTime(new Float32Array([
            node.through.gain.value,
            0
        ]), time, node.prefs.release > 0 && node.prefs.release || 0.00001)), (time - now) * 1000);
    return node;
};

});

parcelRegister("fbcJ7", function(module, exports) {

$parcel$export(module.exports, "create", () => $b0d1c15a14be5e55$export$185802fd694ee1f5);
$parcel$export(module.exports, "update", () => $b0d1c15a14be5e55$export$722fbec263ad908a);
$parcel$export(module.exports, "clone", () => $b0d1c15a14be5e55$export$9cd59f9826255e47);
/**
 * Audio Sampler
 * @module sources/sampler
 */ 
var $ekqew = parcelRequire("ekqew");
/**
 * Creates a sampler (audio sample player)
 * @param {string|null} file - URL to audio file (optional if buffer is provided)
 * @param {AudioBuffer|null} buffer - Pre-loaded audio buffer (optional if file is provided)
 * @param {Object} [prefs={}] - Sampler preferences
 * @param {number} [prefs.gain=0.7] - Output gain (0-1)
 * @returns {Object} Sampler node with source (AudioBufferSourceNode), output (GainNode), and prefs
 */ const $b0d1c15a14be5e55$export$185802fd694ee1f5 = (file, buffer, prefs = {})=>[
        {
            prefs: Object.assign({
                gain: 0.7
            }, prefs),
            source: (0, $ekqew.create)("bufferSource"),
            output: (0, $ekqew.create)("gain")
        }
    ].map((n)=>((0, $ekqew.chain)(n.source, n.output), (0, $ekqew.set)(n.output.gain, "value", n.prefs.gain), !buffer ? fetch(file).then((res)=>res.arrayBuffer()).then((buffer)=>(0, $ekqew.context).decodeAudioData(buffer, (buffer)=>(0, $ekqew.set)(n.source, "buffer", buffer))) : (0, $ekqew.set)(n.source, "buffer", buffer), n)).pop();
/**
 * Updates sampler preferences (placeholder for future implementation)
 * @param {Object} n - Sampler node
 * @param {Object} prefs - New preferences
 * @returns {Object} Updated sampler node
 */ const $b0d1c15a14be5e55$export$722fbec263ad908a = (n, prefs)=>{
    // TODO: Implement update logic
    return n;
};
/**
 * Clones a sampler instance with new preferences
 * @param {Object} n - Source sampler node
 * @param {Object} prefs - New preferences to merge
 * @returns {Object} New sampler node with cloned buffer
 */ const $b0d1c15a14be5e55$export$9cd59f9826255e47 = (n, prefs)=>$b0d1c15a14be5e55$export$185802fd694ee1f5(null, n.source.buffer, Object.assign({}, n.prefs, prefs));

});




parcelRegister("cLsUq", function(module, exports) {
"use strict";

var $jjnZg = parcelRequire("jjnZg");
var $94b04c946912fb92$require$obj = $jjnZg.obj;


const $94b04c946912fb92$var$synthInstrument = {
    ...(parcelRequire("1i5cH")).initial,
    source: (parcelRequire("1i5cH")).synthSource,
    sourceType: "synth"
};


const $94b04c946912fb92$var$samplerInstrument = {
    ...(parcelRequire("1i5cH")).initial,
    source: (parcelRequire("1i5cH")).samplerSource,
    sourceType: "sampler"
};



const $94b04c946912fb92$var$defValues = {
    pianoRoll: (parcelRequire("XfAip")).actions.initial,
    sequencer: (parcelRequire("iFU5r")).initial,
    instrument: (parcelRequire("1i5cH")).initial
};
const $94b04c946912fb92$var$initial = {
    title: "Untitled Piece",
    author: "Anonymous Author",
    bpm: 104,
    ticks: 128,
    selection: {
        instr: [
            1,
            0
        ],
        piano: [
            1,
            0
        ],
        seq: [
            0,
            0
        ]
    },
    rows: [
        {},
        {},
        {},
        {}
    ],
    active: [
        0,
        0,
        0,
        0
    ],
    tracks: [
        {
            name: "Drums",
            type: "seq",
            input: {
                device: -1,
                channel: 10
            },
            output: {
                device: -1,
                channel: 10
            },
            inst: $94b04c946912fb92$var$samplerInstrument,
            measures: [
                {
                    name: "Beat",
                    row: 0,
                    barsLength: 1,
                    loop: true,
                    pattern: [
                        [
                            [
                                1,
                                1,
                                0,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ],
                            [
                                1,
                                0,
                                1,
                                0,
                                1,
                                0,
                                1,
                                0,
                                1,
                                0,
                                1,
                                0,
                                1,
                                0,
                                1,
                                0
                            ],
                            [
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0
                            ]
                        ]
                    ]
                }
            ]
        },
        {
            name: "Bassline",
            input: {
                device: -1,
                channel: 1
            },
            output: {
                device: -1,
                channel: 1
            },
            inst: $94b04c946912fb92$var$synthInstrument,
            type: "piano",
            measures: [
                {
                    name: "Baseline",
                    row: 0,
                    barsLength: 1,
                    events: [
                        {
                            note: "C2",
                            // tick index
                            start: 0,
                            // in relation to ticks / tick = 1/16
                            duration: 1
                        },
                        {
                            note: "G2",
                            // tick index
                            start: 4,
                            // in relation to ticks / tick = 1/16
                            duration: 2
                        },
                        {
                            note: "C2",
                            // tick index
                            start: 7,
                            // in relation to ticks / tick = 1/16
                            duration: 1
                        },
                        {
                            note: "C2",
                            // tick index
                            start: 10,
                            // in relation to ticks / tick = 1/16
                            duration: 1
                        },
                        {
                            note: "G2",
                            // tick index
                            start: 12,
                            // in relation to ticks / tick = 1/16
                            duration: 2
                        },
                        {
                            note: "F#2",
                            // tick index
                            start: 14,
                            // in relation to ticks / tick = 1/16
                            duration: 1
                        }
                    ]
                }
            ]
        },
        {
            name: "Comp 1",
            type: "piano",
            inst: $94b04c946912fb92$var$synthInstrument,
            input: {
                device: -1,
                channel: 1
            },
            output: {
                device: -1,
                channel: 1
            },
            measures: []
        },
        {
            name: "Lead 1",
            type: "piano",
            inst: $94b04c946912fb92$var$synthInstrument,
            input: {
                device: -1,
                channel: 1
            },
            output: {
                device: -1,
                channel: 1
            },
            measures: []
        }
    ],
    arrangement: []
};
const $94b04c946912fb92$var$select = (trackNumber, measureRow)=>(state)=>{
        const track = state.session.tracks[trackNumber];
        const trackType = track.type;
        // Update selection for the track type (piano or seq)
        const updatedState = $94b04c946912fb92$require$obj.patch(state, [
            "session",
            "selection",
            trackType
        ], [
            trackNumber,
            measureRow
        ]);
        // Always update selection.instr (for instrument UI)
        const stateWithInstr = $94b04c946912fb92$require$obj.patch(updatedState, [
            "session",
            "selection",
            "instr"
        ], [
            trackNumber,
            measureRow
        ]);
        // Update sequencer or pianoRoll based on track type
        const trackInstrument = track.inst || $94b04c946912fb92$var$defValues.instrument;
        // Ensure effectsChain exists and is an array
        const instrument = Object.assign({}, trackInstrument, {
            effectsChain: (trackInstrument.effectsChain || $94b04c946912fb92$var$defValues.instrument.effectsChain || []).filter((e)=>e && e.type)
        });
        if (trackType === "seq") return Object.assign(stateWithInstr, {
            sequencer: Object.assign({}, track.measures[measureRow] || $94b04c946912fb92$var$defValues.sequencer),
            instrument: instrument
        });
        else // piano/synth track
        return Object.assign(stateWithInstr, {
            pianoRoll: Object.assign({}, track.measures[measureRow] || $94b04c946912fb92$var$defValues.pianoRoll),
            instrument: instrument
        });
    };
const $94b04c946912fb92$var$activate = (track, ch)=>(state)=>$94b04c946912fb92$require$obj.patch(state, [
            "session",
            "active"
        ], state.session.active.map((c, i)=>i === track ? ch : c));
const $94b04c946912fb92$var$updateTrackInput = (index, type, value)=>(state)=>$94b04c946912fb92$require$obj.patch(state, "session", {
            tracks: [].concat(state.session.tracks.slice(0, index), $94b04c946912fb92$require$obj.patch(state.session.tracks[index], "input", {
                [type]: value
            }), state.session.tracks.slice(index + 1))
        });
const $94b04c946912fb92$var$updateTrackOutput = (index, type, value)=>(state)=>$94b04c946912fb92$require$obj.patch(state, "session", {
            tracks: [].concat(state.session.tracks.slice(0, index), $94b04c946912fb92$require$obj.patch(state.session.tracks[index], "output", {
                [type]: value
            }), state.session.tracks.slice(index + 1))
        });
module.exports = {
    initial: $94b04c946912fb92$var$initial,
    select: $94b04c946912fb92$var$select,
    activate: $94b04c946912fb92$var$activate,
    updateTrackInput: $94b04c946912fb92$var$updateTrackInput,
    updateTrackOutput: $94b04c946912fb92$var$updateTrackOutput
};

});
parcelRegister("1i5cH", function(module, exports) {

$parcel$export(module.exports, "synthSource", () => $0f0b823bdb4ed0b4$export$7069ba844317bcb0);
$parcel$export(module.exports, "samplerSource", () => $0f0b823bdb4ed0b4$export$be8cdcfbde9733a8);
$parcel$export(module.exports, "initial", () => $0f0b823bdb4ed0b4$export$59ff82fc918bd7e3);
$parcel$export(module.exports, "default", () => $0f0b823bdb4ed0b4$export$2e2bcd8739ae039);

var $jjnZg = parcelRequire("jjnZg");

var $54T0Q = parcelRequire("54T0Q");
const $0f0b823bdb4ed0b4$export$7069ba844317bcb0 = {
    vco1: {
        on: true,
        type: "square",
        detune: -1
    },
    vco2: {
        on: true,
        type: "sawtooth",
        detune: 1
    },
    vcaOn: 1,
    vca1: {
        volume: 0.41,
        attack: 0,
        decay: 0.16,
        sustain: 0.8,
        release: 0.21
    },
    vca2: {
        volume: 0.43,
        attack: 0,
        decay: 0.16,
        sustain: 0.8,
        release: 0.19
    },
    chains: [
        [
            "vco1",
            "vca1"
        ],
        [
            "vco2",
            "vca2"
        ]
    ]
};
const $0f0b823bdb4ed0b4$export$be8cdcfbde9733a8 = {
    sampler: {
        file: "assets/samples/kick.wav",
        playing: false
    },
    vca: {
        volume: 0.4,
        attack: 0,
        decay: 0.16,
        sustain: 0.8,
        release: 0.21
    },
    chains: [
        [
            "sampler",
            "vca"
        ]
    ]
};
const $0f0b823bdb4ed0b4$export$e2e3e1fdb5231c14 = {
    vcf: {
        type: "vcf",
        on: true,
        expanded: true,
        cutoff: 0.64,
        resonance: 0,
        gain: 0
    },
    reverb: {
        type: "reverb",
        on: true,
        expanded: true,
        seconds: 3,
        decay: 2,
        reverse: false,
        dry: 0.8,
        wet: 0.3
    },
    lfo: {
        type: "lfo",
        on: false,
        expanded: false,
        lfoType: "sawtooth",
        frequency: 5,
        gain: 0.15
    },
    delay: {
        type: "delay",
        on: false,
        expanded: false,
        time: 1,
        dry: 1,
        wet: 0
    }
};
const $0f0b823bdb4ed0b4$export$59ff82fc918bd7e3 = {
    sourceType: "synth",
    // synth source prefs by default
    source: $0f0b823bdb4ed0b4$export$7069ba844317bcb0,
    // effects chain
    effectsChain: Object.values($0f0b823bdb4ed0b4$export$e2e3e1fdb5231c14).slice(0, 3).map((effect)=>({
            ...effect,
            id: (0, $54T0Q.default)()
        }))
};
/**
 * Immutably reorders an array by moving an item from one index to another.
 * @param {Array} arr - The source array
 * @param {number} from - The index of the item to move
 * @param {number} to - The index to move the item to
 * @returns {Array} A new array with the item moved
 * @example
 * reorder(['a', 'b', 'c', 'd', 'e'], 2, 1) // => ['a', 'c', 'b', 'd', 'e']
 * reorder(['a', 'b', 'c', 'd', 'e'], 1, 3) // => ['a', 'd', 'c', 'b', 'e']
 * reorder(['a', 'b', 'c', 'd', 'e'], 3, 3) // => ['a', 'b', 'c', 'd', 'e']
 */ const $0f0b823bdb4ed0b4$var$reorder = (arr, from, to)=>from === to ? arr : from > to ? [].concat(arr.slice(0, to), [
        arr[from]
    ], arr.slice(to + 1, from), [
        arr[to]
    ], arr.slice(from + 1)) : [].concat(arr.slice(0, from), [
        arr[to]
    ], arr.slice(from + 1, to), [
        arr[from]
    ], arr.slice(to + 1));
const $0f0b823bdb4ed0b4$var$updateProp = (index, prop, value)=>(state)=>(0, $jjnZg.obj).patch(state, [
            "instrument"
        ], {
            ...state.instrument,
            effectsChain: state.instrument.effectsChain.map((effect, i)=>i === index ? Object.assign({}, effect, {
                    [prop]: value
                }) : effect)
        });
const $0f0b823bdb4ed0b4$var$toggleExpanded = (index)=>(state)=>(0, $jjnZg.obj).patch(state, [
            "instrument"
        ], {
            ...state.instrument,
            effectsChain: state.instrument.effectsChain.map((effect, i)=>i === index ? Object.assign({}, effect, {
                    expanded: !effect.expanded
                }) : effect)
        });
const $0f0b823bdb4ed0b4$var$setVca = (index)=>(state)=>(0, $jjnZg.obj).patch(state, [
            "instrument",
            "vcaOn"
        ], index);
const $0f0b823bdb4ed0b4$var$applyPatch = (patch)=>(state)=>(0, $jjnZg.obj).patch(state, "instrument", patch);
// Effects chain actions
const $0f0b823bdb4ed0b4$var$addEffect = (type, config = {})=>(state)=>(0, $jjnZg.obj).patch(state, [
            "instrument",
            "effectsChain"
        ], [].concat(state.instrument.effectsChain, [
            {
                ...$0f0b823bdb4ed0b4$export$e2e3e1fdb5231c14[type] || {},
                ...config,
                id: (0, $54T0Q.default)()
            }
        ]));
const $0f0b823bdb4ed0b4$var$removeEffect = (index)=>(state)=>(0, $jjnZg.obj).patch(state, [
            "instrument",
            "effectsChain"
        ], state.instrument.effectsChain.filter((_, i)=>i !== index));
const $0f0b823bdb4ed0b4$var$reorderEffect = (fromIndex, toIndex)=>(state)=>(0, $jjnZg.obj).patch(state, [
            "instrument",
            "effectsChain"
        ], $0f0b823bdb4ed0b4$var$reorder(state.instrument.effectsChain, fromIndex, toIndex));
const $0f0b823bdb4ed0b4$var$updateEffect = (index, updates)=>(state)=>(0, $jjnZg.obj).patch(state, [
            "instrument",
            "effectsChain",
            index
        ], {
            ...state.instrument.effectsChain[index],
            ...updates
        });
var $0f0b823bdb4ed0b4$export$2e2bcd8739ae039 = {
    initial: $0f0b823bdb4ed0b4$export$59ff82fc918bd7e3,
    updateProp: $0f0b823bdb4ed0b4$var$updateProp,
    toggleExpanded: $0f0b823bdb4ed0b4$var$toggleExpanded,
    setVca: $0f0b823bdb4ed0b4$var$setVca,
    applyPatch: $0f0b823bdb4ed0b4$var$applyPatch,
    addEffect: $0f0b823bdb4ed0b4$var$addEffect,
    removeEffect: $0f0b823bdb4ed0b4$var$removeEffect,
    reorderEffect: $0f0b823bdb4ed0b4$var$reorderEffect,
    updateEffect: $0f0b823bdb4ed0b4$var$updateEffect
};

});
parcelRegister("54T0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b27ffd1474c9943$export$2e2bcd8739ae039);

var $gmjxl = parcelRequire("gmjxl");

var $bQtdI = parcelRequire("bQtdI");

var $kybAo = parcelRequire("kybAo");
function $3b27ffd1474c9943$var$v4(options, buf, offset) {
    if ((0, $gmjxl.default).randomUUID && !buf && !options) return (0, $gmjxl.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, $bQtdI.default))();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $kybAo.unsafeStringify)(rnds);
}
var $3b27ffd1474c9943$export$2e2bcd8739ae039 = $3b27ffd1474c9943$var$v4;

});
parcelRegister("gmjxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8ddaff0afe7b0c$export$2e2bcd8739ae039);
var $be8ddaff0afe7b0c$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $be8ddaff0afe7b0c$export$2e2bcd8739ae039 = {
    randomUUID: $be8ddaff0afe7b0c$var$randomUUID
};

});

parcelRegister("bQtdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $89fb378dddb2dbfb$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $89fb378dddb2dbfb$var$getRandomValues;
var $89fb378dddb2dbfb$var$rnds8 = new Uint8Array(16);
function $89fb378dddb2dbfb$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$89fb378dddb2dbfb$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $89fb378dddb2dbfb$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$89fb378dddb2dbfb$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $89fb378dddb2dbfb$var$getRandomValues($89fb378dddb2dbfb$var$rnds8);
}

});

parcelRegister("kybAo", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $ef5ff855a70f962e$export$8fb373d660548968);

var $a2Wgo = parcelRequire("a2Wgo");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $ef5ff855a70f962e$var$byteToHex = [];
for(var $ef5ff855a70f962e$var$i = 0; $ef5ff855a70f962e$var$i < 256; ++$ef5ff855a70f962e$var$i)$ef5ff855a70f962e$var$byteToHex.push(($ef5ff855a70f962e$var$i + 0x100).toString(16).slice(1));
function $ef5ff855a70f962e$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    //
    // Note to future-self: No, you can't remove the `toLowerCase()` call.
    // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
    return ($ef5ff855a70f962e$var$byteToHex[arr[offset + 0]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 1]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 2]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 3]] + "-" + $ef5ff855a70f962e$var$byteToHex[arr[offset + 4]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 5]] + "-" + $ef5ff855a70f962e$var$byteToHex[arr[offset + 6]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 7]] + "-" + $ef5ff855a70f962e$var$byteToHex[arr[offset + 8]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 9]] + "-" + $ef5ff855a70f962e$var$byteToHex[arr[offset + 10]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 11]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 12]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 13]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 14]] + $ef5ff855a70f962e$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $ef5ff855a70f962e$var$stringify(arr, offset = 0) {
    var uuid = $ef5ff855a70f962e$export$8fb373d660548968(arr, offset);
    // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $a2Wgo.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $ef5ff855a70f962e$export$2e2bcd8739ae039 = $ef5ff855a70f962e$var$stringify;

});
parcelRegister("a2Wgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $75074932cd075bf6$export$2e2bcd8739ae039);

var $bmi9N = parcelRequire("bmi9N");
function $75074932cd075bf6$var$validate(uuid) {
    return typeof uuid === "string" && (0, $bmi9N.default).test(uuid);
}
var $75074932cd075bf6$export$2e2bcd8739ae039 = $75074932cd075bf6$var$validate;

});
parcelRegister("bmi9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $844fd55f7b28bf75$export$2e2bcd8739ae039);
var $844fd55f7b28bf75$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});





parcelRegister("XfAip", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0b21998b337a3c6f$export$e324594224ef24da);
$parcel$export(module.exports, "default", () => $0b21998b337a3c6f$export$2e2bcd8739ae039);
// lib
// 3rd party

var $8QuAY = parcelRequire("8QuAY");
var $4BxWH = parcelRequire("4BxWH");

var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $6SBin = parcelRequire("6SBin");
var $9Jxex = parcelRequire("9Jxex");

var $54T0Q = parcelRequire("54T0Q");

var $jjnZg = parcelRequire("jjnZg");
parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
parcelRequire("50gi8");
var $ff1Wc = parcelRequire("ff1Wc");

var $kTQ8i = parcelRequire("kTQ8i");

var $czxgE = parcelRequire("czxgE");

var $gsDht = parcelRequire("gsDht");

var $46DUK = parcelRequire("46DUK");

var $8MxqK = parcelRequire("8MxqK");

var $3wnmS = parcelRequire("3wnmS");
// Actions
const $0b21998b337a3c6f$var$initial = {
    barsLength: 1,
    bar: 0,
    position: [
        0,
        60
    ],
    dim: [
        30,
        12
    ],
    tool: "pointer",
    selectionMode: "containsRect",
    interaction: {
        type: "idle",
        start: null,
        last: null,
        current: null,
        anchorEventUuid: null,
        anchorEventStart: null,
        originalEventPositions: null,
        creatingEvent: null // Event being created (for pencil tool) {uuid, note, start, duration, velocity}
    },
    selection: [],
    visible: [],
    events: []
};
/**
 * Prepares the time for the piano roll
 * @param {number} start - The start time
 * @param {number} end - The end time
 * @param {number} div - The division
 * @param {number} quantize - The quantize
 * @returns {number} The prepared time
 */ const $0b21998b337a3c6f$var$prepTime = (start, end, div, quantize = 0.25)=>Math.round((end - start) / div / quantize) * quantize;
/**
 * Clears the piano roll events
 */ const $0b21998b337a3c6f$var$clear = ()=>(state)=>(0, $jjnZg.obj).patch(state, [
            "pianoRoll",
            "events"
        ], []);
/**
 * Records the piano roll events
 * @param {Object} pressed - The pressed keys
 * @param {Object} tick - The tick
 * @param {number} currentTime - The current time
 * @returns {Object} The new state
 */ const $0b21998b337a3c6f$var$record = (pressed, tick, currentTime)=>(state)=>(0, $jjnZg.fn).pipe(()=>{
            const ch = state.session.selection.piano[0];
            const trackTick = tick.tracks[ch] || tick;
            const beatIndex = trackTick.index ?? tick.index ?? 0;
            const bar = trackTick.bar ?? tick.bar ?? 0;
            const barStart = bar * state.studio.beatLength;
            const barsLength = state.pianoRoll.barsLength;
            let timeOffset = 0;
            if (state.studio.playing && state.studio.startTime != null) {
                const progress = (0, $gsDht.calculateProgress)(state.studio.startTime, currentTime, state.studio.cycleOffset, state.studio.bpm, state.studio.beatLength, (0, $46DUK.MODIFIER));
                timeOffset = (0, $46DUK.stepTimeOffset)(progress, state.studio.beatLength);
            } else timeOffset = $0b21998b337a3c6f$var$prepTime(tick.time, currentTime, (0, $gsDht.bpmToTime)(state.studio.bpm));
            return {
                timeOffset: timeOffset,
                barStart: barStart,
                beatIndex: beatIndex,
                barsLength: barsLength,
                bar: bar
            };
        }, ({ timeOffset: timeOffset, barStart: barStart, beatIndex: beatIndex, barsLength: barsLength, bar: bar })=>(0, $jjnZg.obj).patch(state, "pianoRoll", {
                events: [].concat(// already recorded events
                state.pianoRoll.events.filter((ev)=>ev.duration > 0), // still pressed
                state.pianoRoll.events.filter((ev)=>ev.duration === 0 && ev.startTime <= currentTime && pressed[ev.note]), // unpressed
                state.pianoRoll.events.filter((ev)=>ev.duration === 0 && ev.startTime <= currentTime && !pressed[ev.note]).map((ev)=>Object.assign(ev, {
                        duration: $0b21998b337a3c6f$var$prepTime(ev.startTime, currentTime, (0, $gsDht.bpmToTime)(state.studio.bpm))
                    })), // new
                Object.keys(pressed).filter((key)=>state.pianoRoll.events.filter((ev)=>ev.note === key && ev.startTime <= currentTime && ev.duration === 0).length === 0).map((note)=>({
                        note: note,
                        start: beatIndex === state.studio.beatLength - 1 && timeOffset > 0.95 ? bar < barsLength - 1 ? barStart + state.studio.beatLength : 0 : barStart + beatIndex + timeOffset,
                        velocity: pressed[note],
                        duration: 0,
                        startTime: currentTime,
                        uuid: (0, $54T0Q.default)()
                    })))
            }))();
/**
 * Handles the pointer down event
 * @param {Object} {x, y} - The pointer coordinates
 * @returns {Object} The new state
 */ const $0b21998b337a3c6f$var$pointerDown = ({ x: x, y: y })=>(state)=>{
        const { interaction: interaction, tool: tool, visible: visible, selection: selection, dim: dim, position: position } = state.pianoRoll;
        // Eraser tool: delete event at click position
        if (tool === "eraser") {
            const clickedEvent = (0, $3wnmS.findEventAtPosition)(visible, {
                x: x,
                y: y
            });
            if (clickedEvent) {
                // Remove event from events array
                const updatedEvents = state.pianoRoll.events.filter((e)=>e.uuid !== clickedEvent.uuid);
                // Remove from selection if it was selected
                const updatedSelection = selection.filter((uuid)=>uuid !== clickedEvent.uuid);
                return (0, $czxgE.patch)(state, "pianoRoll", {
                    events: updatedEvents,
                    selection: updatedSelection,
                    interaction: {
                        ...$0b21998b337a3c6f$var$initial.interaction
                    }
                });
            }
            // If no event found, do nothing
            return state;
        }
        // Pencil tool: create event at click position (if empty space)
        if (tool === "pen" || tool === "pencil") {
            // Check if clicking on existing event - if so, don't create
            const clickedEvent = (0, $3wnmS.findEventAtPosition)(visible, {
                x: x,
                y: y
            });
            if (clickedEvent) // Clicking on existing event in pencil mode - do nothing (or could select it)
            return state;
            // Convert pixel coordinates to grid position
            const bar = state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar || 0;
            const beatLength = state.studio.beatLength;
            const gridPos = (0, $8MxqK.pixelToGrid)(x, y, dim, position, bar, beatLength);
            // Create initial event with default duration (1 grid step)
            const newEvent = {
                uuid: (0, $54T0Q.default)(),
                note: gridPos.note,
                start: gridPos.time,
                duration: 1,
                velocity: 0.8,
                startTime: 0 // Not needed for manual creation
            };
            return (0, $czxgE.patch)(state, "pianoRoll", {
                interaction: {
                    ...interaction,
                    start: {
                        x: x,
                        y: y
                    },
                    current: {
                        x: x,
                        y: y
                    },
                    last: {
                        x: x,
                        y: y
                    },
                    type: "creating",
                    creatingEvent: newEvent
                }
            });
        }
        // Pointer tool: check if clicking on a selected event (for moving)
        if (tool === "pointer" && selection.length > 0) {
            const clickedEvent = (0, $3wnmS.findEventAtPosition)(visible, {
                x: x,
                y: y
            });
            if (clickedEvent && selection.indexOf(clickedEvent.uuid) > -1) {
                // Check if not near edge (for Phase 3 - resizing)
                // For now, assume any click on selected event starts moving
                const edgeThreshold = 5; // pixels from edge
                const { rect: rect } = clickedEvent;
                const nearLeftEdge = Math.abs(x - rect.x) < edgeThreshold;
                const nearRightEdge = Math.abs(x - (rect.x + rect.width)) < edgeThreshold;
                // If not near edge, start moving
                if (!nearLeftEdge && !nearRightEdge) {
                    // Find the anchor event in the events array to get its original start position
                    const anchorEvent = state.pianoRoll.events.find((e)=>e.uuid === clickedEvent.uuid);
                    // Store original positions for all selected events to avoid accumulation during drag
                    const originalEventPositions = state.pianoRoll.events.filter((e)=>selection.indexOf(e.uuid) > -1).reduce((acc, event)=>{
                        acc[event.uuid] = {
                            start: event.start,
                            note: event.note
                        };
                        return acc;
                    }, {});
                    return (0, $czxgE.patch)(state, "pianoRoll", {
                        interaction: {
                            ...interaction,
                            start: {
                                x: x,
                                y: y
                            },
                            current: {
                                x: x,
                                y: y
                            },
                            last: {
                                x: x,
                                y: y
                            },
                            type: "moving",
                            anchorEventUuid: clickedEvent.uuid,
                            anchorEventStart: anchorEvent ? anchorEvent.start : null,
                            originalEventPositions: originalEventPositions // Store all selected events' original positions
                        }
                    });
                }
            }
        }
        // Default: selecting or idle
        return (0, $czxgE.patch)(state, "pianoRoll", {
            interaction: {
                ...interaction,
                start: {
                    x: x,
                    y: y
                },
                current: {
                    x: x,
                    y: y
                },
                last: {
                    x: x,
                    y: y
                },
                type: tool === "pointer" ? "selecting" : "idle"
            }
        });
    };
/**
 * Handles the pointer move event
 * @param {Object} {x, y} - The pointer coordinates
 * @returns {Object} The new state
 */ const $0b21998b337a3c6f$var$pointerMove = ({ x: x, y: y })=>(state)=>{
        if (state.pianoRoll.interaction.type === "idle") return state;
        const { interaction: interaction, dim: dim, selection: selection, events: events, position: position } = state.pianoRoll;
        if (interaction.type === "creating") {
            // Calculate duration based on drag distance
            if (!interaction.creatingEvent || !interaction.start) return state;
            // Convert current position to grid
            const bar = state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar || 0;
            const beatLength = state.studio.beatLength;
            const startGridPos = (0, $8MxqK.pixelToGrid)(interaction.start.x, interaction.start.y, dim, position, bar, beatLength);
            const currentGridPos = (0, $8MxqK.pixelToGrid)(x, y, dim, position, bar, beatLength);
            // Calculate duration in grid steps (minimum 1)
            const duration = Math.max(1, currentGridPos.gridX - startGridPos.gridX + 1);
            // Update the creating event with new duration
            const updatedCreatingEvent = {
                ...interaction.creatingEvent,
                duration: duration
            };
            return (0, $czxgE.patch)(state, "pianoRoll", {
                interaction: {
                    ...interaction,
                    current: {
                        x: x,
                        y: y
                    },
                    last: {
                        x: x,
                        y: y
                    },
                    creatingEvent: updatedCreatingEvent
                }
            });
        }
        if (interaction.type === "moving") {
            // Calculate total movement from start position (not incremental)
            const totalDeltaX = x - interaction.start.x;
            const totalDeltaY = y - interaction.start.y;
            // Convert total delta to grid steps
            const totalGridDeltaX = totalDeltaX / dim[0];
            const totalGridDeltaY = totalDeltaY / dim[1];
            // Find the anchor event (the one being dragged)
            const anchorEvent = events.find((e)=>e.uuid === interaction.anchorEventUuid);
            if (!anchorEvent || selection.indexOf(anchorEvent.uuid) === -1) {
                // Fallback to old behavior if anchor not found
                const gridDeltaX = Math.round(totalGridDeltaX);
                const gridDeltaY = Math.round(totalGridDeltaY);
                const updatedEvents = events.map((event)=>{
                    if (selection.indexOf(event.uuid) === -1) return event;
                    const newStart = Math.round(event.start + gridDeltaX);
                    const newNoteNumber = (0, $kTQ8i.noteToNumber)(event.note) - gridDeltaY;
                    const newNoteObj = (0, $kTQ8i.numberToNote)(newNoteNumber);
                    const newNote = `${newNoteObj.key}${newNoteObj.octave}`;
                    return {
                        ...event,
                        start: newStart,
                        note: newNote
                    };
                });
                const snapped = (0, $8MxqK.snapToGrid)(x, y, dim[0], dim[1]);
                return (0, $jjnZg.obj).patch(state, "pianoRoll", {
                    events: updatedEvents,
                    interaction: {
                        ...interaction,
                        current: {
                            x: x,
                            y: y
                        },
                        last: snapped
                    }
                });
            }
            // Get anchor's original position from when drag started (use stored original, not current event)
            const originalPositions = interaction.originalEventPositions || {};
            const anchorOriginalPos = originalPositions[interaction.anchorEventUuid];
            const anchorOriginalStart = anchorOriginalPos ? anchorOriginalPos.start : interaction.anchorEventStart !== null ? interaction.anchorEventStart : anchorEvent.start;
            const anchorOriginalNote = anchorOriginalPos ? anchorOriginalPos.note : anchorEvent.note;
            const anchorOriginalNoteNumber = (0, $kTQ8i.noteToNumber)(anchorOriginalNote);
            // Calculate the intended movement in grid steps (round to nearest integer for snapping)
            const roundedGridDeltaX = Math.round(totalGridDeltaX);
            const roundedGridDeltaY = Math.round(totalGridDeltaY);
            // Calculate the new position after movement
            const newAnchorStart = anchorOriginalStart + roundedGridDeltaX;
            const newAnchorNoteNumber = anchorOriginalNoteNumber - roundedGridDeltaY;
            // Snap the anchor to the nearest integer grid position
            const snappedAnchorStart = Math.round(newAnchorStart);
            const snappedAnchorNoteNumber = Math.round(newAnchorNoteNumber);
            const snappedAnchorNoteObj = (0, $kTQ8i.numberToNote)(snappedAnchorNoteNumber);
            const snappedAnchorNote = `${snappedAnchorNoteObj.key}${snappedAnchorNoteObj.octave}`;
            // Calculate the anchor's actual movement delta (snapped position - original position)
            // This preserves exact relative positions between events
            // Note: Events that were at integer positions may become non-integer if the delta is non-integer
            // Only the anchor event is guaranteed to be at an integer position after snapping
            const anchorDeltaStart = snappedAnchorStart - anchorOriginalStart;
            const anchorDeltaNoteNumber = snappedAnchorNoteNumber - anchorOriginalNoteNumber;
            // Update all selected events by applying the anchor's movement delta to their original positions
            const updatedEvents = events.map((event)=>{
                if (selection.indexOf(event.uuid) === -1) return event;
                // Special case: anchor event always snaps to grid (integer)
                if (event.uuid === interaction.anchorEventUuid) return {
                    ...event,
                    start: snappedAnchorStart,
                    note: snappedAnchorNote
                };
                // For other events: use original position + anchor's movement delta
                const originalPos = originalPositions[event.uuid];
                if (originalPos) {
                    const newStart = originalPos.start + anchorDeltaStart;
                    const newNoteNumber = (0, $kTQ8i.noteToNumber)(originalPos.note) + anchorDeltaNoteNumber;
                    const newNoteObj = (0, $kTQ8i.numberToNote)(newNoteNumber);
                    const newNote = `${newNoteObj.key}${newNoteObj.octave}`;
                    return {
                        ...event,
                        start: newStart,
                        note: newNote
                    };
                }
                // Fallback: if original position not stored, use current position + delta
                const newStart = event.start + anchorDeltaStart;
                const newNoteNumber = (0, $kTQ8i.noteToNumber)(event.note) + anchorDeltaNoteNumber;
                const newNoteObj = (0, $kTQ8i.numberToNote)(newNoteNumber);
                const newNote = `${newNoteObj.key}${newNoteObj.octave}`;
                return {
                    ...event,
                    start: newStart,
                    note: newNote
                };
            });
            // Snap last position to grid
            const snapped = (0, $8MxqK.snapToGrid)(x, y, dim[0], dim[1]);
            return (0, $jjnZg.obj).patch(state, "pianoRoll", {
                events: updatedEvents,
                interaction: {
                    ...interaction,
                    current: {
                        x: x,
                        y: y
                    },
                    last: snapped
                }
            });
        }
        // For other interaction types (selecting), just update position
        return (0, $czxgE.patch)(state, "pianoRoll", {
            interaction: {
                ...interaction,
                current: {
                    x: x,
                    y: y
                },
                last: interaction.current
            }
        });
    };
/**
 * Handles the pointer up event
 * @param {Object} {x, y} - The pointer coordinates
 * @returns {Object} The new state
 */ const $0b21998b337a3c6f$var$pointerUp = ({ x: x, y: y })=>(state)=>{
        if (state.pianoRoll.interaction.type === "idle") return state;
        const { interaction: interaction, visible: visible, selectionMode: selectionMode } = state.pianoRoll;
        // Check if this was a click (no drag) or a drag
        const wasClick = interaction.start && Math.abs(interaction.start.x - x) < 5 && Math.abs(interaction.start.y - y) < 5;
        if (interaction.type === "selecting") {
            if (wasClick) {
                // Single click selection
                const clickedEvent = (0, $3wnmS.findEventAtPosition)(visible, {
                    x: x,
                    y: y
                });
                if (clickedEvent) // Select the clicked event
                return (0, $jjnZg.obj).patch(state, "pianoRoll", {
                    interaction: {
                        ...$0b21998b337a3c6f$var$initial.interaction
                    },
                    selection: [
                        clickedEvent.uuid
                    ]
                });
                else // Deselect if clicking empty space
                return (0, $jjnZg.obj).patch(state, "pianoRoll", {
                    interaction: {
                        ...$0b21998b337a3c6f$var$initial.interaction
                    },
                    selection: []
                });
            } else {
                // Finalize selection from drag
                const selectionRect = (0, $3wnmS.computeSelectionRect)(interaction.start, {
                    x: x,
                    y: y
                });
                const selection = (0, $3wnmS.computeSelection)(visible, selectionRect, selectionMode);
                return (0, $jjnZg.obj).patch(state, "pianoRoll", {
                    interaction: {
                        ...$0b21998b337a3c6f$var$initial.interaction
                    },
                    selection: selection
                });
            }
        }
        if (interaction.type === "creating") {
            // Finalize creation - add event to events array
            if (!interaction.creatingEvent) return (0, $jjnZg.obj).patch(state, "pianoRoll", {
                interaction: {
                    ...$0b21998b337a3c6f$var$initial.interaction
                }
            });
            // Add the created event to the events array
            const updatedEvents = [
                ...state.pianoRoll.events,
                interaction.creatingEvent
            ];
            // Optionally select the newly created event
            const newSelection = [
                interaction.creatingEvent.uuid
            ];
            return (0, $jjnZg.obj).patch(state, "pianoRoll", {
                events: updatedEvents,
                selection: newSelection,
                interaction: {
                    ...$0b21998b337a3c6f$var$initial.interaction
                }
            });
        }
        if (interaction.type === "moving") // Finalize movement - events are already updated in pointerMove
        // Just reset interaction state
        return (0, $jjnZg.obj).patch(state, "pianoRoll", {
            interaction: {
                ...$0b21998b337a3c6f$var$initial.interaction
            }
        });
        // For other interaction types, just reset
        return (0, $jjnZg.obj).patch(state, "pianoRoll", {
            interaction: {
                ...$0b21998b337a3c6f$var$initial.interaction
            }
        });
    };
const $0b21998b337a3c6f$export$e324594224ef24da = {
    initial: $0b21998b337a3c6f$var$initial,
    clear: $0b21998b337a3c6f$var$clear,
    record: $0b21998b337a3c6f$var$record,
    pointerDown: $0b21998b337a3c6f$var$pointerDown,
    pointerMove: $0b21998b337a3c6f$var$pointerMove,
    pointerUp: $0b21998b337a3c6f$var$pointerUp
};
// const notesPattern = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
// collect midi pressed keys
const $0b21998b337a3c6f$var$prepPressed = (channels, track)=>track.input.device > -1 ? channels[track.input.device] && channels[track.input.device][track.input.channel] || {} : Object.keys(channels).reduce((cn, d)=>Object.keys(channels[d][track.input.channel] || {}).reduce((cn, note)=>(0, $jjnZg.obj).patch(cn, note, channels[d][track.input.channel][note] || cn[note]), cn), {});
let $0b21998b337a3c6f$var$subs = [];
const $0b21998b337a3c6f$export$1062a250c78723ea = ({ state$: state$, actions: actions })=>{
    $0b21998b337a3c6f$var$subs = [];
    // Ensure pianoRoll html els exist before drawing
    const pianoRollEl$ = (0, $4BxWH.interval)(500 /* ms */ ).pipe((0, $6SBin.map)(()=>document.querySelector(".piano-roll")), (0, $glUu6.distinctUntilChanged)((prev, curr)=>prev === curr), (0, $lm9of.filter)((el)=>el), (0, $6SBin.map)((el)=>({
            grid: el.querySelector(".piano-roll .grid"),
            events: el.querySelector(".piano-roll .events"),
            interaction: el.querySelector(".piano-roll .interaction")
        })));
    // on grid changes redraw grid
    $0b21998b337a3c6f$var$subs.push((0, $8QuAY.combineLatest)([
        state$.pipe((0, $glUu6.distinctUntilChanged)((prev, curr)=>{
            const prevPos = prev.pianoRoll.position;
            const currPos = curr.pianoRoll.position;
            return JSON.stringify(prevPos) === JSON.stringify(currPos);
        })),
        pianoRollEl$
    ]).pipe((0, $6SBin.map)(([state, el])=>({
            state: state,
            el: el
        }))).subscribe(({ el: el, state: state })=>{
        const gridCtx = el.grid.getContext("2d");
        const dim = [
            30,
            12
        ];
        (0, $8MxqK.drawGrid)(gridCtx, dim, state.pianoRoll.position);
    }));
    // on event changes update event canvas
    $0b21998b337a3c6f$var$subs.push(state$.pipe((0, $glUu6.distinctUntilChanged)((prev, curr)=>{
        const prevKey = JSON.stringify(prev.pianoRoll.position) + JSON.stringify(prev.studio.tick.tracks[prev.session.selection.piano[0]].bar) + JSON.stringify(prev.pianoRoll.events) + JSON.stringify(prev.pianoRoll.selection);
        const currKey = JSON.stringify(curr.pianoRoll.position) + JSON.stringify(curr.studio.tick.tracks[curr.session.selection.piano[0]].bar) + JSON.stringify(curr.pianoRoll.events) + JSON.stringify(curr.pianoRoll.selection);
        return prevKey === currKey;
    }), (0, $9Jxex.withLatestFrom)(pianoRollEl$), (0, $6SBin.map)(([state, el])=>({
            state: state,
            el: el
        }))).subscribe(({ el: el, state: state })=>{
        const eventsCtx = el.events.getContext("2d");
        const dim = [
            30,
            12
        ];
        // slice of the current visible bar
        const bar = {
            start: state.studio.beatLength * (state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar || 0),
            end: state.studio.beatLength * (state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar + 1 || 1)
        };
        // collect events for the current bar
        const events = state.pianoRoll.events.filter((event)=>event.start >= bar.start && event.start < bar.end);
        const pos = state.pianoRoll.position;
        const rowCount = parseInt(eventsCtx.canvas.height / dim[1], 10);
        const selection = state.pianoRoll.selection;
        const visible = events.filter((event)=>(0, $kTQ8i.noteToNumber)(event.note) <= pos[1] && (0, $kTQ8i.noteToNumber)(event.note) > pos[1] - rowCount).map((event)=>({
                uuid: event.uuid,
                rect: {
                    x: (event.start - bar.start + 1) * dim[0],
                    y: (pos[1] - (0, $kTQ8i.noteToNumber)(event.note)) * dim[1],
                    width: event.duration * dim[0],
                    height: dim[1]
                }
            }));
        // Update visible array - always update when events change (positions, rects, etc.)
        // The distinctUntilChanged above already ensures we only run when events/position/bar change
        // So we should always update the visible array here to reflect current positions
        actions.set("pianoRoll", {
            visible: visible
        });
        // Always render with current selection from state (even if visible didn't change)
        // This ensures selection changes are immediately reflected
        console.log("pianoRoll.events - drawing with selection:", selection, "visible:", visible.map((v)=>v.uuid));
        (0, $8MxqK.drawEvents)(eventsCtx, visible, selection, dim, bar, state.pianoRoll.position);
    }));
    // process interraction 
    $0b21998b337a3c6f$var$subs.push(state$.pipe((0, $glUu6.distinctUntilChanged)((prev, curr)=>{
        return JSON.stringify(prev.pianoRoll.interaction) === JSON.stringify(curr.pianoRoll.interaction);
    }), (0, $9Jxex.withLatestFrom)(pianoRollEl$), (0, $6SBin.map)(([state, el])=>({
            state: state,
            el: el
        }))).subscribe(({ state: state, el: el })=>{
        const ctx = el.interaction.getContext("2d");
        const { interaction: interaction, selectionMode: selectionMode } = state.pianoRoll;
        console.log(interaction);
        (0, $8MxqK.prepCanvas)(ctx);
        if (interaction.type === "selecting" && interaction.start && interaction.current) {
            // Compute visible events on the fly to ensure we have the latest
            const eventsCtx = el.events.getContext("2d");
            const dim = [
                30,
                12
            ];
            const bar = {
                start: state.studio.beatLength * (state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar || 0),
                end: state.studio.beatLength * (state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar + 1 || 1)
            };
            const events = state.pianoRoll.events.filter((event)=>event.start >= bar.start && event.start < bar.end);
            const pos = state.pianoRoll.position;
            const rowCount = parseInt(eventsCtx.canvas.height / dim[1], 10);
            const visible = events.filter((event)=>(0, $kTQ8i.noteToNumber)(event.note) <= pos[1] && (0, $kTQ8i.noteToNumber)(event.note) > pos[1] - rowCount).map((event)=>({
                    uuid: event.uuid,
                    rect: {
                        x: (event.start - bar.start + 1) * dim[0],
                        y: (pos[1] - (0, $kTQ8i.noteToNumber)(event.note)) * dim[1],
                        width: event.duration * dim[0],
                        height: dim[1]
                    }
                }));
            const selectionRect = (0, $3wnmS.computeSelectionRect)(interaction.start, interaction.current);
            const selection = (0, $3wnmS.computeSelection)(visible, selectionRect, selectionMode);
            console.log("[Interaction] Live selection during drag:", selection);
            // Don't set selection here - it will be set in pointerUp
            // This is just for visual feedback during drag
            (0, $ff1Wc).rect(ctx, selectionRect, null, "#fff", [
                10,
                10
            ]);
        }
        if (interaction.type === "creating" && interaction.creatingEvent && interaction.start) {
            // Draw preview of the event being created
            const eventsCtx = el.events.getContext("2d");
            const dim = [
                30,
                12
            ];
            const bar = {
                start: state.studio.beatLength * (state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar || 0),
                end: state.studio.beatLength * (state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar + 1 || 1)
            };
            const pos = state.pianoRoll.position;
            const noteNumber = (0, $kTQ8i.noteToNumber)(interaction.creatingEvent.note);
            const gridY = pos[1] - noteNumber;
            const gridX = interaction.creatingEvent.start - bar.start;
            const previewRect = {
                x: (gridX + 1) * dim[0],
                y: gridY * dim[1],
                width: interaction.creatingEvent.duration * dim[0],
                height: dim[1]
            };
            // Draw preview on interaction canvas (semi-transparent)
            (0, $ff1Wc).rect(ctx, previewRect, "rgba(200, 200, 255, 0.5)", "rgba(100, 100, 200, 0.8)", [
                5,
                5
            ]);
        }
    }));
    // record action
    $0b21998b337a3c6f$var$subs.push(state$.pipe((0, $glUu6.distinctUntilChanged)((prev, curr)=>{
        return JSON.stringify(prev.midiMap.channels) === JSON.stringify(curr.midiMap.channels);
    }), (0, $lm9of.filter)((state)=>state.studio.recording), (0, $6SBin.map)((state)=>({
            state: state,
            pressed: $0b21998b337a3c6f$var$prepPressed(state.midiMap.channels, state.session.tracks[state.session.selection.piano[0]])
        }))).subscribe(({ state: state, pressed: pressed })=>{
        const tick = (0, $46DUK.derivePosition)(state.studio, state.sequencer, state.session, $ekqew.context.currentTime);
        actions.pianoRoll.record(pressed, tick, $ekqew.context.currentTime);
    }));
};
let $0b21998b337a3c6f$export$762f7ab90da36b1a = ()=>$0b21998b337a3c6f$var$subs.forEach((sub)=>sub.unsubscribe());
var $0b21998b337a3c6f$export$2e2bcd8739ae039 = {
    actions: $0b21998b337a3c6f$export$e324594224ef24da,
    hook: $0b21998b337a3c6f$export$1062a250c78723ea,
    unhook: $0b21998b337a3c6f$export$762f7ab90da36b1a
};

});
parcelRegister("8QuAY", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $670ae9a6a329b92a$export$77fa7d86f5204e8a);
$parcel$export(module.exports, "combineLatestInit", () => $670ae9a6a329b92a$export$f04dcfb475ed2128);

var $gN3J6 = parcelRequire("gN3J6");

var $aIbzv = parcelRequire("aIbzv");

var $aIPjU = parcelRequire("aIPjU");

var $hYEnO = parcelRequire("hYEnO");

var $hYp6u = parcelRequire("hYp6u");

var $6kN4i = parcelRequire("6kN4i");

var $9D757 = parcelRequire("9D757");

var $lo1Ce = parcelRequire("lo1Ce");

var $aj4TV = parcelRequire("aj4TV");
function $670ae9a6a329b92a$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(args);
    var resultSelector = (0, $6kN4i.popResultSelector)(args);
    var _a = (0, $aIbzv.argsArgArrayOrObject)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $aIPjU.from)([], scheduler);
    var result = new (0, $gN3J6.Observable)($670ae9a6a329b92a$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $9D757.createObject)(keys, values);
    } : (0, $hYEnO.identity)));
    return resultSelector ? result.pipe((0, $hYp6u.mapOneOrManyArgs)(resultSelector)) : result;
}
function $670ae9a6a329b92a$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $hYEnO.identity);
    return function(subscriber) {
        $670ae9a6a329b92a$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $670ae9a6a329b92a$var$maybeSchedule(scheduler, function() {
                    var source = (0, $aIPjU.from)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $670ae9a6a329b92a$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $aj4TV.executeSchedule)(subscription, scheduler, execute);
    else execute();
}

});
parcelRegister("aIbzv", function(module, exports) {

$parcel$export(module.exports, "argsArgArrayOrObject", () => $7cc6fd59da393ab4$export$8871b3799a14360f);
var $7cc6fd59da393ab4$var$isArray = Array.isArray;
var $7cc6fd59da393ab4$var$getPrototypeOf = Object.getPrototypeOf, $7cc6fd59da393ab4$var$objectProto = Object.prototype, $7cc6fd59da393ab4$var$getKeys = Object.keys;
function $7cc6fd59da393ab4$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($7cc6fd59da393ab4$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($7cc6fd59da393ab4$var$isPOJO(first_1)) {
            var keys = $7cc6fd59da393ab4$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $7cc6fd59da393ab4$var$isPOJO(obj) {
    return obj && typeof obj === "object" && $7cc6fd59da393ab4$var$getPrototypeOf(obj) === $7cc6fd59da393ab4$var$objectProto;
}

});

parcelRegister("aIPjU", function(module, exports) {

$parcel$export(module.exports, "from", () => $7ce5d289b5184c6b$export$6788812c4e6611e6);

var $dKd2f = parcelRequire("dKd2f");

var $kA4PZ = parcelRequire("kA4PZ");
function $7ce5d289b5184c6b$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $dKd2f.scheduled)(input, scheduler) : (0, $kA4PZ.innerFrom)(input);
}

});
parcelRegister("dKd2f", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $a019aecb764db494$export$49c44dfc2bb21d70);

var $9r8N2 = parcelRequire("9r8N2");

var $74NcO = parcelRequire("74NcO");

var $8ggmu = parcelRequire("8ggmu");

var $b9aB1 = parcelRequire("b9aB1");

var $hyfii = parcelRequire("hyfii");

var $5THWY = parcelRequire("5THWY");

var $3kIRy = parcelRequire("3kIRy");

var $deWbE = parcelRequire("deWbE");

var $k5iK4 = parcelRequire("k5iK4");

var $7EGUs = parcelRequire("7EGUs");

var $eNbzY = parcelRequire("eNbzY");

var $Xuqb1 = parcelRequire("Xuqb1");

var $iXq3J = parcelRequire("iXq3J");
function $a019aecb764db494$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $5THWY.isInteropObservable)(input)) return (0, $9r8N2.scheduleObservable)(input, scheduler);
        if ((0, $deWbE.isArrayLike)(input)) return (0, $8ggmu.scheduleArray)(input, scheduler);
        if ((0, $3kIRy.isPromise)(input)) return (0, $74NcO.schedulePromise)(input, scheduler);
        if ((0, $7EGUs.isAsyncIterable)(input)) return (0, $hyfii.scheduleAsyncIterable)(input, scheduler);
        if ((0, $k5iK4.isIterable)(input)) return (0, $b9aB1.scheduleIterable)(input, scheduler);
        if ((0, $Xuqb1.isReadableStreamLike)(input)) return (0, $iXq3J.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $eNbzY.createInvalidObservableTypeError)(input);
}

});
parcelRegister("9r8N2", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $6ded7429c90fe31e$export$ed8bd553a12b6a30);

var $kA4PZ = parcelRequire("kA4PZ");

var $jsLpm = parcelRequire("jsLpm");

var $hOWB1 = parcelRequire("hOWB1");
function $6ded7429c90fe31e$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $kA4PZ.innerFrom)(input).pipe((0, $hOWB1.subscribeOn)(scheduler), (0, $jsLpm.observeOn)(scheduler));
}

});
parcelRegister("kA4PZ", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $efbaec1979d81ee1$export$6a9cfa3ebc765910);

var $1Znhr = parcelRequire("1Znhr");

var $deWbE = parcelRequire("deWbE");

var $3kIRy = parcelRequire("3kIRy");

var $gN3J6 = parcelRequire("gN3J6");

var $5THWY = parcelRequire("5THWY");

var $7EGUs = parcelRequire("7EGUs");

var $eNbzY = parcelRequire("eNbzY");

var $k5iK4 = parcelRequire("k5iK4");

var $Xuqb1 = parcelRequire("Xuqb1");

var $dFWVS = parcelRequire("dFWVS");

var $ZIGxP = parcelRequire("ZIGxP");

var $lzR1Z = parcelRequire("lzR1Z");
function $efbaec1979d81ee1$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $gN3J6.Observable)) return input;
    if (input != null) {
        if ((0, $5THWY.isInteropObservable)(input)) return $efbaec1979d81ee1$export$aa3d41784b3267fa(input);
        if ((0, $deWbE.isArrayLike)(input)) return $efbaec1979d81ee1$export$4cb2acdbcda2c253(input);
        if ((0, $3kIRy.isPromise)(input)) return $efbaec1979d81ee1$export$60f45028237c39d1(input);
        if ((0, $7EGUs.isAsyncIterable)(input)) return $efbaec1979d81ee1$export$e073fccf36d78cc1(input);
        if ((0, $k5iK4.isIterable)(input)) return $efbaec1979d81ee1$export$dcccc29c315dd646(input);
        if ((0, $Xuqb1.isReadableStreamLike)(input)) return $efbaec1979d81ee1$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $eNbzY.createInvalidObservableTypeError)(input);
}
function $efbaec1979d81ee1$export$aa3d41784b3267fa(obj) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var obs = obj[0, $lzR1Z.observable]();
        if ((0, $dFWVS.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $efbaec1979d81ee1$export$4cb2acdbcda2c253(array) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $efbaec1979d81ee1$export$60f45028237c39d1(promise) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $ZIGxP.reportUnhandledError));
    });
}
function $efbaec1979d81ee1$export$dcccc29c315dd646(iterable) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $1Znhr.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $efbaec1979d81ee1$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        $efbaec1979d81ee1$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $efbaec1979d81ee1$export$b2dcb11d46e7a4ad(readableStream) {
    return $efbaec1979d81ee1$export$e073fccf36d78cc1((0, $Xuqb1.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $efbaec1979d81ee1$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $1Znhr.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $1Znhr.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $1Znhr.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("deWbE", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $9a39b7dcf35b06dd$export$1e2f57719e155213);
var $9a39b7dcf35b06dd$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

});

parcelRegister("3kIRy", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $26d60a2a32edbe86$export$4369c812aac99591);

var $dFWVS = parcelRequire("dFWVS");
function $26d60a2a32edbe86$export$4369c812aac99591(value) {
    return (0, $dFWVS.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("5THWY", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $44b42e641422b891$export$48c0cddbc99c45c2);

var $lzR1Z = parcelRequire("lzR1Z");

var $dFWVS = parcelRequire("dFWVS");
function $44b42e641422b891$export$48c0cddbc99c45c2(input) {
    return (0, $dFWVS.isFunction)(input[0, $lzR1Z.observable]);
}

});

parcelRegister("7EGUs", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $592d8dcd5a9b21b1$export$edb10ab8dd75a915);

var $dFWVS = parcelRequire("dFWVS");
function $592d8dcd5a9b21b1$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $dFWVS.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("eNbzY", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $ac4e9fb3b188f5d1$export$7cbe71b9fa263484);
function $ac4e9fb3b188f5d1$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("k5iK4", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $e9f2d015065e1e76$export$9652023d9040757);

var $624cO = parcelRequire("624cO");

var $dFWVS = parcelRequire("dFWVS");
function $e9f2d015065e1e76$export$9652023d9040757(input) {
    return (0, $dFWVS.isFunction)(input === null || input === void 0 ? void 0 : input[0, $624cO.iterator]);
}

});
parcelRegister("624cO", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $4646311d9288ad3b$export$6f58e2338da23f4d);
function $4646311d9288ad3b$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $4646311d9288ad3b$export$6f58e2338da23f4d = $4646311d9288ad3b$export$aa9956be4ae4fe8();

});


parcelRegister("Xuqb1", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $0b2d1bd226c6ae7a$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $0b2d1bd226c6ae7a$export$c088ffafdba7405f);

var $1Znhr = parcelRequire("1Znhr");

var $dFWVS = parcelRequire("dFWVS");
function $0b2d1bd226c6ae7a$export$cf4785e597badab3(readableStream) {
    return (0, $1Znhr.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $1Znhr.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $1Znhr.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $1Znhr.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $1Znhr.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $0b2d1bd226c6ae7a$export$c088ffafdba7405f(obj) {
    return (0, $dFWVS.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});


parcelRegister("jsLpm", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $e2b56815ecd2be16$export$9007f49c319d1ac7);

var $aj4TV = parcelRequire("aj4TV");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $e2b56815ecd2be16$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});
parcelRegister("aj4TV", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $780f7af860c3a5ff$export$a2b7447487315232);
function $780f7af860c3a5ff$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});

parcelRegister("iZT3c", function(module, exports) {

$parcel$export(module.exports, "hasLift", () => $dd48a069f37f5009$export$ebec8610810318c5);
$parcel$export(module.exports, "operate", () => $dd48a069f37f5009$export$871731df685d7753);

var $dFWVS = parcelRequire("dFWVS");
function $dd48a069f37f5009$export$ebec8610810318c5(source) {
    return (0, $dFWVS.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $dd48a069f37f5009$export$871731df685d7753(init) {
    return function(source) {
        if ($dd48a069f37f5009$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}

});

parcelRegister("lo1Ce", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $f91d17b1cd8d7dd0$export$b9e075132cc6937f);
$parcel$export(module.exports, "OperatorSubscriber", () => $f91d17b1cd8d7dd0$export$8fbbf0c4d80268e5);

var $1Znhr = parcelRequire("1Znhr");

var $dUP5u = parcelRequire("dUP5u");
function $f91d17b1cd8d7dd0$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $f91d17b1cd8d7dd0$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $f91d17b1cd8d7dd0$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $1Znhr.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $dUP5u.Subscriber));

});


parcelRegister("hOWB1", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $cf948f2287cf1d0f$export$1eb44d8f5f64733b);

var $iZT3c = parcelRequire("iZT3c");
function $cf948f2287cf1d0f$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("74NcO", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $526f135d9ae5f351$export$fc9afd948577f0a8);

var $kA4PZ = parcelRequire("kA4PZ");

var $jsLpm = parcelRequire("jsLpm");

var $hOWB1 = parcelRequire("hOWB1");
function $526f135d9ae5f351$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $kA4PZ.innerFrom)(input).pipe((0, $hOWB1.subscribeOn)(scheduler), (0, $jsLpm.observeOn)(scheduler));
}

});

parcelRegister("8ggmu", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $603c82704db88b23$export$b34673931371729a);

var $gN3J6 = parcelRequire("gN3J6");
function $603c82704db88b23$export$b34673931371729a(input, scheduler) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("b9aB1", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $81d8c1228c5c8d3e$export$2b75c58ab9b5b766);

var $gN3J6 = parcelRequire("gN3J6");

var $624cO = parcelRequire("624cO");

var $dFWVS = parcelRequire("dFWVS");

var $aj4TV = parcelRequire("aj4TV");
function $81d8c1228c5c8d3e$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var iterator;
        (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $624cO.iterator]();
            (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $dFWVS.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("hyfii", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $cc7179c0e97e93d0$export$7c7f0979b56a32f3);

var $gN3J6 = parcelRequire("gN3J6");

var $aj4TV = parcelRequire("aj4TV");
function $cc7179c0e97e93d0$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $gN3J6.Observable)(function(subscriber) {
        (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("iXq3J", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $dcd1f37ffc5e3a09$export$3385251aeecad28a);

var $hyfii = parcelRequire("hyfii");

var $Xuqb1 = parcelRequire("Xuqb1");
function $dcd1f37ffc5e3a09$export$3385251aeecad28a(input, scheduler) {
    return (0, $hyfii.scheduleAsyncIterable)((0, $Xuqb1.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});



parcelRegister("hYp6u", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", () => $d15b83506ca8cd39$export$559affaa48f4288d);

var $1Znhr = parcelRequire("1Znhr");

var $6SBin = parcelRequire("6SBin");
var $d15b83506ca8cd39$var$isArray = Array.isArray;
function $d15b83506ca8cd39$var$callOrApply(fn, args) {
    return $d15b83506ca8cd39$var$isArray(args) ? fn.apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(args))) : fn(args);
}
function $d15b83506ca8cd39$export$559affaa48f4288d(fn) {
    return (0, $6SBin.map)(function(args) {
        return $d15b83506ca8cd39$var$callOrApply(fn, args);
    });
}

});
parcelRegister("6SBin", function(module, exports) {

$parcel$export(module.exports, "map", () => $5024b74c40e3eace$export$871de8747c9eaa88);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $5024b74c40e3eace$export$871de8747c9eaa88(project, thisArg) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});


parcelRegister("6kN4i", function(module, exports) {

$parcel$export(module.exports, "popResultSelector", () => $49caac480e766f10$export$9ae19b645239a61b);
$parcel$export(module.exports, "popScheduler", () => $49caac480e766f10$export$29534b2f653ae592);
$parcel$export(module.exports, "popNumber", () => $49caac480e766f10$export$3de14b735070dcd5);

var $dFWVS = parcelRequire("dFWVS");

var $iYL21 = parcelRequire("iYL21");
function $49caac480e766f10$var$last(arr) {
    return arr[arr.length - 1];
}
function $49caac480e766f10$export$9ae19b645239a61b(args) {
    return (0, $dFWVS.isFunction)($49caac480e766f10$var$last(args)) ? args.pop() : undefined;
}
function $49caac480e766f10$export$29534b2f653ae592(args) {
    return (0, $iYL21.isScheduler)($49caac480e766f10$var$last(args)) ? args.pop() : undefined;
}
function $49caac480e766f10$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $49caac480e766f10$var$last(args) === "number" ? args.pop() : defaultValue;
}

});
parcelRegister("iYL21", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $dd125016ed30f8c3$export$187e35932e88c15c);

var $dFWVS = parcelRequire("dFWVS");
function $dd125016ed30f8c3$export$187e35932e88c15c(value) {
    return value && (0, $dFWVS.isFunction)(value.schedule);
}

});


parcelRegister("9D757", function(module, exports) {

$parcel$export(module.exports, "createObject", () => $702d3fd5ac6d1f01$export$79c7e160a7743efd);
function $702d3fd5ac6d1f01$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}

});


parcelRegister("4BxWH", function(module, exports) {

$parcel$export(module.exports, "interval", () => $35a4f3067703daad$export$3174cdbf0a0cbc84);

var $lbxJc = parcelRequire("lbxJc");

var $iZWyy = parcelRequire("iZWyy");
function $35a4f3067703daad$export$3174cdbf0a0cbc84(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    if (period < 0) period = 0;
    return (0, $iZWyy.timer)(period, period, scheduler);
}

});
parcelRegister("lbxJc", function(module, exports) {

$parcel$export(module.exports, "asyncScheduler", () => $f6c4c9bd71b20294$export$8d6b71a2b178fc32);
$parcel$export(module.exports, "async", () => $f6c4c9bd71b20294$export$12af436354f1a4f7);

var $dnZ34 = parcelRequire("dnZ34");

var $6hfhx = parcelRequire("6hfhx");
var $f6c4c9bd71b20294$export$8d6b71a2b178fc32 = new (0, $6hfhx.AsyncScheduler)((0, $dnZ34.AsyncAction));
var $f6c4c9bd71b20294$export$12af436354f1a4f7 = $f6c4c9bd71b20294$export$8d6b71a2b178fc32;

});
parcelRegister("dnZ34", function(module, exports) {

$parcel$export(module.exports, "AsyncAction", () => $9becc74b1b373225$export$b5369ffd7cb2211b);

var $1Znhr = parcelRequire("1Znhr");

var $5oSnx = parcelRequire("5oSnx");

var $hAVup = parcelRequire("hAVup");

var $ebAl1 = parcelRequire("ebAl1");
var $9becc74b1b373225$export$b5369ffd7cb2211b = function(_super) {
    (0, $1Znhr.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $hAVup.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $hAVup.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $ebAl1.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $5oSnx.Action));

});
parcelRegister("5oSnx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $3ee960211923e35c$export$e19cd5f9376f8cee);

var $1Znhr = parcelRequire("1Znhr");

var $fgwAY = parcelRequire("fgwAY");
var $3ee960211923e35c$export$e19cd5f9376f8cee = function(_super) {
    (0, $1Znhr.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $fgwAY.Subscription));

});

parcelRegister("hAVup", function(module, exports) {

$parcel$export(module.exports, "intervalProvider", () => $ccf264af78c278c5$export$f0ca5e16f6f68711);

var $1Znhr = parcelRequire("1Znhr");
var $ccf264af78c278c5$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $ccf264af78c278c5$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $1Znhr.__spreadArray)([
            handler,
            timeout
        ], (0, $1Znhr.__read)(args)));
        return setInterval.apply(void 0, (0, $1Znhr.__spreadArray)([
            handler,
            timeout
        ], (0, $1Znhr.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $ccf264af78c278c5$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

});


parcelRegister("6hfhx", function(module, exports) {

$parcel$export(module.exports, "AsyncScheduler", () => $49202f47f01b459a$export$4114a3ec92faa3c6);

var $1Znhr = parcelRequire("1Znhr");

var $f68ij = parcelRequire("f68ij");
var $49202f47f01b459a$export$4114a3ec92faa3c6 = function(_super) {
    (0, $1Znhr.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $f68ij.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $f68ij.Scheduler));

});
parcelRegister("f68ij", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $afddd99de6dafc81$export$d3e54bb8584cda7c);

var $ggeIx = parcelRequire("ggeIx");
var $afddd99de6dafc81$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $ggeIx.dateTimestampProvider).now;
    return Scheduler;
}();

});
parcelRegister("ggeIx", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", () => $bd698e8115fc86c4$export$c1895ea2d519a677);
var $bd698e8115fc86c4$export$c1895ea2d519a677 = {
    now: function() {
        return ($bd698e8115fc86c4$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});




parcelRegister("iZWyy", function(module, exports) {

$parcel$export(module.exports, "timer", () => $dd4b589699967386$export$9dc4ecf953986f04);

var $gN3J6 = parcelRequire("gN3J6");

var $lbxJc = parcelRequire("lbxJc");

var $iYL21 = parcelRequire("iYL21");

var $gGn0E = parcelRequire("gGn0E");
function $dd4b589699967386$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $lbxJc.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $iYL21.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var due = (0, $gGn0E.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}

});
parcelRegister("gGn0E", function(module, exports) {

$parcel$export(module.exports, "isValidDate", () => $c2526ac6c756a544$export$c03bb0116ee09d4b);
function $c2526ac6c756a544$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}

});



parcelRegister("glUu6", function(module, exports) {

$parcel$export(module.exports, "distinctUntilChanged", () => $be7a6c25bf3d5e43$export$779c5fb865a0172e);

var $hYEnO = parcelRequire("hYEnO");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $be7a6c25bf3d5e43$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $hYEnO.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $be7a6c25bf3d5e43$var$defaultCompare;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $be7a6c25bf3d5e43$var$defaultCompare(a, b) {
    return a === b;
}

});

parcelRegister("lm9of", function(module, exports) {

$parcel$export(module.exports, "filter", () => $f8c2efb87b448d56$export$3dea766d36a8935f);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $f8c2efb87b448d56$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("9Jxex", function(module, exports) {

$parcel$export(module.exports, "withLatestFrom", () => $71621886b6c12a6a$export$d449030e5c10edf7);

var $1Znhr = parcelRequire("1Znhr");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");

var $hYEnO = parcelRequire("hYEnO");

var $QfuEL = parcelRequire("QfuEL");

var $6kN4i = parcelRequire("6kN4i");
function $71621886b6c12a6a$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $6kN4i.popResultSelector)(inputs);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $kA4PZ.innerFrom)(inputs[i]).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $hYEnO.identity))) && (hasValue = null);
                }
            }, (0, $QfuEL.noop)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            if (ready) {
                var values = (0, $1Znhr.__spreadArray)([
                    value
                ], (0, $1Znhr.__read)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(values))) : values);
            }
        }));
    });
}

});

parcelRegister("50gi8", function(module, exports) {

$parcel$export(module.exports, "rect", () => (parcelRequire("32Rl8")));
$parcel$export(module.exports, "canvas", () => (parcelRequire("ff1Wc")));
$parcel$export(module.exports, "cursor", () => (parcelRequire("aaOE9")));
$parcel$export(module.exports, "grid", () => (parcelRequire("3iwW1")));
/**
 * @module iblokz-gfx
 * @description Graphics utilities for geometry operations and canvas drawing
 * @version 0.1.0
 */ /**
 * Rectangle and geometry utilities
 * @type {Object}
 */ 
var $32Rl8 = parcelRequire("32Rl8");

var $ff1Wc = parcelRequire("ff1Wc");

var $aaOE9 = parcelRequire("aaOE9");

var $3iwW1 = parcelRequire("3iwW1");

});
parcelRegister("32Rl8", function(module, exports) {

$parcel$export(module.exports, "vectorAdd", () => $237aef3543f9749f$export$e2b112891904e340);
$parcel$export(module.exports, "fromVectors", () => $237aef3543f9749f$export$4a38c94219fc19bd);
$parcel$export(module.exports, "toVectors", () => $237aef3543f9749f$export$41cb0be8c984b628);
$parcel$export(module.exports, "pan", () => $237aef3543f9749f$export$4c486572e961a974);
$parcel$export(module.exports, "resize", () => $237aef3543f9749f$export$4380c87abf28fdf);
$parcel$export(module.exports, "containsVector", () => $237aef3543f9749f$export$e5efddc90fd3c495);
$parcel$export(module.exports, "containsRect", () => $237aef3543f9749f$export$6bbbfd8eda6d4f5);
$parcel$export(module.exports, "contains", () => $237aef3543f9749f$export$2344b14b097df817);
$parcel$export(module.exports, "intersects", () => $237aef3543f9749f$export$7b0a31e10bbff018);
/**
 * Adds two vectors
 * @param {Object} a - First vector {x, y}
 * @param {Object} b - Second vector {x, y}
 * @returns {Object} Sum vector {x, y}
 */ const $237aef3543f9749f$export$e2b112891904e340 = (a, b)=>({
        x: a.x + b.x,
        y: a.y + b.y
    });
/**
 * Creates a rectangle from two vectors (start and end points)
 * @param {Object} a - First vector {x, y}
 * @param {Object} b - Second vector {x, y}
 * @returns {Object} Rectangle {x, y, width, height}
 */ const $237aef3543f9749f$export$4a38c94219fc19bd = (a, b)=>Object.assign(a.x <= b.x ? {
        x: a.x,
        width: b.x - a.x
    } : {
        x: b.x,
        width: a.x - b.x
    }, a.y <= b.y ? {
        y: a.y,
        height: b.y - a.y
    } : {
        y: b.y,
        height: a.y - b.y
    });
/**
 * Converts a rectangle to its four corner vectors
 * @param {Object} rect - Rectangle {x, y, width, height}
 * @returns {Array<Object>} Array of four corner vectors
 */ const $237aef3543f9749f$export$41cb0be8c984b628 = (rect)=>[
        {
            x: rect.x,
            y: rect.y
        },
        {
            x: rect.x + rect.width,
            y: rect.y
        },
        {
            x: rect.x,
            y: rect.y + rect.height
        },
        {
            x: rect.x + rect.width,
            y: rect.y + rect.height
        }
    ];
/**
 * Translates a rectangle by a vector
 * @param {Object} rect - Rectangle {x, y, width, height}
 * @param {Object} v - Translation vector {x, y}
 * @returns {Object} Translated rectangle
 */ const $237aef3543f9749f$export$4c486572e961a974 = (rect, v)=>Object.assign({}, rect, $237aef3543f9749f$export$e2b112891904e340(rect, v));
/**
 * Resizes a rectangle by adjusting its end point
 * @param {Object} rect - Rectangle {x, y, width, height}
 * @param {Object} v - New end point vector {x, y}
 * @returns {Object} Resized rectangle
 */ const $237aef3543f9749f$export$4380c87abf28fdf = (rect, v)=>Object.assign({}, rect, {
        width: rect.width + v.x - rect.x,
        height: rect.height + v.y - rect.y
    });
/**
 * Checks if a rectangle contains a point
 * @param {Object} rect - Rectangle {x, y, width, height}
 * @param {Object} v - Point vector {x, y}
 * @returns {boolean} True if point is inside or on edge of rectangle
 */ const $237aef3543f9749f$export$e5efddc90fd3c495 = (rect, v)=>v.x >= rect.x && v.x <= rect.x + rect.width && v.y >= rect.y && v.y <= rect.y + rect.height;
/**
 * Checks if one rectangle fully contains another
 * @param {Object} rect1 - Container rectangle {x, y, width, height}
 * @param {Object} rect2 - Rectangle to check {x, y, width, height}
 * @returns {boolean} True if rect1 fully contains rect2
 */ const $237aef3543f9749f$export$6bbbfd8eda6d4f5 = (rect1, rect2)=>rect1.x <= rect2.x && rect2.x + rect2.width <= rect1.x + rect1.width && rect1.y <= rect2.y && rect2.y + rect2.height <= rect1.y + rect1.height;
/**
 * Checks if a rectangle contains an object (rect or vector)
 * @param {Object} rect - Rectangle {x, y, width, height}
 * @param {Object} obj - Object to check (rect or vector)
 * @returns {boolean} True if object is contained
 */ const $237aef3543f9749f$export$2344b14b097df817 = (rect, obj)=>obj.width ? $237aef3543f9749f$export$6bbbfd8eda6d4f5(rect, obj) : $237aef3543f9749f$export$e5efddc90fd3c495(rect, obj);
/**
 * Checks if two rectangles intersect (overlap)
 * Two rectangles intersect if they overlap on both axes
 * @param {Object} rect1 - First rectangle {x, y, width, height}
 * @param {Object} rect2 - Second rectangle {x, y, width, height}
 * @returns {boolean} True if rectangles intersect
 */ const $237aef3543f9749f$export$7b0a31e10bbff018 = (rect1, rect2)=>{
    // Handle edge cases: zero or negative dimensions
    if (rect1.width <= 0 || rect1.height <= 0 || rect2.width <= 0 || rect2.height <= 0) return false;
    // Two rects intersect if they overlap on both axes
    // Overlap on X axis: not (rect1 ends before rect2 starts OR rect2 ends before rect1 starts)
    const overlapX = !(rect1.x + rect1.width < rect2.x || rect2.x + rect2.width < rect1.x);
    // Overlap on Y axis: not (rect1 ends before rect2 starts OR rect2 ends before rect1 starts)
    const overlapY = !(rect1.y + rect1.height < rect2.y || rect2.y + rect2.height < rect1.y);
    return overlapX && overlapY;
};

});

parcelRegister("ff1Wc", function(module, exports) {

$parcel$export(module.exports, "clear", () => $b189c2864d48e390$export$42ffd38884aecdac);
$parcel$export(module.exports, "line", () => $b189c2864d48e390$export$53f1d5ea8de3d7c);
$parcel$export(module.exports, "rect", () => $b189c2864d48e390$export$4b409e53cf4df6e6);
$parcel$export(module.exports, "text", () => $b189c2864d48e390$export$6f093cfa640b7166);
$parcel$export(module.exports, "refresh", () => $b189c2864d48e390$export$2d6e9b4c68afb6c8);
/**
 * Clears the entire canvas
 * @param {CanvasRenderingContext2D} ctx - Canvas 2D context
 * @returns {void}
 */ const $b189c2864d48e390$export$42ffd38884aecdac = (ctx)=>ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
/**
 * Draws a line on the canvas
 * @param {CanvasRenderingContext2D} ctx - Canvas 2D context
 * @param {Object} start - Start point {x, y}
 * @param {Object} finish - End point {x, y}
 * @param {string} stroke - Stroke color
 * @param {Array<number>} [dash] - Optional dash pattern
 */ const $b189c2864d48e390$export$53f1d5ea8de3d7c = (ctx, start, finish, stroke, dash)=>{
    ctx.beginPath();
    ctx.moveTo(start.x, start.y);
    ctx.lineTo(finish.x, finish.y);
    if (dash) ctx.setLineDash(dash);
    ctx.lineWidth = 1;
    ctx.strokeStyle = stroke;
    ctx.stroke();
};
/**
 * Draws a rectangle on the canvas
 * @param {CanvasRenderingContext2D} ctx - Canvas 2D context
 * @param {Object} rect - Rectangle {x, y, width, height}
 * @param {string} [background] - Optional fill color
 * @param {string} [stroke] - Optional stroke color
 * @param {Array<number>} [dash] - Optional dash pattern
 */ const $b189c2864d48e390$export$4b409e53cf4df6e6 = (ctx, rect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
}, background, stroke, dash)=>{
    ctx.beginPath();
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    if (background) {
        ctx.fillStyle = background;
        ctx.fill();
    }
    if (dash) ctx.setLineDash(dash);
    if (stroke) {
        ctx.lineWidth = 1;
        ctx.strokeStyle = stroke;
        ctx.stroke();
    }
};
/**
 * Draws text on the canvas
 * @param {CanvasRenderingContext2D} ctx - Canvas 2D context
 * @param {Object} options - Text options
 * @param {string} [options.font='10px Arial'] - Font string
 * @param {string} [options.fillStyle='black'] - Fill color
 * @param {string} [options.fillText=''] - Text to draw
 * @param {number} [options.x=2] - X position
 * @param {number} [options.y=8] - Y position
 */ const $b189c2864d48e390$export$6f093cfa640b7166 = (ctx, { font: font = "10px Arial", fillStyle: fillStyle = "black", fillText: fillText = "", x: x = 2, y: y = 8 })=>{
    ctx.font = font;
    ctx.fillStyle = fillStyle;
    ctx.fillText(fillText, x, y);
};
/**
 * Refreshes canvas size to match parent element
 * @param {CanvasRenderingContext2D} ctx - Canvas 2D context
 * @returns {HTMLCanvasElement} Canvas element with updated dimensions
 */ const $b189c2864d48e390$export$2d6e9b4c68afb6c8 = (ctx)=>Object.assign(ctx.canvas, {
        width: ctx.canvas.parentNode.offsetWidth,
        height: ctx.canvas.parentNode.offsetHeight
    });

});

parcelRegister("aaOE9", function(module, exports) {

$parcel$export(module.exports, "createCanvas", () => $76821fef3c5be30c$export$cd3d1f114b139967);
$parcel$export(module.exports, "iconCodeToDataURL", () => $76821fef3c5be30c$export$2c4e0e8fb6cf3794);
$parcel$export(module.exports, "prepIcons", () => $76821fef3c5be30c$export$5d0e832f17225c6e);
$parcel$export(module.exports, "setCursor", () => $76821fef3c5be30c$export$ca17b14bf34aba4);

var $jjnZg = parcelRequire("jjnZg");
/**
 * Assigns a key-value pair to an object
 * @private
 * @param {Object} o - Object
 * @param {string} k - Key
 * @param {*} v - Value
 * @returns {Object} Object with assigned value
 */ const $76821fef3c5be30c$var$assignKeyValue = (o, k, v)=>(o[k] = v) && o;
/**
 * Creates a canvas element for icon generation
 * @returns {CanvasRenderingContext2D} Canvas 2D context configured for icons
 */ const $76821fef3c5be30c$export$cd3d1f114b139967 = (0, $jjnZg.fn).pipe(()=>Object.assign(document.createElement("canvas"), {
        width: 24,
        height: 24
    }), (canvas)=>canvas.getContext("2d"), (ctx)=>Object.assign(ctx, {
        fillStyle: "#ffffff",
        font: "14px FontAwesome",
        textAlign: "center",
        textBaseline: "middle"
    }));
/**
 * Converts an icon code to a data URL
 * @param {string} code - Icon code (e.g., FontAwesome unicode)
 * @param {CanvasRenderingContext2D} [ctx] - Optional canvas context (creates new if not provided)
 * @returns {string} Data URL of the icon image
 */ const $76821fef3c5be30c$export$2c4e0e8fb6cf3794 = (code, ctx = $76821fef3c5be30c$export$cd3d1f114b139967())=>{
    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.fillText(code, 12, 12);
    return ctx.canvas.toDataURL("image/png");
};
/**
 * Prepares multiple icons from a list of icon codes
 * @param {Object} list - Object mapping icon names to icon codes
 * @returns {Object} Object mapping icon names to data URLs
 */ const $76821fef3c5be30c$export$5d0e832f17225c6e = (0, $jjnZg.fn).pipe((list)=>({
        ctx: $76821fef3c5be30c$export$cd3d1f114b139967(),
        list: list
    }), ({ ctx: ctx, list: list })=>Object.keys(list).reduce((o, key)=>$76821fef3c5be30c$var$assignKeyValue(o, key, $76821fef3c5be30c$export$2c4e0e8fb6cf3794(list[key], ctx)), {}));
/**
 * Sets the cursor style of an element to a custom icon
 * @param {HTMLElement} el - DOM element
 * @param {string} dataURL - Data URL of the cursor image
 */ const $76821fef3c5be30c$export$ca17b14bf34aba4 = (el, dataURL)=>{
    el.style.cursor = `url(${dataURL}), auto`;
};

});

parcelRegister("3iwW1", function(module, exports) {

$parcel$export(module.exports, "snapToGrid", () => $266c99b0ea89496c$export$195604d042fd3f87);
/**
 * Grid utilities for snapping coordinates to grid steps
 * @module grid
 */ /**
 * Snaps pixel coordinates to the nearest grid step
 * @param {number} x - X coordinate in pixels
 * @param {number} y - Y coordinate in pixels
 * @param {number} stepX - Grid step size in X direction
 * @param {number} stepY - Grid step size in Y direction
 * @returns {Object} Snapped coordinates {x, y}
 * @example
 * snapToGrid(37, 23, 30, 12) // => {x: 30, y: 24}
 */ const $266c99b0ea89496c$export$195604d042fd3f87 = (x, y, stepX, stepY)=>{
    const snappedX = Math.round(x / stepX) * stepX;
    const snappedY = Math.round(y / stepY) * stepY;
    return {
        x: snappedX,
        y: snappedY
    };
};

});


parcelRegister("kTQ8i", function(module, exports) {

$parcel$export(module.exports, "numberToNote", () => $f371622efe57d651$export$58f652decc294f5c);
$parcel$export(module.exports, "noteToNumber", () => $f371622efe57d651$export$afeaafc2baee80c3);
$parcel$export(module.exports, "parseMidiMsg", () => $f371622efe57d651$export$194bba571409de2e);
$parcel$export(module.exports, "init", () => $f371622efe57d651$export$2cd8252107eb640b);

var $dMQAa = parcelRequire("dMQAa");
var $aIPjU = parcelRequire("aIPjU");
var $8k9wm = parcelRequire("8k9wm");
var $hgqF6 = parcelRequire("hgqF6");

var $bzRF9 = parcelRequire("bzRF9");
var $6SBin = parcelRequire("6SBin");
var $bVpqG = parcelRequire("bVpqG");
var $aRUkQ = parcelRequire("aRUkQ");
const $f371622efe57d651$var$keys = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
const $f371622efe57d651$export$58f652decc294f5c = (number)=>({
        key: $f371622efe57d651$var$keys[number % 12],
        octave: parseInt((number - number % 12) / 12, 10) - 1,
        number: number
    });
const $f371622efe57d651$export$afeaafc2baee80c3 = (note)=>$f371622efe57d651$var$keys.indexOf(note.replace(/[0-9]+/, "")) + (parseInt(note.replace(/[A-Z#b]+/, ""), 10) + 1) * 12;
const $f371622efe57d651$export$194bba571409de2e = (event)=>{
    // Mask off the lower nibble (MIDI channel, which we don't care about)
    const status = event.data[0] & 0xf0;
    const binary = event.data[0].toString(2);
    const channel = event.data[0] - status + 1;
    let msg = {};
    switch(binary.slice(0, 4)){
        // noteoff
        case "1000":
            msg = {
                state: "noteOff",
                note: $f371622efe57d651$export$58f652decc294f5c(event.data[1])
            };
            break;
        // noteon
        case "1001":
            msg = event.data[2] !== 0 // if velocity != 0, this is a note-on message
             ? {
                state: "noteOn",
                note: $f371622efe57d651$export$58f652decc294f5c(event.data[1]),
                velocity: parseFloat((event.data[2] / 127).toFixed(2))
            } : {
                state: "noteOff",
                note: $f371622efe57d651$export$58f652decc294f5c(event.data[1])
            };
            break;
        // pitch wheel
        case "1110":
            msg = {
                state: "pitchBend",
                pitchValue: event.data[2] === 64 ? 0 : parseFloat((event.data[2] / 63.5 - 1).toFixed(2))
            };
            break;
        // controller
        case "1011":
            msg = {
                state: "controller",
                controller: event.data[1],
                value: parseFloat((event.data[2] / 127).toFixed(2))
            };
            break;
        case "1100":
            msg = {
                state: "bankSelect",
                bank: event.data[1]
            };
            break;
        default:
            msg = {
                state: false
            };
            break;
    }
    return Object.assign({}, msg, {
        binary: binary,
        status: status,
        channel: channel,
        data: event.data
    });
};
//
// const hookUpMIDIInput = midiAccess => {
// 	var haveAtLeastOneDevice = false;
// 	var inputs = midiAccess.inputs.values();
// 	for (var input = inputs.next(); input && !input.done; input = inputs.next()) {
// 		input.value.onmidimessage = MIDIMessageEventHandler;
// 		haveAtLeastOneDevice = true;
// 	}
// };
//
// const onMIDIInit = midi => {
// 	hookUpMIDIInput(midi);
// 	midi.onstatechange = hookUpMIDIInput;
// };
//
// const onMIDIReject = err =>
// 	console.log(err, 'The MIDI system failed to start.');
//
// (navigator.requestMIDIAccess)
// 		&& navigator.requestMIDIAccess().then(onMIDIInit, onMIDIReject);
const $f371622efe57d651$var$parseAccess = (access)=>{
    let inputs = [];
    let outputs = [];
    // console.log(access);
    access.inputs.forEach((input)=>inputs.push(input));
    access.outputs.forEach((output)=>outputs.push(output));
    return {
        access: access,
        inputs: inputs,
        outputs: outputs
    };
};

const $f371622efe57d651$export$2cd8252107eb640b = ()=>{
    const devices$ = new (0, $hgqF6.Subject)();
    if (!navigator.requestMIDIAccess) {
        console.warn("Web MIDI API is not supported in this browser");
        return {
            devices$: devices$,
            msg$: new (0, $hgqF6.Subject)()
        };
    }
    (0, $aIPjU.from)(navigator.requestMIDIAccess()).pipe((0, $bzRF9.flatMap)((access)=>new (parcelRequire("gN3J6")).Observable((observer)=>{
            access.onstatechange = (connection)=>observer.next(connection.currentTarget);
            return ()=>{
                access.onstatechange = null;
            };
        }).pipe((0, $aRUkQ.startWith)(access))), (0, $6SBin.map)($f371622efe57d651$var$parseAccess)).subscribe({
        next: (device)=>devices$.next(device),
        error: (err)=>{
            console.error("Failed to request MIDI access:", err);
        // MIDI access was denied or failed - user can retry from UI
        }
    });
    // share()
    const msg$ = new (0, $hgqF6.Subject)();
    devices$.pipe((0, $bzRF9.flatMap)(({ access: access, inputs: inputs })=>inputs.reduce((msgStream, input)=>msgStream.pipe((0, $bVpqG.merge)((0, $8k9wm.fromEventPattern)((h)=>{
                input.onmidimessage = h;
            }, ()=>{
                input.onmidimessage = null;
            }).pipe((0, $6SBin.map)((msg)=>({
                    access: access,
                    input: input,
                    msg: msg
                }))))), (0, $dMQAa.EMPTY)))).subscribe((msg)=>msg$.next(msg));
    return {
        devices$: devices$,
        msg$: msg$
    };
};
var $f371622efe57d651$export$2e2bcd8739ae039 = {
    init: $f371622efe57d651$export$2cd8252107eb640b,
    numberToNote: $f371622efe57d651$export$58f652decc294f5c,
    noteToNumber: $f371622efe57d651$export$afeaafc2baee80c3,
    parseMidiMsg: $f371622efe57d651$export$194bba571409de2e
};

});
parcelRegister("dMQAa", function(module, exports) {

$parcel$export(module.exports, "EMPTY", () => $a0988bcdc56b56f1$export$ccb33e29d92c9a58);

var $gN3J6 = parcelRequire("gN3J6");
var $a0988bcdc56b56f1$export$ccb33e29d92c9a58 = new (0, $gN3J6.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $a0988bcdc56b56f1$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $a0988bcdc56b56f1$var$emptyScheduled(scheduler) : $a0988bcdc56b56f1$export$ccb33e29d92c9a58;
}
function $a0988bcdc56b56f1$var$emptyScheduled(scheduler) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});

parcelRegister("8k9wm", function(module, exports) {

$parcel$export(module.exports, "fromEventPattern", () => $60f793a6c1ff6b88$export$af596f9f0ff848f8);

var $gN3J6 = parcelRequire("gN3J6");

var $dFWVS = parcelRequire("dFWVS");

var $hYp6u = parcelRequire("hYp6u");
function $60f793a6c1ff6b88$export$af596f9f0ff848f8(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return $60f793a6c1ff6b88$export$af596f9f0ff848f8(addHandler, removeHandler).pipe((0, $hYp6u.mapOneOrManyArgs)(resultSelector));
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, $dFWVS.isFunction)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}

});

parcelRegister("hgqF6", function(module, exports) {

$parcel$export(module.exports, "Subject", () => $c9189cc69fd31ace$export$b6bbab5a9b109038);

var $1Znhr = parcelRequire("1Znhr");

var $gN3J6 = parcelRequire("gN3J6");

var $fgwAY = parcelRequire("fgwAY");

var $vLmN9 = parcelRequire("vLmN9");

var $ebAl1 = parcelRequire("ebAl1");

var $iQsM4 = parcelRequire("iQsM4");
var $c9189cc69fd31ace$export$b6bbab5a9b109038 = function(_super) {
    (0, $1Znhr.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $c9189cc69fd31ace$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $vLmN9.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $iQsM4.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $1Znhr.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $iQsM4.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $iQsM4.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $fgwAY.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $fgwAY.Subscription)(function() {
            _this.currentObservers = null;
            (0, $ebAl1.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $gN3J6.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $c9189cc69fd31ace$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $gN3J6.Observable));
var $c9189cc69fd31ace$export$155189cde295587d = function(_super) {
    (0, $1Znhr.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $fgwAY.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}($c9189cc69fd31ace$export$b6bbab5a9b109038);

});
parcelRegister("vLmN9", function(module, exports) {

$parcel$export(module.exports, "ObjectUnsubscribedError", () => $05f7a3630bce7cef$export$f708eee25634bc80);

var $jaWRE = parcelRequire("jaWRE");
var $05f7a3630bce7cef$export$f708eee25634bc80 = (0, $jaWRE.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});

});


parcelRegister("bzRF9", function(module, exports) {

$parcel$export(module.exports, "flatMap", () => $86dc96e7eafc6994$export$5b8affa63fc6df16);

var $drQX9 = parcelRequire("drQX9");
var $86dc96e7eafc6994$export$5b8affa63fc6df16 = (0, $drQX9.mergeMap);

});
parcelRegister("drQX9", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9);

var $6SBin = parcelRequire("6SBin");

var $kA4PZ = parcelRequire("kA4PZ");

var $iZT3c = parcelRequire("iZT3c");

var $bqdkM = parcelRequire("bqdkM");

var $dFWVS = parcelRequire("dFWVS");
function $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $dFWVS.isFunction)(resultSelector)) return $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $6SBin.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $kA4PZ.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        return (0, $bqdkM.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("bqdkM", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", () => $850c775404996a72$export$600918ebaa9e0a1b);

var $kA4PZ = parcelRequire("kA4PZ");

var $aj4TV = parcelRequire("aj4TV");

var $lo1Ce = parcelRequire("lo1Ce");
function $850c775404996a72$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $kA4PZ.innerFrom)(project(value, index++)).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $aj4TV.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});



parcelRegister("bVpqG", function(module, exports) {

$parcel$export(module.exports, "merge", () => $8ae8be55c06ad12b$export$4950aa0f605343fb);

var $1Znhr = parcelRequire("1Znhr");

var $iZT3c = parcelRequire("iZT3c");

var $8wGrm = parcelRequire("8wGrm");

var $6kN4i = parcelRequire("6kN4i");

var $aIPjU = parcelRequire("aIPjU");
function $8ae8be55c06ad12b$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(args);
    var concurrent = (0, $6kN4i.popNumber)(args, Infinity);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $8wGrm.mergeAll)(concurrent)((0, $aIPjU.from)((0, $1Znhr.__spreadArray)([
            source
        ], (0, $1Znhr.__read)(args)), scheduler)).subscribe(subscriber);
    });
}

});
parcelRegister("8wGrm", function(module, exports) {

$parcel$export(module.exports, "mergeAll", () => $63523ba376002a40$export$18aef43295bbe906);

var $drQX9 = parcelRequire("drQX9");

var $hYEnO = parcelRequire("hYEnO");
function $63523ba376002a40$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $drQX9.mergeMap)((0, $hYEnO.identity), concurrent);
}

});


parcelRegister("aRUkQ", function(module, exports) {

$parcel$export(module.exports, "startWith", () => $7e9a8d9a25bb62cb$export$a4fe86229b0e9bdd);

var $awcxJ = parcelRequire("awcxJ");

var $6kN4i = parcelRequire("6kN4i");

var $iZT3c = parcelRequire("iZT3c");
function $7e9a8d9a25bb62cb$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(values);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (scheduler ? (0, $awcxJ.concat)(values, source, scheduler) : (0, $awcxJ.concat)(values, source)).subscribe(subscriber);
    });
}

});
parcelRegister("awcxJ", function(module, exports) {

$parcel$export(module.exports, "concat", () => $7a869f5745a434e5$export$ee1b3e54f0441b22);

var $aFT1q = parcelRequire("aFT1q");

var $6kN4i = parcelRequire("6kN4i");

var $aIPjU = parcelRequire("aIPjU");
function $7a869f5745a434e5$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $aFT1q.concatAll)()((0, $aIPjU.from)(args, (0, $6kN4i.popScheduler)(args)));
}

});
parcelRegister("aFT1q", function(module, exports) {

$parcel$export(module.exports, "concatAll", () => $7c5869f500d3725f$export$b314777ae20abca9);

var $8wGrm = parcelRequire("8wGrm");
function $7c5869f500d3725f$export$b314777ae20abca9() {
    return (0, $8wGrm.mergeAll)(1);
}

});




parcelRegister("czxgE", function(module, exports) {

$parcel$export(module.exports, "patch", () => $92728f2b24e6e83c$export$b76953f99ab2be78);
/**
 * Object Utils
 * @module util/data/object
 */ 
var $jjnZg = parcelRequire("jjnZg");
const $92728f2b24e6e83c$var$pipe = (0, $jjnZg.fn).pipe;
const $92728f2b24e6e83c$var$combineWithIfObject = (val, obj)=>val instanceof Object ? {
        ...obj,
        ...val
    } : val;
const $92728f2b24e6e83c$export$b76953f99ab2be78 = (obj = {}, path, patchVal)=>$92728f2b24e6e83c$var$pipe(()=>path instanceof Array ? path : path.split("."), (path)=>({
            ...obj ?? {},
            [path[0]]: path.length > 1 ? $92728f2b24e6e83c$export$b76953f99ab2be78(obj[path[0]] ?? {}, path.slice(1), patchVal) : patchVal instanceof Function ? $92728f2b24e6e83c$var$combineWithIfObject(patchVal(obj[path[0]]), obj[path[0]]) : $92728f2b24e6e83c$var$combineWithIfObject(patchVal, obj[path[0]])
        }))();
const $92728f2b24e6e83c$export$1cebf9de757830a3 = (obj = {}, patchTree = {})=>Object.keys(patchTree).map((path)=>({
            path: path,
            patchVal: patchTree[path]
        })).reduce((patchedObj, { path: path, patchVal: patchVal })=>$92728f2b24e6e83c$export$b76953f99ab2be78(patchedObj, path, patchVal), obj);
const $92728f2b24e6e83c$export$f93b5905241a7cca = (obj = {}, path)=>$92728f2b24e6e83c$var$pipe(()=>path instanceof Array ? path : path.split("."), (path)=>({
            ...obj ?? {},
            [path[0]]: path.length > 1 ? $92728f2b24e6e83c$export$f93b5905241a7cca(obj[path[0]] ?? {}, path.slice(1)) : obj[path[0]]
        }))();

});

parcelRegister("8MxqK", function(module, exports) {

$parcel$export(module.exports, "snapToGrid", () => $664cbcfbbe867ea8$export$195604d042fd3f87);
$parcel$export(module.exports, "pixelToGrid", () => $664cbcfbbe867ea8$export$e269ad9b44704394);
$parcel$export(module.exports, "prepCanvas", () => $664cbcfbbe867ea8$export$bcb45675c9c93fbd);
$parcel$export(module.exports, "drawGrid", () => $664cbcfbbe867ea8$export$20d2db9c68afeac);
$parcel$export(module.exports, "drawEvents", () => $664cbcfbbe867ea8$export$b7dfeba5ac5ac4a7);

var $kTQ8i = parcelRequire("kTQ8i");
parcelRequire("50gi8");
var $ff1Wc = parcelRequire("ff1Wc");
var $3iwW1 = parcelRequire("3iwW1");
const { snapToGrid: $664cbcfbbe867ea8$export$195604d042fd3f87 } = (0, $3iwW1);
const $664cbcfbbe867ea8$export$e269ad9b44704394 = (x, y, dim, position, bar, beatLength)=>{
    // Subtract note column width (dim[0]) from x
    const gridX = Math.floor((x - dim[0]) / dim[0]);
    const gridY = Math.floor(y / dim[1]);
    const noteNumber = position[1] - gridY;
    const noteObj = (0, $kTQ8i.numberToNote)(noteNumber);
    const note = `${noteObj.key}${noteObj.octave}`; // Convert to string format like "C4"
    const time = bar * beatLength + gridX;
    return {
        gridX: gridX,
        gridY: gridY,
        note: note,
        time: time
    };
};
const $664cbcfbbe867ea8$export$46698aff03bf69f5 = (note, time, dim, position, bar, beatLength)=>{
    const noteNumber = (0, $kTQ8i.noteToNumber)(note);
    const gridY = position[1] - noteNumber;
    const gridX = time - bar * beatLength;
    return {
        x: dim[0] + gridX * dim[0],
        y: gridY * dim[1]
    };
};
const $664cbcfbbe867ea8$export$bcb45675c9c93fbd = (ctx)=>((0, $ff1Wc).clear(ctx), (0, $ff1Wc).refresh(ctx));
const $664cbcfbbe867ea8$export$20d2db9c68afeac = (ctx, dim = [
    42,
    14
], pos = [
    0,
    60
])=>{
    console.log("drawing grid");
    $664cbcfbbe867ea8$export$bcb45675c9c93fbd(ctx);
    const pattern = [
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        0,
        1,
        0
    ];
    const colCount = parseInt(ctx.canvas.width / dim[0], 10) + 1;
    const rowCount = parseInt(ctx.canvas.height / dim[1], 10);
    // draw rows
    for(let i = 0; i <= rowCount; i++){
        // draw piano note
        (0, $ff1Wc).rect(ctx, {
            x: 0,
            y: i * dim[1],
            width: dim[0],
            height: dim[1]
        }, pattern[(pos[1] - i) % 12] ? "#1e1e1e" : "#ccc", "#555");
        // every octave draw C note + octave number
        if ((pos[1] - i) % 12 === 0) (0, $ff1Wc).text(ctx, {
            x: 2,
            y: (i + 1) * dim[1] - 2,
            fillText: (({ key: key, octave: octave })=>`${key}${octave}`)((0, $kTQ8i.numberToNote)(pos[1] - i)),
            fill: pattern[(pos[1] - i) % 12] ? "#ccc" : "#1e1e1e"
        });
        // draw line
        (0, $ff1Wc).line(ctx, {
            x: dim[0],
            y: (i + 1) * dim[1]
        }, {
            x: ctx.canvas.width,
            y: (i + 1) * dim[1]
        }, "#555");
    }
    // draw tick lines
    for(let i = 0; i < colCount; i++)(0, $ff1Wc).line(ctx, {
        x: i * dim[0],
        y: 0
    }, {
        x: i * dim[0],
        y: ctx.canvas.height
    }, "#555");
};
const $664cbcfbbe867ea8$export$b7dfeba5ac5ac4a7 = (ctx, visible, selection, dim = [
    42,
    14
], bar, pos = [
    0,
    60
])=>{
    console.log("drawing events - selection:", selection, "visible count:", visible.length);
    $664cbcfbbe867ea8$export$bcb45675c9c93fbd(ctx);
    visible.forEach(({ uuid: uuid, rect: rect })=>{
        const isSelected = selection.indexOf(uuid) > -1;
        console.log(`  Event ${uuid}: selected=${isSelected}, rect:`, rect);
        (0, $ff1Wc).rect(ctx, rect, ...isSelected ? [
            "#cfefdf",
            "#214d37"
        ] // Light green fill, dark green border for selected
         : [
            "#eee",
            "#555"
        ]); // Light gray fill, dark gray border for unselected
    });
};

});

parcelRegister("3wnmS", function(module, exports) {

$parcel$export(module.exports, "computeSelection", () => $29067ca42d4b4506$export$3f195a0e9991ff49);
$parcel$export(module.exports, "findEventAtPosition", () => $29067ca42d4b4506$export$5dc4b174d4a8d08e);
$parcel$export(module.exports, "computeSelectionRect", () => $29067ca42d4b4506$export$ca980fb7202833a8);
parcelRequire("50gi8");
var $32Rl8 = parcelRequire("32Rl8");
const { containsRect: $29067ca42d4b4506$var$containsRect, intersects: $29067ca42d4b4506$var$intersects, fromVectors: $29067ca42d4b4506$var$fromVectors, containsVector: $29067ca42d4b4506$var$containsVector } = (0, $32Rl8);
const $29067ca42d4b4506$export$3f195a0e9991ff49 = (visible, selectionRect, mode = "containsRect")=>{
    const selectionFn = mode === "intersects" ? $29067ca42d4b4506$var$intersects : $29067ca42d4b4506$var$containsRect;
    return visible.filter(({ rect: itemRect })=>selectionFn(selectionRect, itemRect)).map(({ uuid: uuid })=>uuid);
};
const $29067ca42d4b4506$export$5dc4b174d4a8d08e = (visible, position)=>visible.find(({ rect: itemRect })=>$29067ca42d4b4506$var$containsVector(itemRect, position));
const $29067ca42d4b4506$export$ca980fb7202833a8 = (start, current)=>$29067ca42d4b4506$var$fromVectors(start, current);

});


parcelRegister("iFU5r", function(module, exports) {
"use strict";

var $jjnZg = parcelRequire("jjnZg");
var $d9878ffd14f309f2$require$obj = $jjnZg.obj;

var $gsDht = parcelRequire("gsDht");
var $d9878ffd14f309f2$require$measureToBeatLength = $gsDht.measureToBeatLength;
const $d9878ffd14f309f2$var$initial = {
    barsLength: 1,
    bar: 0,
    channel: -1,
    channels: [
        3,
        17,
        8,
        13,
        6
    ],
    pattern: [
        [
            [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0
            ]
        ]
    ]
};
const $d9878ffd14f309f2$var$toggle = (bar, r, c, forceOn = false)=>(state)=>{
        let pattern = [].concat(state.sequencer.pattern.slice());
        pattern[bar] = pattern[bar] && pattern[bar].slice() || [];
        pattern[bar][r] = pattern[bar][r] && pattern[bar][r].slice() || [];
        pattern[bar][r][c] = pattern[bar][r][c] && !forceOn ? 0 : 1;
        // console.log(pattern, pattern[bar][r][c]);
        return $d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            pattern: pattern
        });
    };
const $d9878ffd14f309f2$var$update = (bar, r, c, v)=>(state)=>{
        let pattern = [].concat(state.sequencer.pattern.slice());
        pattern[bar] = pattern[bar] && pattern[bar].slice() || [];
        pattern[bar][r] = pattern[bar][r] && pattern[bar][r].slice() || [];
        pattern[bar][r][c] = v > 1 ? 1 : v < 0 ? 0 : v;
        // console.log(pattern, pattern[bar][r][c]);
        return $d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            pattern: pattern
        });
    };
const $d9878ffd14f309f2$var$clear = ()=>(state)=>{
        let pattern = state.sequencer.pattern.slice();
        if (state.sequencer.channel > -1) pattern[state.sequencer.bar][state.sequencer.channel] = [];
        return $d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            pattern: pattern
        });
    };
const $d9878ffd14f309f2$var$select = (channel)=>(state)=>$d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            channel: state.sequencer.channel === channel ? -1 : channel
        });
const $d9878ffd14f309f2$var$prev = ()=>(state)=>$d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            channel: state.sequencer.channel > 0 ? state.sequencer.channel - 1 : state.sequencer.channels.length - 1
        });
const $d9878ffd14f309f2$var$next = ()=>(state)=>$d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            channel: state.sequencer.channel < state.sequencer.channels.length - 1 ? state.sequencer.channel + 1 : 0
        });
const $d9878ffd14f309f2$var$add = (channel)=>(state)=>$d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            channels: [].concat(state.sequencer.channels, [
                0
            ]),
            channel: state.sequencer.channels.length
        });
const $d9878ffd14f309f2$var$remove = ()=>(state)=>state.sequencer.channel === -1 ? state : $d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            channels: [].concat(state.sequencer.channels.slice(0, state.sequencer.channel), state.sequencer.channels.slice(state.sequencer.channel + 1)),
            pattern: state.sequencer.pattern.map((pattern)=>pattern.filter((r, i)=>i !== state.sequencer.channel)),
            channel: -1
        });
const $d9878ffd14f309f2$var$setSample = (channel, sample)=>(state)=>$d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            channels: channel > -1 ? [].concat(state.sequencer.channels.slice(0, channel), [
                sample
            ], state.sequencer.channels.slice(channel + 1)) : [].concat(state.sequencer.channels, [
                sample
            ])
        });
const $d9878ffd14f309f2$var$loop = (times, index = 0)=>index < times ? [
        index
    ].concat($d9878ffd14f309f2$var$loop(times, index + 1)) : [];
const $d9878ffd14f309f2$var$setBarsLength = (barsLength)=>(state)=>$d9878ffd14f309f2$require$obj.patch(state, "sequencer", {
            barsLength: barsLength,
            pattern: $d9878ffd14f309f2$var$loop(barsLength).map((index)=>state.sequencer.pattern[index] || state.sequencer.pattern[0])
        });
module.exports = {
    initial: $d9878ffd14f309f2$var$initial,
    toggle: $d9878ffd14f309f2$var$toggle,
    update: $d9878ffd14f309f2$var$update,
    clear: $d9878ffd14f309f2$var$clear,
    select: $d9878ffd14f309f2$var$select,
    prev: $d9878ffd14f309f2$var$prev,
    next: $d9878ffd14f309f2$var$next,
    add: $d9878ffd14f309f2$var$add,
    remove: $d9878ffd14f309f2$var$remove,
    setSample: $d9878ffd14f309f2$var$setSample,
    setBarsLength: $d9878ffd14f309f2$var$setBarsLength
};

});


parcelRegister("DSqxu", function(module, exports) {
"use strict";

var $gsDht = parcelRequire("gsDht");
var $077ddcb625c032cf$require$measureToBeatLength = $gsDht.measureToBeatLength;

var $jjnZg = parcelRequire("jjnZg");
var $077ddcb625c032cf$require$obj = $jjnZg.obj;
var $077ddcb625c032cf$require$arr = $jjnZg.arr;
const $077ddcb625c032cf$var$arrMod = (a, p, v)=>[].concat(a.slice(0, p[0]), [
        p.length === 1 ? v : $077ddcb625c032cf$var$arrMod(a[p[0]], p.slice(1), v)
    ], a.slice(p[0] + 1));
const $077ddcb625c032cf$var$initial = {
    devices: {
        inputs: [],
        outputs: []
    },
    settings: {
        midiRouteToActive: true
    },
    clock: {
        in: [],
        out: []
    },
    data: {
        in: [],
        out: []
    },
    pitch: 0,
    channels: {},
    map: [
        [
            "controller",
            20,
            [
                "instrument",
                "vcf",
                "cutoff"
            ]
        ],
        [
            "controller",
            21,
            [
                "instrument",
                "vcf",
                "resonance"
            ]
        ],
        [
            "controller",
            22,
            [
                "studio",
                "bpm"
            ],
            60,
            200,
            0
        ],
        [
            "controller",
            23,
            [
                "studio",
                "volume"
            ]
        ],
        [
            "controller",
            24,
            [
                "instrument",
                "eg",
                "attack"
            ]
        ],
        [
            "controller",
            25,
            [
                "instrument",
                "eg",
                "decay"
            ]
        ],
        [
            "controller",
            26,
            [
                "instrument",
                "eg",
                "sustain"
            ]
        ],
        [
            "controller",
            27,
            [
                "instrument",
                "eg",
                "release"
            ]
        ]
    ]
};
const $077ddcb625c032cf$var$findAutoConnectMpkIndex = (inputs)=>{
    const ivMidi = inputs.findIndex((dev)=>/MPK Mini IV MIDI Port/i.test(dev.name));
    if (ivMidi > -1) return ivMidi;
    const mk2 = inputs.findIndex((dev)=>/MPKmini2/i.test(dev.name));
    if (mk2 > -1) return mk2;
    return inputs.findIndex((dev)=>/MPK Mini IV/i.test(dev.name));
};
const $077ddcb625c032cf$var$connect = (devices)=>(state)=>{
        const mpkIndex = $077ddcb625c032cf$var$findAutoConnectMpkIndex(devices.inputs);
        const dataIn = mpkIndex > -1 && state.midiMap.data.in.indexOf(mpkIndex) === -1 ? $077ddcb625c032cf$require$arr.add(state.midiMap.data.in, mpkIndex) : state.midiMap.data.in;
        return $077ddcb625c032cf$require$obj.patch(state, "midiMap", {
            devices: devices,
            data: {
                ...state.midiMap.data,
                in: dataIn
            }
        });
    };
const $077ddcb625c032cf$var$toggleClock = (inOut, index)=>(state)=>$077ddcb625c032cf$require$obj.patch(state, [
            "midiMap",
            "clock",
            inOut
        ], $077ddcb625c032cf$require$arr.toggle($077ddcb625c032cf$require$obj.sub(state, [
            "midiMap",
            "clock"
        ])[inOut], index));
const $077ddcb625c032cf$var$toggleData = (inOut, index)=>(state)=>$077ddcb625c032cf$require$obj.patch(state, [
            "midiMap",
            "data",
            inOut
        ], $077ddcb625c032cf$require$arr.toggle($077ddcb625c032cf$require$obj.sub(state, [
            "midiMap",
            "data",
            inOut
        ]), index));
const $077ddcb625c032cf$var$noteOn = (device = 0, channel, note, velocity = 0)=>(state)=>channel !== undefined ? // console.log(state.midiMap.channels, obj.sub(state, ['midiMap', 'channels', channel, note]), channel, note, velocity),
        velocity !== 0 ? $077ddcb625c032cf$require$obj.patch(state, [
            "midiMap",
            "channels",
            device,
            channel,
            note
        ], velocity) : $077ddcb625c032cf$require$obj.patch(state, [
            "midiMap",
            "channels",
            device
        ], {
            [channel]: $077ddcb625c032cf$require$obj.filter($077ddcb625c032cf$require$obj.sub(state, [
                "midiMap",
                "channels",
                device,
                channel
            ]) || {}, (key, value)=>key !== note)
        }) : state;
const $077ddcb625c032cf$var$panic = ()=>(state)=>$077ddcb625c032cf$require$obj.patch(state, [
            "midiMap",
            "channels"
        ], {});
const $077ddcb625c032cf$var$modify = (p, v)=>(state)=>$077ddcb625c032cf$require$obj.patch(state, [
            "midiMap"
        ], {
            map: $077ddcb625c032cf$var$arrMod(state.midiMap.map, p, v)
        });
module.exports = {
    initial: $077ddcb625c032cf$var$initial,
    connect: $077ddcb625c032cf$var$connect,
    toggleClock: $077ddcb625c032cf$var$toggleClock,
    toggleData: $077ddcb625c032cf$var$toggleData,
    noteOn: $077ddcb625c032cf$var$noteOn,
    panic: $077ddcb625c032cf$var$panic,
    modify: $077ddcb625c032cf$var$modify
};

});

parcelRegister("d3zJK", function(module, exports) {
"use strict";

var $jjnZg = parcelRequire("jjnZg");
var $981746c5d5994e19$require$obj = $jjnZg.obj;
var $981746c5d5994e19$require$arr = $jjnZg.arr;
var $981746c5d5994e19$require$fn = $jjnZg.fn;

var $gsDht = parcelRequire("gsDht");
var $981746c5d5994e19$require$measureToBeatLength = $gsDht.measureToBeatLength;
const $981746c5d5994e19$var$initial = {
    files: [],
    samples: [
        // {
        // 	name: 'original bank(will be replaced soon)',
        // 	expanded: true,
        // 	items: [
        // 		{
        // 			name: 'kick',
        // 			items: [
        // 				'kick01.ogg',
        // 				'kick02.ogg',
        // 				'kick03.ogg',
        // 				'kick_hiphop01.ogg'
        // 			]
        // 		},
        // 		{
        // 			name: 'hihat',
        // 			items: [
        // 				'hihat_opened02.ogg',
        // 				'hihat_opened03.ogg'
        // 			]
        // 		},
        // 		{
        // 			name: 'snare',
        // 			items: [
        // 				'snare01.ogg',
        // 				'snare02.ogg',
        // 				'snare03.ogg',
        // 				'snare04.ogg',
        // 				'snare05.ogg'
        // 			]
        // 		},
        // 		{
        // 			name: 'clap',
        // 			items: [
        // 				'clap01.ogg',
        // 				'clap02.ogg',
        // 				'clap03.ogg',
        // 				'clap04.ogg'
        // 			]
        // 		},
        // 		{
        // 			name: 'shaker',
        // 			items: [
        // 				'shaker01.ogg',
        // 				'shaker02.ogg'
        // 			]
        // 		},
        // 		'ride02.ogg',
        // 		'rim01.ogg'
        // 	]
        // },
        {
            name: "custom",
            items: []
        }
    ],
    patches: [
        {
            name: "default",
            patch: {
                vcaOn: 0,
                vca1: {
                    volume: 0.41,
                    attack: 0.31,
                    decay: 0.16,
                    sustain: 0.8,
                    release: 0.21
                },
                vca2: {
                    volume: 0.43,
                    attack: 0,
                    decay: 0.16,
                    sustain: 0.8,
                    release: 0.19
                },
                vco1: {
                    on: true,
                    type: "square",
                    detune: -1
                },
                vco2: {
                    on: true,
                    type: "sawtooth",
                    detune: 1
                },
                lfo: {
                    on: false,
                    type: "sawtooth",
                    frequency: 5,
                    gain: 0.15
                },
                vcf: {
                    on: true,
                    cutoff: 0.64,
                    resonance: 0,
                    gain: 0
                }
            }
        },
        {
            name: "fantasy bells",
            patch: {
                vcaOn: 1,
                vca1: {
                    volume: 0.21,
                    attack: 0,
                    decay: 0.16,
                    sustain: 0.8,
                    release: 0.52
                },
                vca2: {
                    volume: 0.17,
                    attack: 0,
                    decay: 0.16,
                    sustain: 0.8,
                    release: 0.55
                },
                vco1: {
                    on: true,
                    type: "sawtooth",
                    detune: -5
                },
                vco2: {
                    on: true,
                    type: "sine",
                    detune: 8
                },
                vcf: {
                    on: true,
                    cutoff: 0.57,
                    resonance: 0.37,
                    gain: 0
                }
            }
        },
        {
            name: "accordeon",
            patch: {
                vcaOn: 0,
                vca1: {
                    volume: 0.14,
                    attack: 0.19,
                    decay: 0.55,
                    sustain: 0.5,
                    release: 0.43
                },
                vca2: {
                    volume: 0.21,
                    attack: 0.16,
                    decay: 0.17,
                    sustain: 0.47,
                    release: 0.38
                },
                vco1: {
                    on: true,
                    type: "square",
                    detune: -3
                },
                vco2: {
                    on: true,
                    type: "sawtooth",
                    detune: 3
                },
                lfo: {
                    on: false,
                    type: "sawtooth",
                    frequency: 5,
                    gain: 0.15
                },
                vcf: {
                    on: true,
                    cutoff: 0.51,
                    resonance: 0.14,
                    gain: 0
                }
            }
        }
    ]
};
const $981746c5d5994e19$var$indexAt = (list, prop, value)=>list.reduce((at, item, index)=>item[prop] === value ? index : at, -1);
const $981746c5d5994e19$var$treePatch = (nodes, path, item)=>// console.log(nodes, path, item),
    path.length === 1 && path[0] === item ? [].concat(nodes, [
        item
    ]) : [
        $981746c5d5994e19$var$indexAt(nodes, "name", path[0])
    ].map((index)=>[
            {
                name: path[0],
                items: path.length > 2 ? $981746c5d5994e19$var$treePatch(index > -1 ? nodes[index].items : [], path.slice(1), item) : [].concat(index > -1 ? nodes[index].items : [], [
                    item
                ])
            }
        ].map((patch)=>index > -1 ? [].concat(nodes.slice(0, index), [
                patch
            ], nodes.slice(index + 1)) : [].concat(nodes, [
                patch
            ])).pop()).pop();
const $981746c5d5994e19$var$loadSamples = (list)=>(state)=>$981746c5d5994e19$require$obj.patch(state, "mediaLibrary", {
            files: [].concat(state.mediaLibrary.files, list),
            samples: list.reduce((tree, item)=>$981746c5d5994e19$var$treePatch(tree, item.split("/"), item.split("/").pop()), state.mediaLibrary.samples)
        });
const $981746c5d5994e19$var$addSample = (sample, bank = "custom")=>(state)=>$981746c5d5994e19$require$obj.patch(state, "mediaLibrary", [
            $981746c5d5994e19$var$indexAt(state.mediaLibrary.samples, "name", bank)
        ].map((index)=>({
                samples: [].concat(state.mediaLibrary.samples.slice(0, index), $981746c5d5994e19$require$obj.patch(state.mediaLibrary.samples[index], {
                    index: $981746c5d5994e19$require$arr.add(state.mediaLibrary.samples[index].items, sample)
                }), state.mediaLibrary.samples.slice(index + 1))
            })).pop());
const $981746c5d5994e19$var$addPatch = (name, patch)=>(state)=>$981746c5d5994e19$require$obj.patch(state, "mediaLibrary", {
            patches: $981746c5d5994e19$require$arr.add(state.mediaLibrary.patches, {
                name: name,
                patch: patch
            })
        });
module.exports = {
    initial: $981746c5d5994e19$var$initial,
    loadSamples: $981746c5d5994e19$var$loadSamples,
    addSample: $981746c5d5994e19$var$addSample,
    addPatch: $981746c5d5994e19$var$addPatch
};

});


parcelRegister("cVcju", function(module, exports) {
"use strict";

var $jjnZg = parcelRequire("jjnZg");
var $96845c124faaba05$require$obj = $jjnZg.obj;
var $96845c124faaba05$require$fn = $jjnZg.fn;

var $2Z6Kw = parcelRequire("2Z6Kw");
var $96845c124faaba05$require$div = $2Z6Kw.div;
var $96845c124faaba05$require$p = $2Z6Kw.p;
var $96845c124faaba05$require$button = $2Z6Kw.button;
var $96845c124faaba05$require$a = $2Z6Kw.a;
var $96845c124faaba05$require$ul = $2Z6Kw.ul;
var $96845c124faaba05$require$li = $2Z6Kw.li;

var $5KiKJ = parcelRequire("5KiKJ");

var $eiEv3 = parcelRequire("eiEv3");

var $8ekoQ = parcelRequire("8ekoQ");

var $hFQ5h = parcelRequire("hFQ5h");

var $fYMUn = parcelRequire("fYMUn");

var $ll0Ct = parcelRequire("ll0Ct");

var $b7zo8 = parcelRequire("b7zo8");

var $a0RSb = parcelRequire("a0RSb");

var $26ETC = parcelRequire("26ETC");
const $96845c124faaba05$var$panels = {
    mediaLibrary: $8ekoQ,
    instrument: $hFQ5h,
    session: $fYMUn,
    sequencer: $ll0Ct,
    midiMap: $b7zo8,
    midiKeyboard: $a0RSb,
    pianoRoll: $26ETC
};
module.exports = ({ state: state, actions: actions, tapTempo: tapTempo })=>$96845c124faaba05$require$div("#ui", [
        $5KiKJ({
            state: state,
            actions: actions,
            tapTempo: tapTempo
        }),
        $96845c124faaba05$require$div("#content", $eiEv3({
            state: state,
            actions: actions
        }, $96845c124faaba05$var$panels))
    ]);

});
parcelRegister("2Z6Kw", function(module, exports) {

$parcel$export(module.exports, "patchStream", () => $22c6838f21f4f3e5$export$6d1478bea94d2d41);
$parcel$export(module.exports, "a", () => $22c6838f21f4f3e5$export$407448d2b89b1813);
$parcel$export(module.exports, "br", () => $22c6838f21f4f3e5$export$479ac0420f53ed26);
$parcel$export(module.exports, "button", () => $22c6838f21f4f3e5$export$2ba01fb71ed41cb6);
$parcel$export(module.exports, "canvas", () => $22c6838f21f4f3e5$export$67ea982130081db);
$parcel$export(module.exports, "div", () => $22c6838f21f4f3e5$export$159d9494db57879b);
$parcel$export(module.exports, "fieldset", () => $22c6838f21f4f3e5$export$a38812d1aa1302d9);
$parcel$export(module.exports, "form", () => $22c6838f21f4f3e5$export$6210fa4921d2a466);
$parcel$export(module.exports, "h1", () => $22c6838f21f4f3e5$export$448e4850cad7c7b0);
$parcel$export(module.exports, "h2", () => $22c6838f21f4f3e5$export$a943aa9a0fca3f0b);
$parcel$export(module.exports, "h3", () => $22c6838f21f4f3e5$export$7edd4a21fac8ce55);
$parcel$export(module.exports, "header", () => $22c6838f21f4f3e5$export$38e42c68cf43b5d4);
$parcel$export(module.exports, "hr", () => $22c6838f21f4f3e5$export$b4adb3f464574dcf);
$parcel$export(module.exports, "i", () => $22c6838f21f4f3e5$export$23f2a1d2818174ef);
$parcel$export(module.exports, "img", () => $22c6838f21f4f3e5$export$463b44d9bf3628be);
$parcel$export(module.exports, "input", () => $22c6838f21f4f3e5$export$b7e3ae3d7c15e42e);
$parcel$export(module.exports, "label", () => $22c6838f21f4f3e5$export$1237798dc640739a);
$parcel$export(module.exports, "legend", () => $22c6838f21f4f3e5$export$9a9b59e08de24cef);
$parcel$export(module.exports, "li", () => $22c6838f21f4f3e5$export$19caeaf7d9d84644);
$parcel$export(module.exports, "option", () => $22c6838f21f4f3e5$export$a75d1723e6bda2ec);
$parcel$export(module.exports, "p", () => $22c6838f21f4f3e5$export$ffb5f4729a158638);
$parcel$export(module.exports, "select", () => $22c6838f21f4f3e5$export$2e6c959c16ff56b8);
$parcel$export(module.exports, "span", () => $22c6838f21f4f3e5$export$afc1bfabebaf28a2);
$parcel$export(module.exports, "table", () => $22c6838f21f4f3e5$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tbody", () => $22c6838f21f4f3e5$export$7cdd536eaa8f163c);
$parcel$export(module.exports, "td", () => $22c6838f21f4f3e5$export$2beef8af2014e5c6);
$parcel$export(module.exports, "th", () => $22c6838f21f4f3e5$export$d657bc098992a431);
$parcel$export(module.exports, "thead", () => $22c6838f21f4f3e5$export$e3f32a5920890b82);
$parcel$export(module.exports, "tr", () => $22c6838f21f4f3e5$export$72451b88a72ad9c2);
$parcel$export(module.exports, "ul", () => $22c6838f21f4f3e5$export$b5023c870cb34848);
$parcel$export(module.exports, "h", () => (parcelRequire("8mEVn")).h);
/**
 * @module iblokz-snabbdom-helpers
 * @description Snabbdom virtual DOM helpers with hyperscript syntax sugar
 * @version 2.0.0
 */ 
var $jD6HF = parcelRequire("jD6HF");
var $1KGiq = parcelRequire("1KGiq");
var $el8X9 = parcelRequire("el8X9");
var $8mEVn = parcelRequire("8mEVn");
var $6J8nM = parcelRequire("6J8nM");
var $gPWxq = parcelRequire("gPWxq");
var $jLqM6 = parcelRequire("jLqM6");

var $f6wSa = parcelRequire("f6wSa");

var $94573 = parcelRequire("94573");

var $aADWn = parcelRequire("aADWn");
const $22c6838f21f4f3e5$export$b76953f99ab2be78 = (0, $6J8nM.init)([
    (0, $1KGiq.classModule),
    (0, $gPWxq.propsModule),
    (0, $jD6HF.attributesModule),
    (0, $jLqM6.styleModule),
    (0, $el8X9.eventListenersModule // attaches event listeners
    )
]);
const $22c6838f21f4f3e5$export$6d1478bea94d2d41 = (stream, dom)=>{
    dom = typeof dom === "string" ? document.querySelector(dom) : dom;
    return stream.pipe((0, $f6wSa.scan)((vnode, newVnode)=>$22c6838f21f4f3e5$export$b76953f99ab2be78(vnode, newVnode), dom)).subscribe();
};
/**
 * Generate hyperscript helper functions for all HTML tags
 */ const $22c6838f21f4f3e5$var$hyperHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($94573))).reduce((o, tag)=>{
    o[tag] = function() {
        return [
            Array.from(arguments)
        ].map($aADWn.process).map((args)=>// is the first argument a selector
            args[0] && typeof args[0] === "string" && args[0].match(/^(\.|#)[a-zA-Z\-_0-9]+/ig) ? [].concat(tag + args[0], args.slice(1)) : [
                tag
            ].concat(args)).map((args)=>(0, $8mEVn.h).apply(this, args)).pop();
    };
    return o;
}, {});
const { a: $22c6838f21f4f3e5$export$407448d2b89b1813, abbr: $22c6838f21f4f3e5$export$2bcb785951133fe5, address: $22c6838f21f4f3e5$export$f7d3c097ceca6c15, area: $22c6838f21f4f3e5$export$bb3edc44842b5f2e, article: $22c6838f21f4f3e5$export$bba2aacf8566461b, aside: $22c6838f21f4f3e5$export$64a02cd6422b91be, audio: $22c6838f21f4f3e5$export$592b77e6034db746, b: $22c6838f21f4f3e5$export$8b22cf2602fb60ce, base: $22c6838f21f4f3e5$export$e2253033e6e1df16, bdi: $22c6838f21f4f3e5$export$2d20a4e9df674436, bdo: $22c6838f21f4f3e5$export$fae0db89ef70aab2, blockquote: $22c6838f21f4f3e5$export$67dc04e652a298ca, body: $22c6838f21f4f3e5$export$32180ef41b15b513, br: $22c6838f21f4f3e5$export$479ac0420f53ed26, button: $22c6838f21f4f3e5$export$2ba01fb71ed41cb6, canvas: $22c6838f21f4f3e5$export$67ea982130081db, caption: $22c6838f21f4f3e5$export$8e3c2dfdc4f0453d, cite: $22c6838f21f4f3e5$export$3035df57df42c31a, code: $22c6838f21f4f3e5$export$6565f9f03506010b, col: $22c6838f21f4f3e5$export$aba86695643891f5, colgroup: $22c6838f21f4f3e5$export$3db318dd257cd653, data: $22c6838f21f4f3e5$export$4051a07651545597, datalist: $22c6838f21f4f3e5$export$d6956b5f6d5ee87d, dd: $22c6838f21f4f3e5$export$eaaeafa904fe3ddf, del: $22c6838f21f4f3e5$export$1d2f21e549771e67, details: $22c6838f21f4f3e5$export$41ee12f6f6f05843, dfn: $22c6838f21f4f3e5$export$771f54d1a902afc9, dialog: $22c6838f21f4f3e5$export$518824cf31321346, div: $22c6838f21f4f3e5$export$159d9494db57879b, dl: $22c6838f21f4f3e5$export$53d26b7a9a23d594, dt: $22c6838f21f4f3e5$export$9198f9466fc833e, em: $22c6838f21f4f3e5$export$c63c6f932822f543, embed: $22c6838f21f4f3e5$export$2be46bb7e96db87f, fieldset: $22c6838f21f4f3e5$export$a38812d1aa1302d9, figcaption: $22c6838f21f4f3e5$export$b75acb72a9c69c26, figure: $22c6838f21f4f3e5$export$991dc94f816a1d48, footer: $22c6838f21f4f3e5$export$adb608be33961c98, form: $22c6838f21f4f3e5$export$6210fa4921d2a466, h1: $22c6838f21f4f3e5$export$448e4850cad7c7b0, h2: $22c6838f21f4f3e5$export$a943aa9a0fca3f0b, h3: $22c6838f21f4f3e5$export$7edd4a21fac8ce55, h4: $22c6838f21f4f3e5$export$51a85cc1b68f452c, h5: $22c6838f21f4f3e5$export$f44841a11990acb2, h6: $22c6838f21f4f3e5$export$c9ccd321d64f47e3, head: $22c6838f21f4f3e5$export$5fd5031fecdacec3, header: $22c6838f21f4f3e5$export$38e42c68cf43b5d4, hgroup: $22c6838f21f4f3e5$export$e7c17d6cef8bd1c, hr: $22c6838f21f4f3e5$export$b4adb3f464574dcf, html: $22c6838f21f4f3e5$export$c0bb0b647f701bb5, i: $22c6838f21f4f3e5$export$23f2a1d2818174ef, iframe: $22c6838f21f4f3e5$export$8cde213409fd6377, img: $22c6838f21f4f3e5$export$463b44d9bf3628be, input: $22c6838f21f4f3e5$export$b7e3ae3d7c15e42e, ins: $22c6838f21f4f3e5$export$27a48efc044c200a, kbd: $22c6838f21f4f3e5$export$1ed45b69d23c052b, label: $22c6838f21f4f3e5$export$1237798dc640739a, legend: $22c6838f21f4f3e5$export$9a9b59e08de24cef, li: $22c6838f21f4f3e5$export$19caeaf7d9d84644, link: $22c6838f21f4f3e5$export$9c30223ca0a664fb, main: $22c6838f21f4f3e5$export$f22da7240b7add18, map: $22c6838f21f4f3e5$export$871de8747c9eaa88, mark: $22c6838f21f4f3e5$export$bf7f2fce5c1cf636, menu: $22c6838f21f4f3e5$export$b1e5508a851be14d, meta: $22c6838f21f4f3e5$export$6990040ee07315, meter: $22c6838f21f4f3e5$export$82334bbdfcebb57, nav: $22c6838f21f4f3e5$export$80e4b313e5e6b30d, noscript: $22c6838f21f4f3e5$export$528ba0e6da49e146, object: $22c6838f21f4f3e5$export$be5493f9613cbbe, ol: $22c6838f21f4f3e5$export$b2235297ee22a6fe, optgroup: $22c6838f21f4f3e5$export$b9d336f245a516e8, option: $22c6838f21f4f3e5$export$a75d1723e6bda2ec, output: $22c6838f21f4f3e5$export$c789db2c85949867, p: $22c6838f21f4f3e5$export$ffb5f4729a158638, picture: $22c6838f21f4f3e5$export$1188214e9d38144e, pre: $22c6838f21f4f3e5$export$2af2ac64526e2aa9, progress: $22c6838f21f4f3e5$export$504d7abb21fa8c9, q: $22c6838f21f4f3e5$export$9e5f44173e64f162, rp: $22c6838f21f4f3e5$export$6d4c73e3ddf8818b, rt: $22c6838f21f4f3e5$export$f08282231bb71285, ruby: $22c6838f21f4f3e5$export$f2b283820b448b35, s: $22c6838f21f4f3e5$export$2408f22a0fab9ae5, samp: $22c6838f21f4f3e5$export$8c1cb8fb6818c292, script: $22c6838f21f4f3e5$export$bc237d627614fc48, search: $22c6838f21f4f3e5$export$d76128d007d19019, section: $22c6838f21f4f3e5$export$fe2e36411d703b3d, select: $22c6838f21f4f3e5$export$2e6c959c16ff56b8, slot: $22c6838f21f4f3e5$export$103b78750979eead, small: $22c6838f21f4f3e5$export$3c17b0e969a90510, source: $22c6838f21f4f3e5$export$b4d5da5f34fb77ad, span: $22c6838f21f4f3e5$export$afc1bfabebaf28a2, strong: $22c6838f21f4f3e5$export$59ae2c325a998f89, style: $22c6838f21f4f3e5$export$1d567c320f4763bc, sub: $22c6838f21f4f3e5$export$f93b5905241a7cca, summary: $22c6838f21f4f3e5$export$9a2dbef7a17e2e58, sup: $22c6838f21f4f3e5$export$abe1cd54efe9b9cd, table: $22c6838f21f4f3e5$export$9852986a3ec5f6a0, tbody: $22c6838f21f4f3e5$export$7cdd536eaa8f163c, td: $22c6838f21f4f3e5$export$2beef8af2014e5c6, template: $22c6838f21f4f3e5$export$ce69bd05624d0c48, textarea: $22c6838f21f4f3e5$export$a3574df893ffa88d, tfoot: $22c6838f21f4f3e5$export$9396b2f97a03ad14, th: $22c6838f21f4f3e5$export$d657bc098992a431, thead: $22c6838f21f4f3e5$export$e3f32a5920890b82, time: $22c6838f21f4f3e5$export$2da9be4cfdb689b1, title: $22c6838f21f4f3e5$export$fb184b623420d9be, tr: $22c6838f21f4f3e5$export$72451b88a72ad9c2, track: $22c6838f21f4f3e5$export$6b2a7d5132615086, u: $22c6838f21f4f3e5$export$3b14a55fb2447963, ul: $22c6838f21f4f3e5$export$b5023c870cb34848, video: $22c6838f21f4f3e5$export$5f8d3589eb8441ca, wbr: $22c6838f21f4f3e5$export$ee8f8f9447a35bdc } = $22c6838f21f4f3e5$var$hyperHelpers;

});
parcelRegister("jD6HF", function(module, exports) {

$parcel$export(module.exports, "attributesModule", () => $e4a6dbf465fd919f$export$5381d68fac100f69);
const $e4a6dbf465fd919f$var$xlinkNS = "http://www.w3.org/1999/xlink";
const $e4a6dbf465fd919f$var$xmlnsNS = "http://www.w3.org/2000/xmlns/";
const $e4a6dbf465fd919f$var$xmlNS = "http://www.w3.org/XML/1998/namespace";
const $e4a6dbf465fd919f$var$colonChar = 58;
const $e4a6dbf465fd919f$var$xChar = 120;
const $e4a6dbf465fd919f$var$mChar = 109;
function $e4a6dbf465fd919f$var$updateAttrs(oldVnode, vnode) {
    let key;
    const elm = vnode.elm;
    let oldAttrs = oldVnode.data.attrs;
    let attrs = vnode.data.attrs;
    if (!oldAttrs && !attrs) return;
    if (oldAttrs === attrs) return;
    oldAttrs = oldAttrs || {};
    attrs = attrs || {};
    // update modified attributes, add new attributes
    for(key in attrs){
        const cur = attrs[key];
        const old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, "");
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key.charCodeAt(0) !== $e4a6dbf465fd919f$var$xChar) elm.setAttribute(key, cur);
                else if (key.charCodeAt(3) === $e4a6dbf465fd919f$var$colonChar) // Assume xml namespace
                elm.setAttributeNS($e4a6dbf465fd919f$var$xmlNS, key, cur);
                else if (key.charCodeAt(5) === $e4a6dbf465fd919f$var$colonChar) // Assume 'xmlns' or 'xlink' namespace
                key.charCodeAt(1) === $e4a6dbf465fd919f$var$mChar ? elm.setAttributeNS($e4a6dbf465fd919f$var$xmlnsNS, key, cur) : elm.setAttributeNS($e4a6dbf465fd919f$var$xlinkNS, key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    // remove removed attributes
    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
    // the other option is to remove all attributes with value == undefined
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
const $e4a6dbf465fd919f$export$5381d68fac100f69 = {
    create: $e4a6dbf465fd919f$var$updateAttrs,
    update: $e4a6dbf465fd919f$var$updateAttrs
};

});

parcelRegister("1KGiq", function(module, exports) {

$parcel$export(module.exports, "classModule", () => $146ae574f24b65f5$export$63b0a5e02d9d5ac4);
function $146ae574f24b65f5$var$updateClass(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldClass = oldVnode.data.class;
    let klass = vnode.data.class;
    if (!oldClass && !klass) return;
    if (oldClass === klass) return;
    oldClass = oldClass || {};
    klass = klass || {};
    for(name in oldClass)if (oldClass[name] && !Object.prototype.hasOwnProperty.call(klass, name)) // was `true` and now not provided
    elm.classList.remove(name);
    for(name in klass){
        cur = klass[name];
        if (cur !== oldClass[name]) elm.classList[cur ? "add" : "remove"](name);
    }
}
const $146ae574f24b65f5$export$63b0a5e02d9d5ac4 = {
    create: $146ae574f24b65f5$var$updateClass,
    update: $146ae574f24b65f5$var$updateClass
};

});

parcelRegister("el8X9", function(module, exports) {

$parcel$export(module.exports, "eventListenersModule", () => $a709f8bfbf99c957$export$7141f6ad17467258);
function $a709f8bfbf99c957$var$invokeHandler(handler, vnode, event) {
    if (typeof handler === "function") // call function handler
    handler.call(vnode, event, vnode);
    else if (typeof handler === "object") // call multiple handlers
    for(let i = 0; i < handler.length; i++)$a709f8bfbf99c957$var$invokeHandler(handler[i], vnode, event);
}
function $a709f8bfbf99c957$var$handleEvent(event, vnode) {
    const name = event.type;
    const on = vnode.data.on;
    // call event handler(s) if exists
    if (on && on[name]) $a709f8bfbf99c957$var$invokeHandler(on[name], vnode, event);
}
function $a709f8bfbf99c957$var$createListener() {
    return function handler(event) {
        $a709f8bfbf99c957$var$handleEvent(event, handler.vnode);
    };
}
function $a709f8bfbf99c957$var$updateEventListeners(oldVnode, vnode) {
    const oldOn = oldVnode.data.on;
    const oldListener = oldVnode.listener;
    const oldElm = oldVnode.elm;
    const on = vnode && vnode.data.on;
    const elm = vnode && vnode.elm;
    let name;
    // optimization for reused immutable handlers
    if (oldOn === on) return;
    // remove existing listeners which no longer used
    if (oldOn && oldListener) {
        // if element changed or deleted we remove all existing listeners unconditionally
        if (!on) for(name in oldOn)// remove listener if element was changed or existing listeners removed
        oldElm.removeEventListener(name, oldListener, false);
        else {
            for(name in oldOn)// remove listener if existing listener removed
            if (!on[name]) oldElm.removeEventListener(name, oldListener, false);
        }
    }
    // add new listeners which has not already attached
    if (on) {
        // reuse existing listener or create new
        const listener = vnode.listener = oldVnode.listener || $a709f8bfbf99c957$var$createListener();
        // update vnode for listener
        listener.vnode = vnode;
        // if element changed or added we add all needed listeners unconditionally
        if (!oldOn) for(name in on)// add listener if element was changed or new listeners added
        elm.addEventListener(name, listener, false);
        else {
            for(name in on)// add listener if new listener added
            if (!oldOn[name]) elm.addEventListener(name, listener, false);
        }
    }
}
const $a709f8bfbf99c957$export$7141f6ad17467258 = {
    create: $a709f8bfbf99c957$var$updateEventListeners,
    update: $a709f8bfbf99c957$var$updateEventListeners,
    destroy: $a709f8bfbf99c957$var$updateEventListeners
};

});

parcelRegister("8mEVn", function(module, exports) {

$parcel$export(module.exports, "h", () => $61701f878e412ab1$export$dda1d9f60106f0e9);

var $ezf0Y = parcelRequire("ezf0Y");

var $dWTau = parcelRequire("dWTau");
function $61701f878e412ab1$export$588773bb5c18f715(data, children, sel) {
    data.ns = "http://www.w3.org/2000/svg";
    if (sel !== "foreignObject" && children !== undefined) for(let i = 0; i < children.length; ++i){
        const child = children[i];
        if (typeof child === "string") continue;
        const childData = child.data;
        if (childData !== undefined) $61701f878e412ab1$export$588773bb5c18f715(childData, child.children, child.sel);
    }
}
function $61701f878e412ab1$export$dda1d9f60106f0e9(sel, b, c) {
    let data = {};
    let children;
    let text;
    let i;
    if (c !== undefined) {
        if (b !== null) data = b;
        if ($dWTau.array(c)) children = c;
        else if ($dWTau.primitive(c)) text = c.toString();
        else if (c && c.sel) children = [
            c
        ];
    } else if (b !== undefined && b !== null) {
        if ($dWTau.array(b)) children = b;
        else if ($dWTau.primitive(b)) text = b.toString();
        else if (b && b.sel) children = [
            b
        ];
        else data = b;
    }
    if (children !== undefined) {
        for(i = 0; i < children.length; ++i)if ($dWTau.primitive(children[i])) children[i] = (0, $ezf0Y.vnode)(undefined, undefined, undefined, children[i], undefined);
    }
    if (sel.startsWith("svg") && (sel.length === 3 || sel[3] === "." || sel[3] === "#")) $61701f878e412ab1$export$588773bb5c18f715(data, children, sel);
    return (0, $ezf0Y.vnode)(sel, data, children, text, undefined);
}
function $61701f878e412ab1$export$f00aeb236b6f05af(children) {
    let c;
    let text;
    if ($dWTau.array(children)) c = children;
    else if ($dWTau.primitive(c)) text = children;
    else if (c && c.sel) c = [
        children
    ];
    if (c !== undefined) {
        for(let i = 0; i < c.length; ++i)if ($dWTau.primitive(c[i])) c[i] = (0, $ezf0Y.vnode)(undefined, undefined, undefined, c[i], undefined);
    }
    return (0, $ezf0Y.vnode)(undefined, {}, c, text, undefined);
}

});
parcelRegister("ezf0Y", function(module, exports) {

$parcel$export(module.exports, "vnode", () => $a9affb2f56d1931e$export$86f1c2e46be1e431);
function $a9affb2f56d1931e$export$86f1c2e46be1e431(sel, data, children, text, elm) {
    const key = data === undefined ? undefined : data.key;
    return {
        sel: sel,
        data: data,
        children: children,
        text: text,
        elm: elm,
        key: key
    };
}

});

parcelRegister("dWTau", function(module, exports) {

$parcel$export(module.exports, "array", () => $a27b7c6934573bfd$export$2f23118c22fb2630);
$parcel$export(module.exports, "primitive", () => $a27b7c6934573bfd$export$f371853e3c41119);
const $a27b7c6934573bfd$export$2f23118c22fb2630 = Array.isArray;
function $a27b7c6934573bfd$export$f371853e3c41119(s) {
    return typeof s === "string" || typeof s === "number" || s instanceof String || s instanceof Number;
}

});


parcelRegister("6J8nM", function(module, exports) {

$parcel$export(module.exports, "init", () => $4e5d729fc02fe30d$export$2cd8252107eb640b);

var $ezf0Y = parcelRequire("ezf0Y");

var $dWTau = parcelRequire("dWTau");

var $8C7GF = parcelRequire("8C7GF");
const $4e5d729fc02fe30d$var$emptyNode = (0, $ezf0Y.vnode)("", {}, [], undefined, undefined);
function $4e5d729fc02fe30d$var$sameVnode(vnode1, vnode2) {
    var _a, _b;
    const isSameKey = vnode1.key === vnode2.key;
    const isSameIs = ((_a = vnode1.data) === null || _a === void 0 ? void 0 : _a.is) === ((_b = vnode2.data) === null || _b === void 0 ? void 0 : _b.is);
    const isSameSel = vnode1.sel === vnode2.sel;
    const isSameTextOrFragment = !vnode1.sel && vnode1.sel === vnode2.sel ? typeof vnode1.text === typeof vnode2.text : true;
    return isSameSel && isSameKey && isSameIs && isSameTextOrFragment;
}
/**
 * @todo Remove this function when the document fragment is considered stable.
 */ function $4e5d729fc02fe30d$var$documentFragmentIsNotSupported() {
    throw new Error("The document fragment is not supported on this platform.");
}
function $4e5d729fc02fe30d$var$isElement(api, vnode) {
    return api.isElement(vnode);
}
function $4e5d729fc02fe30d$var$isDocumentFragment(api, vnode) {
    return api.isDocumentFragment(vnode);
}
function $4e5d729fc02fe30d$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var _a;
    const map = {};
    for(let i = beginIdx; i <= endIdx; ++i){
        const key = (_a = children[i]) === null || _a === void 0 ? void 0 : _a.key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
const $4e5d729fc02fe30d$var$hooks = [
    "create",
    "update",
    "remove",
    "destroy",
    "pre",
    "post"
];
function $4e5d729fc02fe30d$export$2cd8252107eb640b(modules, domApi, options) {
    const cbs = {
        create: [],
        update: [],
        remove: [],
        destroy: [],
        pre: [],
        post: []
    };
    const api = domApi !== undefined ? domApi : (0, $8C7GF.htmlDomApi);
    for (const hook of $4e5d729fc02fe30d$var$hooks)for (const module of modules){
        const currentHook = module[hook];
        if (currentHook !== undefined) cbs[hook].push(currentHook);
    }
    function emptyNodeAt(elm) {
        const id = elm.id ? "#" + elm.id : "";
        // elm.className doesn't return a string when elm is an SVG element inside a shadowRoot.
        // https://stackoverflow.com/questions/29454340/detecting-classname-of-svganimatedstring
        const classes = elm.getAttribute("class");
        const c = classes ? "." + classes.split(" ").join(".") : "";
        return (0, $ezf0Y.vnode)(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
    }
    function emptyDocumentFragmentAt(frag) {
        return (0, $ezf0Y.vnode)(undefined, {}, [], undefined, frag);
    }
    function createRmCb(childElm, listeners) {
        return function rmCb() {
            if (--listeners === 0) {
                const parent = api.parentNode(childElm);
                if (parent !== null) api.removeChild(parent, childElm);
            }
        };
    }
    function createElm(vnode, insertedVnodeQueue) {
        var _a, _b, _c, _d, _e;
        let i;
        const data = vnode.data;
        const hook = data === null || data === void 0 ? void 0 : data.hook;
        (_a = hook === null || hook === void 0 ? void 0 : hook.init) === null || _a === void 0 || _a.call(hook, vnode);
        const children = vnode.children;
        const sel = vnode.sel;
        if (sel === "!") {
            (_b = vnode.text) !== null && _b !== void 0 ? _b : vnode.text = "";
            vnode.elm = api.createComment(vnode.text);
        } else if (sel === "") // textNode has no selector
        vnode.elm = api.createTextNode(vnode.text);
        else if (sel !== undefined) {
            // Parse selector
            const hashIdx = sel.indexOf("#");
            const dotIdx = sel.indexOf(".", hashIdx);
            const hash = hashIdx > 0 ? hashIdx : sel.length;
            const dot = dotIdx > 0 ? dotIdx : sel.length;
            const tag = hashIdx !== -1 || dotIdx !== -1 ? sel.slice(0, Math.min(hash, dot)) : sel;
            const ns = data === null || data === void 0 ? void 0 : data.ns;
            const elm = ns === undefined ? api.createElement(tag, data) : api.createElementNS(ns, tag, data);
            vnode.elm = elm;
            if (hash < dot) elm.setAttribute("id", sel.slice(hash + 1, dot));
            if (dotIdx > 0) elm.setAttribute("class", sel.slice(dot + 1).replace(/\./g, " "));
            for(i = 0; i < cbs.create.length; ++i)cbs.create[i]($4e5d729fc02fe30d$var$emptyNode, vnode);
            if ($dWTau.primitive(vnode.text) && (!$dWTau.array(children) || children.length === 0)) // allow h1 and similar nodes to be created w/ text and empty child list
            api.appendChild(elm, api.createTextNode(vnode.text));
            if ($dWTau.array(children)) for(i = 0; i < children.length; ++i){
                const ch = children[i];
                if (ch != null) api.appendChild(elm, createElm(ch, insertedVnodeQueue));
            }
            if (hook !== undefined) {
                (_c = hook.create) === null || _c === void 0 || _c.call(hook, $4e5d729fc02fe30d$var$emptyNode, vnode);
                if (hook.insert !== undefined) insertedVnodeQueue.push(vnode);
            }
        } else if (((_d = options === null || options === void 0 ? void 0 : options.experimental) === null || _d === void 0 ? void 0 : _d.fragments) && vnode.children) {
            vnode.elm = ((_e = api.createDocumentFragment) !== null && _e !== void 0 ? _e : $4e5d729fc02fe30d$var$documentFragmentIsNotSupported)();
            for(i = 0; i < cbs.create.length; ++i)cbs.create[i]($4e5d729fc02fe30d$var$emptyNode, vnode);
            for(i = 0; i < vnode.children.length; ++i){
                const ch = vnode.children[i];
                if (ch != null) api.appendChild(vnode.elm, createElm(ch, insertedVnodeQueue));
            }
        } else vnode.elm = api.createTextNode(vnode.text);
        return vnode.elm;
    }
    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for(; startIdx <= endIdx; ++startIdx){
            const ch = vnodes[startIdx];
            if (ch != null) api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
        }
    }
    function invokeDestroyHook(vnode) {
        var _a, _b;
        const data = vnode.data;
        if (data !== undefined) {
            (_b = (_a = data === null || data === void 0 ? void 0 : data.hook) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 || _b.call(_a, vnode);
            for(let i = 0; i < cbs.destroy.length; ++i)cbs.destroy[i](vnode);
            if (vnode.children !== undefined) for(let j = 0; j < vnode.children.length; ++j){
                const child = vnode.children[j];
                if (child != null && typeof child !== "string") invokeDestroyHook(child);
            }
        }
    }
    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
        var _a, _b;
        for(; startIdx <= endIdx; ++startIdx){
            let listeners;
            const ch = vnodes[startIdx];
            if (ch != null) {
                if (ch.sel !== undefined) {
                    invokeDestroyHook(ch);
                    listeners = cbs.remove.length + 1;
                    const rm = createRmCb(ch.elm, listeners);
                    for(let i = 0; i < cbs.remove.length; ++i)cbs.remove[i](ch, rm);
                    const removeHook = (_b = (_a = ch === null || ch === void 0 ? void 0 : ch.data) === null || _a === void 0 ? void 0 : _a.hook) === null || _b === void 0 ? void 0 : _b.remove;
                    if (removeHook !== undefined) removeHook(ch, rm);
                    else rm();
                } else if (ch.children) {
                    // Fragment node
                    invokeDestroyHook(ch);
                    removeVnodes(parentElm, ch.children, 0, ch.children.length - 1);
                } else // Text node
                api.removeChild(parentElm, ch.elm);
            }
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
        let oldStartIdx = 0;
        let newStartIdx = 0;
        let oldEndIdx = oldCh.length - 1;
        let oldStartVnode = oldCh[0];
        let oldEndVnode = oldCh[oldEndIdx];
        let newEndIdx = newCh.length - 1;
        let newStartVnode = newCh[0];
        let newEndVnode = newCh[newEndIdx];
        let oldKeyToIdx;
        let idxInOld;
        let elmToMove;
        let before;
        while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
            if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
            else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
            else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
            else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
            else if ($4e5d729fc02fe30d$var$sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if ($4e5d729fc02fe30d$var$sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($4e5d729fc02fe30d$var$sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($4e5d729fc02fe30d$var$sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if (oldKeyToIdx === undefined) oldKeyToIdx = $4e5d729fc02fe30d$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = oldKeyToIdx[newStartVnode.key];
                if (idxInOld === undefined) {
                    // `newStartVnode` is new, create and insert it in beginning
                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    newStartVnode = newCh[++newStartIdx];
                } else if (oldKeyToIdx[newEndVnode.key] === undefined) {
                    // `newEndVnode` is new, create and insert it in the end
                    api.insertBefore(parentElm, createElm(newEndVnode, insertedVnodeQueue), api.nextSibling(oldEndVnode.elm));
                    newEndVnode = newCh[--newEndIdx];
                } else {
                    // Neither of the new endpoints are new vnodes, so we make progress by
                    // moving `newStartVnode` into position
                    elmToMove = oldCh[idxInOld];
                    if (elmToMove.sel !== newStartVnode.sel) api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    else {
                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
                        oldCh[idxInOld] = undefined;
                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                    }
                    newStartVnode = newCh[++newStartIdx];
                }
            }
        }
        if (newStartIdx <= newEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        if (oldStartIdx <= oldEndIdx) removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const hook = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.hook;
        (_b = hook === null || hook === void 0 ? void 0 : hook.prepatch) === null || _b === void 0 || _b.call(hook, oldVnode, vnode);
        const elm = vnode.elm = oldVnode.elm;
        if (oldVnode === vnode) return;
        if (vnode.data !== undefined || vnode.text !== undefined && vnode.text !== oldVnode.text) {
            (_c = vnode.data) !== null && _c !== void 0 ? _c : vnode.data = {};
            (_d = oldVnode.data) !== null && _d !== void 0 ? _d : oldVnode.data = {};
            for(let i = 0; i < cbs.update.length; ++i)cbs.update[i](oldVnode, vnode);
            (_g = (_f = (_e = vnode.data) === null || _e === void 0 ? void 0 : _e.hook) === null || _f === void 0 ? void 0 : _f.update) === null || _g === void 0 || _g.call(_f, oldVnode, vnode);
        }
        const oldCh = oldVnode.children;
        const ch = vnode.children;
        if (vnode.text === undefined) {
            if (oldCh !== undefined && ch !== undefined) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue);
            } else if (ch !== undefined) {
                if (oldVnode.text !== undefined) api.setTextContent(elm, "");
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if (oldCh !== undefined) removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            else if (oldVnode.text !== undefined) api.setTextContent(elm, "");
        } else if (oldVnode.text !== vnode.text) {
            if (oldCh !== undefined) removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            api.setTextContent(elm, vnode.text);
        }
        (_h = hook === null || hook === void 0 ? void 0 : hook.postpatch) === null || _h === void 0 || _h.call(hook, oldVnode, vnode);
    }
    return function patch(oldVnode, vnode) {
        let i, elm, parent;
        const insertedVnodeQueue = [];
        for(i = 0; i < cbs.pre.length; ++i)cbs.pre[i]();
        if ($4e5d729fc02fe30d$var$isElement(api, oldVnode)) oldVnode = emptyNodeAt(oldVnode);
        else if ($4e5d729fc02fe30d$var$isDocumentFragment(api, oldVnode)) oldVnode = emptyDocumentFragmentAt(oldVnode);
        if ($4e5d729fc02fe30d$var$sameVnode(oldVnode, vnode)) patchVnode(oldVnode, vnode, insertedVnodeQueue);
        else {
            elm = oldVnode.elm;
            parent = api.parentNode(elm);
            createElm(vnode, insertedVnodeQueue);
            if (parent !== null) {
                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
                removeVnodes(parent, [
                    oldVnode
                ], 0, 0);
            }
        }
        for(i = 0; i < insertedVnodeQueue.length; ++i)insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
        for(i = 0; i < cbs.post.length; ++i)cbs.post[i]();
        return vnode;
    };
}

});
parcelRegister("8C7GF", function(module, exports) {

$parcel$export(module.exports, "htmlDomApi", () => $6457d5db16a04cc3$export$b5620185d61e7315);
function $6457d5db16a04cc3$var$createElement(tagName, options) {
    return document.createElement(tagName, options);
}
function $6457d5db16a04cc3$var$createElementNS(namespaceURI, qualifiedName, options) {
    return document.createElementNS(namespaceURI, qualifiedName, options);
}
function $6457d5db16a04cc3$var$createDocumentFragment() {
    return $6457d5db16a04cc3$var$parseFragment(document.createDocumentFragment());
}
function $6457d5db16a04cc3$var$createTextNode(text) {
    return document.createTextNode(text);
}
function $6457d5db16a04cc3$var$createComment(text) {
    return document.createComment(text);
}
function $6457d5db16a04cc3$var$insertBefore(parentNode, newNode, referenceNode) {
    if ($6457d5db16a04cc3$var$isDocumentFragment(parentNode)) {
        let node = parentNode;
        while(node && $6457d5db16a04cc3$var$isDocumentFragment(node)){
            const fragment = $6457d5db16a04cc3$var$parseFragment(node);
            node = fragment.parent;
        }
        parentNode = node !== null && node !== void 0 ? node : parentNode;
    }
    if ($6457d5db16a04cc3$var$isDocumentFragment(newNode)) newNode = $6457d5db16a04cc3$var$parseFragment(newNode, parentNode);
    if (referenceNode && $6457d5db16a04cc3$var$isDocumentFragment(referenceNode)) referenceNode = $6457d5db16a04cc3$var$parseFragment(referenceNode).firstChildNode;
    parentNode.insertBefore(newNode, referenceNode);
}
function $6457d5db16a04cc3$var$removeChild(node, child) {
    node.removeChild(child);
}
function $6457d5db16a04cc3$var$appendChild(node, child) {
    if ($6457d5db16a04cc3$var$isDocumentFragment(child)) child = $6457d5db16a04cc3$var$parseFragment(child, node);
    node.appendChild(child);
}
function $6457d5db16a04cc3$var$parentNode(node) {
    if ($6457d5db16a04cc3$var$isDocumentFragment(node)) {
        while(node && $6457d5db16a04cc3$var$isDocumentFragment(node)){
            const fragment = $6457d5db16a04cc3$var$parseFragment(node);
            node = fragment.parent;
        }
        return node !== null && node !== void 0 ? node : null;
    }
    return node.parentNode;
}
function $6457d5db16a04cc3$var$nextSibling(node) {
    var _a;
    if ($6457d5db16a04cc3$var$isDocumentFragment(node)) {
        const fragment = $6457d5db16a04cc3$var$parseFragment(node);
        const parent = $6457d5db16a04cc3$var$parentNode(fragment);
        if (parent && fragment.lastChildNode) {
            const children = Array.from(parent.childNodes);
            const index = children.indexOf(fragment.lastChildNode);
            return (_a = children[index + 1]) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }
    return node.nextSibling;
}
function $6457d5db16a04cc3$var$tagName(elm) {
    return elm.tagName;
}
function $6457d5db16a04cc3$var$setTextContent(node, text) {
    node.textContent = text;
}
function $6457d5db16a04cc3$var$getTextContent(node) {
    return node.textContent;
}
function $6457d5db16a04cc3$var$isElement(node) {
    return node.nodeType === 1;
}
function $6457d5db16a04cc3$var$isText(node) {
    return node.nodeType === 3;
}
function $6457d5db16a04cc3$var$isComment(node) {
    return node.nodeType === 8;
}
function $6457d5db16a04cc3$var$isDocumentFragment(node) {
    return node.nodeType === 11;
}
function $6457d5db16a04cc3$var$parseFragment(fragmentNode, parentNode) {
    var _a, _b, _c;
    const fragment = fragmentNode;
    (_a = fragment.parent) !== null && _a !== void 0 ? _a : fragment.parent = parentNode !== null && parentNode !== void 0 ? parentNode : null;
    (_b = fragment.firstChildNode) !== null && _b !== void 0 ? _b : fragment.firstChildNode = fragmentNode.firstChild;
    (_c = fragment.lastChildNode) !== null && _c !== void 0 ? _c : fragment.lastChildNode = fragmentNode.lastChild;
    return fragment;
}
const $6457d5db16a04cc3$export$b5620185d61e7315 = {
    createElement: $6457d5db16a04cc3$var$createElement,
    createElementNS: $6457d5db16a04cc3$var$createElementNS,
    createTextNode: $6457d5db16a04cc3$var$createTextNode,
    createDocumentFragment: $6457d5db16a04cc3$var$createDocumentFragment,
    createComment: $6457d5db16a04cc3$var$createComment,
    insertBefore: $6457d5db16a04cc3$var$insertBefore,
    removeChild: $6457d5db16a04cc3$var$removeChild,
    appendChild: $6457d5db16a04cc3$var$appendChild,
    parentNode: $6457d5db16a04cc3$var$parentNode,
    nextSibling: $6457d5db16a04cc3$var$nextSibling,
    tagName: $6457d5db16a04cc3$var$tagName,
    setTextContent: $6457d5db16a04cc3$var$setTextContent,
    getTextContent: $6457d5db16a04cc3$var$getTextContent,
    isElement: $6457d5db16a04cc3$var$isElement,
    isText: $6457d5db16a04cc3$var$isText,
    isComment: $6457d5db16a04cc3$var$isComment,
    isDocumentFragment: $6457d5db16a04cc3$var$isDocumentFragment
};

});


parcelRegister("gPWxq", function(module, exports) {

$parcel$export(module.exports, "propsModule", () => $c41ed1321adc5c62$export$d0f594d8c58ce469);
function $c41ed1321adc5c62$var$updateProps(oldVnode, vnode) {
    let key;
    let cur;
    let old;
    const elm = vnode.elm;
    let oldProps = oldVnode.data.props;
    let props = vnode.data.props;
    if (!oldProps && !props) return;
    if (oldProps === props) return;
    oldProps = oldProps || {};
    props = props || {};
    for(key in props){
        cur = props[key];
        old = oldProps[key];
        if (old !== cur && (key !== "value" || elm[key] !== cur)) elm[key] = cur;
    }
}
const $c41ed1321adc5c62$export$d0f594d8c58ce469 = {
    create: $c41ed1321adc5c62$var$updateProps,
    update: $c41ed1321adc5c62$var$updateProps
};

});

parcelRegister("jLqM6", function(module, exports) {

$parcel$export(module.exports, "styleModule", () => $e6372d03f1577732$export$8f225d2f409cea76);
// Binding `requestAnimationFrame` like this fixes a bug in IE/Edge. See #360 and #409.
const $e6372d03f1577732$var$raf = typeof (window === null || window === void 0 ? void 0 : window.requestAnimationFrame) === "function" ? window.requestAnimationFrame.bind(window) : setTimeout;
const $e6372d03f1577732$var$nextFrame = (fn)=>{
    $e6372d03f1577732$var$raf(()=>{
        $e6372d03f1577732$var$raf(fn);
    });
};
let $e6372d03f1577732$var$reflowForced = false;
function $e6372d03f1577732$var$setNextFrame(obj, prop, val) {
    $e6372d03f1577732$var$nextFrame(()=>{
        obj[prop] = val;
    });
}
function $e6372d03f1577732$var$updateStyle(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldStyle = oldVnode.data.style;
    let style = vnode.data.style;
    if (!oldStyle && !style) return;
    if (oldStyle === style) return;
    oldStyle = oldStyle || {};
    style = style || {};
    const oldHasDel = "delayed" in oldStyle;
    for(name in oldStyle)if (!(name in style)) {
        if (name[0] === "-" && name[1] === "-") elm.style.removeProperty(name);
        else elm.style[name] = "";
    }
    for(name in style){
        cur = style[name];
        if (name === "delayed" && style.delayed) for(const name2 in style.delayed){
            cur = style.delayed[name2];
            if (!oldHasDel || cur !== oldStyle.delayed[name2]) $e6372d03f1577732$var$setNextFrame(elm.style, name2, cur);
        }
        else if (name !== "remove" && cur !== oldStyle[name]) {
            if (name[0] === "-" && name[1] === "-") elm.style.setProperty(name, cur);
            else elm.style[name] = cur;
        }
    }
}
function $e6372d03f1577732$var$applyDestroyStyle(vnode) {
    let style;
    let name;
    const elm = vnode.elm;
    const s = vnode.data.style;
    if (!s || !(style = s.destroy)) return;
    for(name in style)elm.style[name] = style[name];
}
function $e6372d03f1577732$var$applyRemoveStyle(vnode, rm) {
    const s = vnode.data.style;
    if (!s || !s.remove) {
        rm();
        return;
    }
    if (!$e6372d03f1577732$var$reflowForced) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        vnode.elm.offsetLeft;
        $e6372d03f1577732$var$reflowForced = true;
    }
    let name;
    const elm = vnode.elm;
    let i = 0;
    const style = s.remove;
    let amount = 0;
    const applied = [];
    for(name in style){
        applied.push(name);
        elm.style[name] = style[name];
    }
    const compStyle = getComputedStyle(elm);
    const props = compStyle["transition-property"].split(", ");
    for(; i < props.length; ++i)if (applied.indexOf(props[i]) !== -1) amount++;
    elm.addEventListener("transitionend", (ev)=>{
        if (ev.target === elm) --amount;
        if (amount === 0) rm();
    });
}
function $e6372d03f1577732$var$forceReflow() {
    $e6372d03f1577732$var$reflowForced = false;
}
const $e6372d03f1577732$export$8f225d2f409cea76 = {
    pre: $e6372d03f1577732$var$forceReflow,
    create: $e6372d03f1577732$var$updateStyle,
    update: $e6372d03f1577732$var$updateStyle,
    destroy: $e6372d03f1577732$var$applyDestroyStyle,
    remove: $e6372d03f1577732$var$applyRemoveStyle
};

});

parcelRegister("f6wSa", function(module, exports) {

$parcel$export(module.exports, "scan", () => $aff0ea62bddc8b76$export$c87d910e63d22ed6);

var $iZT3c = parcelRequire("iZT3c");

var $5F2Ze = parcelRequire("5F2Ze");
function $aff0ea62bddc8b76$export$c87d910e63d22ed6(accumulator, seed) {
    return (0, $iZT3c.operate)((0, $5F2Ze.scanInternals)(accumulator, seed, arguments.length >= 2, true));
}

});
parcelRegister("5F2Ze", function(module, exports) {

$parcel$export(module.exports, "scanInternals", () => $41f319248fadf70f$export$30fc204bc7867c02);

var $lo1Ce = parcelRequire("lo1Ce");
function $41f319248fadf70f$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}

});


parcelRegister("94573", function(module, exports) {
module.exports = JSON.parse('["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","label","legend","li","link","main","map","mark","math","menu","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","picture","pre","progress","q","rp","rt","ruby","s","samp","script","search","section","select","selectedcontent","slot","small","source","span","strong","style","sub","summary","sup","svg","table","tbody","td","template","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr"]');

});

parcelRegister("aADWn", function(module, exports) {

$parcel$export(module.exports, "process", () => $7b5c3f842c3ee33f$export$e54fe5b0f43758f7);
/**
 * Attribute utilities for snabbdom helpers
 * @module util/attrs
 */ 
var $jjnZg = parcelRequire("jjnZg");
/**
 * Parse string values to appropriate types
 * @param {string} s - String to parse
 * @return {number|boolean|string} Parsed value
 */ const $7b5c3f842c3ee33f$export$4e21b1533c28e5b8 = (s)=>s.match(/^[0-9]+$/) ? parseInt(s, 10) : s.match(/^[0-9.]+$/) ? parseFloat(s) : s === "true" ? true : s === "false" ? false : s;
/**
 * Process hyperscript arguments with attribute selector support
 * @param {Array} args - Arguments to process
 * @return {Array} Processed arguments
 * @example
 * process(['[name="john"]']) // => [{attrs: {name: 'john'}}]
 */ const $7b5c3f842c3ee33f$export$e54fe5b0f43758f7 = (args)=>{
    let newArgs = args.slice();
    let selector = newArgs[0] && typeof newArgs[0] === "string" && newArgs[0] || "";
    if (selector !== "") newArgs = newArgs.slice(1);
    const attrRegExp = /\[[a-z\-0-9]+=("[^"]+"|'[^']+'|[0-9.]+|true|false|[^\]^=^"^']+)\]/ig;
    let attrs = selector && selector.match(attrRegExp);
    selector = selector.replace(attrRegExp, "");
    attrs = attrs && attrs.map && attrs.map((c)=>c.replace(/[[\]("|')]/g, "").split("=")).reduce((o, attr)=>(0, $jjnZg.obj).patch(o, attr[0], $7b5c3f842c3ee33f$export$4e21b1533c28e5b8(attr[1])), {}) || {};
    if (attrs && Object.keys(attrs).length > 0) {
        if (!newArgs[0] || newArgs[0] && typeof newArgs[0] === "object" && !(newArgs[0] instanceof Array)) {
            attrs = Object.assign({}, newArgs[0] && newArgs[0].attrs || {}, attrs);
            newArgs[0] = Object.assign({}, newArgs[0] || {}, {
                attrs: attrs
            });
        } else newArgs = [
            {
                attrs: attrs
            }
        ].concat(newArgs);
    }
    if (selector !== "") newArgs = [
        selector
    ].concat(newArgs);
    return newArgs;
};

});


parcelRegister("5KiKJ", function(module, exports) {
"use strict";

var $h5Z1H = parcelRequire("h5Z1H");

var $2Z6Kw = parcelRequire("2Z6Kw");
var $42efcb83a882b578$require$div = $2Z6Kw.div;
var $42efcb83a882b578$require$h1 = $2Z6Kw.h1;
var $42efcb83a882b578$require$header = $2Z6Kw.header;
var $42efcb83a882b578$require$img = $2Z6Kw.img;
var $42efcb83a882b578$require$i = $2Z6Kw.i;
var $42efcb83a882b578$require$ul = $2Z6Kw.ul;
var $42efcb83a882b578$require$li = $2Z6Kw.li;
var $42efcb83a882b578$require$a = $2Z6Kw.a;
var $42efcb83a882b578$require$button = $2Z6Kw.button;
var $42efcb83a882b578$require$input = $2Z6Kw.input;
var $42efcb83a882b578$require$label = $2Z6Kw.label;
var $42efcb83a882b578$require$span = $2Z6Kw.span;

var $6TsbL = parcelRequire("6TsbL");
const $42efcb83a882b578$var$openDialog = (cb)=>{
    let fileEl = document.createElement("input");
    fileEl.setAttribute("type", "file");
    fileEl.addEventListener("change", (ev)=>{
        console.log(ev.target.files, module.exports);
        cb(ev.target.files);
    });
    fileEl.dispatchEvent(new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
    }));
};
module.exports = ({ state: state, actions: actions, tapTempo: tapTempo })=>$42efcb83a882b578$require$header([
        $42efcb83a882b578$require$ul(".views", [
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a({
                    class: {
                        on: state.layout.mediaLibrary.visible
                    },
                    on: {
                        click: (ev)=>actions.toggle([
                                "layout",
                                "mediaLibrary",
                                "visible"
                            ])
                    }
                }, [
                    $42efcb83a882b578$require$i(".fa.fa-book")
                ])
            ]),
            // li([a({class: {on: state.ui.patches}, on: {click: ev => actions.toggleUI('patches')}}, 'Patches')]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a({
                    class: {
                        on: state.layout.instrument.visible
                    },
                    on: {
                        click: (ev)=>actions.toggle([
                                "layout",
                                "instrument",
                                "visible"
                            ])
                    }
                }, [
                    $42efcb83a882b578$require$i(".fa.fa-sliders")
                ])
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a({
                    class: {
                        on: state.layout.session.visible
                    },
                    on: {
                        click: (ev)=>actions.toggle([
                                "layout",
                                "session",
                                "visible"
                            ])
                    }
                }, [
                    $42efcb83a882b578$require$img('[src="assets/session.svg"][height="20px"]', {
                        style: {
                            margin: "9px 0px"
                        }
                    })
                ])
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a({
                    class: {
                        on: state.layout.sequencer.visible
                    },
                    on: {
                        click: (ev)=>actions.toggle([
                                "layout",
                                "sequencer",
                                "visible"
                            ])
                    }
                }, [
                    $42efcb83a882b578$require$i(".fa.fa-braille")
                ])
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a({
                    class: {
                        on: state.layout.pianoRoll.visible
                    },
                    on: {
                        click: (ev)=>actions.toggle([
                                "layout",
                                "pianoRoll",
                                "visible"
                            ])
                    }
                }, [
                    $42efcb83a882b578$require$img('[src="assets/piano-roll.svg"][height="34px"]')
                ])
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a({
                    class: {
                        on: state.layout.midiKeyboard.visible
                    },
                    on: {
                        click: (ev)=>actions.toggle([
                                "layout",
                                "midiKeyboard",
                                "visible"
                            ])
                    }
                }, [
                    $42efcb83a882b578$require$img('[src="assets/midi-keyboard.svg"]')
                ])
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a({
                    class: {
                        on: state.layout.midiMap.visible
                    },
                    on: {
                        click: (ev)=>actions.toggle([
                                "layout",
                                "midiMap",
                                "visible"
                            ])
                    }
                }, [
                    $42efcb83a882b578$require$img('[src="assets/midi.svg"][height="38px"]')
                ])
            ])
        ]),
        $42efcb83a882b578$require$ul(".center.controls", [
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$img('[src="assets/logo2.png"]')
            ]),
            $42efcb83a882b578$require$li(".right", [
                $42efcb83a882b578$require$button(".fa.fa-play", {
                    class: {
                        on: state.studio.playing
                    },
                    on: {
                        click: ()=>actions.studio.play()
                    }
                }),
                $42efcb83a882b578$require$button(".fa.fa-circle", {
                    class: {
                        on: state.studio.recording
                    },
                    on: {
                        click: ()=>actions.studio.record()
                    }
                }),
                $42efcb83a882b578$require$button(".fa.fa-stop", {
                    on: {
                        click: ()=>actions.studio.stop()
                    }
                }),
                $42efcb83a882b578$require$label(" "),
                $42efcb83a882b578$require$label({
                    on: {
                        click: ()=>tapTempo.tap()
                    }
                }, "BPM"),
                $42efcb83a882b578$require$input(".bpm", {
                    props: {
                        value: state.studio.bpm || 120,
                        size: 3
                    },
                    on: {
                        input: (ev)=>actions.studio.change("bpm", ev.target.value)
                    }
                }),
                /*
			label('LN'),
			input('.bars-length', {
				props: {value: state.studio.barsLength || 4, size: 3},
				on: {input: ev => actions.studio.change('barsLength', ev.target.value)}
			}),
			*/ $42efcb83a882b578$require$label("SIG"),
                $42efcb83a882b578$require$input(".measure", {
                    props: {
                        value: state.studio.measure || "4/4",
                        size: 6
                    },
                    on: {
                        input: (ev)=>actions.studio.change("measure", ev.target.value)
                    }
                })
            ])
        ]),
        $42efcb83a882b578$require$ul(".right.menu", [
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$input('[type="range"]', {
                    attrs: {
                        min: 0,
                        max: 1,
                        step: 0.005
                    },
                    props: {
                        value: state.studio.volume
                    },
                    on: {
                        change: (ev)=>actions.studio.change("volume", parseFloat(ev.target.value))
                    }
                })
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a('[title="New"]', {
                    on: {
                        click: ()=>actions.clear()
                    }
                }, [
                    $42efcb83a882b578$require$i(".fa.fa-file-o")
                ])
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a('[title="Save"]', {
                    on: {
                        click: (ev)=>$6TsbL.save($h5Z1H().format("YYYY-MM-DD-hh-mm[-jam.json]"), state)
                    }
                }, [
                    $42efcb83a882b578$require$i(".fa.fa-save")
                ])
            ]),
            $42efcb83a882b578$require$li([
                $42efcb83a882b578$require$a('[title="Load"]', {
                    on: {
                        click: (ev)=>$42efcb83a882b578$var$openDialog((files)=>$6TsbL.load(files[0], "json").subscribe((content)=>actions.load(content)))
                    }
                }, [
                    $42efcb83a882b578$require$i(".fa.fa-upload")
                ])
            ])
        ])
    ]);

});
parcelRegister("h5Z1H", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("6TsbL", function(module, exports) {
"use strict";

var $awcxJ = parcelRequire("awcxJ");
var $dMQAa = parcelRequire("dMQAa");
var $aIPjU = parcelRequire("aIPjU");
var $gN3J6 = parcelRequire("gN3J6");
var $504dbecdd81b0133$require$Observable = $gN3J6.Observable;
var $504dbecdd81b0133$require$from = $aIPjU.from;
var $504dbecdd81b0133$require$concat = $awcxJ.concat;
var $504dbecdd81b0133$require$EMPTY = $dMQAa.EMPTY;

var $g6ewV = parcelRequire("g6ewV");
var $bzRF9 = parcelRequire("bzRF9");
var $6SBin = parcelRequire("6SBin");
var $euDQb = parcelRequire("euDQb");
var $504dbecdd81b0133$require$flatMap = $bzRF9.flatMap;
var $504dbecdd81b0133$require$map = $6SBin.map;
var $504dbecdd81b0133$require$reduce = $euDQb.reduce;
var $504dbecdd81b0133$require$catchError = $g6ewV.catchError;

var $lvEvf = parcelRequire("lvEvf");

var $6PzUf = parcelRequire("6PzUf");

var $jjnZg = parcelRequire("jjnZg");
var $504dbecdd81b0133$require$fn = $jjnZg.fn;
var $504dbecdd81b0133$require$obj = $jjnZg.obj;
const $504dbecdd81b0133$var$load = (file, readAs = "text")=>new $504dbecdd81b0133$require$Observable((observer)=>{
        const fr = new FileReader();
        fr.onload = function(ev) {
            // console.log(readAs, ev.target.result);
            observer.next(readAs === "json" ? JSON.parse(ev.target.result) : ev.target.result);
            observer.complete();
        };
        fr.onerror = function(err) {
            observer.error(err);
        };
        // console.log(file, readAs);
        (typeof file === "string" ? $504dbecdd81b0133$require$from(fetch(file)).pipe($504dbecdd81b0133$require$flatMap((res)=>$504dbecdd81b0133$require$from(res.blob()))) : $504dbecdd81b0133$require$from([
            file
        ])).subscribe({
            next: (f)=>$504dbecdd81b0133$require$fn.switch(readAs, {
                    arrayBuffer: (f)=>fr.readAsArrayBuffer(f),
                    default: (f)=>fr.readAsText(f)
                })(f),
            error: (err)=>observer.error(err)
        });
    });
const $504dbecdd81b0133$var$loadZip = (file)=>$504dbecdd81b0133$var$load(file, "arrayBuffer").pipe($504dbecdd81b0133$require$flatMap((data)=>$504dbecdd81b0133$require$from($6PzUf.loadAsync(data))), $504dbecdd81b0133$require$flatMap((zf)=>$504dbecdd81b0133$require$concat(...Object.keys(zf.files).filter((k)=>!zf.files[k].dir)// .map(k => (console.log(k), k))
        .map((k)=>$504dbecdd81b0133$require$from(zf.files[k].async("arraybuffer")).pipe($504dbecdd81b0133$require$map((v)=>({
                    k: k,
                    v: v
                }))))).pipe($504dbecdd81b0133$require$reduce((o, { k: k, v: v })=>$504dbecdd81b0133$require$obj.patch(o, k, v), {}))));
const $504dbecdd81b0133$var$save = (fileName, content)=>$lvEvf.saveAs(new Blob([
        JSON.stringify(content)
    ], {
        type: "text/plain;charset=utf-8"
    }), fileName);
module.exports = {
    load: $504dbecdd81b0133$var$load,
    loadZip: $504dbecdd81b0133$var$loadZip,
    save: $504dbecdd81b0133$var$save
};

});
parcelRegister("g6ewV", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $bb887a44dcacc78f$export$3dede90624df3ba9);

var $kA4PZ = parcelRequire("kA4PZ");

var $lo1Ce = parcelRequire("lo1Ce");

var $iZT3c = parcelRequire("iZT3c");
function $bb887a44dcacc78f$export$3dede90624df3ba9(selector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $kA4PZ.innerFrom)(selector(err, $bb887a44dcacc78f$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

});

parcelRegister("euDQb", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $a8d2c58e2ec249ed$export$533b26079ad0b4b);

var $5F2Ze = parcelRequire("5F2Ze");

var $iZT3c = parcelRequire("iZT3c");
function $a8d2c58e2ec249ed$export$533b26079ad0b4b(accumulator, seed) {
    return (0, $iZT3c.operate)((0, $5F2Ze.scanInternals)(accumulator, seed, arguments.length >= 2, false, true));
}

});

parcelRegister("lvEvf", function(module, exports) {
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $fa8be949723f0250$var$saveAs = $fa8be949723f0250$var$saveAs || function(view) {
    "use strict";
    // IE <10 is explicitly unsupported
    if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var doc = view.document, get_URL = function() {
        return view.URL || view.webkitURL || view;
    }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
        var event = new MouseEvent("click");
        node.dispatchEvent(event);
    }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
        (view.setImmediate || view.setTimeout)(function() {
            throw ex;
        }, 0);
    }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000 // in ms
    , revoke = function(file) {
        var revoker = function() {
            if (typeof file === "string") get_URL().revokeObjectURL(file);
            else file.remove();
        };
        setTimeout(revoker, arbitrary_revoke_timeout);
    }, dispatch = function(filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while(i--){
            var listener = filesaver["on" + event_types[i]];
            if (typeof listener === "function") try {
                listener.call(filesaver, event || filesaver);
            } catch (ex) {
                throw_outside(ex);
            }
        }
    }, auto_bom = function(blob) {
        // prepend BOM for UTF-8 XML and text/* types (including HTML)
        // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
            String.fromCharCode(0xFEFF),
            blob
        ], {
            type: blob.type
        });
        return blob;
    }, FileSaver = function(blob, name, no_auto_bom) {
        if (!no_auto_bom) blob = auto_bom(blob);
        // First try a.download, then web filesystem, then object URLs
        var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
            dispatch(filesaver, "writestart progress write writeend".split(" "));
        }, fs_error = function() {
            if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                // Safari doesn't allow downloading of blob urls
                var reader = new FileReader();
                reader.onloadend = function() {
                    var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                    var popup = view.open(url, "_blank");
                    if (!popup) view.location.href = url;
                    url = undefined; // release reference before dispatching
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            // don't create more object URLs than needed
            if (!object_url) object_url = get_URL().createObjectURL(blob);
            if (force) view.location.href = object_url;
            else {
                var opened = view.open(object_url, "_blank");
                if (!opened) // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
                view.location.href = object_url;
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        };
        filesaver.readyState = filesaver.INIT;
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function() {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        fs_error();
    }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
        return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    };
    // IE 10+ (native saveAs)
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
        name = name || blob.name || "download";
        if (!no_auto_bom) blob = auto_bom(blob);
        return navigator.msSaveOrOpenBlob(blob, name);
    };
    FS_proto.abort = function() {};
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
    return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window
if (0, module.exports) module.exports.saveAs = $fa8be949723f0250$var$saveAs;
else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
    return $fa8be949723f0250$var$saveAs;
});

});

parcelRegister("6PzUf", function(module, exports) {
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ 
var $cbQCu = parcelRequire("cbQCu");
var $4f935bb8b4cfed5e$require$Buffer = $cbQCu.Buffer;

var $4Jj9n = parcelRequire("4Jj9n");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof $4f935bb8b4cfed5e$require$Buffer,
                    newBufferFrom: function(e, t) {
                        if ($4f935bb8b4cfed5e$require$Buffer.from && $4f935bb8b4cfed5e$require$Buffer.from !== Uint8Array.from) return $4f935bb8b4cfed5e$require$Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new $4f935bb8b4cfed5e$require$Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if ($4f935bb8b4cfed5e$require$Buffer.alloc) return $4f935bb8b4cfed5e$require$Buffer.alloc(e);
                        var t = new $4f935bb8b4cfed5e$require$Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return $4f935bb8b4cfed5e$require$Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return $4f935bb8b4cfed5e$require$Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof $4f935bb8b4cfed5e$require$Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                $4Jj9n.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

});
parcelRegister("cbQCu", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $8dff54558831dec9$export$a143d493d941bafc, (v) => $8dff54558831dec9$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8dff54558831dec9$export$f99ded8fe4b79145, (v) => $8dff54558831dec9$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
"use strict";

var $6ocIT = parcelRequire("6ocIT");

var $1wLos = parcelRequire("1wLos");
const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case "ascii":
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case "base64":
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $6ocIT.fromByteArray(buf);
    else return $6ocIT.fromByteArray(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $1wLos.read(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $1wLos.read(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $1wLos.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$8dff54558831dec9$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $6ocIT.toByteArray($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("6ocIT", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $4a6eda7d0e4e0857$export$d622b2ad8d90c771, (v) => $4a6eda7d0e4e0857$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $4a6eda7d0e4e0857$export$6100ba28696e12de, (v) => $4a6eda7d0e4e0857$export$6100ba28696e12de = v);
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
"use strict";
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup["-".charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup["_".charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("1wLos", function(module, exports) {

$parcel$export(module.exports, "read", () => $11cd8afb6c84e33a$export$aafa59e2e03f2942, (v) => $11cd8afb6c84e33a$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $11cd8afb6c84e33a$export$68d8715fc104d294, (v) => $11cd8afb6c84e33a$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = "browser";
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ""; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$371a3837fd81d701$var$process.cwd = function() {
    return "/";
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});




parcelRegister("eiEv3", function(module, exports) {

var $2Z6Kw = parcelRequire("2Z6Kw");
var $a6922994e5fb894c$require$div = $2Z6Kw.div;
var $a6922994e5fb894c$require$h1 = $2Z6Kw.h1;
var $a6922994e5fb894c$require$header = $2Z6Kw.header;
var $a6922994e5fb894c$require$img = $2Z6Kw.img;
var $a6922994e5fb894c$require$i = $2Z6Kw.i;
var $a6922994e5fb894c$require$ul = $2Z6Kw.ul;
var $a6922994e5fb894c$require$li = $2Z6Kw.li;
var $a6922994e5fb894c$require$a = $2Z6Kw.a;
var $a6922994e5fb894c$require$button = $2Z6Kw.button;
var $a6922994e5fb894c$require$input = $2Z6Kw.input;
var $a6922994e5fb894c$require$label = $2Z6Kw.label;
var $a6922994e5fb894c$require$span = $2Z6Kw.span;

var $jjnZg = parcelRequire("jjnZg");
var $a6922994e5fb894c$require$obj = $jjnZg.obj;
var $a6922994e5fb894c$require$fn = $jjnZg.fn;

var $1bMen = parcelRequire("1bMen");
var $a6922994e5fb894c$require$Sortable = $1bMen.default;
// TODO: Replace with arr.patchAt from iblokz-data after it is updated
/**
 * Immutably patches an array at a given index.
 * @param {Array} arr - The source array
 * @param {number} index - The index to patch
 * @param {Object|Function} patch - The patch to apply
 * @returns {Array} A new array with the patch applied
 */ const $a6922994e5fb894c$var$arrPatchAt = (arr = [], index, patch)=>[].concat(// if index is greater than 0, slice the array up to the index
    index > 0 ? arr.slice(0, index) : [], // if index is greater than the array length, fill the array with undefined up to the index
    arr.length - 1 < index ? new Array(index - arr.length).fill(undefined) : [], // if patch is a function, call it with the array at the index, otherwise apply the patch directly
    patch instanceof Function ? patch(arr[index] ?? {}) : Object.assign({}, arr[index], patch), // if index is less than the array length - 1, slice the array from the index + 1
    index < arr.length - 1 ? arr.slice(index + 1) : []);
const $a6922994e5fb894c$var$constructLayout = (config)=>Object.keys(config).map((name)=>({
            widget: config[name],
            name: name
        })).filter(({ widget: widget })=>widget.visible === true).reduce((layout, { widget: widget, name: name })=>// console.log(name, widget, layout), 
        ({
            cols: $a6922994e5fb894c$var$arrPatchAt(layout.cols, layout.cols.findIndex((col)=>col.id === widget.pos.col) ?? widget.pos.col, (col)=>({
                    id: widget.pos.col,
                    width: col.width > widget.dim.width ? col.width : widget.dim.width,
                    rows: $a6922994e5fb894c$var$arrPatchAt(col.rows ?? [], widget.pos.row, (row)=>({
                            ...row,
                            name: name,
                            ...widget
                        }))
                }))
        }), {
        cols: [],
        width: 0
    });
module.exports = ({ state: state, actions: actions }, panels)=>$a6922994e5fb894c$require$fn.pipe(()=>$a6922994e5fb894c$var$constructLayout(state.layout), (layout)=>({
            ...layout,
            width: layout.cols.reduce((w, c)=>w + c.width, 0)
        }), // layout => (console.log('layout', layout), layout),
    (layout)=>$a6922994e5fb894c$require$div("#layout", {
            style: {
                width: `${layout.width}px`
            }
        }, layout.cols.sort((c1, c2)=>c1.id - c2.id).map((col)=>$a6922994e5fb894c$require$ul({
                hook: {
                    insert: (vnode)=>(console.log("onInsert", vnode.elm, col.id), new $a6922994e5fb894c$require$Sortable(vnode.elm, {
                            group: "table",
                            draggable: "li",
                            handle: ".header",
                            // filter: '.opened',
                            // sort: false,
                            // preventOnFilter: true,
                            ghostClass: "placeholder",
                            dataIdAttr: "data-name"
                        }))
                },
                style: {
                    width: `${col.width}px`
                }
            }, col.rows.sort((a, b)=>a.pos.row - b.pos.row).map((widget)=>$a6922994e5fb894c$require$li({
                    key: widget.name,
                    style: {
                        height: widget.dim.height || "auto"
                    },
                    attrs: {
                        "data-name": widget.name
                    }
                }, panels[widget.name]({
                    state: state,
                    actions: actions
                })))))))();

});
parcelRegister("1bMen", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ddc3b26c84abd97$export$2e2bcd8739ae039);
/**!
 * Sortable 1.15.3
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $0ddc3b26c84abd97$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0ddc3b26c84abd97$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0ddc3b26c84abd97$var$ownKeys(Object(source), true).forEach(function(key) {
            $0ddc3b26c84abd97$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0ddc3b26c84abd97$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0ddc3b26c84abd97$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0ddc3b26c84abd97$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $0ddc3b26c84abd97$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0ddc3b26c84abd97$var$_typeof(obj);
}
function $0ddc3b26c84abd97$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0ddc3b26c84abd97$var$_extends() {
    $0ddc3b26c84abd97$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ddc3b26c84abd97$var$_extends.apply(this, arguments);
}
function $0ddc3b26c84abd97$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0ddc3b26c84abd97$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0ddc3b26c84abd97$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0ddc3b26c84abd97$var$_toConsumableArray(arr) {
    return $0ddc3b26c84abd97$var$_arrayWithoutHoles(arr) || $0ddc3b26c84abd97$var$_iterableToArray(arr) || $0ddc3b26c84abd97$var$_unsupportedIterableToArray(arr) || $0ddc3b26c84abd97$var$_nonIterableSpread();
}
function $0ddc3b26c84abd97$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $0ddc3b26c84abd97$var$_arrayLikeToArray(arr);
}
function $0ddc3b26c84abd97$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $0ddc3b26c84abd97$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0ddc3b26c84abd97$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0ddc3b26c84abd97$var$_arrayLikeToArray(o, minLen);
}
function $0ddc3b26c84abd97$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0ddc3b26c84abd97$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $0ddc3b26c84abd97$var$version = "1.15.3";
function $0ddc3b26c84abd97$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $0ddc3b26c84abd97$var$IE11OrLess = $0ddc3b26c84abd97$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $0ddc3b26c84abd97$var$Edge = $0ddc3b26c84abd97$var$userAgent(/Edge/i);
var $0ddc3b26c84abd97$var$FireFox = $0ddc3b26c84abd97$var$userAgent(/firefox/i);
var $0ddc3b26c84abd97$var$Safari = $0ddc3b26c84abd97$var$userAgent(/safari/i) && !$0ddc3b26c84abd97$var$userAgent(/chrome/i) && !$0ddc3b26c84abd97$var$userAgent(/android/i);
var $0ddc3b26c84abd97$var$IOS = $0ddc3b26c84abd97$var$userAgent(/iP(ad|od|hone)/i);
var $0ddc3b26c84abd97$var$ChromeForAndroid = $0ddc3b26c84abd97$var$userAgent(/chrome/i) && $0ddc3b26c84abd97$var$userAgent(/android/i);
var $0ddc3b26c84abd97$var$captureMode = {
    capture: false,
    passive: false
};
function $0ddc3b26c84abd97$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$0ddc3b26c84abd97$var$IE11OrLess && $0ddc3b26c84abd97$var$captureMode);
}
function $0ddc3b26c84abd97$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$0ddc3b26c84abd97$var$IE11OrLess && $0ddc3b26c84abd97$var$captureMode);
}
function $0ddc3b26c84abd97$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $0ddc3b26c84abd97$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $0ddc3b26c84abd97$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $0ddc3b26c84abd97$var$matches(el, selector) : $0ddc3b26c84abd97$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $0ddc3b26c84abd97$var$getParentOrHost(el));
    }
    return null;
}
var $0ddc3b26c84abd97$var$R_SPACE = /\s+/g;
function $0ddc3b26c84abd97$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($0ddc3b26c84abd97$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($0ddc3b26c84abd97$var$R_SPACE, " ");
        }
    }
}
function $0ddc3b26c84abd97$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $0ddc3b26c84abd97$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $0ddc3b26c84abd97$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $0ddc3b26c84abd97$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $0ddc3b26c84abd97$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $0ddc3b26c84abd97$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $0ddc3b26c84abd97$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$0ddc3b26c84abd97$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($0ddc3b26c84abd97$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $0ddc3b26c84abd97$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($0ddc3b26c84abd97$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($0ddc3b26c84abd97$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $0ddc3b26c84abd97$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $0ddc3b26c84abd97$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $0ddc3b26c84abd97$var$getParentAutoScrollElement(el, true), elSideVal = $0ddc3b26c84abd97$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $0ddc3b26c84abd97$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $0ddc3b26c84abd97$var$getWindowScrollingElement()) break;
        parent = $0ddc3b26c84abd97$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $0ddc3b26c84abd97$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $0ddc3b26c84abd97$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $0ddc3b26c84abd97$export$31b3ca70d8f57423.dragged) && $0ddc3b26c84abd97$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $0ddc3b26c84abd97$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $0ddc3b26c84abd97$export$31b3ca70d8f57423.ghost || $0ddc3b26c84abd97$var$css(last, "display") === "none" || selector && !$0ddc3b26c84abd97$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $0ddc3b26c84abd97$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $0ddc3b26c84abd97$export$31b3ca70d8f57423.clone && (!selector || $0ddc3b26c84abd97$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $0ddc3b26c84abd97$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $0ddc3b26c84abd97$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $0ddc3b26c84abd97$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $0ddc3b26c84abd97$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $0ddc3b26c84abd97$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $0ddc3b26c84abd97$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $0ddc3b26c84abd97$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $0ddc3b26c84abd97$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $0ddc3b26c84abd97$var$getWindowScrollingElement();
}
function $0ddc3b26c84abd97$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $0ddc3b26c84abd97$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $0ddc3b26c84abd97$var$_throttleTimeout;
function $0ddc3b26c84abd97$var$throttle(callback, ms) {
    return function() {
        if (!$0ddc3b26c84abd97$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $0ddc3b26c84abd97$var$_throttleTimeout = setTimeout(function() {
                $0ddc3b26c84abd97$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $0ddc3b26c84abd97$var$cancelThrottle() {
    clearTimeout($0ddc3b26c84abd97$var$_throttleTimeout);
    $0ddc3b26c84abd97$var$_throttleTimeout = void 0;
}
function $0ddc3b26c84abd97$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $0ddc3b26c84abd97$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $0ddc3b26c84abd97$var$setRect(el, rect) {
    $0ddc3b26c84abd97$var$css(el, "position", "absolute");
    $0ddc3b26c84abd97$var$css(el, "top", rect.top);
    $0ddc3b26c84abd97$var$css(el, "left", rect.left);
    $0ddc3b26c84abd97$var$css(el, "width", rect.width);
    $0ddc3b26c84abd97$var$css(el, "height", rect.height);
}
function $0ddc3b26c84abd97$var$unsetRect(el) {
    $0ddc3b26c84abd97$var$css(el, "position", "");
    $0ddc3b26c84abd97$var$css(el, "top", "");
    $0ddc3b26c84abd97$var$css(el, "left", "");
    $0ddc3b26c84abd97$var$css(el, "width", "");
    $0ddc3b26c84abd97$var$css(el, "height", "");
}
function $0ddc3b26c84abd97$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$0ddc3b26c84abd97$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $0ddc3b26c84abd97$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $0ddc3b26c84abd97$var$expando = "Sortable" + new Date().getTime();
function $0ddc3b26c84abd97$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($0ddc3b26c84abd97$var$css(child, "display") === "none" || child === $0ddc3b26c84abd97$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $0ddc3b26c84abd97$var$getRect(child)
                });
                var fromRect = $0ddc3b26c84abd97$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $0ddc3b26c84abd97$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($0ddc3b26c84abd97$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $0ddc3b26c84abd97$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $0ddc3b26c84abd97$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($0ddc3b26c84abd97$var$isRectEqual(prevFromRect, toRect) && !$0ddc3b26c84abd97$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $0ddc3b26c84abd97$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$0ddc3b26c84abd97$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $0ddc3b26c84abd97$var$css(target, "transition", "");
                $0ddc3b26c84abd97$var$css(target, "transform", "");
                var elMatrix = $0ddc3b26c84abd97$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $0ddc3b26c84abd97$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $0ddc3b26c84abd97$var$repaint(target); // repaint
                $0ddc3b26c84abd97$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $0ddc3b26c84abd97$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $0ddc3b26c84abd97$var$css(target, "transition", "");
                    $0ddc3b26c84abd97$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $0ddc3b26c84abd97$var$repaint(target) {
    return target.offsetWidth;
}
function $0ddc3b26c84abd97$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $0ddc3b26c84abd97$var$plugins = [];
var $0ddc3b26c84abd97$var$defaults = {
    initializeByDefault: true
};
var $0ddc3b26c84abd97$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $0ddc3b26c84abd97$var$defaults)if ($0ddc3b26c84abd97$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $0ddc3b26c84abd97$var$defaults[option];
        $0ddc3b26c84abd97$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $0ddc3b26c84abd97$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $0ddc3b26c84abd97$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($0ddc3b26c84abd97$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($0ddc3b26c84abd97$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $0ddc3b26c84abd97$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $0ddc3b26c84abd97$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $0ddc3b26c84abd97$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $0ddc3b26c84abd97$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $0ddc3b26c84abd97$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $0ddc3b26c84abd97$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$0ddc3b26c84abd97$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$0ddc3b26c84abd97$var$IE11OrLess && !$0ddc3b26c84abd97$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $0ddc3b26c84abd97$var$_objectSpread2($0ddc3b26c84abd97$var$_objectSpread2({}, extraEventProperties), $0ddc3b26c84abd97$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $0ddc3b26c84abd97$var$_excluded = [
    "evt"
];
var $0ddc3b26c84abd97$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $0ddc3b26c84abd97$var$_objectWithoutProperties(_ref, $0ddc3b26c84abd97$var$_excluded);
    $0ddc3b26c84abd97$var$PluginManager.pluginEvent.bind($0ddc3b26c84abd97$export$31b3ca70d8f57423)(eventName, sortable, $0ddc3b26c84abd97$var$_objectSpread2({
        dragEl: $0ddc3b26c84abd97$var$dragEl,
        parentEl: $0ddc3b26c84abd97$var$parentEl,
        ghostEl: $0ddc3b26c84abd97$var$ghostEl,
        rootEl: $0ddc3b26c84abd97$var$rootEl,
        nextEl: $0ddc3b26c84abd97$var$nextEl,
        lastDownEl: $0ddc3b26c84abd97$var$lastDownEl,
        cloneEl: $0ddc3b26c84abd97$var$cloneEl,
        cloneHidden: $0ddc3b26c84abd97$var$cloneHidden,
        dragStarted: $0ddc3b26c84abd97$var$moved,
        putSortable: $0ddc3b26c84abd97$var$putSortable,
        activeSortable: $0ddc3b26c84abd97$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $0ddc3b26c84abd97$var$oldIndex,
        oldDraggableIndex: $0ddc3b26c84abd97$var$oldDraggableIndex,
        newIndex: $0ddc3b26c84abd97$var$newIndex,
        newDraggableIndex: $0ddc3b26c84abd97$var$newDraggableIndex,
        hideGhostForTarget: $0ddc3b26c84abd97$var$_hideGhostForTarget,
        unhideGhostForTarget: $0ddc3b26c84abd97$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $0ddc3b26c84abd97$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $0ddc3b26c84abd97$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $0ddc3b26c84abd97$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $0ddc3b26c84abd97$var$_dispatchEvent(info) {
    $0ddc3b26c84abd97$var$dispatchEvent($0ddc3b26c84abd97$var$_objectSpread2({
        putSortable: $0ddc3b26c84abd97$var$putSortable,
        cloneEl: $0ddc3b26c84abd97$var$cloneEl,
        targetEl: $0ddc3b26c84abd97$var$dragEl,
        rootEl: $0ddc3b26c84abd97$var$rootEl,
        oldIndex: $0ddc3b26c84abd97$var$oldIndex,
        oldDraggableIndex: $0ddc3b26c84abd97$var$oldDraggableIndex,
        newIndex: $0ddc3b26c84abd97$var$newIndex,
        newDraggableIndex: $0ddc3b26c84abd97$var$newDraggableIndex
    }, info));
}
var $0ddc3b26c84abd97$var$dragEl, $0ddc3b26c84abd97$var$parentEl, $0ddc3b26c84abd97$var$ghostEl, $0ddc3b26c84abd97$var$rootEl, $0ddc3b26c84abd97$var$nextEl, $0ddc3b26c84abd97$var$lastDownEl, $0ddc3b26c84abd97$var$cloneEl, $0ddc3b26c84abd97$var$cloneHidden, $0ddc3b26c84abd97$var$oldIndex, $0ddc3b26c84abd97$var$newIndex, $0ddc3b26c84abd97$var$oldDraggableIndex, $0ddc3b26c84abd97$var$newDraggableIndex, $0ddc3b26c84abd97$var$activeGroup, $0ddc3b26c84abd97$var$putSortable, $0ddc3b26c84abd97$var$awaitingDragStarted = false, $0ddc3b26c84abd97$var$ignoreNextClick = false, $0ddc3b26c84abd97$var$sortables = [], $0ddc3b26c84abd97$var$tapEvt, $0ddc3b26c84abd97$var$touchEvt, $0ddc3b26c84abd97$var$lastDx, $0ddc3b26c84abd97$var$lastDy, $0ddc3b26c84abd97$var$tapDistanceLeft, $0ddc3b26c84abd97$var$tapDistanceTop, $0ddc3b26c84abd97$var$moved, $0ddc3b26c84abd97$var$lastTarget, $0ddc3b26c84abd97$var$lastDirection, $0ddc3b26c84abd97$var$pastFirstInvertThresh = false, $0ddc3b26c84abd97$var$isCircumstantialInvert = false, $0ddc3b26c84abd97$var$targetMoveDistance, // For positioning ghost absolutely
$0ddc3b26c84abd97$var$ghostRelativeParent, $0ddc3b26c84abd97$var$ghostRelativeParentInitialScroll = [], // (left, top)
$0ddc3b26c84abd97$var$_silent = false, $0ddc3b26c84abd97$var$savedInputChecked = [];
/** @const */ var $0ddc3b26c84abd97$var$documentExists = typeof document !== "undefined", $0ddc3b26c84abd97$var$PositionGhostAbsolutely = $0ddc3b26c84abd97$var$IOS, $0ddc3b26c84abd97$var$CSSFloatProperty = $0ddc3b26c84abd97$var$Edge || $0ddc3b26c84abd97$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$0ddc3b26c84abd97$var$supportDraggable = $0ddc3b26c84abd97$var$documentExists && !$0ddc3b26c84abd97$var$ChromeForAndroid && !$0ddc3b26c84abd97$var$IOS && "draggable" in document.createElement("div"), $0ddc3b26c84abd97$var$supportCssPointerEvents = function() {
    if (!$0ddc3b26c84abd97$var$documentExists) return;
    // false when <= IE11
    if ($0ddc3b26c84abd97$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $0ddc3b26c84abd97$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $0ddc3b26c84abd97$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $0ddc3b26c84abd97$var$getChild(el, 0, options), child2 = $0ddc3b26c84abd97$var$getChild(el, 1, options), firstChildCSS = child1 && $0ddc3b26c84abd97$var$css(child1), secondChildCSS = child2 && $0ddc3b26c84abd97$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $0ddc3b26c84abd97$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $0ddc3b26c84abd97$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$0ddc3b26c84abd97$var$CSSFloatProperty] === "none" || child2 && elCSS[$0ddc3b26c84abd97$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $0ddc3b26c84abd97$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $0ddc3b26c84abd97$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $0ddc3b26c84abd97$var$sortables.some(function(sortable) {
        var threshold = sortable[$0ddc3b26c84abd97$var$expando].options.emptyInsertThreshold;
        if (!threshold || $0ddc3b26c84abd97$var$lastChild(sortable)) return;
        var rect = $0ddc3b26c84abd97$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $0ddc3b26c84abd97$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $0ddc3b26c84abd97$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $0ddc3b26c84abd97$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$0ddc3b26c84abd97$var$supportCssPointerEvents && $0ddc3b26c84abd97$var$ghostEl) $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "display", "none");
}, $0ddc3b26c84abd97$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$0ddc3b26c84abd97$var$supportCssPointerEvents && $0ddc3b26c84abd97$var$ghostEl) $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "display", "");
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($0ddc3b26c84abd97$var$documentExists && !$0ddc3b26c84abd97$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($0ddc3b26c84abd97$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $0ddc3b26c84abd97$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($0ddc3b26c84abd97$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $0ddc3b26c84abd97$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$0ddc3b26c84abd97$var$expando]._onDragOver(event);
        }
    }
};
var $0ddc3b26c84abd97$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($0ddc3b26c84abd97$var$dragEl) $0ddc3b26c84abd97$var$dragEl.parentNode[$0ddc3b26c84abd97$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $0ddc3b26c84abd97$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $0ddc3b26c84abd97$var$_extends({}, options);
    // Export instance
    el[$0ddc3b26c84abd97$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $0ddc3b26c84abd97$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $0ddc3b26c84abd97$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$0ddc3b26c84abd97$var$Safari,
        emptyInsertThreshold: 5
    };
    $0ddc3b26c84abd97$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $0ddc3b26c84abd97$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $0ddc3b26c84abd97$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $0ddc3b26c84abd97$var$on(el, "pointerdown", this._onTapStart);
    else {
        $0ddc3b26c84abd97$var$on(el, "mousedown", this._onTapStart);
        $0ddc3b26c84abd97$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $0ddc3b26c84abd97$var$on(el, "dragover", this);
        $0ddc3b26c84abd97$var$on(el, "dragenter", this);
    }
    $0ddc3b26c84abd97$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $0ddc3b26c84abd97$var$_extends(this, $0ddc3b26c84abd97$var$AnimationStateManager());
}
$0ddc3b26c84abd97$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $0ddc3b26c84abd97$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $0ddc3b26c84abd97$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $0ddc3b26c84abd97$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $0ddc3b26c84abd97$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($0ddc3b26c84abd97$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $0ddc3b26c84abd97$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $0ddc3b26c84abd97$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($0ddc3b26c84abd97$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $0ddc3b26c84abd97$var$oldIndex = $0ddc3b26c84abd97$var$index(target);
        $0ddc3b26c84abd97$var$oldDraggableIndex = $0ddc3b26c84abd97$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $0ddc3b26c84abd97$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $0ddc3b26c84abd97$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $0ddc3b26c84abd97$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $0ddc3b26c84abd97$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $0ddc3b26c84abd97$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$0ddc3b26c84abd97$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$0ddc3b26c84abd97$var$dragEl && target.parentNode === el) {
            var dragRect = $0ddc3b26c84abd97$var$getRect(target);
            $0ddc3b26c84abd97$var$rootEl = el;
            $0ddc3b26c84abd97$var$dragEl = target;
            $0ddc3b26c84abd97$var$parentEl = $0ddc3b26c84abd97$var$dragEl.parentNode;
            $0ddc3b26c84abd97$var$nextEl = $0ddc3b26c84abd97$var$dragEl.nextSibling;
            $0ddc3b26c84abd97$var$lastDownEl = target;
            $0ddc3b26c84abd97$var$activeGroup = options.group;
            $0ddc3b26c84abd97$export$31b3ca70d8f57423.dragged = $0ddc3b26c84abd97$var$dragEl;
            $0ddc3b26c84abd97$var$tapEvt = {
                target: $0ddc3b26c84abd97$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $0ddc3b26c84abd97$var$tapDistanceLeft = $0ddc3b26c84abd97$var$tapEvt.clientX - dragRect.left;
            $0ddc3b26c84abd97$var$tapDistanceTop = $0ddc3b26c84abd97$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $0ddc3b26c84abd97$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $0ddc3b26c84abd97$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$0ddc3b26c84abd97$var$FireFox && _this.nativeDraggable) $0ddc3b26c84abd97$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $0ddc3b26c84abd97$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                // Chosen item
                $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $0ddc3b26c84abd97$var$find($0ddc3b26c84abd97$var$dragEl, criteria.trim(), $0ddc3b26c84abd97$var$_disableDraggable);
            });
            $0ddc3b26c84abd97$var$on(ownerDocument, "dragover", $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent);
            $0ddc3b26c84abd97$var$on(ownerDocument, "mousemove", $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent);
            $0ddc3b26c84abd97$var$on(ownerDocument, "touchmove", $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent);
            $0ddc3b26c84abd97$var$on(ownerDocument, "mouseup", _this._onDrop);
            $0ddc3b26c84abd97$var$on(ownerDocument, "touchend", _this._onDrop);
            $0ddc3b26c84abd97$var$on(ownerDocument, "touchcancel", _this._onDrop);
            // Make dragEl draggable (must be before delay for FireFox)
            if ($0ddc3b26c84abd97$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $0ddc3b26c84abd97$var$dragEl.draggable = true;
            }
            $0ddc3b26c84abd97$var$pluginEvent("delayStart", this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($0ddc3b26c84abd97$var$Edge || $0ddc3b26c84abd97$var$IE11OrLess))) {
                if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $0ddc3b26c84abd97$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $0ddc3b26c84abd97$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $0ddc3b26c84abd97$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $0ddc3b26c84abd97$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $0ddc3b26c84abd97$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $0ddc3b26c84abd97$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $0ddc3b26c84abd97$var$dragEl && $0ddc3b26c84abd97$var$_disableDraggable($0ddc3b26c84abd97$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $0ddc3b26c84abd97$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $0ddc3b26c84abd97$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $0ddc3b26c84abd97$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $0ddc3b26c84abd97$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $0ddc3b26c84abd97$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $0ddc3b26c84abd97$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $0ddc3b26c84abd97$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $0ddc3b26c84abd97$var$on(document, "touchmove", this._onTouchMove);
            else $0ddc3b26c84abd97$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $0ddc3b26c84abd97$var$on($0ddc3b26c84abd97$var$dragEl, "dragend", this);
            $0ddc3b26c84abd97$var$on($0ddc3b26c84abd97$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $0ddc3b26c84abd97$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $0ddc3b26c84abd97$var$awaitingDragStarted = false;
        if ($0ddc3b26c84abd97$var$rootEl && $0ddc3b26c84abd97$var$dragEl) {
            $0ddc3b26c84abd97$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $0ddc3b26c84abd97$var$on(document, "dragover", $0ddc3b26c84abd97$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, options.dragClass, false);
            $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, options.ghostClass, true);
            $0ddc3b26c84abd97$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $0ddc3b26c84abd97$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($0ddc3b26c84abd97$var$touchEvt) {
            this._lastX = $0ddc3b26c84abd97$var$touchEvt.clientX;
            this._lastY = $0ddc3b26c84abd97$var$touchEvt.clientY;
            $0ddc3b26c84abd97$var$_hideGhostForTarget();
            var target = document.elementFromPoint($0ddc3b26c84abd97$var$touchEvt.clientX, $0ddc3b26c84abd97$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($0ddc3b26c84abd97$var$touchEvt.clientX, $0ddc3b26c84abd97$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $0ddc3b26c84abd97$var$dragEl.parentNode[$0ddc3b26c84abd97$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$0ddc3b26c84abd97$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$0ddc3b26c84abd97$var$expando]._onDragOver({
                        clientX: $0ddc3b26c84abd97$var$touchEvt.clientX,
                        clientY: $0ddc3b26c84abd97$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = $0ddc3b26c84abd97$var$getParentOrHost(parent));
            $0ddc3b26c84abd97$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($0ddc3b26c84abd97$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $0ddc3b26c84abd97$var$ghostEl && $0ddc3b26c84abd97$var$matrix($0ddc3b26c84abd97$var$ghostEl, true), scaleX = $0ddc3b26c84abd97$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $0ddc3b26c84abd97$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $0ddc3b26c84abd97$var$PositionGhostAbsolutely && $0ddc3b26c84abd97$var$ghostRelativeParent && $0ddc3b26c84abd97$var$getRelativeScrollOffset($0ddc3b26c84abd97$var$ghostRelativeParent), dx = (touch.clientX - $0ddc3b26c84abd97$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $0ddc3b26c84abd97$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $0ddc3b26c84abd97$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $0ddc3b26c84abd97$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$0ddc3b26c84abd97$export$31b3ca70d8f57423.active && !$0ddc3b26c84abd97$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($0ddc3b26c84abd97$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($0ddc3b26c84abd97$var$lastDx || 0);
                    ghostMatrix.f += dy - ($0ddc3b26c84abd97$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "webkitTransform", cssMatrix);
                $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "mozTransform", cssMatrix);
                $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "msTransform", cssMatrix);
                $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "transform", cssMatrix);
                $0ddc3b26c84abd97$var$lastDx = dx;
                $0ddc3b26c84abd97$var$lastDy = dy;
                $0ddc3b26c84abd97$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$0ddc3b26c84abd97$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $0ddc3b26c84abd97$var$rootEl, rect = $0ddc3b26c84abd97$var$getRect($0ddc3b26c84abd97$var$dragEl, true, $0ddc3b26c84abd97$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($0ddc3b26c84abd97$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $0ddc3b26c84abd97$var$ghostRelativeParent = container;
                while($0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostRelativeParent, "position") === "static" && $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostRelativeParent, "transform") === "none" && $0ddc3b26c84abd97$var$ghostRelativeParent !== document)$0ddc3b26c84abd97$var$ghostRelativeParent = $0ddc3b26c84abd97$var$ghostRelativeParent.parentNode;
                if ($0ddc3b26c84abd97$var$ghostRelativeParent !== document.body && $0ddc3b26c84abd97$var$ghostRelativeParent !== document.documentElement) {
                    if ($0ddc3b26c84abd97$var$ghostRelativeParent === document) $0ddc3b26c84abd97$var$ghostRelativeParent = $0ddc3b26c84abd97$var$getWindowScrollingElement();
                    rect.top += $0ddc3b26c84abd97$var$ghostRelativeParent.scrollTop;
                    rect.left += $0ddc3b26c84abd97$var$ghostRelativeParent.scrollLeft;
                } else $0ddc3b26c84abd97$var$ghostRelativeParent = $0ddc3b26c84abd97$var$getWindowScrollingElement();
                $0ddc3b26c84abd97$var$ghostRelativeParentInitialScroll = $0ddc3b26c84abd97$var$getRelativeScrollOffset($0ddc3b26c84abd97$var$ghostRelativeParent);
            }
            $0ddc3b26c84abd97$var$ghostEl = $0ddc3b26c84abd97$var$dragEl.cloneNode(true);
            $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$ghostEl, options.ghostClass, false);
            $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$ghostEl, options.fallbackClass, true);
            $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$ghostEl, options.dragClass, true);
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "transition", "");
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "transform", "");
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "box-sizing", "border-box");
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "margin", 0);
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "top", rect.top);
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "left", rect.left);
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "width", rect.width);
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "height", rect.height);
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "opacity", "0.8");
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "position", $0ddc3b26c84abd97$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "zIndex", "100000");
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "pointerEvents", "none");
            $0ddc3b26c84abd97$export$31b3ca70d8f57423.ghost = $0ddc3b26c84abd97$var$ghostEl;
            container.appendChild($0ddc3b26c84abd97$var$ghostEl);
            // Set transform-origin
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$ghostEl, "transform-origin", $0ddc3b26c84abd97$var$tapDistanceLeft / parseInt($0ddc3b26c84abd97$var$ghostEl.style.width) * 100 + "% " + $0ddc3b26c84abd97$var$tapDistanceTop / parseInt($0ddc3b26c84abd97$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $0ddc3b26c84abd97$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $0ddc3b26c84abd97$var$pluginEvent("setupClone", this);
        if (!$0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) {
            $0ddc3b26c84abd97$var$cloneEl = $0ddc3b26c84abd97$var$clone($0ddc3b26c84abd97$var$dragEl);
            $0ddc3b26c84abd97$var$cloneEl.removeAttribute("id");
            $0ddc3b26c84abd97$var$cloneEl.draggable = false;
            $0ddc3b26c84abd97$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$cloneEl, this.options.chosenClass, false);
            $0ddc3b26c84abd97$export$31b3ca70d8f57423.clone = $0ddc3b26c84abd97$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $0ddc3b26c84abd97$var$_nextTick(function() {
            $0ddc3b26c84abd97$var$pluginEvent("clone", _this);
            if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $0ddc3b26c84abd97$var$rootEl.insertBefore($0ddc3b26c84abd97$var$cloneEl, $0ddc3b26c84abd97$var$dragEl);
            _this._hideClone();
            $0ddc3b26c84abd97$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $0ddc3b26c84abd97$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $0ddc3b26c84abd97$var$off(document, "mouseup", _this._onDrop);
            $0ddc3b26c84abd97$var$off(document, "touchend", _this._onDrop);
            $0ddc3b26c84abd97$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $0ddc3b26c84abd97$var$dragEl);
            }
            $0ddc3b26c84abd97$var$on(document, "drop", _this);
            // #1276 fix:
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$dragEl, "transform", "translateZ(0)");
        }
        $0ddc3b26c84abd97$var$awaitingDragStarted = true;
        _this._dragStartId = $0ddc3b26c84abd97$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $0ddc3b26c84abd97$var$on(document, "selectstart", _this);
        $0ddc3b26c84abd97$var$moved = true;
        if ($0ddc3b26c84abd97$var$Safari) $0ddc3b26c84abd97$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $0ddc3b26c84abd97$export$31b3ca70d8f57423.active, isOwner = $0ddc3b26c84abd97$var$activeGroup === group, canSort = options.sort, fromSortable = $0ddc3b26c84abd97$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($0ddc3b26c84abd97$var$_silent) return;
        function dragOverEvent(name, extra) {
            $0ddc3b26c84abd97$var$pluginEvent(name, _this, $0ddc3b26c84abd97$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $0ddc3b26c84abd97$var$_onMove($0ddc3b26c84abd97$var$rootEl, el, $0ddc3b26c84abd97$var$dragEl, dragRect, target, $0ddc3b26c84abd97$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, $0ddc3b26c84abd97$var$putSortable ? $0ddc3b26c84abd97$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, options.ghostClass, true);
                }
                if ($0ddc3b26c84abd97$var$putSortable !== _this && _this !== $0ddc3b26c84abd97$export$31b3ca70d8f57423.active) $0ddc3b26c84abd97$var$putSortable = _this;
                else if (_this === $0ddc3b26c84abd97$export$31b3ca70d8f57423.active && $0ddc3b26c84abd97$var$putSortable) $0ddc3b26c84abd97$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $0ddc3b26c84abd97$var$dragEl && !$0ddc3b26c84abd97$var$dragEl.animated || target === el && !target.animated) $0ddc3b26c84abd97$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $0ddc3b26c84abd97$var$dragEl.parentNode[$0ddc3b26c84abd97$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $0ddc3b26c84abd97$var$newIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl);
            $0ddc3b26c84abd97$var$newDraggableIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl, options.draggable);
            $0ddc3b26c84abd97$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $0ddc3b26c84abd97$var$newIndex,
                newDraggableIndex: $0ddc3b26c84abd97$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $0ddc3b26c84abd97$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($0ddc3b26c84abd97$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $0ddc3b26c84abd97$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $0ddc3b26c84abd97$var$parentEl !== $0ddc3b26c84abd97$var$rootEl // Reverting item into the original list
        ) : $0ddc3b26c84abd97$var$putSortable === this || (this.lastPutMode = $0ddc3b26c84abd97$var$activeGroup.checkPull(this, activeSortable, $0ddc3b26c84abd97$var$dragEl, evt)) && group.checkPut(this, activeSortable, $0ddc3b26c84abd97$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $0ddc3b26c84abd97$var$getRect($0ddc3b26c84abd97$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $0ddc3b26c84abd97$var$parentEl = $0ddc3b26c84abd97$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) {
                    if ($0ddc3b26c84abd97$var$nextEl) $0ddc3b26c84abd97$var$rootEl.insertBefore($0ddc3b26c84abd97$var$dragEl, $0ddc3b26c84abd97$var$nextEl);
                    else $0ddc3b26c84abd97$var$rootEl.appendChild($0ddc3b26c84abd97$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $0ddc3b26c84abd97$var$lastChild(el, options.draggable);
            if (!elLastChild || $0ddc3b26c84abd97$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $0ddc3b26c84abd97$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $0ddc3b26c84abd97$var$getRect(target);
                if ($0ddc3b26c84abd97$var$_onMove($0ddc3b26c84abd97$var$rootEl, el, $0ddc3b26c84abd97$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($0ddc3b26c84abd97$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($0ddc3b26c84abd97$var$dragEl);
                    $0ddc3b26c84abd97$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $0ddc3b26c84abd97$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $0ddc3b26c84abd97$var$getChild(el, 0, options, true);
                if (firstChild === $0ddc3b26c84abd97$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $0ddc3b26c84abd97$var$getRect(target);
                if ($0ddc3b26c84abd97$var$_onMove($0ddc3b26c84abd97$var$rootEl, el, $0ddc3b26c84abd97$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($0ddc3b26c84abd97$var$dragEl, firstChild);
                    $0ddc3b26c84abd97$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $0ddc3b26c84abd97$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $0ddc3b26c84abd97$var$dragEl.parentNode !== el, differentRowCol = !$0ddc3b26c84abd97$var$_dragElInRowColumn($0ddc3b26c84abd97$var$dragEl.animated && $0ddc3b26c84abd97$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $0ddc3b26c84abd97$var$isScrolledPast(target, "top", "top") || $0ddc3b26c84abd97$var$isScrolledPast($0ddc3b26c84abd97$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($0ddc3b26c84abd97$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $0ddc3b26c84abd97$var$pastFirstInvertThresh = false;
                    $0ddc3b26c84abd97$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $0ddc3b26c84abd97$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $0ddc3b26c84abd97$var$isCircumstantialInvert, $0ddc3b26c84abd97$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $0ddc3b26c84abd97$var$parentEl.children[dragIndex];
                    }while (sibling && ($0ddc3b26c84abd97$var$css(sibling, "display") === "none" || sibling === $0ddc3b26c84abd97$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $0ddc3b26c84abd97$var$lastTarget = target;
                $0ddc3b26c84abd97$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $0ddc3b26c84abd97$var$_onMove($0ddc3b26c84abd97$var$rootEl, el, $0ddc3b26c84abd97$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $0ddc3b26c84abd97$var$_silent = true;
                    setTimeout($0ddc3b26c84abd97$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($0ddc3b26c84abd97$var$dragEl);
                    else target.parentNode.insertBefore($0ddc3b26c84abd97$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $0ddc3b26c84abd97$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $0ddc3b26c84abd97$var$parentEl = $0ddc3b26c84abd97$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$0ddc3b26c84abd97$var$isCircumstantialInvert) $0ddc3b26c84abd97$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $0ddc3b26c84abd97$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($0ddc3b26c84abd97$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $0ddc3b26c84abd97$var$off(document, "mousemove", this._onTouchMove);
        $0ddc3b26c84abd97$var$off(document, "touchmove", this._onTouchMove);
        $0ddc3b26c84abd97$var$off(document, "pointermove", this._onTouchMove);
        $0ddc3b26c84abd97$var$off(document, "dragover", $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent);
        $0ddc3b26c84abd97$var$off(document, "mousemove", $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent);
        $0ddc3b26c84abd97$var$off(document, "touchmove", $0ddc3b26c84abd97$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $0ddc3b26c84abd97$var$off(ownerDocument, "mouseup", this._onDrop);
        $0ddc3b26c84abd97$var$off(ownerDocument, "touchend", this._onDrop);
        $0ddc3b26c84abd97$var$off(ownerDocument, "pointerup", this._onDrop);
        $0ddc3b26c84abd97$var$off(ownerDocument, "touchcancel", this._onDrop);
        $0ddc3b26c84abd97$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $0ddc3b26c84abd97$var$newIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl);
        $0ddc3b26c84abd97$var$newDraggableIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl, options.draggable);
        $0ddc3b26c84abd97$var$pluginEvent("drop", this, {
            evt: evt
        });
        $0ddc3b26c84abd97$var$parentEl = $0ddc3b26c84abd97$var$dragEl && $0ddc3b26c84abd97$var$dragEl.parentNode;
        // Get again after plugin event
        $0ddc3b26c84abd97$var$newIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl);
        $0ddc3b26c84abd97$var$newDraggableIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl, options.draggable);
        if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $0ddc3b26c84abd97$var$awaitingDragStarted = false;
        $0ddc3b26c84abd97$var$isCircumstantialInvert = false;
        $0ddc3b26c84abd97$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $0ddc3b26c84abd97$var$_cancelNextTick(this.cloneId);
        $0ddc3b26c84abd97$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $0ddc3b26c84abd97$var$off(document, "drop", this);
            $0ddc3b26c84abd97$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($0ddc3b26c84abd97$var$Safari) $0ddc3b26c84abd97$var$css(document.body, "user-select", "");
        $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$dragEl, "transform", "");
        if (evt) {
            if ($0ddc3b26c84abd97$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $0ddc3b26c84abd97$var$ghostEl && $0ddc3b26c84abd97$var$ghostEl.parentNode && $0ddc3b26c84abd97$var$ghostEl.parentNode.removeChild($0ddc3b26c84abd97$var$ghostEl);
            if ($0ddc3b26c84abd97$var$rootEl === $0ddc3b26c84abd97$var$parentEl || $0ddc3b26c84abd97$var$putSortable && $0ddc3b26c84abd97$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $0ddc3b26c84abd97$var$cloneEl && $0ddc3b26c84abd97$var$cloneEl.parentNode && $0ddc3b26c84abd97$var$cloneEl.parentNode.removeChild($0ddc3b26c84abd97$var$cloneEl);
            if ($0ddc3b26c84abd97$var$dragEl) {
                if (this.nativeDraggable) $0ddc3b26c84abd97$var$off($0ddc3b26c84abd97$var$dragEl, "dragend", this);
                $0ddc3b26c84abd97$var$_disableDraggable($0ddc3b26c84abd97$var$dragEl);
                $0ddc3b26c84abd97$var$dragEl.style["will-change"] = "";
                // Remove classes
                // ghostClass is added in dragStarted
                if ($0ddc3b26c84abd97$var$moved && !$0ddc3b26c84abd97$var$awaitingDragStarted) $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, $0ddc3b26c84abd97$var$putSortable ? $0ddc3b26c84abd97$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $0ddc3b26c84abd97$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $0ddc3b26c84abd97$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($0ddc3b26c84abd97$var$rootEl !== $0ddc3b26c84abd97$var$parentEl) {
                    if ($0ddc3b26c84abd97$var$newIndex >= 0) {
                        // Add event
                        $0ddc3b26c84abd97$var$_dispatchEvent({
                            rootEl: $0ddc3b26c84abd97$var$parentEl,
                            name: "add",
                            toEl: $0ddc3b26c84abd97$var$parentEl,
                            fromEl: $0ddc3b26c84abd97$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $0ddc3b26c84abd97$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $0ddc3b26c84abd97$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $0ddc3b26c84abd97$var$_dispatchEvent({
                            rootEl: $0ddc3b26c84abd97$var$parentEl,
                            name: "sort",
                            toEl: $0ddc3b26c84abd97$var$parentEl,
                            fromEl: $0ddc3b26c84abd97$var$rootEl,
                            originalEvent: evt
                        });
                        $0ddc3b26c84abd97$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $0ddc3b26c84abd97$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $0ddc3b26c84abd97$var$putSortable && $0ddc3b26c84abd97$var$putSortable.save();
                } else {
                    if ($0ddc3b26c84abd97$var$newIndex !== $0ddc3b26c84abd97$var$oldIndex) {
                        if ($0ddc3b26c84abd97$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $0ddc3b26c84abd97$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $0ddc3b26c84abd97$var$parentEl,
                                originalEvent: evt
                            });
                            $0ddc3b26c84abd97$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $0ddc3b26c84abd97$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($0ddc3b26c84abd97$var$newIndex == null || $0ddc3b26c84abd97$var$newIndex === -1) {
                        $0ddc3b26c84abd97$var$newIndex = $0ddc3b26c84abd97$var$oldIndex;
                        $0ddc3b26c84abd97$var$newDraggableIndex = $0ddc3b26c84abd97$var$oldDraggableIndex;
                    }
                    $0ddc3b26c84abd97$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $0ddc3b26c84abd97$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $0ddc3b26c84abd97$var$pluginEvent("nulling", this);
        $0ddc3b26c84abd97$var$rootEl = $0ddc3b26c84abd97$var$dragEl = $0ddc3b26c84abd97$var$parentEl = $0ddc3b26c84abd97$var$ghostEl = $0ddc3b26c84abd97$var$nextEl = $0ddc3b26c84abd97$var$cloneEl = $0ddc3b26c84abd97$var$lastDownEl = $0ddc3b26c84abd97$var$cloneHidden = $0ddc3b26c84abd97$var$tapEvt = $0ddc3b26c84abd97$var$touchEvt = $0ddc3b26c84abd97$var$moved = $0ddc3b26c84abd97$var$newIndex = $0ddc3b26c84abd97$var$newDraggableIndex = $0ddc3b26c84abd97$var$oldIndex = $0ddc3b26c84abd97$var$oldDraggableIndex = $0ddc3b26c84abd97$var$lastTarget = $0ddc3b26c84abd97$var$lastDirection = $0ddc3b26c84abd97$var$putSortable = $0ddc3b26c84abd97$var$activeGroup = $0ddc3b26c84abd97$export$31b3ca70d8f57423.dragged = $0ddc3b26c84abd97$export$31b3ca70d8f57423.ghost = $0ddc3b26c84abd97$export$31b3ca70d8f57423.clone = $0ddc3b26c84abd97$export$31b3ca70d8f57423.active = null;
        $0ddc3b26c84abd97$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $0ddc3b26c84abd97$var$savedInputChecked.length = $0ddc3b26c84abd97$var$lastDx = $0ddc3b26c84abd97$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($0ddc3b26c84abd97$var$dragEl) {
                    this._onDragOver(evt);
                    $0ddc3b26c84abd97$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($0ddc3b26c84abd97$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $0ddc3b26c84abd97$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($0ddc3b26c84abd97$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $0ddc3b26c84abd97$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $0ddc3b26c84abd97$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $0ddc3b26c84abd97$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $0ddc3b26c84abd97$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$0ddc3b26c84abd97$var$expando] = null;
        $0ddc3b26c84abd97$var$off(el, "mousedown", this._onTapStart);
        $0ddc3b26c84abd97$var$off(el, "touchstart", this._onTapStart);
        $0ddc3b26c84abd97$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $0ddc3b26c84abd97$var$off(el, "dragover", this);
            $0ddc3b26c84abd97$var$off(el, "dragenter", this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $0ddc3b26c84abd97$var$sortables.splice($0ddc3b26c84abd97$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$0ddc3b26c84abd97$var$cloneHidden) {
            $0ddc3b26c84abd97$var$pluginEvent("hideClone", this);
            if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) return;
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $0ddc3b26c84abd97$var$cloneEl.parentNode) $0ddc3b26c84abd97$var$cloneEl.parentNode.removeChild($0ddc3b26c84abd97$var$cloneEl);
            $0ddc3b26c84abd97$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($0ddc3b26c84abd97$var$cloneHidden) {
            $0ddc3b26c84abd97$var$pluginEvent("showClone", this);
            if ($0ddc3b26c84abd97$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($0ddc3b26c84abd97$var$dragEl.parentNode == $0ddc3b26c84abd97$var$rootEl && !this.options.group.revertClone) $0ddc3b26c84abd97$var$rootEl.insertBefore($0ddc3b26c84abd97$var$cloneEl, $0ddc3b26c84abd97$var$dragEl);
            else if ($0ddc3b26c84abd97$var$nextEl) $0ddc3b26c84abd97$var$rootEl.insertBefore($0ddc3b26c84abd97$var$cloneEl, $0ddc3b26c84abd97$var$nextEl);
            else $0ddc3b26c84abd97$var$rootEl.appendChild($0ddc3b26c84abd97$var$cloneEl);
            if (this.options.group.revertClone) this.animate($0ddc3b26c84abd97$var$dragEl, $0ddc3b26c84abd97$var$cloneEl);
            $0ddc3b26c84abd97$var$css($0ddc3b26c84abd97$var$cloneEl, "display", "");
            $0ddc3b26c84abd97$var$cloneHidden = false;
        }
    }
};
function $0ddc3b26c84abd97$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $0ddc3b26c84abd97$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$0ddc3b26c84abd97$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$0ddc3b26c84abd97$var$IE11OrLess && !$0ddc3b26c84abd97$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $0ddc3b26c84abd97$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $0ddc3b26c84abd97$var$_disableDraggable(el) {
    el.draggable = false;
}
function $0ddc3b26c84abd97$var$_unsilent() {
    $0ddc3b26c84abd97$var$_silent = false;
}
function $0ddc3b26c84abd97$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $0ddc3b26c84abd97$var$getRect($0ddc3b26c84abd97$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $0ddc3b26c84abd97$var$getChildContainingRectFromElement(sortable.el, sortable.options, $0ddc3b26c84abd97$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $0ddc3b26c84abd97$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $0ddc3b26c84abd97$var$getRect($0ddc3b26c84abd97$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $0ddc3b26c84abd97$var$getChildContainingRectFromElement(sortable.el, sortable.options, $0ddc3b26c84abd97$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $0ddc3b26c84abd97$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $0ddc3b26c84abd97$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$0ddc3b26c84abd97$var$pastFirstInvertThresh && ($0ddc3b26c84abd97$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $0ddc3b26c84abd97$var$pastFirstInvertThresh = true;
            if (!$0ddc3b26c84abd97$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($0ddc3b26c84abd97$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $0ddc3b26c84abd97$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $0ddc3b26c84abd97$var$targetMoveDistance) return -$0ddc3b26c84abd97$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $0ddc3b26c84abd97$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $0ddc3b26c84abd97$var$_getInsertDirection(target) {
    if ($0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl) < $0ddc3b26c84abd97$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $0ddc3b26c84abd97$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $0ddc3b26c84abd97$var$_saveInputCheckedState(root) {
    $0ddc3b26c84abd97$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $0ddc3b26c84abd97$var$savedInputChecked.push(el);
    }
}
function $0ddc3b26c84abd97$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $0ddc3b26c84abd97$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($0ddc3b26c84abd97$var$documentExists) $0ddc3b26c84abd97$var$on(document, "touchmove", function(evt) {
    if (($0ddc3b26c84abd97$export$31b3ca70d8f57423.active || $0ddc3b26c84abd97$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$0ddc3b26c84abd97$export$31b3ca70d8f57423.utils = {
    on: $0ddc3b26c84abd97$var$on,
    off: $0ddc3b26c84abd97$var$off,
    css: $0ddc3b26c84abd97$var$css,
    find: $0ddc3b26c84abd97$var$find,
    is: function is(el, selector) {
        return !!$0ddc3b26c84abd97$var$closest(el, selector, el, false);
    },
    extend: $0ddc3b26c84abd97$var$extend,
    throttle: $0ddc3b26c84abd97$var$throttle,
    closest: $0ddc3b26c84abd97$var$closest,
    toggleClass: $0ddc3b26c84abd97$var$toggleClass,
    clone: $0ddc3b26c84abd97$var$clone,
    index: $0ddc3b26c84abd97$var$index,
    nextTick: $0ddc3b26c84abd97$var$_nextTick,
    cancelNextTick: $0ddc3b26c84abd97$var$_cancelNextTick,
    detectDirection: $0ddc3b26c84abd97$var$_detectDirection,
    getChild: $0ddc3b26c84abd97$var$getChild,
    expando: $0ddc3b26c84abd97$var$expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $0ddc3b26c84abd97$export$31b3ca70d8f57423.get = function(element) {
    return element[$0ddc3b26c84abd97$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $0ddc3b26c84abd97$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $0ddc3b26c84abd97$export$31b3ca70d8f57423.utils = $0ddc3b26c84abd97$var$_objectSpread2($0ddc3b26c84abd97$var$_objectSpread2({}, $0ddc3b26c84abd97$export$31b3ca70d8f57423.utils), plugin.utils);
        $0ddc3b26c84abd97$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $0ddc3b26c84abd97$export$31b3ca70d8f57423.create = function(el, options) {
    return new $0ddc3b26c84abd97$export$31b3ca70d8f57423(el, options);
};
// Export
$0ddc3b26c84abd97$export$31b3ca70d8f57423.version = $0ddc3b26c84abd97$var$version;
var $0ddc3b26c84abd97$var$autoScrolls = [], $0ddc3b26c84abd97$var$scrollEl, $0ddc3b26c84abd97$var$scrollRootEl, $0ddc3b26c84abd97$var$scrolling = false, $0ddc3b26c84abd97$var$lastAutoScrollX, $0ddc3b26c84abd97$var$lastAutoScrollY, $0ddc3b26c84abd97$var$touchEvt$1, $0ddc3b26c84abd97$var$pointerElemChangedInterval;
function $0ddc3b26c84abd97$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $0ddc3b26c84abd97$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $0ddc3b26c84abd97$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $0ddc3b26c84abd97$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $0ddc3b26c84abd97$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $0ddc3b26c84abd97$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $0ddc3b26c84abd97$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $0ddc3b26c84abd97$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $0ddc3b26c84abd97$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $0ddc3b26c84abd97$var$clearPointerElemChangedInterval();
            $0ddc3b26c84abd97$var$clearAutoScrolls();
            $0ddc3b26c84abd97$var$cancelThrottle();
        },
        nulling: function nulling() {
            $0ddc3b26c84abd97$var$touchEvt$1 = $0ddc3b26c84abd97$var$scrollRootEl = $0ddc3b26c84abd97$var$scrollEl = $0ddc3b26c84abd97$var$scrolling = $0ddc3b26c84abd97$var$pointerElemChangedInterval = $0ddc3b26c84abd97$var$lastAutoScrollX = $0ddc3b26c84abd97$var$lastAutoScrollY = null;
            $0ddc3b26c84abd97$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $0ddc3b26c84abd97$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $0ddc3b26c84abd97$var$Edge || $0ddc3b26c84abd97$var$IE11OrLess || $0ddc3b26c84abd97$var$Safari) {
                $0ddc3b26c84abd97$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $0ddc3b26c84abd97$var$getParentAutoScrollElement(elem, true);
                if ($0ddc3b26c84abd97$var$scrolling && (!$0ddc3b26c84abd97$var$pointerElemChangedInterval || x !== $0ddc3b26c84abd97$var$lastAutoScrollX || y !== $0ddc3b26c84abd97$var$lastAutoScrollY)) {
                    $0ddc3b26c84abd97$var$pointerElemChangedInterval && $0ddc3b26c84abd97$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $0ddc3b26c84abd97$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $0ddc3b26c84abd97$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $0ddc3b26c84abd97$var$clearAutoScrolls();
                        }
                        $0ddc3b26c84abd97$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $0ddc3b26c84abd97$var$lastAutoScrollX = x;
                    $0ddc3b26c84abd97$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $0ddc3b26c84abd97$var$getParentAutoScrollElement(elem, true) === $0ddc3b26c84abd97$var$getWindowScrollingElement()) {
                    $0ddc3b26c84abd97$var$clearAutoScrolls();
                    return;
                }
                $0ddc3b26c84abd97$var$autoScroll(evt, this.options, $0ddc3b26c84abd97$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $0ddc3b26c84abd97$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $0ddc3b26c84abd97$var$clearAutoScrolls() {
    $0ddc3b26c84abd97$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $0ddc3b26c84abd97$var$autoScrolls = [];
}
function $0ddc3b26c84abd97$var$clearPointerElemChangedInterval() {
    clearInterval($0ddc3b26c84abd97$var$pointerElemChangedInterval);
}
var $0ddc3b26c84abd97$var$autoScroll = $0ddc3b26c84abd97$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $0ddc3b26c84abd97$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($0ddc3b26c84abd97$var$scrollRootEl !== rootEl) {
        $0ddc3b26c84abd97$var$scrollRootEl = rootEl;
        $0ddc3b26c84abd97$var$clearAutoScrolls();
        $0ddc3b26c84abd97$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($0ddc3b26c84abd97$var$scrollEl === true) $0ddc3b26c84abd97$var$scrollEl = $0ddc3b26c84abd97$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $0ddc3b26c84abd97$var$scrollEl;
    do {
        var el = currentParent, rect = $0ddc3b26c84abd97$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $0ddc3b26c84abd97$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$0ddc3b26c84abd97$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$0ddc3b26c84abd97$var$autoScrolls[i]) $0ddc3b26c84abd97$var$autoScrolls[i] = {};
        }
        if ($0ddc3b26c84abd97$var$autoScrolls[layersOut].vx != vx || $0ddc3b26c84abd97$var$autoScrolls[layersOut].vy != vy || $0ddc3b26c84abd97$var$autoScrolls[layersOut].el !== el) {
            $0ddc3b26c84abd97$var$autoScrolls[layersOut].el = el;
            $0ddc3b26c84abd97$var$autoScrolls[layersOut].vx = vx;
            $0ddc3b26c84abd97$var$autoScrolls[layersOut].vy = vy;
            clearInterval($0ddc3b26c84abd97$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $0ddc3b26c84abd97$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $0ddc3b26c84abd97$export$31b3ca70d8f57423.active._onTouchMove($0ddc3b26c84abd97$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $0ddc3b26c84abd97$var$autoScrolls[this.layer].vy ? $0ddc3b26c84abd97$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $0ddc3b26c84abd97$var$autoScrolls[this.layer].vx ? $0ddc3b26c84abd97$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($0ddc3b26c84abd97$export$31b3ca70d8f57423.dragged.parentNode[$0ddc3b26c84abd97$var$expando], scrollOffsetX, scrollOffsetY, evt, $0ddc3b26c84abd97$var$touchEvt$1, $0ddc3b26c84abd97$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $0ddc3b26c84abd97$var$scrollBy($0ddc3b26c84abd97$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $0ddc3b26c84abd97$var$getParentAutoScrollElement(currentParent, false)));
    $0ddc3b26c84abd97$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $0ddc3b26c84abd97$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $0ddc3b26c84abd97$var$Revert() {}
$0ddc3b26c84abd97$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $0ddc3b26c84abd97$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $0ddc3b26c84abd97$var$drop
};
$0ddc3b26c84abd97$var$_extends($0ddc3b26c84abd97$var$Revert, {
    pluginName: "revertOnSpill"
});
function $0ddc3b26c84abd97$var$Remove() {}
$0ddc3b26c84abd97$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $0ddc3b26c84abd97$var$drop
};
$0ddc3b26c84abd97$var$_extends($0ddc3b26c84abd97$var$Remove, {
    pluginName: "removeOnSpill"
});
var $0ddc3b26c84abd97$var$lastSwapEl;
function $0ddc3b26c84abd97$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $0ddc3b26c84abd97$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $0ddc3b26c84abd97$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $0ddc3b26c84abd97$var$toggleClass(target, options.swapClass, true);
                    $0ddc3b26c84abd97$var$lastSwapEl = target;
                } else $0ddc3b26c84abd97$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $0ddc3b26c84abd97$var$lastSwapEl) $0ddc3b26c84abd97$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $0ddc3b26c84abd97$var$lastSwapEl && $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$lastSwapEl, options.swapClass, false);
            if ($0ddc3b26c84abd97$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $0ddc3b26c84abd97$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $0ddc3b26c84abd97$var$swapNodes(dragEl, $0ddc3b26c84abd97$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $0ddc3b26c84abd97$var$lastSwapEl = null;
        }
    };
    return $0ddc3b26c84abd97$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $0ddc3b26c84abd97$var$lastSwapEl
            };
        }
    });
}
function $0ddc3b26c84abd97$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $0ddc3b26c84abd97$var$index(n1);
    i2 = $0ddc3b26c84abd97$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $0ddc3b26c84abd97$var$multiDragElements = [], $0ddc3b26c84abd97$var$multiDragClones = [], $0ddc3b26c84abd97$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$0ddc3b26c84abd97$var$multiDragSortable, $0ddc3b26c84abd97$var$initialFolding = false, // Initial multi-drag fold when drag started
$0ddc3b26c84abd97$var$folding = false, // Folding any other time
$0ddc3b26c84abd97$var$dragStarted = false, $0ddc3b26c84abd97$var$dragEl$1, $0ddc3b26c84abd97$var$clonesFromRect, $0ddc3b26c84abd97$var$clonesHidden;
function $0ddc3b26c84abd97$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $0ddc3b26c84abd97$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $0ddc3b26c84abd97$var$on(document, "mouseup", this._deselectMultiDrag);
                $0ddc3b26c84abd97$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $0ddc3b26c84abd97$var$on(document, "keydown", this._checkKeyDown);
        $0ddc3b26c84abd97$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($0ddc3b26c84abd97$var$multiDragElements.length && $0ddc3b26c84abd97$var$multiDragSortable === sortable) $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $0ddc3b26c84abd97$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$0ddc3b26c84abd97$var$multiDragElements.indexOf($0ddc3b26c84abd97$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $0ddc3b26c84abd97$var$multiDragElements.length; i++){
                $0ddc3b26c84abd97$var$multiDragClones.push($0ddc3b26c84abd97$var$clone($0ddc3b26c84abd97$var$multiDragElements[i]));
                $0ddc3b26c84abd97$var$multiDragClones[i].sortableIndex = $0ddc3b26c84abd97$var$multiDragElements[i].sortableIndex;
                $0ddc3b26c84abd97$var$multiDragClones[i].draggable = false;
                $0ddc3b26c84abd97$var$multiDragClones[i].style["will-change"] = "";
                $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$multiDragClones[i], this.options.selectedClass, false);
                $0ddc3b26c84abd97$var$multiDragElements[i] === $0ddc3b26c84abd97$var$dragEl$1 && $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($0ddc3b26c84abd97$var$multiDragElements.length && $0ddc3b26c84abd97$var$multiDragSortable === sortable) {
                    $0ddc3b26c84abd97$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $0ddc3b26c84abd97$var$insertMultiDragClones(false, rootEl);
            $0ddc3b26c84abd97$var$multiDragClones.forEach(function(clone) {
                $0ddc3b26c84abd97$var$css(clone, "display", "");
            });
            cloneNowShown();
            $0ddc3b26c84abd97$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $0ddc3b26c84abd97$var$multiDragClones.forEach(function(clone) {
                $0ddc3b26c84abd97$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $0ddc3b26c84abd97$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $0ddc3b26c84abd97$var$multiDragSortable) $0ddc3b26c84abd97$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $0ddc3b26c84abd97$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $0ddc3b26c84abd97$var$multiDragElements = $0ddc3b26c84abd97$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $0ddc3b26c84abd97$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $0ddc3b26c84abd97$var$dragEl$1) return;
                        $0ddc3b26c84abd97$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $0ddc3b26c84abd97$var$getRect($0ddc3b26c84abd97$var$dragEl$1, false, true, true);
                    $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $0ddc3b26c84abd97$var$dragEl$1) return;
                        $0ddc3b26c84abd97$var$setRect(multiDragElement, dragRect);
                    });
                    $0ddc3b26c84abd97$var$folding = true;
                    $0ddc3b26c84abd97$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $0ddc3b26c84abd97$var$folding = false;
                $0ddc3b26c84abd97$var$initialFolding = false;
                if (_this2.options.animation) $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                    $0ddc3b26c84abd97$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $0ddc3b26c84abd97$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($0ddc3b26c84abd97$var$folding && ~$0ddc3b26c84abd97$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($0ddc3b26c84abd97$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $0ddc3b26c84abd97$var$folding ? $0ddc3b26c84abd97$var$getRect(multiDragElement) : dragRect
                    });
                    $0ddc3b26c84abd97$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $0ddc3b26c84abd97$var$folding = false;
                $0ddc3b26c84abd97$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $0ddc3b26c84abd97$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $0ddc3b26c84abd97$var$multiDragElements.length > 1 && ($0ddc3b26c84abd97$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $0ddc3b26c84abd97$var$getRect($0ddc3b26c84abd97$var$dragEl$1, false, true, true);
                    $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $0ddc3b26c84abd97$var$dragEl$1) return;
                        $0ddc3b26c84abd97$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $0ddc3b26c84abd97$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$0ddc3b26c84abd97$var$folding) $0ddc3b26c84abd97$var$removeMultiDragElements();
                    if ($0ddc3b26c84abd97$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $0ddc3b26c84abd97$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$0ddc3b26c84abd97$var$clonesHidden && clonesHiddenBefore) $0ddc3b26c84abd97$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $0ddc3b26c84abd97$var$clonesFromRect
                            });
                            clone.fromRect = $0ddc3b26c84abd97$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $0ddc3b26c84abd97$var$clonesFromRect = $0ddc3b26c84abd97$var$_extends({}, dragRect);
                var dragMatrix = $0ddc3b26c84abd97$var$matrix($0ddc3b26c84abd97$var$dragEl$1, true);
                $0ddc3b26c84abd97$var$clonesFromRect.top -= dragMatrix.f;
                $0ddc3b26c84abd97$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($0ddc3b26c84abd97$var$folding) {
                $0ddc3b26c84abd97$var$folding = false;
                $0ddc3b26c84abd97$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$0ddc3b26c84abd97$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $0ddc3b26c84abd97$var$toggleClass($0ddc3b26c84abd97$var$dragEl$1, options.selectedClass, !~$0ddc3b26c84abd97$var$multiDragElements.indexOf($0ddc3b26c84abd97$var$dragEl$1));
                if (!~$0ddc3b26c84abd97$var$multiDragElements.indexOf($0ddc3b26c84abd97$var$dragEl$1)) {
                    $0ddc3b26c84abd97$var$multiDragElements.push($0ddc3b26c84abd97$var$dragEl$1);
                    $0ddc3b26c84abd97$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $0ddc3b26c84abd97$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $0ddc3b26c84abd97$var$lastMultiDragSelect && sortable.el.contains($0ddc3b26c84abd97$var$lastMultiDragSelect)) {
                        var lastIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$lastMultiDragSelect), currentIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$0ddc3b26c84abd97$var$multiDragElements.indexOf(children[i])) continue;
                                $0ddc3b26c84abd97$var$toggleClass(children[i], options.selectedClass, true);
                                $0ddc3b26c84abd97$var$multiDragElements.push(children[i]);
                                $0ddc3b26c84abd97$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $0ddc3b26c84abd97$var$lastMultiDragSelect = $0ddc3b26c84abd97$var$dragEl$1;
                    $0ddc3b26c84abd97$var$multiDragSortable = toSortable;
                } else {
                    $0ddc3b26c84abd97$var$multiDragElements.splice($0ddc3b26c84abd97$var$multiDragElements.indexOf($0ddc3b26c84abd97$var$dragEl$1), 1);
                    $0ddc3b26c84abd97$var$lastMultiDragSelect = null;
                    $0ddc3b26c84abd97$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $0ddc3b26c84abd97$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($0ddc3b26c84abd97$var$dragStarted && this.isMultiDrag) {
                $0ddc3b26c84abd97$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$0ddc3b26c84abd97$var$expando].options.sort || parentEl !== rootEl) && $0ddc3b26c84abd97$var$multiDragElements.length > 1) {
                    var dragRect = $0ddc3b26c84abd97$var$getRect($0ddc3b26c84abd97$var$dragEl$1), multiDragIndex = $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$0ddc3b26c84abd97$var$initialFolding && options.animation) $0ddc3b26c84abd97$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$0ddc3b26c84abd97$var$initialFolding) {
                        if (options.animation) {
                            $0ddc3b26c84abd97$var$dragEl$1.fromRect = dragRect;
                            $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $0ddc3b26c84abd97$var$dragEl$1) {
                                    var rect = $0ddc3b26c84abd97$var$folding ? $0ddc3b26c84abd97$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $0ddc3b26c84abd97$var$removeMultiDragElements();
                        $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $0ddc3b26c84abd97$var$index($0ddc3b26c84abd97$var$dragEl$1)) {
                            var update = false;
                            $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $0ddc3b26c84abd97$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent("update");
                                dispatchSortableEvent("sort");
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                        $0ddc3b26c84abd97$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $0ddc3b26c84abd97$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $0ddc3b26c84abd97$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $0ddc3b26c84abd97$var$dragStarted = false;
            $0ddc3b26c84abd97$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $0ddc3b26c84abd97$var$off(document, "pointerup", this._deselectMultiDrag);
            $0ddc3b26c84abd97$var$off(document, "mouseup", this._deselectMultiDrag);
            $0ddc3b26c84abd97$var$off(document, "touchend", this._deselectMultiDrag);
            $0ddc3b26c84abd97$var$off(document, "keydown", this._checkKeyDown);
            $0ddc3b26c84abd97$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $0ddc3b26c84abd97$var$dragStarted !== "undefined" && $0ddc3b26c84abd97$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($0ddc3b26c84abd97$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $0ddc3b26c84abd97$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($0ddc3b26c84abd97$var$multiDragElements.length){
                var el = $0ddc3b26c84abd97$var$multiDragElements[0];
                $0ddc3b26c84abd97$var$toggleClass(el, this.options.selectedClass, false);
                $0ddc3b26c84abd97$var$multiDragElements.shift();
                $0ddc3b26c84abd97$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $0ddc3b26c84abd97$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$0ddc3b26c84abd97$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$0ddc3b26c84abd97$var$multiDragElements.indexOf(el)) return;
                if ($0ddc3b26c84abd97$var$multiDragSortable && $0ddc3b26c84abd97$var$multiDragSortable !== sortable) {
                    $0ddc3b26c84abd97$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $0ddc3b26c84abd97$var$multiDragSortable = sortable;
                }
                $0ddc3b26c84abd97$var$toggleClass(el, sortable.options.selectedClass, true);
                $0ddc3b26c84abd97$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$0ddc3b26c84abd97$var$expando], index = $0ddc3b26c84abd97$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $0ddc3b26c84abd97$var$toggleClass(el, sortable.options.selectedClass, false);
                $0ddc3b26c84abd97$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($0ddc3b26c84abd97$var$folding && multiDragElement !== $0ddc3b26c84abd97$var$dragEl$1) newIndex = -1;
                else if ($0ddc3b26c84abd97$var$folding) newIndex = $0ddc3b26c84abd97$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $0ddc3b26c84abd97$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $0ddc3b26c84abd97$var$_toConsumableArray($0ddc3b26c84abd97$var$multiDragElements),
                clones: [].concat($0ddc3b26c84abd97$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $0ddc3b26c84abd97$var$insertMultiDragElements(clonesInserted, rootEl) {
    $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $0ddc3b26c84abd97$var$insertMultiDragClones(elementsInserted, rootEl) {
    $0ddc3b26c84abd97$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $0ddc3b26c84abd97$var$removeMultiDragElements() {
    $0ddc3b26c84abd97$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $0ddc3b26c84abd97$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$0ddc3b26c84abd97$export$31b3ca70d8f57423.mount(new $0ddc3b26c84abd97$var$AutoScrollPlugin());
$0ddc3b26c84abd97$export$31b3ca70d8f57423.mount($0ddc3b26c84abd97$var$Remove, $0ddc3b26c84abd97$var$Revert);
var $0ddc3b26c84abd97$export$2e2bcd8739ae039 = $0ddc3b26c84abd97$export$31b3ca70d8f57423;

});


parcelRegister("8ekoQ", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $5fdf747caac97244$require$div = $2Z6Kw.div;
var $5fdf747caac97244$require$h2 = $2Z6Kw.h2;
var $5fdf747caac97244$require$span = $2Z6Kw.span;
var $5fdf747caac97244$require$p = $2Z6Kw.p;
var $5fdf747caac97244$require$ul = $2Z6Kw.ul;
var $5fdf747caac97244$require$li = $2Z6Kw.li;
var $5fdf747caac97244$require$hr = $2Z6Kw.hr;
var $5fdf747caac97244$require$button = $2Z6Kw.button;
var $5fdf747caac97244$require$fieldset = $2Z6Kw.fieldset;
var $5fdf747caac97244$require$legend = $2Z6Kw.legend;
var $5fdf747caac97244$require$i = $2Z6Kw.i;
var $5fdf747caac97244$require$input = $2Z6Kw.input;
var $5fdf747caac97244$require$label = $2Z6Kw.label;

var $jjnZg = parcelRequire("jjnZg");
var $5fdf747caac97244$require$obj = $jjnZg.obj;
var $5fdf747caac97244$require$str = $jjnZg.str;
const $5fdf747caac97244$var$indexAt = (collection, prop, value)=>collection.reduce((index, doc, i)=>doc[prop] === value ? i : index, -1);
/*
const groupList = list => list.reduce((groups, name) =>
	[str.toCamelCase(name.replace(/[0-9]+/ig, '').replace('.ogg', ''))]
		.map(group => ({group, index: indexAt(groups, 'name', group)}))
		.map(({group, index}) =>
		(index > -1)
			? [].concat(
				groups.slice(0, index),
				[{
					name: group,
					items: groups[index].items.concat([name])
				}],
				groups.slice(index + 1)
			)
			: groups.concat([{
				name: group,
				items: [name]
			}])
	).pop(), []
);
*/ // console.log(groupList([
// 	'kick01.ogg',
// 	'kick02.ogg',
// 	'kick03.ogg',
// 	'kick_hiphop01.ogg',
// 	'hihat_opened02.ogg',
// 	'hihat_opened03.ogg',
// 	'ride02.ogg',
// 	'rim01.ogg']));
const $5fdf747caac97244$var$parseTree = (items, state, actions, level = 0, path = [])=>$5fdf747caac97244$require$ul(items.map((item, k)=>typeof item === "object" ? $5fdf747caac97244$require$li('[draggable="true"]', [
            $5fdf747caac97244$require$input(`[type="checkbox"][id="li-${level}-${k}-${item.name}"]`, {
                attrs: {
                    checked: item.expanded
                }
            }),
            $5fdf747caac97244$require$label(`[for="li-${level}-${k}-${item.name}"]`, {
                style: {
                    paddingLeft: 5 + level * 5 + "px"
                }
            }, [
                $5fdf747caac97244$require$i(".fa.fa-folder-o"),
                " ",
                item.name
            ])
        ].concat(item.items ? $5fdf747caac97244$var$parseTree(item.items, state, actions, level + 1, [].concat(path, item.name)) : [])) : $5fdf747caac97244$require$li('[draggable="true"]', {
            on: {
                dblclick: ()=>(console.log(state.mediaLibrary.files, [].concat(path, item).join("/")), actions.sequencer.setSample(state.sequencer.channel, state.mediaLibrary.files.indexOf([].concat(path, item).join("/"))))
            }
        }, [
            $5fdf747caac97244$require$label({
                style: {
                    paddingLeft: 5 + level * 5 + "px"
                }
            }, [
                $5fdf747caac97244$require$i(".fa.fa-file-audio-o"),
                " ",
                item
            ]),
            $5fdf747caac97244$require$button(".right.fa.fa-play")
        ])));
module.exports = ({ state: state, actions: actions, params: params = {} })=>$5fdf747caac97244$require$div(".media-library", params, [
        /*
	div('.header', [
		h2([i('.fa.fa-book'), ' Media Library'])
	]),
	*/ $5fdf747caac97244$require$div(".body", [
            $5fdf747caac97244$require$fieldset([
                $5fdf747caac97244$require$legend("Samples"),
                $5fdf747caac97244$var$parseTree(state.mediaLibrary.samples, state, actions)
            ]),
            $5fdf747caac97244$require$fieldset([
                $5fdf747caac97244$require$legend("Patches"),
                $5fdf747caac97244$require$ul(state.mediaLibrary.patches.map((patch)=>$5fdf747caac97244$require$li('[draggable="true"]', {
                        on: {
                            dblclick: ()=>actions.instrument.applyPatch(patch.patch)
                        }
                    }, [
                        $5fdf747caac97244$require$label([
                            $5fdf747caac97244$require$i(".fa.fa-file-code-o"),
                            " ",
                            patch.name
                        ])
                    ])))
            ])
        ])
    ]);

});

parcelRegister("hFQ5h", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $cddeaada76772d78$require$div = $2Z6Kw.div;
var $cddeaada76772d78$require$h2 = $2Z6Kw.h2;
var $cddeaada76772d78$require$h3 = $2Z6Kw.h3;
var $cddeaada76772d78$require$span = $2Z6Kw.span;
var $cddeaada76772d78$require$p = $2Z6Kw.p;
var $cddeaada76772d78$require$ul = $2Z6Kw.ul;
var $cddeaada76772d78$require$li = $2Z6Kw.li;
var $cddeaada76772d78$require$hr = $2Z6Kw.hr;
var $cddeaada76772d78$require$button = $2Z6Kw.button;
var $cddeaada76772d78$require$br = $2Z6Kw.br;
var $cddeaada76772d78$require$form = $2Z6Kw.form;
var $cddeaada76772d78$require$label = $2Z6Kw.label;
var $cddeaada76772d78$require$input = $2Z6Kw.input;
var $cddeaada76772d78$require$fieldset = $2Z6Kw.fieldset;
var $cddeaada76772d78$require$legend = $2Z6Kw.legend;
var $cddeaada76772d78$require$i = $2Z6Kw.i;
var $cddeaada76772d78$require$img = $2Z6Kw.img;

var $jjnZg = parcelRequire("jjnZg");
var $cddeaada76772d78$require$obj = $jjnZg.obj;

var $1bMen = parcelRequire("1bMen");
var $cddeaada76772d78$require$Sortable = $1bMen.default;

var $k25bp = parcelRequire("k25bp");
const $cddeaada76772d78$var$prompt = (message, cb)=>$k25bp.dialog.prompt({
        message: message,
        callback: (v)=>v && v !== "" && cb(v)
    });

var $2YOME = parcelRequire("2YOME");
var $cddeaada76772d78$require$vco = $2YOME.default;

var $1K0uO = parcelRequire("1K0uO");
var $cddeaada76772d78$require$vca = $1K0uO.default;

var $iIjXE = parcelRequire("iIjXE");

var $704jW = parcelRequire("704jW");

var $lQN1z = parcelRequire("lQN1z");

var $27D8y = parcelRequire("27D8y");


const $cddeaada76772d78$var$sampler = (parcelRequire("kIWAM")).default || (parcelRequire("kIWAM"));
const $cddeaada76772d78$var$vcas = [
    "vca1",
    "vca2"
];
const $cddeaada76772d78$var$synth = ({ state: state, actions: actions })=>[
        $cddeaada76772d78$require$vco({
            name: "vco1",
            prefs: state.instrument.source.vco1,
            updateProp: (prop, value)=>actions.set([
                    "instrument",
                    "source",
                    "vco1",
                    prop
                ], value)
        }),
        $cddeaada76772d78$require$vco({
            name: "vco2",
            prefs: state.instrument.source.vco2,
            updateProp: (prop, value)=>actions.set([
                    "instrument",
                    "source",
                    "vco2",
                    prop
                ], value)
        }),
        $cddeaada76772d78$require$fieldset([].concat(// vca tabs selector
        $cddeaada76772d78$require$legend($cddeaada76772d78$var$vcas.map((name, i)=>$cddeaada76772d78$require$span({
                class: {
                    on: state.instrument.source.vcaOn === i + 1
                },
                on: {
                    click: ()=>actions.set([
                            "instrument",
                            "source",
                            "vcaOn"
                        ], i + 1)
                }
            }, name.toUpperCase()))), // active vca
        $cddeaada76772d78$require$vca({
            prefs: state.instrument.source[`vca${state.instrument.source.vcaOn}`],
            updateProp: (prop, value)=>actions.set([
                    "instrument",
                    "source",
                    `vca${state.instrument.source.vcaOn}`,
                    prop
                ], value)
        })))
    ];
module.exports = ({ state: state, actions: actions, params: params = {} })=>$cddeaada76772d78$require$div(".instrument", params, [
        $cddeaada76772d78$require$div(".header", [
            $cddeaada76772d78$require$h2([
                $cddeaada76772d78$require$i(".fa.fa-sliders"),
                " Instrument [",
                state.session.selection.instr.join(":"),
                "]"
            ]),
            $cddeaada76772d78$require$div(".right", [
                $cddeaada76772d78$require$button(".fa.fa-eraser", {
                    on: {
                        click: ()=>actions.instrument.applyPatch(state.mediaLibrary.patches.filter((p)=>p.name === "default").pop().patch)
                    }
                }),
                $cddeaada76772d78$require$button(".fa.fa-save", {
                    on: {
                        click: ()=>$cddeaada76772d78$var$prompt("Save patch as", (name)=>actions.mediaLibrary.addPatch(name, state.instrument))
                    }
                })
            ])
        ]),
        $cddeaada76772d78$require$div(".body", [
            // source
            $cddeaada76772d78$require$form({
                on: {
                    submit: (ev)=>ev.preventDefault()
                }
            }, [].concat($cddeaada76772d78$require$h3("Source"), $cddeaada76772d78$require$obj.switch(state.instrument.sourceType, {
                synth: $cddeaada76772d78$var$synth,
                sampler: $cddeaada76772d78$var$sampler,
                default: ()=>[]
            })({
                state: state,
                actions: actions
            }))),
            // effects chain
            $cddeaada76772d78$require$form({
                on: {
                    submit: (ev)=>ev.preventDefault()
                },
                hook: {
                    insert: (vnode)=>new $cddeaada76772d78$require$Sortable(vnode.elm, {
                            group: "effects-chain",
                            draggable: "fieldset",
                            handle: "legend",
                            dataIdAttr: "data-id",
                            onEnd: (event)=>{
                                const fromIndex = event.oldIndex - 1;
                                const toIndex = event.newIndex - 1;
                                console.log("onEnd", fromIndex, toIndex);
                                actions.instrument.reorderEffect(fromIndex, toIndex);
                            }
                        })
                }
            }, [].concat($cddeaada76772d78$require$h3("Effects"), ...(state.instrument.effectsChain || []).map((effect, index)=>$cddeaada76772d78$require$obj.switch(effect.type, {
                    vcf: $iIjXE,
                    lfo: $704jW,
                    reverb: $lQN1z,
                    delay: $27D8y,
                    default: ()=>""
                }) // pass the effect object to the component
                ({
                    effect: effect,
                    index: index,
                    updateProp: (prop, value)=>actions.instrument.updateProp(index, prop, value),
                    toggleExpanded: ()=>actions.instrument.toggleExpanded(index)
                })), $cddeaada76772d78$require$button({
                on: {
                    click: ()=>actions.instrument.addEffect("vcf")
                }
            }, [
                $cddeaada76772d78$require$i(".fa.fa-plus"),
                " Add Effect"
            ])))
        ])
    ]);

});
parcelRegister("k25bp", function(module, exports) {
(function(f) {
    var g;
    module.exports = f();
})(function() {
    var define, module1, exports;
    return (function() {
        function e(t, n, r) {
            function s(o, u) {
                if (!n[o]) {
                    if (!t[o]) {
                        var a = undefined;
                        if (!u && a) return a(o, !0);
                        if (i) return i(o, !0);
                        var f = new Error("Cannot find module '" + o + "'");
                        throw f.code = "MODULE_NOT_FOUND", f;
                    }
                    var l = n[o] = {
                        exports: {}
                    };
                    t[o][0].call(l.exports, function(e) {
                        var n = t[o][1][e];
                        return s(n ? n : e);
                    }, l, l.exports, e, t, n, r);
                }
                return n[o].exports;
            }
            var i = undefined;
            for(var o = 0; o < r.length; o++)s(r[o]);
            return s;
        }
        return e;
    })()({
        1: [
            function(require1, module1, exports) {
                /*
 * classList.js: Cross-browser full element.classList implementation.
 * 1.1.20170427
 *
 * By Eli Grey, http://eligrey.com
 * License: Dedicated to the public domain.
 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
 */ /*global self, document, DOMException */ /*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */ if ("document" in window.self) {
                    // Full polyfill for browsers with no classList support
                    // Including IE < Edge missing SVGElement.classList
                    if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) (function(view) {
                        "use strict";
                        if (!("Element" in view)) return;
                        var classListProp = "classList", protoProp = "prototype", elemCtrProto = view.Element[protoProp], objCtr = Object, strTrim = String[protoProp].trim || function() {
                            return this.replace(/^\s+|\s+$/g, "");
                        }, arrIndexOf = Array[protoProp].indexOf || function(item) {
                            var i = 0, len = this.length;
                            for(; i < len; i++){
                                if (i in this && this[i] === item) return i;
                            }
                            return -1;
                        }, DOMEx = function(type, message) {
                            this.name = type;
                            this.code = DOMException[type];
                            this.message = message;
                        }, checkTokenAndGetIndex = function(classList, token) {
                            if (token === "") throw new DOMEx("SYNTAX_ERR", "An invalid or illegal string was specified");
                            if (/\s/.test(token)) throw new DOMEx("INVALID_CHARACTER_ERR", "String contains an invalid character");
                            return arrIndexOf.call(classList, token);
                        }, ClassList = function(elem) {
                            var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""), classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [], i = 0, len = classes.length;
                            for(; i < len; i++)this.push(classes[i]);
                            this._updateClassName = function() {
                                elem.setAttribute("class", this.toString());
                            };
                        }, classListProto = ClassList[protoProp] = [], classListGetter = function() {
                            return new ClassList(this);
                        };
                        // Most DOMException implementations don't allow calling DOMException's toString()
                        // on non-DOMExceptions. Error's toString() is sufficient here.
                        DOMEx[protoProp] = Error[protoProp];
                        classListProto.item = function(i) {
                            return this[i] || null;
                        };
                        classListProto.contains = function(token) {
                            token += "";
                            return checkTokenAndGetIndex(this, token) !== -1;
                        };
                        classListProto.add = function() {
                            var tokens = arguments, i = 0, l = tokens.length, token, updated = false;
                            do {
                                token = tokens[i] + "";
                                if (checkTokenAndGetIndex(this, token) === -1) {
                                    this.push(token);
                                    updated = true;
                                }
                            }while (++i < l);
                            if (updated) this._updateClassName();
                        };
                        classListProto.remove = function() {
                            var tokens = arguments, i = 0, l = tokens.length, token, updated = false, index;
                            do {
                                token = tokens[i] + "";
                                index = checkTokenAndGetIndex(this, token);
                                while(index !== -1){
                                    this.splice(index, 1);
                                    updated = true;
                                    index = checkTokenAndGetIndex(this, token);
                                }
                            }while (++i < l);
                            if (updated) this._updateClassName();
                        };
                        classListProto.toggle = function(token, force) {
                            token += "";
                            var result = this.contains(token), method = result ? force !== true && "remove" : force !== false && "add";
                            if (method) this[method](token);
                            if (force === true || force === false) return force;
                            else return !result;
                        };
                        classListProto.toString = function() {
                            return this.join(" ");
                        };
                        if (objCtr.defineProperty) {
                            var classListPropDesc = {
                                get: classListGetter,
                                enumerable: true,
                                configurable: true
                            };
                            try {
                                objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                            } catch (ex) {
                                // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                                // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                                if (ex.number === undefined || ex.number === -2146823252) {
                                    classListPropDesc.enumerable = false;
                                    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                                }
                            }
                        } else if (objCtr[protoProp].__defineGetter__) elemCtrProto.__defineGetter__(classListProp, classListGetter);
                    })(window.self);
                    // There is full or partial native classList support, so just check if we need
                    // to normalize the add/remove and toggle APIs.
                    (function() {
                        "use strict";
                        var testElement = document.createElement("_");
                        testElement.classList.add("c1", "c2");
                        // Polyfill for IE 10/11 and Firefox <26, where classList.add and
                        // classList.remove exist but support only one argument at a time.
                        if (!testElement.classList.contains("c2")) {
                            var createMethod = function(method) {
                                var original = DOMTokenList.prototype[method];
                                DOMTokenList.prototype[method] = function(token) {
                                    var i, len = arguments.length;
                                    for(i = 0; i < len; i++){
                                        token = arguments[i];
                                        original.call(this, token);
                                    }
                                };
                            };
                            createMethod("add");
                            createMethod("remove");
                        }
                        testElement.classList.toggle("c3", false);
                        // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
                        // support the second argument.
                        if (testElement.classList.contains("c3")) {
                            var _toggle = DOMTokenList.prototype.toggle;
                            DOMTokenList.prototype.toggle = function(token, force) {
                                if (1 in arguments && !this.contains(token) === !force) return force;
                                else return _toggle.call(this, token);
                            };
                        }
                        testElement = null;
                    })();
                }
            },
            {}
        ],
        2: [
            function(require1, module1, exports) {
                /**
 * Expose `parse`.
 */ module1.exports = parse;
                /**
 * Tests for browser support.
 */ var innerHTMLBug = false;
                var bugTestDiv;
                if (typeof document !== "undefined") {
                    bugTestDiv = document.createElement("div");
                    // Setup
                    bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
                    // Make sure that link elements get serialized correctly by innerHTML
                    // This requires a wrapper element in IE
                    innerHTMLBug = !bugTestDiv.getElementsByTagName("link").length;
                    bugTestDiv = undefined;
                }
                /**
 * Wrap map from jquery.
 */ var map = {
                    legend: [
                        1,
                        "<fieldset>",
                        "</fieldset>"
                    ],
                    tr: [
                        2,
                        "<table><tbody>",
                        "</tbody></table>"
                    ],
                    col: [
                        2,
                        "<table><tbody></tbody><colgroup>",
                        "</colgroup></table>"
                    ],
                    // for script/link/style tags to work in IE6-8, you have to wrap
                    // in a div with a non-whitespace character in front, ha!
                    _default: innerHTMLBug ? [
                        1,
                        "X<div>",
                        "</div>"
                    ] : [
                        0,
                        "",
                        ""
                    ]
                };
                map.td = map.th = [
                    3,
                    "<table><tbody><tr>",
                    "</tr></tbody></table>"
                ];
                map.option = map.optgroup = [
                    1,
                    '<select multiple="multiple">',
                    "</select>"
                ];
                map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [
                    1,
                    "<table>",
                    "</table>"
                ];
                map.polyline = map.ellipse = map.polygon = map.circle = map.text = map.line = map.path = map.rect = map.g = [
                    1,
                    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">',
                    "</svg>"
                ];
                /**
 * Parse `html` and return a DOM Node instance, which could be a TextNode,
 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
 * instance, depending on the contents of the `html` string.
 *
 * @param {String} html - HTML string to "domify"
 * @param {Document} doc - The `document` instance to create the Node for
 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
 * @api private
 */ function parse(html, doc) {
                    if ("string" != typeof html) throw new TypeError("String expected");
                    // default to the global `document` object
                    if (!doc) doc = document;
                    // tag name
                    var m = /<([\w:]+)/.exec(html);
                    if (!m) return doc.createTextNode(html);
                    html = html.replace(/^\s+|\s+$/g, ""); // Remove leading/trailing whitespace
                    var tag = m[1];
                    // body support
                    if (tag == "body") {
                        var el = doc.createElement("html");
                        el.innerHTML = html;
                        return el.removeChild(el.lastChild);
                    }
                    // wrap map
                    var wrap = map[tag] || map._default;
                    var depth = wrap[0];
                    var prefix = wrap[1];
                    var suffix = wrap[2];
                    var el = doc.createElement("div");
                    el.innerHTML = prefix + html + suffix;
                    while(depth--)el = el.lastChild;
                    // one element
                    if (el.firstChild == el.lastChild) return el.removeChild(el.firstChild);
                    // several elements
                    var fragment = doc.createDocumentFragment();
                    while(el.firstChild)fragment.appendChild(el.removeChild(el.firstChild));
                    return fragment;
                }
            },
            {}
        ],
        3: [
            function(require1, module1, exports) {
                /**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ "use strict";
                function assign(target, firstSource) {
                    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
                    var to = Object(target);
                    for(var i = 1; i < arguments.length; i++){
                        var nextSource = arguments[i];
                        if (nextSource === undefined || nextSource === null) continue;
                        var keysArray = Object.keys(Object(nextSource));
                        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
                            var nextKey = keysArray[nextIndex];
                            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
                        }
                    }
                    return to;
                }
                function polyfill() {
                    if (!Object.assign) Object.defineProperty(Object, "assign", {
                        enumerable: false,
                        configurable: true,
                        writable: true,
                        value: assign
                    });
                }
                module1.exports = {
                    assign: assign,
                    polyfill: polyfill
                };
            },
            {}
        ],
        4: [
            function(require1, module1, exports) {
                // classList polyfill for old browsers
                require1("classlist-polyfill");
                // Object.assign polyfill
                require1("es6-object-assign").polyfill();
                // String to DOM function
                var domify = require1("domify");
                // Use the DOM's HTML parsing to escape any dangerous strings
                var escapeHtml = function escapeHtml(str) {
                    if (typeof str !== "undefined") {
                        var div = document.createElement("div");
                        div.appendChild(document.createTextNode(str));
                        return div.innerHTML;
                    } else return "";
                };
                // Utility function to add space-delimited class strings to a DOM element's classList
                var addClasses = function addClasses(el, classStr) {
                    if (typeof classStr !== "string" || classStr.length === 0) return;
                    var classes = classStr.split(" ");
                    for(var i = 0; i < classes.length; i++){
                        var className = classes[i];
                        if (className.length) el.classList.add(className);
                    }
                };
                // Detect CSS Animation End Support
                // https://github.com/limonte/sweetalert2/blob/99bd539f85e15ac170f69d35001d12e092ef0054/src/utils/dom.js#L194
                var animationEndEvent = function detectAnimationEndEvent() {
                    var el = document.createElement("div");
                    var eventNames = {
                        "animation": "animationend",
                        "WebkitAnimation": "webkitAnimationEnd",
                        "MozAnimation": "animationend",
                        "OAnimation": "oanimationend",
                        "msAnimation": "MSAnimationEnd"
                    };
                    for(var i in eventNames){
                        if (el.style[i] !== undefined) return eventNames[i];
                    }
                    return false;
                }();
                // vex base CSS classes
                var baseClassNames = {
                    vex: "vex",
                    content: "vex-content",
                    overlay: "vex-overlay",
                    close: "vex-close",
                    closing: "vex-closing",
                    open: "vex-open"
                };
                // Private lookup table of all open vex objects, keyed by id
                var vexes = {};
                var globalId = 1;
                // Private boolean to assist the escapeButtonCloses option
                var isEscapeActive = false;
                // vex itself is an object that exposes a simple API to open and close vex objects in various ways
                var vex = {
                    open: function open(opts) {
                        // Check for usage of deprecated options, and log a warning
                        var warnDeprecated = function warnDeprecated(prop) {
                            console.warn('The "' + prop + '" property is deprecated in vex 3. Use CSS classes and the appropriate "ClassName" options, instead.');
                            console.warn("See http://github.hubspot.com/vex/api/advanced/#options");
                        };
                        if (opts.css) warnDeprecated("css");
                        if (opts.overlayCSS) warnDeprecated("overlayCSS");
                        if (opts.contentCSS) warnDeprecated("contentCSS");
                        if (opts.closeCSS) warnDeprecated("closeCSS");
                        // The dialog instance
                        var vexInstance = {};
                        // Set id
                        vexInstance.id = globalId++;
                        // Store internally
                        vexes[vexInstance.id] = vexInstance;
                        // Set state
                        vexInstance.isOpen = true;
                        // Close function on the vex instance
                        // This is how all API functions should close individual vexes
                        vexInstance.close = function instanceClose() {
                            // Check state
                            if (!this.isOpen) return true;
                            var options = this.options;
                            // escapeButtonCloses is checked first
                            if (isEscapeActive && !options.escapeButtonCloses) return false;
                            // Allow the user to validate any info or abort the close with the beforeClose callback
                            var shouldClose = (function shouldClose() {
                                // Call before close callback
                                if (options.beforeClose) return options.beforeClose.call(this);
                                // Otherwise indicate that it's ok to continue with close
                                return true;
                            }).bind(this)();
                            // If beforeClose() fails, abort the close
                            if (shouldClose === false) return false;
                            // Update state
                            this.isOpen = false;
                            // Detect if the content el has any CSS animations defined
                            var style = window.getComputedStyle(this.contentEl);
                            function hasAnimationPre(prefix) {
                                return style.getPropertyValue(prefix + "animation-name") !== "none" && style.getPropertyValue(prefix + "animation-duration") !== "0s";
                            }
                            var hasAnimation = hasAnimationPre("") || hasAnimationPre("-webkit-") || hasAnimationPre("-moz-") || hasAnimationPre("-o-");
                            // Define the function that will actually close the instance
                            var close = (function close() {
                                if (!this.rootEl.parentNode) return;
                                // Run once
                                this.rootEl.removeEventListener(animationEndEvent, close);
                                this.overlayEl.removeEventListener(animationEndEvent, close);
                                // Remove from lookup table (prevent memory leaks)
                                delete vexes[this.id];
                                // Remove the dialog from the DOM
                                this.rootEl.parentNode.removeChild(this.rootEl);
                                // Remove the overlay from the DOM
                                this.bodyEl.removeChild(this.overlayEl);
                                // Call after close callback
                                if (options.afterClose) options.afterClose.call(this);
                                // Remove styling from the body, if no more vexes are open
                                if (Object.keys(vexes).length === 0) document.body.classList.remove(baseClassNames.open);
                            }).bind(this);
                            // Close the vex
                            if (animationEndEvent && hasAnimation) {
                                // Setup the end event listener, to remove the el from the DOM
                                this.rootEl.addEventListener(animationEndEvent, close);
                                this.overlayEl.addEventListener(animationEndEvent, close);
                                // Add the closing class to the dialog, showing the close animation
                                this.rootEl.classList.add(baseClassNames.closing);
                                this.overlayEl.classList.add(baseClassNames.closing);
                            } else close();
                            return true;
                        };
                        // Allow strings as content
                        if (typeof opts === "string") opts = {
                            content: opts
                        };
                        // `content` is unsafe internally, so translate
                        // safe default: HTML-escape the content before passing it through
                        if (opts.unsafeContent && !opts.content) opts.content = opts.unsafeContent;
                        else if (opts.content) opts.content = escapeHtml(opts.content);
                        // Store options on instance for future reference
                        var options = vexInstance.options = Object.assign({}, vex.defaultOptions, opts);
                        // Get Body Element
                        var bodyEl = vexInstance.bodyEl = document.getElementsByTagName("body")[0];
                        // vex root
                        var rootEl = vexInstance.rootEl = document.createElement("div");
                        rootEl.classList.add(baseClassNames.vex);
                        addClasses(rootEl, options.className);
                        // Overlay
                        var overlayEl = vexInstance.overlayEl = document.createElement("div");
                        overlayEl.classList.add(baseClassNames.overlay);
                        addClasses(overlayEl, options.overlayClassName);
                        if (options.overlayClosesOnClick) rootEl.addEventListener("click", function overlayClickListener(e) {
                            if (e.target === rootEl) vexInstance.close();
                        });
                        bodyEl.appendChild(overlayEl);
                        // Content
                        var contentEl = vexInstance.contentEl = document.createElement("div");
                        contentEl.classList.add(baseClassNames.content);
                        addClasses(contentEl, options.contentClassName);
                        contentEl.appendChild(options.content instanceof window.Node ? options.content : domify(options.content));
                        rootEl.appendChild(contentEl);
                        // Close button
                        if (options.showCloseButton) {
                            var closeEl = vexInstance.closeEl = document.createElement("div");
                            closeEl.classList.add(baseClassNames.close);
                            addClasses(closeEl, options.closeClassName);
                            closeEl.addEventListener("click", vexInstance.close.bind(vexInstance));
                            contentEl.appendChild(closeEl);
                        }
                        // Add to DOM
                        document.querySelector(options.appendLocation).appendChild(rootEl);
                        // Call after open callback
                        if (options.afterOpen) options.afterOpen.call(vexInstance);
                        // Apply styling to the body
                        document.body.classList.add(baseClassNames.open);
                        // Return the created vex instance
                        return vexInstance;
                    },
                    // A top-level vex.close function to close dialogs by reference or id
                    close: function close(vexOrId) {
                        var id;
                        if (vexOrId.id) id = vexOrId.id;
                        else if (typeof vexOrId === "string") id = vexOrId;
                        else throw new TypeError("close requires a vex object or id string");
                        if (!vexes[id]) return false;
                        return vexes[id].close();
                    },
                    // Close the most recently created/opened vex
                    closeTop: function closeTop() {
                        var ids = Object.keys(vexes);
                        if (!ids.length) return false;
                        return vexes[ids[ids.length - 1]].close();
                    },
                    // Close every vex!
                    closeAll: function closeAll() {
                        for(var id in vexes)this.close(id);
                        return true;
                    },
                    // A getter for the internal lookup table
                    getAll: function getAll() {
                        return vexes;
                    },
                    // A getter for the internal lookup table
                    getById: function getById(id) {
                        return vexes[id];
                    }
                };
                // Close top vex on escape
                window.addEventListener("keyup", function vexKeyupListener(e) {
                    if (e.keyCode === 27) {
                        isEscapeActive = true;
                        vex.closeTop();
                        isEscapeActive = false;
                    }
                });
                // Close all vexes on history pop state (useful in single page apps)
                window.addEventListener("popstate", function() {
                    if (vex.defaultOptions.closeAllOnPopState) vex.closeAll();
                });
                vex.defaultOptions = {
                    content: "",
                    showCloseButton: true,
                    escapeButtonCloses: true,
                    overlayClosesOnClick: true,
                    appendLocation: "body",
                    className: "",
                    overlayClassName: "",
                    contentClassName: "",
                    closeClassName: "",
                    closeAllOnPopState: true
                };
                // TODO Loading symbols?
                // Include escapeHtml function on the library object
                Object.defineProperty(vex, "_escapeHtml", {
                    configurable: false,
                    enumerable: false,
                    writable: false,
                    value: escapeHtml
                });
                // Plugin system!
                vex.registerPlugin = function registerPlugin(pluginFn, name) {
                    var plugin = pluginFn(vex);
                    var pluginName = name || plugin.name;
                    if (vex[pluginName]) throw new Error("Plugin " + name + " is already registered.");
                    vex[pluginName] = plugin;
                };
                module1.exports = vex;
            },
            {
                "classlist-polyfill": 1,
                "domify": 2,
                "es6-object-assign": 3
            }
        ]
    }, {}, [
        4
    ])(4);
});

});

parcelRegister("2YOME", function(module, exports) {

$parcel$export(module.exports, "default", () => $22b893f25948efd5$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");
const $22b893f25948efd5$export$b14ad400b1d09e0f = [
    "sine",
    "square",
    "sawtooth",
    "triangle"
];
var $22b893f25948efd5$export$2e2bcd8739ae039 = ({ name: name, prefs: prefs, updateProp: updateProp })=>(0, $2Z6Kw.fieldset)([
        (0, $2Z6Kw.legend)([
            (0, $2Z6Kw.span)(".on", name.toUpperCase()),
            (0, $2Z6Kw.div)($22b893f25948efd5$export$b14ad400b1d09e0f.reduce((list, type)=>list.concat([
                    (0, $2Z6Kw.button)(`.btn-opt`, {
                        on: {
                            click: (ev)=>updateProp("type", type)
                        },
                        class: {
                            on: prefs.type === type
                        }
                    }, [
                        (0, $2Z6Kw.img)(`[src="assets/icons/wave-${type}.svg"]`)
                    ])
                ]), [])),
            (0, $2Z6Kw.div)(".on-switch.fa", {
                on: {
                    click: (ev)=>updateProp("on", !prefs.on)
                },
                class: {
                    "fa-circle-thin": !prefs.on,
                    "on": prefs.on,
                    "fa-circle": prefs.on
                }
            }),
            (0, $2Z6Kw.img)('[src="assets/tuning-fork.png"]'),
            (0, $2Z6Kw.div)(".knob", {
                style: {
                    transform: `rotate(${prefs.detune / 100 * 135}deg)`
                },
                on: {
                    wheel: (ev)=>(ev.preventDefault(), updateProp("detune", prefs.detune - ev.deltaY / 53))
                }
            }),
            (0, $2Z6Kw.input)('[size="3"][type="number"]', {
                props: {
                    value: prefs.detune
                },
                on: {
                    input: (ev)=>updateProp("detune", ev.target.value)
                }
            })
        ])
    ]);

});

parcelRegister("1K0uO", function(module, exports) {

$parcel$export(module.exports, "default", () => $144a78c98d95117e$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");
var $144a78c98d95117e$export$2e2bcd8739ae039 = ({ prefs: prefs, updateProp: updateProp })=>[
        (0, $2Z6Kw.div)(".vertical", [
            (0, $2Z6Kw.label)(`ATT`),
            (0, $2Z6Kw.span)(".right", `${prefs.attack}`),
            (0, $2Z6Kw.input)('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: prefs.attack
                },
                on: {
                    change: (ev)=>updateProp("attack", parseFloat(ev.target.value))
                }
            }),
            (0, $2Z6Kw.label)(`DEC`),
            (0, $2Z6Kw.span)(".right", `${prefs.decay}`),
            (0, $2Z6Kw.input)('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: prefs.decay
                },
                on: {
                    change: (ev)=>updateProp("decay", parseFloat(ev.target.value))
                }
            }),
            (0, $2Z6Kw.label)(`SUS`),
            (0, $2Z6Kw.span)(".right", `${prefs.sustain}`),
            (0, $2Z6Kw.input)('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: prefs.sustain
                },
                on: {
                    change: (ev)=>updateProp("sustain", parseFloat(ev.target.value))
                }
            }),
            (0, $2Z6Kw.label)(`REL`),
            (0, $2Z6Kw.span)(".right", `${prefs.release}`),
            (0, $2Z6Kw.input)('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: prefs.release
                },
                on: {
                    change: (ev)=>updateProp("release", parseFloat(ev.target.value))
                }
            })
        ]),
        (0, $2Z6Kw.div)([
            (0, $2Z6Kw.label)(`Volume`),
            (0, $2Z6Kw.span)(".right", `${prefs.volume}`),
            (0, $2Z6Kw.input)('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: prefs.volume
                },
                on: {
                    change: (ev)=>updateProp("volume", parseFloat(ev.target.value))
                }
            })
        ])
    ];

});

parcelRegister("iIjXE", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $d9fbd1ece01cdf5b$require$div = $2Z6Kw.div;
var $d9fbd1ece01cdf5b$require$h2 = $2Z6Kw.h2;
var $d9fbd1ece01cdf5b$require$span = $2Z6Kw.span;
var $d9fbd1ece01cdf5b$require$p = $2Z6Kw.p;
var $d9fbd1ece01cdf5b$require$ul = $2Z6Kw.ul;
var $d9fbd1ece01cdf5b$require$li = $2Z6Kw.li;
var $d9fbd1ece01cdf5b$require$hr = $2Z6Kw.hr;
var $d9fbd1ece01cdf5b$require$button = $2Z6Kw.button;
var $d9fbd1ece01cdf5b$require$br = $2Z6Kw.br;
var $d9fbd1ece01cdf5b$require$a = $2Z6Kw.a;
var $d9fbd1ece01cdf5b$require$form = $2Z6Kw.form;
var $d9fbd1ece01cdf5b$require$label = $2Z6Kw.label;
var $d9fbd1ece01cdf5b$require$input = $2Z6Kw.input;
var $d9fbd1ece01cdf5b$require$fieldset = $2Z6Kw.fieldset;
var $d9fbd1ece01cdf5b$require$legend = $2Z6Kw.legend;
var $d9fbd1ece01cdf5b$require$i = $2Z6Kw.i;
var $d9fbd1ece01cdf5b$require$img = $2Z6Kw.img;
var $d9fbd1ece01cdf5b$require$select = $2Z6Kw.select;
var $d9fbd1ece01cdf5b$require$option = $2Z6Kw.option;
module.exports = ({ effect: effect, index: index, updateProp: updateProp, toggleExpanded: toggleExpanded })=>$d9fbd1ece01cdf5b$require$fieldset({
        key: effect.id,
        attrs: {
            "data-id": effect.id
        }
    }, [
        $d9fbd1ece01cdf5b$require$legend([
            $d9fbd1ece01cdf5b$require$span(".on", {
                on: {
                    click: ()=>toggleExpanded()
                }
            }, [
                $d9fbd1ece01cdf5b$require$i(`.fa.${effect.expanded ? "fa-minus-square-o" : "fa-plus-square-o"}`),
                " ",
                effect.type.toUpperCase()
            ]),
            // button('.drop-down.fa.fa-ellipsis-v'),
            $d9fbd1ece01cdf5b$require$div(".on-switch.fa", {
                on: {
                    click: (ev)=>updateProp("on", !effect.on)
                },
                class: {
                    "fa-circle-thin": !effect.on,
                    "on": effect.on,
                    "fa-circle": effect.on
                }
            })
        ]),
        effect.expanded ? $d9fbd1ece01cdf5b$require$div([
            $d9fbd1ece01cdf5b$require$div([
                $d9fbd1ece01cdf5b$require$label(`Type`),
                $d9fbd1ece01cdf5b$require$select({
                    on: {
                        change: (ev)=>updateProp("type", ev.target.value)
                    }
                }, [
                    "lowpass",
                    "highpass"
                ].map((type)=>$d9fbd1ece01cdf5b$require$option({
                        attrs: {
                            value: type
                        },
                        props: {
                            selected: effect.type === type
                        }
                    }, type)))
            ]),
            $d9fbd1ece01cdf5b$require$div([
                $d9fbd1ece01cdf5b$require$label(`Cutoff`),
                $d9fbd1ece01cdf5b$require$span(".right", `${effect.cutoff}`),
                $d9fbd1ece01cdf5b$require$input('[type="range"]', {
                    attrs: {
                        min: 0,
                        max: 1,
                        step: 0.01
                    },
                    props: {
                        value: effect.cutoff
                    },
                    on: {
                        change: (ev)=>updateProp("cutoff", parseFloat(ev.target.value))
                    }
                })
            ]),
            $d9fbd1ece01cdf5b$require$label(`Resonance`),
            $d9fbd1ece01cdf5b$require$span(".right", `${effect.resonance}`),
            $d9fbd1ece01cdf5b$require$input('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: effect.resonance
                },
                on: {
                    change: (ev)=>updateProp("resonance", parseFloat(ev.target.value))
                }
            })
        ]) : ""
    ]);

});

parcelRegister("704jW", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $518be27cffcbe738$require$div = $2Z6Kw.div;
var $518be27cffcbe738$require$h2 = $2Z6Kw.h2;
var $518be27cffcbe738$require$span = $2Z6Kw.span;
var $518be27cffcbe738$require$p = $2Z6Kw.p;
var $518be27cffcbe738$require$ul = $2Z6Kw.ul;
var $518be27cffcbe738$require$li = $2Z6Kw.li;
var $518be27cffcbe738$require$hr = $2Z6Kw.hr;
var $518be27cffcbe738$require$button = $2Z6Kw.button;
var $518be27cffcbe738$require$br = $2Z6Kw.br;
var $518be27cffcbe738$require$select = $2Z6Kw.select;
var $518be27cffcbe738$require$option = $2Z6Kw.option;
var $518be27cffcbe738$require$form = $2Z6Kw.form;
var $518be27cffcbe738$require$label = $2Z6Kw.label;
var $518be27cffcbe738$require$input = $2Z6Kw.input;
var $518be27cffcbe738$require$fieldset = $2Z6Kw.fieldset;
var $518be27cffcbe738$require$legend = $2Z6Kw.legend;
var $518be27cffcbe738$require$i = $2Z6Kw.i;
var $518be27cffcbe738$require$img = $2Z6Kw.img;
const $518be27cffcbe738$var$types = [
    "sine",
    "square",
    "sawtooth",
    "triangle"
];
module.exports = ({ effect: effect, index: index, updateProp: updateProp, toggleExpanded: toggleExpanded })=>$518be27cffcbe738$require$fieldset({
        key: effect.id,
        attrs: {
            "data-id": effect.id
        }
    }, [].concat($518be27cffcbe738$require$legend([
        $518be27cffcbe738$require$span(".on", {
            on: {
                click: ()=>toggleExpanded()
            }
        }, [
            $518be27cffcbe738$require$i(`.fa.${effect.expanded ? "fa-minus-square-o" : "fa-plus-square-o"}`),
            " ",
            effect.type.toUpperCase()
        ]),
        $518be27cffcbe738$require$div($518be27cffcbe738$var$types.reduce((list, type)=>list.concat([
                $518be27cffcbe738$require$button(`.btn-opt`, {
                    on: {
                        click: (ev)=>updateProp("type", type)
                    },
                    class: {
                        on: effect.type === type
                    }
                }, [
                    $518be27cffcbe738$require$img(`[src="assets/icons/wave-${type}.svg"]`)
                ])
            ]), [])),
        $518be27cffcbe738$require$div(".on-switch.fa", {
            on: {
                click: (ev)=>updateProp("on", !effect.on)
            },
            class: {
                "fa-circle-thin": !effect.on,
                "on": effect.on,
                "fa-circle": effect.on
            }
        })
    ]), effect.expanded ? $518be27cffcbe738$require$div([
        $518be27cffcbe738$require$label(`Frequency`),
        $518be27cffcbe738$require$span(".right", `${effect.frequency}`),
        $518be27cffcbe738$require$input('[type="range"]', {
            attrs: {
                min: 0,
                max: 100,
                step: 0.05
            },
            props: {
                value: effect.frequency
            },
            on: {
                change: (ev)=>updateProp("frequency", parseFloat(ev.target.value))
            }
        }),
        $518be27cffcbe738$require$label(`Gain`),
        $518be27cffcbe738$require$span(".right", `${effect.gain}`),
        $518be27cffcbe738$require$input('[type="range"]', {
            attrs: {
                min: 0,
                max: 1000,
                step: 1
            },
            props: {
                value: effect.gain
            },
            on: {
                change: (ev)=>updateProp("gain", parseFloat(ev.target.value))
            }
        }),
        $518be27cffcbe738$require$div([
            $518be27cffcbe738$require$label(`Target`),
            $518be27cffcbe738$require$select({
                on: {
                    change: (ev)=>updateProp("target", ev.target.value)
                }
            }, [
                "volume",
                "pitch"
            ].map((target)=>$518be27cffcbe738$require$option({
                    attrs: {
                        value: target
                    },
                    props: {
                        selected: effect.target === target
                    }
                }, target)))
        ])
    ]) : []));

});

parcelRegister("lQN1z", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $fe847b829e34c4f2$require$div = $2Z6Kw.div;
var $fe847b829e34c4f2$require$h2 = $2Z6Kw.h2;
var $fe847b829e34c4f2$require$span = $2Z6Kw.span;
var $fe847b829e34c4f2$require$p = $2Z6Kw.p;
var $fe847b829e34c4f2$require$ul = $2Z6Kw.ul;
var $fe847b829e34c4f2$require$li = $2Z6Kw.li;
var $fe847b829e34c4f2$require$hr = $2Z6Kw.hr;
var $fe847b829e34c4f2$require$button = $2Z6Kw.button;
var $fe847b829e34c4f2$require$br = $2Z6Kw.br;
var $fe847b829e34c4f2$require$form = $2Z6Kw.form;
var $fe847b829e34c4f2$require$label = $2Z6Kw.label;
var $fe847b829e34c4f2$require$input = $2Z6Kw.input;
var $fe847b829e34c4f2$require$fieldset = $2Z6Kw.fieldset;
var $fe847b829e34c4f2$require$legend = $2Z6Kw.legend;
var $fe847b829e34c4f2$require$i = $2Z6Kw.i;
var $fe847b829e34c4f2$require$img = $2Z6Kw.img;
module.exports = ({ effect: effect, index: index, updateProp: updateProp, toggleExpanded: toggleExpanded })=>$fe847b829e34c4f2$require$fieldset({
        key: effect.id,
        attrs: {
            "data-id": effect.id
        }
    }, [
        $fe847b829e34c4f2$require$legend([
            $fe847b829e34c4f2$require$span(".on", {
                on: {
                    click: ()=>toggleExpanded()
                }
            }, [
                $fe847b829e34c4f2$require$i(`.fa.${effect.expanded ? "fa-minus-square-o" : "fa-plus-square-o"}`),
                " ",
                effect.type.toUpperCase()
            ]),
            $fe847b829e34c4f2$require$div(".on-switch.fa", {
                on: {
                    click: (ev)=>updateProp("on", !effect.on)
                },
                class: {
                    "fa-circle-thin": !effect.on,
                    "on": effect.on,
                    "fa-circle": effect.on
                }
            })
        ]),
        effect.expanded ? $fe847b829e34c4f2$require$div([
            $fe847b829e34c4f2$require$label(`Seconds`),
            " ",
            // span('.right', `${state.instrument[name].seconds}`),
            $fe847b829e34c4f2$require$input('[type="number"]', {
                attrs: {
                    min: 1,
                    max: 50,
                    step: 0.01
                },
                props: {
                    value: effect.seconds
                },
                on: {
                    change: (ev)=>updateProp("seconds", parseFloat(ev.target.value))
                }
            }),
            " ",
            $fe847b829e34c4f2$require$label(`Decay`),
            // span('.right', `${state.instrument[name].decay}`),
            " ",
            $fe847b829e34c4f2$require$input('[type="number"]', {
                attrs: {
                    min: 0,
                    max: 100,
                    step: 0.01
                },
                props: {
                    value: effect.decay
                },
                on: {
                    change: (ev)=>updateProp("decay", parseFloat(ev.target.value))
                }
            }),
            " ",
            /*
		label(`Reverse`),
		// span('.right', `${effect.reverse}`),
		' ',
		button('.fa', {
			class: {
				'fa-toggle-on': effect.reverse,
				'fa-toggle-off': !effect.reverse
			},
			on: {
				click: () => updateProp('reverse', !effect.reverse)
			}
		}),
		*/ $fe847b829e34c4f2$require$br(),
            $fe847b829e34c4f2$require$label(`Dry`),
            $fe847b829e34c4f2$require$span(".right", `${effect.dry}`),
            $fe847b829e34c4f2$require$input('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: effect.dry
                },
                on: {
                    change: (ev)=>updateProp("dry", parseFloat(ev.target.value))
                }
            }),
            $fe847b829e34c4f2$require$label(`Wet`),
            $fe847b829e34c4f2$require$span(".right", `${effect.wet}`),
            $fe847b829e34c4f2$require$input('[type="range"]', {
                attrs: {
                    min: 0,
                    max: 1,
                    step: 0.01
                },
                props: {
                    value: effect.wet
                },
                on: {
                    change: (ev)=>updateProp("wet", parseFloat(ev.target.value))
                }
            })
        ]) : ""
    ]);

});

parcelRegister("27D8y", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $18ba97fb7ffe9edf$require$div = $2Z6Kw.div;
var $18ba97fb7ffe9edf$require$h2 = $2Z6Kw.h2;
var $18ba97fb7ffe9edf$require$span = $2Z6Kw.span;
var $18ba97fb7ffe9edf$require$p = $2Z6Kw.p;
var $18ba97fb7ffe9edf$require$ul = $2Z6Kw.ul;
var $18ba97fb7ffe9edf$require$li = $2Z6Kw.li;
var $18ba97fb7ffe9edf$require$hr = $2Z6Kw.hr;
var $18ba97fb7ffe9edf$require$button = $2Z6Kw.button;
var $18ba97fb7ffe9edf$require$br = $2Z6Kw.br;
var $18ba97fb7ffe9edf$require$form = $2Z6Kw.form;
var $18ba97fb7ffe9edf$require$label = $2Z6Kw.label;
var $18ba97fb7ffe9edf$require$input = $2Z6Kw.input;
var $18ba97fb7ffe9edf$require$fieldset = $2Z6Kw.fieldset;
var $18ba97fb7ffe9edf$require$legend = $2Z6Kw.legend;
var $18ba97fb7ffe9edf$require$i = $2Z6Kw.i;
var $18ba97fb7ffe9edf$require$img = $2Z6Kw.img;
module.exports = ({ effect: effect, index: index, updateProp: updateProp, toggleExpanded: toggleExpanded })=>$18ba97fb7ffe9edf$require$fieldset([
        $18ba97fb7ffe9edf$require$legend([
            $18ba97fb7ffe9edf$require$span(".on", effect.type.toUpperCase())
        ]),
        $18ba97fb7ffe9edf$require$div(".on-switch.fa", {
            on: {
                click: (ev)=>updateProp("on", !effect.on)
            },
            class: {
                "fa-circle-thin": !effect.on,
                "on": effect.on,
                "fa-circle": effect.on
            }
        }),
        $18ba97fb7ffe9edf$require$label(`Time`),
        $18ba97fb7ffe9edf$require$span(".right", `${effect.time}`),
        $18ba97fb7ffe9edf$require$input('[type="range"]', {
            attrs: {
                min: 0,
                max: 3,
                step: 0.01
            },
            props: {
                value: effect.time
            },
            on: {
                change: (ev)=>updateProp("time", parseFloat(ev.target.value))
            }
        }),
        $18ba97fb7ffe9edf$require$label(`Dry`),
        $18ba97fb7ffe9edf$require$span(".right", `${effect.dry}`),
        $18ba97fb7ffe9edf$require$input('[type="range"]', {
            attrs: {
                min: 0,
                max: 1,
                step: 0.01
            },
            props: {
                value: effect.dry
            },
            on: {
                change: (ev)=>updateProp("dry", parseFloat(ev.target.value))
            }
        }),
        $18ba97fb7ffe9edf$require$label(`Wet`),
        $18ba97fb7ffe9edf$require$span(".right", `${effect.wet}`),
        $18ba97fb7ffe9edf$require$input('[type="range"]', {
            attrs: {
                min: 0,
                max: 1,
                step: 0.01
            },
            props: {
                value: effect.wet
            },
            on: {
                change: (ev)=>updateProp("wet", parseFloat(ev.target.value))
            }
        })
    ]);

});

parcelRegister("kIWAM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f1655deb6c571482$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");
parcelRequire("jjnZg");

var $4vA8D = parcelRequire("4vA8D");

var $kKA2u = parcelRequire("kKA2u");
let $f1655deb6c571482$var$wavesurferInstance = null;
let $f1655deb6c571482$var$currentSampleFile = null;
const $f1655deb6c571482$var$initWavesurfer = (containerId, sampleUrl, sampleBuffer)=>{
    // Clean up existing instance if any
    if ($f1655deb6c571482$var$wavesurferInstance) {
        $f1655deb6c571482$var$wavesurferInstance.destroy();
        $f1655deb6c571482$var$wavesurferInstance = null;
    }
    // Wait for container to exist (similar to xAmplR pattern)
    const tryInit = ()=>{
        const container = document.querySelector(`#${containerId}`);
        if (!container) {
            setTimeout(tryInit, 10);
            return;
        }
        // Check if WaveSurfer is available
        if (!(0, $4vA8D.default)) {
            console.warn("WaveSurfer not available");
            return;
        }
        // Create wavesurfer instance (xAmplR uses WaveSurfer.create directly)
        try {
            // Clear container like xAmplR does
            container.innerHTML = "";
            // WaveSurfer v7 uses create() method (same as xAmplR v2)
            $f1655deb6c571482$var$wavesurferInstance = (0, $4vA8D.default).create({
                container: `#${containerId}`,
                waveColor: "#000",
                progressColor: "#111516",
                height: 128
            });
            // Load sample
            if ($f1655deb6c571482$var$wavesurferInstance) {
                if (sampleBuffer) $f1655deb6c571482$var$wavesurferInstance.loadDecodedBuffer(sampleBuffer);
                else if (sampleUrl) $f1655deb6c571482$var$wavesurferInstance.load(sampleUrl);
            }
        } catch (err) {
            console.error("Error creating WaveSurfer instance:", err);
        }
    };
    setTimeout(tryInit, 0);
};
var $f1655deb6c571482$export$2e2bcd8739ae039 = ({ state: state, actions: actions })=>{
    // Get selected sequencer channel
    const selectedChannel = state.sequencer.channel;
    const channelSampleIndex = selectedChannel > -1 && state.sequencer.channels[selectedChannel];
    const sampleFileName = channelSampleIndex !== undefined && state.mediaLibrary.files[channelSampleIndex];
    // Get sample buffer from pocket if available
    let sampleBuffer = null;
    let sampleUrl = null;
    if (sampleFileName) {
        const sampleNode = (0, (/*@__PURE__*/$parcel$interopDefault($kKA2u))).get([
            "sampleBank",
            sampleFileName
        ]);
        if (sampleNode && sampleNode.output && sampleNode.output.buffer) sampleBuffer = sampleNode.output.buffer;
        else sampleUrl = sampleFileName;
    }
    const containerId = "sampler-wavesurfer";
    const displayName = sampleFileName ? sampleFileName.replace(/\.(ogg|wav|mp3|aif)$/, "") : "No sample selected";
    // Initialize or update wavesurfer when sample changes
    if (sampleFileName !== $f1655deb6c571482$var$currentSampleFile && (sampleBuffer || sampleUrl)) {
        $f1655deb6c571482$var$currentSampleFile = sampleFileName;
        $f1655deb6c571482$var$initWavesurfer(containerId, sampleUrl, sampleBuffer);
    }
    return (0, $2Z6Kw.div)(".sampler", [
        (0, $2Z6Kw.div)(".sampler-header", [
            (0, $2Z6Kw.span)(".sample-name", displayName)
        ]),
        (0, $2Z6Kw.div)(".sampler-wavesurfer", [
            (0, $2Z6Kw.div)(`#${containerId}`, {
                hook: {
                    insert: (vnode)=>{
                        // Initialize wavesurfer when container is inserted (like xAmplR)
                        $f1655deb6c571482$var$initWavesurfer(containerId, sampleUrl, sampleBuffer);
                    },
                    update: (oldVnode, vnode)=>{
                        // Update sample when it changes
                        if (sampleFileName !== $f1655deb6c571482$var$currentSampleFile && $f1655deb6c571482$var$wavesurferInstance) {
                            $f1655deb6c571482$var$currentSampleFile = sampleFileName;
                            if (sampleBuffer) $f1655deb6c571482$var$wavesurferInstance.loadDecodedBuffer(sampleBuffer);
                            else if (sampleUrl) $f1655deb6c571482$var$wavesurferInstance.load(sampleUrl);
                        }
                    },
                    destroy: (vnode)=>{
                        if ($f1655deb6c571482$var$wavesurferInstance) {
                            $f1655deb6c571482$var$wavesurferInstance.destroy();
                            $f1655deb6c571482$var$wavesurferInstance = null;
                            $f1655deb6c571482$var$currentSampleFile = null;
                        }
                    }
                }
            })
        ]),
        (0, $2Z6Kw.div)(".sampler-controls", [
            (0, $2Z6Kw.button)(".fa.fa-play", {
                on: {
                    click: ()=>{
                        if ($f1655deb6c571482$var$wavesurferInstance) $f1655deb6c571482$var$wavesurferInstance.playPause();
                    }
                }
            })
        ])
    ]);
};

});
parcelRegister("4vA8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $348617004b10d2a2$export$2e2bcd8739ae039);

var $1j2db = parcelRequire("1j2db");

var $lbYwF = parcelRequire("lbYwF");

var $h7M3V = parcelRequire("h7M3V");

var $bY7cC = parcelRequire("bY7cC");

var $1faNt = parcelRequire("1faNt");

var $gH3kz = parcelRequire("gH3kz");

var $5t6GI = parcelRequire("5t6GI");

var $cCKRd = parcelRequire("cCKRd");

var $hAIlD = parcelRequire("hAIlD");

var $iZSFu = parcelRequire("iZSFu");
var $348617004b10d2a2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $348617004b10d2a2$var$defaultOptions = {
    waveColor: "#999",
    progressColor: "#555",
    cursorWidth: 1,
    minPxPerSec: 0,
    fillParent: true,
    interact: true,
    dragToSeek: false,
    autoScroll: true,
    autoCenter: true,
    sampleRate: 8000
};
class $348617004b10d2a2$var$WaveSurfer extends (0, $1faNt.default) {
    /** Create a new WaveSurfer instance */ static create(options) {
        return new $348617004b10d2a2$var$WaveSurfer(options);
    }
    /** Get the reactive state for advanced use cases */ getState() {
        return this.wavesurferState;
    }
    /** Get the renderer instance for plugin access to reactive streams */ getRenderer() {
        return this.renderer;
    }
    /** Create a new WaveSurfer instance */ constructor(options){
        const media = options.media || (options.backend === "WebAudio" ? new (0, $cCKRd.default)() : undefined);
        super({
            media: media,
            mediaControls: options.mediaControls,
            autoplay: options.autoplay,
            playbackRate: options.audioRate
        });
        this.plugins = [];
        this.decodedData = null;
        this.stopAtPosition = null;
        this.subscriptions = [];
        this.mediaSubscriptions = [];
        this.abortController = null;
        this.reactiveCleanups = [];
        this.options = Object.assign({}, $348617004b10d2a2$var$defaultOptions, options);
        // Initialize reactive state
        // Pass Player signals to compose them into WaveSurferState
        const { state: state, actions: actions } = (0, $hAIlD.createWaveSurferState)({
            isPlaying: this.isPlayingSignal,
            currentTime: this.currentTimeSignal,
            duration: this.durationSignal,
            volume: this.volumeSignal,
            playbackRate: this.playbackRateSignal,
            isSeeking: this.seekingSignal
        });
        this.wavesurferState = state;
        this.wavesurferActions = actions;
        this.timer = new (0, $5t6GI.default)();
        const audioElement = media ? undefined : this.getMediaElement();
        this.renderer = new (0, $gH3kz.default)(this.options, audioElement);
        this.initPlayerEvents();
        this.initRendererEvents();
        this.initTimerEvents();
        this.initReactiveState();
        this.initPlugins();
        // Read the initial URL before load has been called
        const initialUrl = this.options.url || this.getSrc() || "";
        // Init and load async to allow external events to be registered
        Promise.resolve().then(()=>{
            this.emit("init");
            // Load audio if URL or an external media with an src is passed,
            // of render w/o audio if pre-decoded peaks and duration are provided
            const { peaks: peaks, duration: duration } = this.options;
            if (initialUrl || peaks && duration) // Swallow async errors because they cannot be caught from a constructor call.
            // Subscribe to the wavesurfer's error event to handle them.
            this.load(initialUrl, peaks, duration).catch((err)=>{
                // Emit error event for proper error handling
                this.emit("error", err instanceof Error ? err : new Error(String(err)));
            });
        });
    }
    updateProgress(currentTime = this.getCurrentTime()) {
        this.renderer.renderProgress(currentTime / this.getDuration(), this.isPlaying());
        return currentTime;
    }
    initTimerEvents() {
        // The timer fires every 16ms for a smooth progress animation
        this.subscriptions.push(this.timer.on("tick", ()=>{
            if (!this.isSeeking()) {
                const currentTime = this.updateProgress();
                this.emit("timeupdate", currentTime);
                this.emit("audioprocess", currentTime);
                // Pause audio when it reaches the stopAtPosition
                if (this.stopAtPosition != null && this.isPlaying() && currentTime >= this.stopAtPosition) this.pause();
            }
        }));
    }
    initReactiveState() {
        // Bridge reactive state to EventEmitter for backwards compatibility
        this.reactiveCleanups.push((0, $iZSFu.setupStateEventEmission)(this.wavesurferState, {
            emit: this.emit.bind(this)
        }));
    }
    initPlayerEvents() {
        if (this.isPlaying()) {
            this.emit("play");
            this.timer.start();
        }
        this.mediaSubscriptions.push(this.onMediaEvent("timeupdate", ()=>{
            const currentTime = this.updateProgress();
            this.emit("timeupdate", currentTime);
        }), this.onMediaEvent("play", ()=>{
            this.emit("play");
            this.timer.start();
        }), this.onMediaEvent("pause", ()=>{
            this.emit("pause");
            this.timer.stop();
            this.stopAtPosition = null;
        }), this.onMediaEvent("emptied", ()=>{
            this.timer.stop();
            this.stopAtPosition = null;
        }), this.onMediaEvent("ended", ()=>{
            this.emit("timeupdate", this.getDuration());
            this.emit("finish");
            this.stopAtPosition = null;
        }), this.onMediaEvent("seeking", ()=>{
            this.emit("seeking", this.getCurrentTime());
        }), this.onMediaEvent("error", ()=>{
            var _a;
            this.emit("error", (_a = this.getMediaElement().error) !== null && _a !== void 0 ? _a : new Error("Media error"));
            this.stopAtPosition = null;
        }));
    }
    initRendererEvents() {
        this.subscriptions.push(// Seek on click
        this.renderer.on("click", (relativeX, relativeY)=>{
            if (this.options.interact) {
                this.seekTo(relativeX);
                this.emit("interaction", relativeX * this.getDuration());
                this.emit("click", relativeX, relativeY);
            }
        }), // Double click
        this.renderer.on("dblclick", (relativeX, relativeY)=>{
            this.emit("dblclick", relativeX, relativeY);
        }), // Scroll
        this.renderer.on("scroll", (startX, endX, scrollLeft, scrollRight)=>{
            const duration = this.getDuration();
            this.emit("scroll", startX * duration, endX * duration, scrollLeft, scrollRight);
        }), // Redraw
        this.renderer.on("render", ()=>{
            this.emit("redraw");
        }), // RedrawComplete
        this.renderer.on("rendered", ()=>{
            this.emit("redrawcomplete");
        }), // DragStart
        this.renderer.on("dragstart", (relativeX)=>{
            this.emit("dragstart", relativeX);
        }), // DragEnd
        this.renderer.on("dragend", (relativeX)=>{
            this.emit("dragend", relativeX);
        }), // Resize
        this.renderer.on("resize", ()=>{
            this.emit("resize");
        }));
        // Drag
        {
            let debounce;
            const unsubscribeDrag = this.renderer.on("drag", (relativeX)=>{
                var _a;
                if (!this.options.interact) return;
                // Update the visual position
                this.renderer.renderProgress(relativeX);
                // Set the audio position with a debounce
                clearTimeout(debounce);
                let debounceTime = 0;
                const dragToSeek = this.options.dragToSeek;
                if (this.isPlaying()) debounceTime = 0;
                else if (dragToSeek === true) debounceTime = 200;
                else if (dragToSeek && typeof dragToSeek === "object") debounceTime = (_a = dragToSeek.debounceTime) !== null && _a !== void 0 ? _a : 200;
                debounce = setTimeout(()=>{
                    this.seekTo(relativeX);
                }, debounceTime);
                this.emit("interaction", relativeX * this.getDuration());
                this.emit("drag", relativeX);
            });
            // Clear debounce timeout on destroy
            this.subscriptions.push(()=>{
                clearTimeout(debounce);
                unsubscribeDrag();
            });
        }
    }
    initPlugins() {
        var _a;
        if (!((_a = this.options.plugins) === null || _a === void 0 ? void 0 : _a.length)) return;
        this.options.plugins.forEach((plugin)=>{
            this.registerPlugin(plugin);
        });
    }
    unsubscribePlayerEvents() {
        this.mediaSubscriptions.forEach((unsubscribe)=>unsubscribe());
        this.mediaSubscriptions = [];
    }
    /** Set new wavesurfer options and re-render it */ setOptions(options) {
        this.options = Object.assign({}, this.options, options);
        if (options.duration && !options.peaks) this.decodedData = (0, $lbYwF.default).createBuffer(this.exportPeaks(), options.duration);
        if (options.peaks && options.duration) // Create new decoded data buffer from peaks and duration
        this.decodedData = (0, $lbYwF.default).createBuffer(options.peaks, options.duration);
        this.renderer.setOptions(this.options);
        if (options.audioRate) this.setPlaybackRate(options.audioRate);
        if (options.mediaControls != null) this.getMediaElement().controls = options.mediaControls;
    }
    /** Register a wavesurfer.js plugin */ registerPlugin(plugin) {
        // Check if the plugin is already registered
        if (this.plugins.includes(plugin)) return plugin;
        plugin._init(this);
        this.plugins.push(plugin);
        // Unregister plugin on destroy
        const unsubscribe = plugin.once("destroy", ()=>{
            this.plugins = this.plugins.filter((p)=>p !== plugin);
            this.subscriptions = this.subscriptions.filter((fn)=>fn !== unsubscribe);
        });
        this.subscriptions.push(unsubscribe);
        return plugin;
    }
    /** Unregister a wavesurfer.js plugin */ unregisterPlugin(plugin) {
        this.plugins = this.plugins.filter((p)=>p !== plugin);
        plugin.destroy();
    }
    /** For plugins only: get the waveform wrapper div */ getWrapper() {
        return this.renderer.getWrapper();
    }
    /** For plugins only: get the scroll container client width */ getWidth() {
        return this.renderer.getWidth();
    }
    /** Get the current scroll position in pixels */ getScroll() {
        return this.renderer.getScroll();
    }
    /** Set the current scroll position in pixels */ setScroll(pixels) {
        return this.renderer.setScroll(pixels);
    }
    /** Move the start of the viewing window to a specific time in the audio (in seconds) */ setScrollTime(time) {
        const percentage = time / this.getDuration();
        this.renderer.setScrollPercentage(percentage);
    }
    /** Get all registered plugins */ getActivePlugins() {
        return this.plugins;
    }
    loadAudio(url, blob, channelData, duration) {
        return $348617004b10d2a2$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            this.emit("load", url);
            if (!this.options.media && this.isPlaying()) this.pause();
            this.decodedData = null;
            this.stopAtPosition = null;
            // Abort any ongoing fetch before starting a new one
            (_a = this.abortController) === null || _a === void 0 || _a.abort();
            this.abortController = null;
            // Fetch the entire audio as a blob if pre-decoded data is not provided
            if (!blob && !channelData) {
                const fetchParams = this.options.fetchParams || {};
                if (window.AbortController && !fetchParams.signal) {
                    this.abortController = new AbortController();
                    fetchParams.signal = this.abortController.signal;
                }
                const onProgress = (percentage)=>this.emit("loading", percentage);
                blob = yield (0, $bY7cC.default).fetchBlob(url, onProgress, fetchParams);
                const overridenMimeType = this.options.blobMimeType;
                if (overridenMimeType) blob = new Blob([
                    blob
                ], {
                    type: overridenMimeType
                });
            }
            // Set the mediaelement source
            this.setSrc(url, blob);
            // Wait for the audio duration
            const audioDuration = yield new Promise((resolve)=>{
                const staticDuration = duration || this.getDuration();
                if (staticDuration) resolve(staticDuration);
                else this.mediaSubscriptions.push(this.onMediaEvent("loadedmetadata", ()=>resolve(this.getDuration()), {
                    once: true
                }));
            });
            // Set the duration if the player is a WebAudioPlayer without a URL
            if (!url && !blob) {
                const media = this.getMediaElement();
                if (media instanceof (0, $cCKRd.default)) media.duration = audioDuration;
            }
            // Decode the audio data or use user-provided peaks
            if (channelData) this.decodedData = (0, $lbYwF.default).createBuffer(channelData, audioDuration || 0);
            else if (blob) {
                const arrayBuffer = yield blob.arrayBuffer();
                this.decodedData = yield (0, $lbYwF.default).decode(arrayBuffer, this.options.sampleRate);
            }
            if (this.decodedData) {
                this.emit("decode", this.getDuration());
                this.renderer.render(this.decodedData);
            }
            this.emit("ready", this.getDuration());
        });
    }
    /** Load an audio file by URL, with optional pre-decoded audio data */ load(url, channelData, duration) {
        return $348617004b10d2a2$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.loadAudio(url, undefined, channelData, duration);
            } catch (err) {
                this.emit("error", err);
                throw err;
            }
        });
    }
    /** Load an audio blob */ loadBlob(blob, channelData, duration) {
        return $348617004b10d2a2$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.loadAudio("", blob, channelData, duration);
            } catch (err) {
                this.emit("error", err);
                throw err;
            }
        });
    }
    /** Zoom the waveform by a given pixels-per-second factor */ zoom(minPxPerSec) {
        if (!this.decodedData) throw new Error("No audio loaded");
        this.renderer.zoom(minPxPerSec);
        this.emit("zoom", minPxPerSec);
    }
    /** Get the decoded audio data */ getDecodedData() {
        return this.decodedData;
    }
    /** Get decoded peaks */ exportPeaks({ channels: channels = 2, maxLength: maxLength = 8000, precision: precision = 10000 } = {}) {
        if (!this.decodedData) throw new Error("The audio has not been decoded yet");
        const maxChannels = Math.min(channels, this.decodedData.numberOfChannels);
        const peaks = [];
        for(let i = 0; i < maxChannels; i++){
            const channel = this.decodedData.getChannelData(i);
            const data = [];
            const sampleSize = channel.length / maxLength;
            for(let j = 0; j < maxLength; j++){
                const sample = channel.slice(Math.floor(j * sampleSize), Math.ceil((j + 1) * sampleSize));
                let max = 0;
                for(let x = 0; x < sample.length; x++){
                    const n = sample[x];
                    if (Math.abs(n) > Math.abs(max)) max = n;
                }
                data.push(Math.round(max * precision) / precision);
            }
            peaks.push(data);
        }
        return peaks;
    }
    /** Get the duration of the audio in seconds */ getDuration() {
        let duration = super.getDuration() || 0;
        // Fall back to the decoded data duration if the media duration is incorrect
        if ((duration === 0 || duration === Infinity) && this.decodedData) duration = this.decodedData.duration;
        return duration;
    }
    /** Toggle if the waveform should react to clicks */ toggleInteraction(isInteractive) {
        this.options.interact = isInteractive;
    }
    /** Jump to a specific time in the audio (in seconds) */ setTime(time) {
        this.stopAtPosition = null;
        super.setTime(time);
        this.updateProgress(time);
        this.emit("timeupdate", time);
    }
    /** Seek to a ratio of audio as [0..1] (0 = beginning, 1 = end) */ seekTo(progress) {
        const time = this.getDuration() * progress;
        this.setTime(time);
    }
    /** Start playing the audio */ play(start, end) {
        const _super = Object.create(null, {
            play: {
                get: ()=>super.play
            }
        });
        return $348617004b10d2a2$var$__awaiter(this, void 0, void 0, function*() {
            if (start != null) this.setTime(start);
            const playResult = yield _super.play.call(this);
            if (end != null) {
                if (this.media instanceof (0, $cCKRd.default)) this.media.stopAt(end);
                else this.stopAtPosition = end;
            }
            return playResult;
        });
    }
    /** Play or pause the audio */ playPause() {
        return $348617004b10d2a2$var$__awaiter(this, void 0, void 0, function*() {
            return this.isPlaying() ? this.pause() : this.play();
        });
    }
    /** Stop the audio and go to the beginning */ stop() {
        this.pause();
        this.setTime(0);
    }
    /** Skip N or -N seconds from the current position */ skip(seconds) {
        this.setTime(this.getCurrentTime() + seconds);
    }
    /** Empty the waveform */ empty() {
        this.load("", [
            [
                0
            ]
        ], 0.001);
    }
    /** Set HTML media element */ setMediaElement(element) {
        this.unsubscribePlayerEvents();
        super.setMediaElement(element);
        this.initPlayerEvents();
    }
    exportImage() {
        return $348617004b10d2a2$var$__awaiter(this, arguments, void 0, function*(format = "image/png", quality = 1, type = "dataURL") {
            return this.renderer.exportImage(format, quality, type);
        });
    }
    /** Unmount wavesurfer */ destroy() {
        var _a;
        this.emit("destroy");
        (_a = this.abortController) === null || _a === void 0 || _a.abort();
        this.plugins.forEach((plugin)=>plugin.destroy());
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.unsubscribePlayerEvents();
        this.reactiveCleanups.forEach((cleanup)=>cleanup());
        this.reactiveCleanups = [];
        this.timer.destroy();
        this.renderer.destroy();
        super.destroy();
    }
}
$348617004b10d2a2$var$WaveSurfer.BasePlugin = (0, $1j2db.default);
$348617004b10d2a2$var$WaveSurfer.dom = $h7M3V;
var $348617004b10d2a2$export$2e2bcd8739ae039 = $348617004b10d2a2$var$WaveSurfer;

});
parcelRegister("1j2db", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f3947f9e1dd1fb7$export$2e2bcd8739ae039);

var $3gKqg = parcelRequire("3gKqg");
class $0f3947f9e1dd1fb7$export$af2591e7a96958a7 extends (0, $3gKqg.default) {
    /** Create a plugin instance */ constructor(options){
        super();
        this.subscriptions = [];
        this.isDestroyed = false;
        this.options = options;
    }
    /** Called after this.wavesurfer is available */ onInit() {
        return;
    }
    /** Do not call directly, only called by WavesSurfer internally */ _init(wavesurfer) {
        // Reset state if plugin was previously destroyed
        if (this.isDestroyed) {
            this.subscriptions = [];
            this.isDestroyed = false;
        }
        this.wavesurfer = wavesurfer;
        this.onInit();
    }
    /** Destroy the plugin and unsubscribe from all events */ destroy() {
        this.emit("destroy");
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.subscriptions = [];
        this.isDestroyed = true;
        this.wavesurfer = undefined;
    }
}
var $0f3947f9e1dd1fb7$export$2e2bcd8739ae039 = $0f3947f9e1dd1fb7$export$af2591e7a96958a7;

});
parcelRegister("3gKqg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2616e04ac82a31a2$export$2e2bcd8739ae039);
/** A simple event emitter that can be used to listen to and emit events. */ class $2616e04ac82a31a2$var$EventEmitter {
    constructor(){
        this.listeners = {};
    }
    /** Subscribe to an event. Returns an unsubscribe function. */ on(event, listener, options) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        if (options === null || options === void 0 ? void 0 : options.once) {
            // Create a wrapper that removes itself after being called once
            const onceWrapper = (...args)=>{
                this.un(event, onceWrapper);
                listener(...args);
            };
            this.listeners[event].add(onceWrapper);
            return ()=>this.un(event, onceWrapper);
        }
        this.listeners[event].add(listener);
        return ()=>this.un(event, listener);
    }
    /** Unsubscribe from an event */ un(event, listener) {
        var _a;
        (_a = this.listeners[event]) === null || _a === void 0 || _a.delete(listener);
    }
    /** Subscribe to an event only once */ once(event, listener) {
        return this.on(event, listener, {
            once: true
        });
    }
    /** Clear all events */ unAll() {
        this.listeners = {};
    }
    /** Emit an event */ emit(eventName, ...args) {
        if (this.listeners[eventName]) this.listeners[eventName].forEach((listener)=>listener(...args));
    }
}
var $2616e04ac82a31a2$export$2e2bcd8739ae039 = $2616e04ac82a31a2$var$EventEmitter;

});


parcelRegister("lbYwF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d9933f4b3bcb11$export$2e2bcd8739ae039);
var $f6d9933f4b3bcb11$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Decode an array buffer into an audio buffer */ function $f6d9933f4b3bcb11$var$decode(audioData, sampleRate) {
    return $f6d9933f4b3bcb11$var$__awaiter(this, void 0, void 0, function*() {
        const audioCtx = new AudioContext({
            sampleRate: sampleRate
        });
        try {
            return yield audioCtx.decodeAudioData(audioData);
        } finally{
            // Ensure AudioContext is always closed, even on synchronous errors
            audioCtx.close();
        }
    });
}
/** Normalize peaks to -1..1 */ function $f6d9933f4b3bcb11$var$normalize(channelData) {
    const firstChannel = channelData[0];
    if (firstChannel.some((n)=>n > 1 || n < -1)) {
        const length = firstChannel.length;
        let max = 0;
        for(let i = 0; i < length; i++){
            const absN = Math.abs(firstChannel[i]);
            if (absN > max) max = absN;
        }
        for (const channel of channelData)for(let i = 0; i < length; i++)channel[i] /= max;
    }
    return channelData;
}
/** Create an audio buffer from pre-decoded audio data */ function $f6d9933f4b3bcb11$var$createBuffer(channelData, duration) {
    // Validate inputs
    if (!channelData || channelData.length === 0) throw new Error("channelData must be a non-empty array");
    if (duration <= 0) throw new Error("duration must be greater than 0");
    // If a single array of numbers is passed, make it an array of arrays
    if (typeof channelData[0] === "number") channelData = [
        channelData
    ];
    // Validate channel data after conversion
    if (!channelData[0] || channelData[0].length === 0) throw new Error("channelData must contain non-empty channel arrays");
    // Normalize to -1..1
    $f6d9933f4b3bcb11$var$normalize(channelData);
    // Convert to Float32Array for consistency
    const float32Channels = channelData.map((channel)=>channel instanceof Float32Array ? channel : Float32Array.from(channel));
    return {
        duration: duration,
        length: float32Channels[0].length,
        sampleRate: float32Channels[0].length / duration,
        numberOfChannels: float32Channels.length,
        getChannelData: (i)=>{
            const channel = float32Channels[i];
            if (!channel) throw new Error(`Channel ${i} not found`);
            return channel;
        },
        copyFromChannel: AudioBuffer.prototype.copyFromChannel,
        copyToChannel: AudioBuffer.prototype.copyToChannel
    };
}
const $f6d9933f4b3bcb11$var$Decoder = {
    decode: $f6d9933f4b3bcb11$var$decode,
    createBuffer: $f6d9933f4b3bcb11$var$createBuffer
};
var $f6d9933f4b3bcb11$export$2e2bcd8739ae039 = $f6d9933f4b3bcb11$var$Decoder;

});

parcelRegister("h7M3V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "createElement", () => $c7785f4c2ae088d4$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "default", () => $c7785f4c2ae088d4$export$2e2bcd8739ae039);
function $c7785f4c2ae088d4$var$renderNode(tagName, content) {
    const element = content.xmlns ? document.createElementNS(content.xmlns, tagName) : document.createElement(tagName);
    for (const [key, value] of Object.entries(content)){
        if (key === "children" && value) for (const [childTag, childValue] of Object.entries(value)){
            if (childValue instanceof Node) element.appendChild(childValue);
            else if (typeof childValue === "string") element.appendChild(document.createTextNode(childValue));
            else element.appendChild($c7785f4c2ae088d4$var$renderNode(childTag, childValue));
        }
        else if (key === "style") Object.assign(element.style, value);
        else if (key === "textContent") element.textContent = value;
        else element.setAttribute(key, value.toString());
    }
    return element;
}
function $c7785f4c2ae088d4$export$c8a8987d4410bf2d(tagName, content, container) {
    const el = $c7785f4c2ae088d4$var$renderNode(tagName, content || {});
    container === null || container === void 0 || container.appendChild(el);
    return el;
}
var $c7785f4c2ae088d4$export$2e2bcd8739ae039 = $c7785f4c2ae088d4$export$c8a8987d4410bf2d;

});

parcelRegister("bY7cC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6ae29931fde81f$export$2e2bcd8739ae039);
var $8b6ae29931fde81f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $8b6ae29931fde81f$var$watchProgress(response, progressCallback) {
    return $8b6ae29931fde81f$var$__awaiter(this, void 0, void 0, function*() {
        if (!response.body || !response.headers) return;
        const reader = response.body.getReader();
        const contentLength = Number(response.headers.get("Content-Length")) || 0;
        let receivedLength = 0;
        // Process the data
        const processChunk = (value)=>{
            // Add to the received length
            receivedLength += (value === null || value === void 0 ? void 0 : value.length) || 0;
            const percentage = Math.round(receivedLength / contentLength * 100);
            progressCallback(percentage);
        };
        // Use iteration instead of recursion to avoid stack issues
        try {
            while(true){
                const data = yield reader.read();
                if (data.done) break;
                processChunk(data.value);
            }
        } catch (err) {
            // Ignore errors because we can only handle the main response
            console.warn("Progress tracking error:", err);
        }
    });
}
function $8b6ae29931fde81f$var$fetchBlob(url, progressCallback, requestInit) {
    return $8b6ae29931fde81f$var$__awaiter(this, void 0, void 0, function*() {
        // Fetch the resource
        const response = yield fetch(url, requestInit);
        if (response.status >= 400) throw new Error(`Failed to fetch ${url}: ${response.status} (${response.statusText})`);
        // Read the data to track progress
        $8b6ae29931fde81f$var$watchProgress(response.clone(), progressCallback);
        return response.blob();
    });
}
const $8b6ae29931fde81f$var$Fetcher = {
    fetchBlob: $8b6ae29931fde81f$var$fetchBlob
};
var $8b6ae29931fde81f$export$2e2bcd8739ae039 = $8b6ae29931fde81f$var$Fetcher;

});

parcelRegister("1faNt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e7f913a06e10548$export$2e2bcd8739ae039);

var $3gKqg = parcelRequire("3gKqg");

var $gkUki = parcelRequire("gkUki");
var $0e7f913a06e10548$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $0e7f913a06e10548$var$Player extends (0, $3gKqg.default) {
    // Expose reactive state as writable signals
    // These are writable to allow WaveSurfer to compose them into centralized state
    get isPlayingSignal() {
        return this._isPlaying;
    }
    get currentTimeSignal() {
        return this._currentTime;
    }
    get durationSignal() {
        return this._duration;
    }
    get volumeSignal() {
        return this._volume;
    }
    get mutedSignal() {
        return this._muted;
    }
    get playbackRateSignal() {
        return this._playbackRate;
    }
    get seekingSignal() {
        return this._seeking;
    }
    constructor(options){
        super();
        this.isExternalMedia = false;
        this.reactiveMediaEventCleanups = [];
        if (options.media) {
            this.media = options.media;
            this.isExternalMedia = true;
        } else this.media = document.createElement("audio");
        // Initialize reactive state
        this._isPlaying = (0, $gkUki.signal)(false);
        this._currentTime = (0, $gkUki.signal)(0);
        this._duration = (0, $gkUki.signal)(0);
        this._volume = (0, $gkUki.signal)(this.media.volume);
        this._muted = (0, $gkUki.signal)(this.media.muted);
        this._playbackRate = (0, $gkUki.signal)(this.media.playbackRate || 1);
        this._seeking = (0, $gkUki.signal)(false);
        // Setup reactive media event handlers
        this.setupReactiveMediaEvents();
        // Controls
        if (options.mediaControls) this.media.controls = true;
        // Autoplay
        if (options.autoplay) this.media.autoplay = true;
        // Speed
        if (options.playbackRate != null) this.onMediaEvent("canplay", ()=>{
            if (options.playbackRate != null) this.media.playbackRate = options.playbackRate;
        }, {
            once: true
        });
    }
    /**
     * Setup reactive media event handlers that update signals
     * This bridges the imperative HTMLMediaElement API to reactive state
     */ setupReactiveMediaEvents() {
        // Playing state
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("play", ()=>{
            this._isPlaying.set(true);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("pause", ()=>{
            this._isPlaying.set(false);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("ended", ()=>{
            this._isPlaying.set(false);
        }));
        // Time tracking
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("timeupdate", ()=>{
            this._currentTime.set(this.media.currentTime);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("durationchange", ()=>{
            this._duration.set(this.media.duration || 0);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("loadedmetadata", ()=>{
            this._duration.set(this.media.duration || 0);
        }));
        // Seeking state
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("seeking", ()=>{
            this._seeking.set(true);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("seeked", ()=>{
            this._seeking.set(false);
        }));
        // Volume and muted
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("volumechange", ()=>{
            this._volume.set(this.media.volume);
            this._muted.set(this.media.muted);
        }));
        // Playback rate
        this.reactiveMediaEventCleanups.push(this.onMediaEvent("ratechange", ()=>{
            this._playbackRate.set(this.media.playbackRate);
        }));
    }
    onMediaEvent(event, callback, options) {
        this.media.addEventListener(event, callback, options);
        return ()=>this.media.removeEventListener(event, callback, options);
    }
    getSrc() {
        return this.media.currentSrc || this.media.src || "";
    }
    revokeSrc() {
        const src = this.getSrc();
        if (src.startsWith("blob:")) URL.revokeObjectURL(src);
    }
    canPlayType(type) {
        return this.media.canPlayType(type) !== "";
    }
    setSrc(url, blob) {
        const prevSrc = this.getSrc();
        if (url && prevSrc === url) return; // no need to change the source
        this.revokeSrc();
        const newSrc = blob instanceof Blob && (this.canPlayType(blob.type) || !url) ? URL.createObjectURL(blob) : url;
        // Reset the media element, otherwise it keeps the previous source
        if (prevSrc) this.media.removeAttribute("src");
        if (newSrc || url) try {
            this.media.src = newSrc;
        } catch (_a) {
            this.media.src = url;
        }
    }
    destroy() {
        // Cleanup reactive media event listeners
        this.reactiveMediaEventCleanups.forEach((cleanup)=>cleanup());
        this.reactiveMediaEventCleanups = [];
        if (this.isExternalMedia) return;
        this.media.pause();
        this.revokeSrc();
        this.media.removeAttribute("src");
        // Load resets the media element to its initial state
        this.media.load();
        // Remove from DOM after cleanup
        this.media.remove();
    }
    setMediaElement(element) {
        // Cleanup reactive event listeners from old media element
        this.reactiveMediaEventCleanups.forEach((cleanup)=>cleanup());
        this.reactiveMediaEventCleanups = [];
        // Set new media element
        this.media = element;
        // Reinitialize reactive event listeners on new media element
        this.setupReactiveMediaEvents();
    }
    /** Start playing the audio */ play() {
        return $0e7f913a06e10548$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.media.play();
            } catch (err) {
                if (err instanceof DOMException && err.name === "AbortError") return;
                throw err;
            }
        });
    }
    /** Pause the audio */ pause() {
        this.media.pause();
    }
    /** Check if the audio is playing */ isPlaying() {
        return !this.media.paused && !this.media.ended;
    }
    /** Jump to a specific time in the audio (in seconds) */ setTime(time) {
        this.media.currentTime = Math.max(0, Math.min(time, this.getDuration()));
    }
    /** Get the duration of the audio in seconds */ getDuration() {
        return this.media.duration;
    }
    /** Get the current audio position in seconds */ getCurrentTime() {
        return this.media.currentTime;
    }
    /** Get the audio volume */ getVolume() {
        return this.media.volume;
    }
    /** Set the audio volume */ setVolume(volume) {
        this.media.volume = volume;
    }
    /** Get the audio muted state */ getMuted() {
        return this.media.muted;
    }
    /** Mute or unmute the audio */ setMuted(muted) {
        this.media.muted = muted;
    }
    /** Get the playback speed */ getPlaybackRate() {
        return this.media.playbackRate;
    }
    /** Check if the audio is seeking */ isSeeking() {
        return this.media.seeking;
    }
    /** Set the playback speed, pass an optional false to NOT preserve the pitch */ setPlaybackRate(rate, preservePitch) {
        // preservePitch is true by default in most browsers
        if (preservePitch != null) this.media.preservesPitch = preservePitch;
        this.media.playbackRate = rate;
    }
    /** Get the HTML media element */ getMediaElement() {
        return this.media;
    }
    /** Set a sink id to change the audio output device */ setSinkId(sinkId) {
        // See https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId
        const media = this.media;
        return media.setSinkId(sinkId);
    }
}
var $0e7f913a06e10548$export$2e2bcd8739ae039 = $0e7f913a06e10548$var$Player;

});
parcelRegister("gkUki", function(module, exports) {

$parcel$export(module.exports, "signal", () => $be4a34dd270d040f$export$e2ef10f86a8d60e8);
$parcel$export(module.exports, "computed", () => $be4a34dd270d040f$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "effect", () => $be4a34dd270d040f$export$dc573d8a6576cdb3);
/**
 * Reactive primitives for managing state in WaveSurfer
 *
 * This module provides signal-based reactivity similar to SolidJS signals.
 * Signals are reactive values that notify subscribers when they change.
 */ /**
 * Create a reactive signal that notifies subscribers when its value changes
 *
 * @example
 * ```typescript
 * const count = signal(0)
 * count.subscribe(val => console.log('Count:', val))
 * count.set(5) // Logs: Count: 5
 * ```
 */ function $be4a34dd270d040f$export$e2ef10f86a8d60e8(initialValue) {
    let _value = initialValue;
    const subscribers = new Set();
    return {
        get value () {
            return _value;
        },
        set (newValue) {
            // Only update and notify if value actually changed
            if (!Object.is(_value, newValue)) {
                _value = newValue;
                subscribers.forEach((fn)=>fn(_value));
            }
        },
        update (fn) {
            this.set(fn(_value));
        },
        subscribe (callback) {
            subscribers.add(callback);
            return ()=>subscribers.delete(callback);
        }
    };
}
function $be4a34dd270d040f$export$2983e091f1a1e8e2(fn, dependencies) {
    const result = $be4a34dd270d040f$export$e2ef10f86a8d60e8(fn());
    // Subscribe to all dependencies immediately
    // This ensures the computed value stays in sync even if no one is subscribed to it
    dependencies.forEach((dep)=>dep.subscribe(()=>{
            const newValue = fn();
            // Update the result signal, which will notify our subscribers if value changed
            if (!Object.is(result.value, newValue)) result.set(newValue);
        }));
    // Return a read-only signal that proxies the result
    return {
        get value () {
            return result.value;
        },
        subscribe (callback) {
            // Just subscribe to result changes
            return result.subscribe(callback);
        }
    };
}
function $be4a34dd270d040f$export$dc573d8a6576cdb3(fn, dependencies) {
    let cleanup;
    const run = ()=>{
        // Run cleanup from previous execution
        if (cleanup) {
            cleanup();
            cleanup = undefined;
        }
        // Run effect and capture new cleanup
        cleanup = fn();
    };
    // Subscribe to all dependencies
    const unsubscribes = dependencies.map((dep)=>dep.subscribe(run));
    // Run effect immediately
    run();
    // Return function that unsubscribes and runs cleanup
    return ()=>{
        if (cleanup) {
            cleanup();
            cleanup = undefined;
        }
        unsubscribes.forEach((unsub)=>unsub());
    };
}

});


parcelRegister("gH3kz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2733ee61dcf1e76$export$2e2bcd8739ae039);

var $3gKqg = parcelRequire("3gKqg");

var $g9D4V = parcelRequire("g9D4V");

var $jvjd6 = parcelRequire("jvjd6");

var $e6zf7 = parcelRequire("e6zf7");

var $gkUki = parcelRequire("gkUki");
var $c2733ee61dcf1e76$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c2733ee61dcf1e76$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $c2733ee61dcf1e76$var$Renderer extends (0, $3gKqg.default) {
    constructor(options, audioElement){
        super();
        this.timeouts = [];
        this.isScrollable = false;
        this.audioData = null;
        this.resizeObserver = null;
        this.lastContainerWidth = 0;
        this.isDragging = false;
        this.subscriptions = [];
        this.unsubscribeOnScroll = [];
        this.dragStream = null;
        this.scrollStream = null;
        this.subscriptions = [];
        this.options = options;
        const parent = this.parentFromOptionsContainer(options.container);
        this.parent = parent;
        const [div, shadow] = this.initHtml();
        parent.appendChild(div);
        this.container = div;
        this.scrollContainer = shadow.querySelector(".scroll");
        this.wrapper = shadow.querySelector(".wrapper");
        this.canvasWrapper = shadow.querySelector(".canvases");
        this.progressWrapper = shadow.querySelector(".progress");
        this.cursor = shadow.querySelector(".cursor");
        if (audioElement) shadow.appendChild(audioElement);
        this.initEvents();
    }
    parentFromOptionsContainer(container) {
        let parent;
        if (typeof container === "string") parent = document.querySelector(container);
        else if (container instanceof HTMLElement) parent = container;
        if (!parent) throw new Error("Container not found");
        return parent;
    }
    initEvents() {
        // Add a click listener
        this.wrapper.addEventListener("click", (e)=>{
            const rect = this.wrapper.getBoundingClientRect();
            const [x, y] = $g9D4V.getRelativePointerPosition(rect, e.clientX, e.clientY);
            this.emit("click", x, y);
        });
        // Add a double click listener
        this.wrapper.addEventListener("dblclick", (e)=>{
            const rect = this.wrapper.getBoundingClientRect();
            const [x, y] = $g9D4V.getRelativePointerPosition(rect, e.clientX, e.clientY);
            this.emit("dblclick", x, y);
        });
        // Drag
        if (this.options.dragToSeek === true || typeof this.options.dragToSeek === "object") this.initDrag();
        // Add a scroll listener using reactive stream
        this.scrollStream = (0, $e6zf7.createScrollStream)(this.scrollContainer);
        const unsubscribeScroll = (0, $gkUki.effect)(()=>{
            const { startX: startX, endX: endX } = this.scrollStream.percentages.value;
            const { left: left, right: right } = this.scrollStream.bounds.value;
            this.emit("scroll", startX, endX, left, right);
        }, [
            this.scrollStream.percentages,
            this.scrollStream.bounds
        ]);
        this.subscriptions.push(unsubscribeScroll);
        // Re-render the waveform on container resize
        if (typeof ResizeObserver === "function") {
            const delay = this.createDelay(100);
            this.resizeObserver = new ResizeObserver(()=>{
                delay().then(()=>this.onContainerResize()).catch(()=>undefined);
            });
            this.resizeObserver.observe(this.scrollContainer);
        }
    }
    onContainerResize() {
        const width = this.parent.clientWidth;
        if (width === this.lastContainerWidth && this.options.height !== "auto") return;
        this.lastContainerWidth = width;
        this.reRender();
        this.emit("resize");
    }
    initDrag() {
        // Don't initialize drag if it's already set up
        if (this.dragStream) return;
        this.dragStream = (0, $jvjd6.createDragStream)(this.wrapper);
        const unsubscribeDrag = (0, $gkUki.effect)(()=>{
            const drag = this.dragStream.signal.value;
            if (!drag) return;
            const width = this.wrapper.getBoundingClientRect().width;
            const relX = $g9D4V.clampToUnit(drag.x / width);
            if (drag.type === "start") {
                this.isDragging = true;
                this.emit("dragstart", relX);
            } else if (drag.type === "move") this.emit("drag", relX);
            else if (drag.type === "end") {
                this.isDragging = false;
                this.emit("dragend", relX);
            }
        }, [
            this.dragStream.signal
        ]);
        this.subscriptions.push(unsubscribeDrag);
    }
    initHtml() {
        const div = document.createElement("div");
        const shadow = div.attachShadow({
            mode: "open"
        });
        const cspNonce = this.options.cspNonce && typeof this.options.cspNonce === "string" ? this.options.cspNonce.replace(/"/g, "") : "";
        shadow.innerHTML = `
      <style${cspNonce ? ` nonce="${cspNonce}"` : ""}>
        :host {
          user-select: none;
          min-width: 1px;
        }
        :host audio {
          display: block;
          width: 100%;
        }
        :host .scroll {
          overflow-x: auto;
          overflow-y: hidden;
          width: 100%;
          position: relative;
        }
        :host .noScrollbar {
          scrollbar-color: transparent;
          scrollbar-width: none;
        }
        :host .noScrollbar::-webkit-scrollbar {
          display: none;
          -webkit-appearance: none;
        }
        :host .wrapper {
          position: relative;
          overflow: visible;
          z-index: 2;
        }
        :host .canvases {
          min-height: ${this.getHeight(this.options.height, this.options.splitChannels)}px;
          pointer-events: none;
        }
        :host .canvases > div {
          position: relative;
        }
        :host canvas {
          display: block;
          position: absolute;
          top: 0;
          image-rendering: pixelated;
        }
        :host .progress {
          pointer-events: none;
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 0;
          height: 100%;
          overflow: hidden;
        }
        :host .progress > div {
          position: relative;
        }
        :host .cursor {
          pointer-events: none;
          position: absolute;
          z-index: 5;
          top: 0;
          left: 0;
          height: 100%;
          border-radius: 2px;
        }
      </style>

      <div class="scroll" part="scroll">
        <div class="wrapper" part="wrapper">
          <div class="canvases" part="canvases"></div>
          <div class="progress" part="progress"></div>
          <div class="cursor" part="cursor"></div>
        </div>
      </div>
    `;
        return [
            div,
            shadow
        ];
    }
    /** Wavesurfer itself calls this method. Do not call it manually. */ setOptions(options) {
        if (this.options.container !== options.container) {
            const newParent = this.parentFromOptionsContainer(options.container);
            newParent.appendChild(this.container);
            this.parent = newParent;
        }
        if (options.dragToSeek === true || typeof this.options.dragToSeek === "object") this.initDrag();
        this.options = options;
        // Re-render the waveform
        this.reRender();
    }
    getWrapper() {
        return this.wrapper;
    }
    getWidth() {
        return this.scrollContainer.clientWidth;
    }
    getScroll() {
        return this.scrollContainer.scrollLeft;
    }
    setScroll(pixels) {
        this.scrollContainer.scrollLeft = pixels;
    }
    setScrollPercentage(percent) {
        const { scrollWidth: scrollWidth } = this.scrollContainer;
        const scrollStart = scrollWidth * percent;
        this.setScroll(scrollStart);
    }
    destroy() {
        var _a;
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.container.remove();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        (_a = this.unsubscribeOnScroll) === null || _a === void 0 || _a.forEach((unsubscribe)=>unsubscribe());
        this.unsubscribeOnScroll = [];
        if (this.dragStream) {
            this.dragStream.cleanup();
            this.dragStream = null;
        }
        if (this.scrollStream) {
            this.scrollStream.cleanup();
            this.scrollStream = null;
        }
    }
    createDelay(delayMs = 10) {
        let timeout;
        let rejectFn;
        const onClear = ()=>{
            if (timeout) {
                clearTimeout(timeout);
                timeout = undefined;
            }
            if (rejectFn) {
                rejectFn();
                rejectFn = undefined;
            }
        };
        this.timeouts.push(onClear);
        return ()=>{
            return new Promise((resolve, reject)=>{
                // Clear any pending delay
                onClear();
                // Store reject function for cleanup
                rejectFn = reject;
                // Set new timeout
                timeout = setTimeout(()=>{
                    timeout = undefined;
                    rejectFn = undefined;
                    resolve();
                }, delayMs);
            });
        };
    }
    getHeight(optionsHeight, optionsSplitChannel) {
        var _a;
        const numberOfChannels = ((_a = this.audioData) === null || _a === void 0 ? void 0 : _a.numberOfChannels) || 1;
        return $g9D4V.resolveChannelHeight({
            optionsHeight: optionsHeight,
            optionsSplitChannels: optionsSplitChannel,
            parentHeight: this.parent.clientHeight,
            numberOfChannels: numberOfChannels,
            defaultHeight: $g9D4V.DEFAULT_HEIGHT
        });
    }
    convertColorValues(color, ctx) {
        return $g9D4V.resolveColorValue(color, this.getPixelRatio(), ctx === null || ctx === void 0 ? void 0 : ctx.canvas.height);
    }
    getPixelRatio() {
        return $g9D4V.getPixelRatio(window.devicePixelRatio);
    }
    renderBarWaveform(channelData, options, ctx, vScale) {
        const { width: width, height: height } = ctx.canvas;
        const { halfHeight: halfHeight, barWidth: barWidth, barRadius: barRadius, barIndexScale: barIndexScale, barSpacing: barSpacing, barMinHeight: barMinHeight } = $g9D4V.calculateBarRenderConfig({
            width: width,
            height: height,
            length: (channelData[0] || []).length,
            options: options,
            pixelRatio: this.getPixelRatio()
        });
        const segments = $g9D4V.calculateBarSegments({
            channelData: channelData,
            barIndexScale: barIndexScale,
            barSpacing: barSpacing,
            barWidth: barWidth,
            halfHeight: halfHeight,
            vScale: vScale,
            canvasHeight: height,
            barAlign: options.barAlign,
            barMinHeight: barMinHeight
        });
        ctx.beginPath();
        for (const segment of segments)if (barRadius && "roundRect" in ctx) ctx.roundRect(segment.x, segment.y, segment.width, segment.height, barRadius);
        else ctx.rect(segment.x, segment.y, segment.width, segment.height);
        ctx.fill();
        ctx.closePath();
    }
    renderLineWaveform(channelData, _options, ctx, vScale) {
        const { width: width, height: height } = ctx.canvas;
        const paths = $g9D4V.calculateLinePaths({
            channelData: channelData,
            width: width,
            height: height,
            vScale: vScale
        });
        ctx.beginPath();
        for (const path of paths){
            if (!path.length) continue;
            ctx.moveTo(path[0].x, path[0].y);
            for(let i = 1; i < path.length; i++){
                const point = path[i];
                ctx.lineTo(point.x, point.y);
            }
        }
        ctx.fill();
        ctx.closePath();
    }
    renderWaveform(channelData, options, ctx) {
        ctx.fillStyle = this.convertColorValues(options.waveColor, ctx);
        if (options.renderFunction) {
            options.renderFunction(channelData, ctx);
            return;
        }
        const vScale = $g9D4V.calculateVerticalScale({
            channelData: channelData,
            barHeight: options.barHeight,
            normalize: options.normalize,
            maxPeak: options.maxPeak
        });
        if ($g9D4V.shouldRenderBars(options)) {
            this.renderBarWaveform(channelData, options, ctx, vScale);
            return;
        }
        this.renderLineWaveform(channelData, options, ctx, vScale);
    }
    renderSingleCanvas(data, options, width, height, offset, canvasContainer, progressContainer) {
        const pixelRatio = this.getPixelRatio();
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(width * pixelRatio);
        canvas.height = Math.round(height * pixelRatio);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        canvas.style.left = `${Math.round(offset)}px`;
        canvasContainer.appendChild(canvas);
        const ctx = canvas.getContext("2d");
        if (options.renderFunction) {
            ctx.fillStyle = this.convertColorValues(options.waveColor, ctx);
            options.renderFunction(data, ctx);
        } else this.renderWaveform(data, options, ctx);
        // Draw a progress canvas
        if (canvas.width > 0 && canvas.height > 0) {
            const progressCanvas = canvas.cloneNode();
            const progressCtx = progressCanvas.getContext("2d");
            progressCtx.drawImage(canvas, 0, 0);
            // Set the composition method to draw only where the waveform is drawn
            progressCtx.globalCompositeOperation = "source-in";
            progressCtx.fillStyle = this.convertColorValues(options.progressColor, progressCtx);
            // This rectangle acts as a mask thanks to the composition method
            progressCtx.fillRect(0, 0, canvas.width, canvas.height);
            progressContainer.appendChild(progressCanvas);
        }
    }
    renderMultiCanvas(channelData, options, width, height, canvasContainer, progressContainer) {
        const pixelRatio = this.getPixelRatio();
        const { clientWidth: clientWidth } = this.scrollContainer;
        const totalWidth = width / pixelRatio;
        const singleCanvasWidth = $g9D4V.calculateSingleCanvasWidth({
            clientWidth: clientWidth,
            totalWidth: totalWidth,
            options: options
        });
        let drawnIndexes = {};
        // Nothing to render
        if (singleCanvasWidth === 0) return;
        // Draw a single canvas
        const draw = (index)=>{
            if (index < 0 || index >= numCanvases) return;
            if (drawnIndexes[index]) return;
            drawnIndexes[index] = true;
            const offset = index * singleCanvasWidth;
            let clampedWidth = Math.min(totalWidth - offset, singleCanvasWidth);
            // Clamp the width to the bar grid to avoid empty canvases at the end
            clampedWidth = $g9D4V.clampWidthToBarGrid(clampedWidth, options);
            if (clampedWidth <= 0) return;
            const data = $g9D4V.sliceChannelData({
                channelData: channelData,
                offset: offset,
                clampedWidth: clampedWidth,
                totalWidth: totalWidth
            });
            this.renderSingleCanvas(data, options, clampedWidth, height, offset, canvasContainer, progressContainer);
        };
        // Clear canvases to avoid too many DOM nodes
        const clearCanvases = ()=>{
            if ($g9D4V.shouldClearCanvases(Object.keys(drawnIndexes).length)) {
                canvasContainer.innerHTML = "";
                progressContainer.innerHTML = "";
                drawnIndexes = {};
            }
        };
        // Calculate how many canvases to render
        const numCanvases = Math.ceil(totalWidth / singleCanvasWidth);
        // Render all canvases if the waveform doesn't scroll
        if (!this.isScrollable) {
            for(let i = 0; i < numCanvases; i++)draw(i);
            return;
        }
        // Lazy rendering
        const initialRange = $g9D4V.getLazyRenderRange({
            scrollLeft: this.scrollContainer.scrollLeft,
            totalWidth: totalWidth,
            numCanvases: numCanvases
        });
        initialRange.forEach((index)=>draw(index));
        // Subscribe to the scroll event to draw additional canvases
        if (numCanvases > 1) {
            const unsubscribe = this.on("scroll", ()=>{
                const { scrollLeft: scrollLeft } = this.scrollContainer;
                clearCanvases();
                $g9D4V.getLazyRenderRange({
                    scrollLeft: scrollLeft,
                    totalWidth: totalWidth,
                    numCanvases: numCanvases
                }).forEach((index)=>draw(index));
            });
            this.unsubscribeOnScroll.push(unsubscribe);
        }
    }
    renderChannel(channelData, _a, width, channelIndex) {
        var { overlay: overlay } = _a, options = $c2733ee61dcf1e76$var$__rest(_a, [
            "overlay"
        ]);
        // A container for canvases
        const canvasContainer = document.createElement("div");
        const height = this.getHeight(options.height, options.splitChannels);
        canvasContainer.style.height = `${height}px`;
        if (overlay && channelIndex > 0) canvasContainer.style.marginTop = `-${height}px`;
        this.canvasWrapper.style.minHeight = `${height}px`;
        this.canvasWrapper.appendChild(canvasContainer);
        // A container for progress canvases
        const progressContainer = canvasContainer.cloneNode();
        this.progressWrapper.appendChild(progressContainer);
        // Render the waveform
        this.renderMultiCanvas(channelData, options, width, height, canvasContainer, progressContainer);
    }
    render(audioData) {
        return $c2733ee61dcf1e76$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            // Clear previous timeouts
            this.timeouts.forEach((clear)=>clear());
            this.timeouts = [];
            // Clear the canvases
            this.canvasWrapper.innerHTML = "";
            this.progressWrapper.innerHTML = "";
            // Width
            if (this.options.width != null) this.scrollContainer.style.width = typeof this.options.width === "number" ? `${this.options.width}px` : this.options.width;
            // Determine the width of the waveform
            const pixelRatio = this.getPixelRatio();
            const parentWidth = this.scrollContainer.clientWidth;
            const { scrollWidth: scrollWidth, isScrollable: isScrollable, useParentWidth: useParentWidth, width: width } = $g9D4V.calculateWaveformLayout({
                duration: audioData.duration,
                minPxPerSec: this.options.minPxPerSec || 0,
                parentWidth: parentWidth,
                fillParent: this.options.fillParent,
                pixelRatio: pixelRatio
            });
            // Whether the container should scroll
            this.isScrollable = isScrollable;
            // Set the width of the wrapper
            this.wrapper.style.width = useParentWidth ? "100%" : `${scrollWidth}px`;
            // Set additional styles
            this.scrollContainer.style.overflowX = this.isScrollable ? "auto" : "hidden";
            this.scrollContainer.classList.toggle("noScrollbar", !!this.options.hideScrollbar);
            this.cursor.style.backgroundColor = `${this.options.cursorColor || this.options.progressColor}`;
            this.cursor.style.width = `${this.options.cursorWidth}px`;
            this.audioData = audioData;
            this.emit("render");
            // Render the waveform
            if (this.options.splitChannels) // Render a waveform for each channel
            for(let i = 0; i < audioData.numberOfChannels; i++){
                const options = Object.assign(Object.assign({}, this.options), (_a = this.options.splitChannels) === null || _a === void 0 ? void 0 : _a[i]);
                this.renderChannel([
                    audioData.getChannelData(i)
                ], options, width, i);
            }
            else {
                // Render a single waveform for the first two channels (left and right)
                const channels = [
                    audioData.getChannelData(0)
                ];
                if (audioData.numberOfChannels > 1) channels.push(audioData.getChannelData(1));
                this.renderChannel(channels, this.options, width, 0);
            }
            // Must be emitted asynchronously for backward compatibility
            Promise.resolve().then(()=>this.emit("rendered"));
        });
    }
    reRender() {
        this.unsubscribeOnScroll.forEach((unsubscribe)=>unsubscribe());
        this.unsubscribeOnScroll = [];
        // Return if the waveform has not been rendered yet
        if (!this.audioData) return;
        // Remember the current cursor position
        const { scrollWidth: scrollWidth } = this.scrollContainer;
        const { right: before } = this.progressWrapper.getBoundingClientRect();
        // Re-render the waveform
        this.render(this.audioData);
        // Adjust the scroll position so that the cursor stays in the same place
        if (this.isScrollable && scrollWidth !== this.scrollContainer.scrollWidth) {
            const { right: after } = this.progressWrapper.getBoundingClientRect();
            const delta = $g9D4V.roundToHalfAwayFromZero(after - before);
            this.scrollContainer.scrollLeft += delta;
        }
    }
    zoom(minPxPerSec) {
        this.options.minPxPerSec = minPxPerSec;
        this.reRender();
    }
    scrollIntoView(progress, isPlaying = false) {
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.scrollContainer;
        const progressWidth = progress * scrollWidth;
        const startEdge = scrollLeft;
        const endEdge = scrollLeft + clientWidth;
        const middle = clientWidth / 2;
        if (this.isDragging) {
            // Scroll when dragging close to the edge of the viewport
            const minGap = 30;
            if (progressWidth + minGap > endEdge) this.scrollContainer.scrollLeft += minGap;
            else if (progressWidth - minGap < startEdge) this.scrollContainer.scrollLeft -= minGap;
        } else {
            if (progressWidth < startEdge || progressWidth > endEdge) this.scrollContainer.scrollLeft = progressWidth - (this.options.autoCenter ? middle : 0);
            // Keep the cursor centered when playing
            const center = progressWidth - scrollLeft - middle;
            if (isPlaying && this.options.autoCenter && center > 0) this.scrollContainer.scrollLeft += center;
        }
    }
    renderProgress(progress, isPlaying) {
        if (isNaN(progress)) return;
        const percents = progress * 100;
        this.canvasWrapper.style.clipPath = `polygon(${percents}% 0%, 100% 0%, 100% 100%, ${percents}% 100%)`;
        this.progressWrapper.style.width = `${percents}%`;
        this.cursor.style.left = `${percents}%`;
        this.cursor.style.transform = this.options.cursorWidth ? `translateX(-${progress * this.options.cursorWidth}px)` : "";
        // Only scroll if we have valid audio data to prevent race conditions during loading
        if (this.isScrollable && this.options.autoScroll && this.audioData && this.audioData.duration > 0) this.scrollIntoView(progress, isPlaying);
    }
    exportImage(format, quality, type) {
        return $c2733ee61dcf1e76$var$__awaiter(this, void 0, void 0, function*() {
            const canvases = this.canvasWrapper.querySelectorAll("canvas");
            if (!canvases.length) throw new Error("No waveform data");
            // Data URLs
            if (type === "dataURL") {
                const images = Array.from(canvases).map((canvas)=>canvas.toDataURL(format, quality));
                return Promise.resolve(images);
            }
            // Blobs
            return Promise.all(Array.from(canvases).map((canvas)=>{
                return new Promise((resolve, reject)=>{
                    canvas.toBlob((blob)=>{
                        if (blob) resolve(blob);
                        else reject(new Error("Could not export image"));
                    }, format, quality);
                });
            }));
        });
    }
}
var $c2733ee61dcf1e76$export$2e2bcd8739ae039 = $c2733ee61dcf1e76$var$Renderer;

});
parcelRegister("g9D4V", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_HEIGHT", () => $bc2bccca450fc166$export$611c894df53833b0);
$parcel$export(module.exports, "clampToUnit", () => $bc2bccca450fc166$export$776b1d1435d2fa37);
$parcel$export(module.exports, "calculateBarRenderConfig", () => $bc2bccca450fc166$export$69b5491eba61a90b);
$parcel$export(module.exports, "calculateBarSegments", () => $bc2bccca450fc166$export$636c362d38494a26);
$parcel$export(module.exports, "getRelativePointerPosition", () => $bc2bccca450fc166$export$79263550b33b988b);
$parcel$export(module.exports, "resolveChannelHeight", () => $bc2bccca450fc166$export$d630a9b35845d240);
$parcel$export(module.exports, "getPixelRatio", () => $bc2bccca450fc166$export$d39ce20a37bba061);
$parcel$export(module.exports, "shouldRenderBars", () => $bc2bccca450fc166$export$37d24b806fa5b2b4);
$parcel$export(module.exports, "resolveColorValue", () => $bc2bccca450fc166$export$49e8fee65a2fdff4);
$parcel$export(module.exports, "calculateWaveformLayout", () => $bc2bccca450fc166$export$9c27752397a2512);
$parcel$export(module.exports, "clampWidthToBarGrid", () => $bc2bccca450fc166$export$4766851639f2524b);
$parcel$export(module.exports, "calculateSingleCanvasWidth", () => $bc2bccca450fc166$export$4451f28166035aba);
$parcel$export(module.exports, "sliceChannelData", () => $bc2bccca450fc166$export$34f17f9de070b166);
$parcel$export(module.exports, "shouldClearCanvases", () => $bc2bccca450fc166$export$9285152e38948d30);
$parcel$export(module.exports, "getLazyRenderRange", () => $bc2bccca450fc166$export$ba2afa84c20ab77);
$parcel$export(module.exports, "calculateVerticalScale", () => $bc2bccca450fc166$export$49323a595c296b40);
$parcel$export(module.exports, "calculateLinePaths", () => $bc2bccca450fc166$export$21106e810ee1bb6);
$parcel$export(module.exports, "roundToHalfAwayFromZero", () => $bc2bccca450fc166$export$1e39918a51b733b5);
const $bc2bccca450fc166$export$611c894df53833b0 = 128;
const $bc2bccca450fc166$export$6e4fdb84fb59930 = 8000;
const $bc2bccca450fc166$export$53ed3718ef0d5777 = 10;
function $bc2bccca450fc166$export$776b1d1435d2fa37(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
}
function $bc2bccca450fc166$export$69b5491eba61a90b({ width: width, height: height, length: length, options: options, pixelRatio: pixelRatio }) {
    const halfHeight = height / 2;
    const barWidth = options.barWidth ? options.barWidth * pixelRatio : 1;
    const barGap = options.barGap ? options.barGap * pixelRatio : options.barWidth ? barWidth / 2 : 0;
    const barRadius = options.barRadius || 0;
    const barMinHeight = options.barMinHeight ? options.barMinHeight * pixelRatio : 0;
    const spacing = barWidth + barGap || 1;
    const barIndexScale = length > 0 ? width / spacing / length : 0;
    return {
        halfHeight: halfHeight,
        barWidth: barWidth,
        barGap: barGap,
        barRadius: barRadius,
        barMinHeight: barMinHeight,
        barIndexScale: barIndexScale,
        barSpacing: spacing
    };
}
function $bc2bccca450fc166$export$62f79955b284cfcc({ maxTop: maxTop, maxBottom: maxBottom, halfHeight: halfHeight, vScale: vScale, barMinHeight: barMinHeight = 0, barAlign: barAlign }) {
    let topHeight = Math.round(maxTop * halfHeight * vScale);
    const bottomHeight = Math.round(maxBottom * halfHeight * vScale);
    let totalHeight = topHeight + bottomHeight || 1;
    if (totalHeight < barMinHeight) {
        totalHeight = barMinHeight;
        if (!barAlign) topHeight = totalHeight / 2;
    }
    return {
        topHeight: topHeight,
        totalHeight: totalHeight
    };
}
function $bc2bccca450fc166$export$ce0c16a2881c3080({ barAlign: barAlign, halfHeight: halfHeight, topHeight: topHeight, totalHeight: totalHeight, canvasHeight: canvasHeight }) {
    if (barAlign === "top") return 0;
    if (barAlign === "bottom") return canvasHeight - totalHeight;
    return halfHeight - topHeight;
}
function $bc2bccca450fc166$export$636c362d38494a26({ channelData: channelData, barIndexScale: barIndexScale, barSpacing: barSpacing, barWidth: barWidth, halfHeight: halfHeight, vScale: vScale, canvasHeight: canvasHeight, barAlign: barAlign, barMinHeight: barMinHeight }) {
    const topChannel = channelData[0] || [];
    const bottomChannel = channelData[1] || topChannel;
    const length = topChannel.length;
    const segments = [];
    let prevX = 0;
    let maxTop = 0;
    let maxBottom = 0;
    for(let i = 0; i <= length; i++){
        const x = Math.round(i * barIndexScale);
        if (x > prevX) {
            const { topHeight: topHeight, totalHeight: totalHeight } = $bc2bccca450fc166$export$62f79955b284cfcc({
                maxTop: maxTop,
                maxBottom: maxBottom,
                halfHeight: halfHeight,
                vScale: vScale,
                barMinHeight: barMinHeight,
                barAlign: barAlign
            });
            const y = $bc2bccca450fc166$export$ce0c16a2881c3080({
                barAlign: barAlign,
                halfHeight: halfHeight,
                topHeight: topHeight,
                totalHeight: totalHeight,
                canvasHeight: canvasHeight
            });
            segments.push({
                x: prevX * barSpacing,
                y: y,
                width: barWidth,
                height: totalHeight
            });
            prevX = x;
            maxTop = 0;
            maxBottom = 0;
        }
        const magnitudeTop = Math.abs(topChannel[i] || 0);
        const magnitudeBottom = Math.abs(bottomChannel[i] || 0);
        if (magnitudeTop > maxTop) maxTop = magnitudeTop;
        if (magnitudeBottom > maxBottom) maxBottom = magnitudeBottom;
    }
    return segments;
}
function $bc2bccca450fc166$export$79263550b33b988b(rect, clientX, clientY) {
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    const relativeX = x / rect.width;
    const relativeY = y / rect.height;
    return [
        relativeX,
        relativeY
    ];
}
function $bc2bccca450fc166$export$d630a9b35845d240({ optionsHeight: optionsHeight, optionsSplitChannels: optionsSplitChannels, parentHeight: parentHeight, numberOfChannels: numberOfChannels, defaultHeight: defaultHeight = $bc2bccca450fc166$export$611c894df53833b0 }) {
    if (optionsHeight == null) return defaultHeight;
    const numericHeight = Number(optionsHeight);
    if (!isNaN(numericHeight)) return numericHeight;
    if (optionsHeight === "auto") {
        const height = parentHeight || defaultHeight;
        if (optionsSplitChannels === null || optionsSplitChannels === void 0 ? void 0 : optionsSplitChannels.every((channel)=>!channel.overlay)) return height / numberOfChannels;
        return height;
    }
    return defaultHeight;
}
function $bc2bccca450fc166$export$d39ce20a37bba061(devicePixelRatio) {
    return Math.max(1, devicePixelRatio || 1);
}
function $bc2bccca450fc166$export$37d24b806fa5b2b4(options) {
    return Boolean(options.barWidth || options.barGap || options.barAlign);
}
function $bc2bccca450fc166$export$49e8fee65a2fdff4(color, devicePixelRatio, canvasHeight) {
    if (!Array.isArray(color)) return color || "";
    if (color.length === 0) return "#999";
    if (color.length < 2) return color[0] || "";
    const canvasElement = document.createElement("canvas");
    const ctx = canvasElement.getContext("2d");
    const gradientHeight = canvasHeight !== null && canvasHeight !== void 0 ? canvasHeight : canvasElement.height * devicePixelRatio;
    const gradient = ctx.createLinearGradient(0, 0, 0, gradientHeight || devicePixelRatio);
    const colorStopPercentage = 1 / (color.length - 1);
    color.forEach((value, index)=>{
        gradient.addColorStop(index * colorStopPercentage, value);
    });
    return gradient;
}
function $bc2bccca450fc166$export$9c27752397a2512({ duration: duration, minPxPerSec: minPxPerSec = 0, parentWidth: parentWidth, fillParent: fillParent, pixelRatio: pixelRatio }) {
    const scrollWidth = Math.ceil(duration * minPxPerSec);
    const isScrollable = scrollWidth > parentWidth;
    const useParentWidth = Boolean(fillParent && !isScrollable);
    const width = (useParentWidth ? parentWidth : scrollWidth) * pixelRatio;
    return {
        scrollWidth: scrollWidth,
        isScrollable: isScrollable,
        useParentWidth: useParentWidth,
        width: width
    };
}
function $bc2bccca450fc166$export$4766851639f2524b(width, options) {
    if (!$bc2bccca450fc166$export$37d24b806fa5b2b4(options)) return width;
    const barWidth = options.barWidth || 0.5;
    const barGap = options.barGap || barWidth / 2;
    const totalBarWidth = barWidth + barGap;
    if (totalBarWidth === 0) return width;
    return Math.floor(width / totalBarWidth) * totalBarWidth;
}
function $bc2bccca450fc166$export$4451f28166035aba({ clientWidth: clientWidth, totalWidth: totalWidth, options: options }) {
    const baseWidth = Math.min($bc2bccca450fc166$export$6e4fdb84fb59930, clientWidth, totalWidth);
    return $bc2bccca450fc166$export$4766851639f2524b(baseWidth, options);
}
function $bc2bccca450fc166$export$34f17f9de070b166({ channelData: channelData, offset: offset, clampedWidth: clampedWidth, totalWidth: totalWidth }) {
    return channelData.map((channel)=>{
        const start = Math.floor(offset / totalWidth * channel.length);
        const end = Math.floor((offset + clampedWidth) / totalWidth * channel.length);
        return channel.slice(start, end);
    });
}
function $bc2bccca450fc166$export$9285152e38948d30(currentNodeCount) {
    return currentNodeCount > $bc2bccca450fc166$export$53ed3718ef0d5777;
}
function $bc2bccca450fc166$export$ba2afa84c20ab77({ scrollLeft: scrollLeft, totalWidth: totalWidth, numCanvases: numCanvases }) {
    if (totalWidth === 0) return [
        0
    ];
    const viewPosition = scrollLeft / totalWidth;
    const startCanvas = Math.floor(viewPosition * numCanvases);
    return [
        startCanvas - 1,
        startCanvas,
        startCanvas + 1
    ];
}
function $bc2bccca450fc166$export$49323a595c296b40({ channelData: channelData, barHeight: barHeight, normalize: normalize, maxPeak: maxPeak }) {
    var _a;
    const baseScale = barHeight || 1;
    if (!normalize) return baseScale;
    const firstChannel = channelData[0];
    if (!firstChannel || firstChannel.length === 0) return baseScale;
    // Use fixed max peak if provided, otherwise calculate from data
    let max = maxPeak !== null && maxPeak !== void 0 ? maxPeak : 0;
    if (!maxPeak) for(let i = 0; i < firstChannel.length; i++){
        const value = (_a = firstChannel[i]) !== null && _a !== void 0 ? _a : 0;
        const magnitude = Math.abs(value);
        if (magnitude > max) max = magnitude;
    }
    if (!max) return baseScale;
    return baseScale / max;
}
function $bc2bccca450fc166$export$21106e810ee1bb6({ channelData: channelData, width: width, height: height, vScale: vScale }) {
    const halfHeight = height / 2;
    const primaryChannel = channelData[0] || [];
    const secondaryChannel = channelData[1] || primaryChannel;
    const channels = [
        primaryChannel,
        secondaryChannel
    ];
    return channels.map((channel, index)=>{
        const length = channel.length;
        const hScale = length ? width / length : 0;
        const baseY = halfHeight;
        const direction = index === 0 ? -1 : 1;
        const path = [
            {
                x: 0,
                y: baseY
            }
        ];
        let prevX = 0;
        let max = 0;
        for(let i = 0; i <= length; i++){
            const x = Math.round(i * hScale);
            if (x > prevX) {
                const heightDelta = Math.round(max * halfHeight * vScale) || 1;
                const y = baseY + heightDelta * direction;
                path.push({
                    x: prevX,
                    y: y
                });
                prevX = x;
                max = 0;
            }
            const value = Math.abs(channel[i] || 0);
            if (value > max) max = value;
        }
        path.push({
            x: prevX,
            y: baseY
        });
        return path;
    });
}
function $bc2bccca450fc166$export$2d870b98f8da4582({ scrollLeft: scrollLeft, clientWidth: clientWidth, scrollWidth: scrollWidth }) {
    if (scrollWidth === 0) return {
        startX: 0,
        endX: 1
    };
    const startX = scrollLeft / scrollWidth;
    const endX = (scrollLeft + clientWidth) / scrollWidth;
    return {
        startX: Math.max(0, Math.min(1, startX)),
        endX: Math.max(0, Math.min(1, endX))
    };
}
function $bc2bccca450fc166$export$1e39918a51b733b5(value) {
    const scaled = value * 2;
    const rounded = scaled < 0 ? Math.floor(scaled) : Math.ceil(scaled);
    return rounded / 2;
}

});

parcelRegister("jvjd6", function(module, exports) {

$parcel$export(module.exports, "createDragStream", () => $e32fd05e24987a74$export$80452e177a17f59a);
/**
 * Reactive drag stream utilities
 *
 * Provides declarative drag handling using reactive streams.
 * Automatically handles mouseup cleanup and supports constraints.
 */ 
var $gkUki = parcelRequire("gkUki");

var $fndGV = parcelRequire("fndGV");
function $e32fd05e24987a74$export$80452e177a17f59a(element, options = {}) {
    const { threshold: threshold = 3, mouseButton: mouseButton = 0, touchDelay: touchDelay = 100 } = options;
    const dragSignal = (0, $gkUki.signal)(null);
    const activePointers = new Map();
    const isTouchDevice = matchMedia("(pointer: coarse)").matches;
    let unsubscribeDocument = ()=>void 0;
    const onPointerDown = (event)=>{
        if (event.button !== mouseButton) return;
        activePointers.set(event.pointerId, event);
        if (activePointers.size > 1) return;
        let startX = event.clientX;
        let startY = event.clientY;
        let isDragging = false;
        const touchStartTime = Date.now();
        const rect = element.getBoundingClientRect();
        const { left: left, top: top } = rect;
        const onPointerMove = (event)=>{
            if (event.defaultPrevented || activePointers.size > 1) return;
            if (isTouchDevice && Date.now() - touchStartTime < touchDelay) return;
            const x = event.clientX;
            const y = event.clientY;
            const dx = x - startX;
            const dy = y - startY;
            if (isDragging || Math.abs(dx) > threshold || Math.abs(dy) > threshold) {
                event.preventDefault();
                event.stopPropagation();
                if (!isDragging) {
                    // Emit start event
                    dragSignal.set({
                        type: "start",
                        x: startX - left,
                        y: startY - top
                    });
                    isDragging = true;
                }
                // Emit move event
                dragSignal.set({
                    type: "move",
                    x: x - left,
                    y: y - top,
                    deltaX: dx,
                    deltaY: dy
                });
                startX = x;
                startY = y;
            }
        };
        const onPointerUp = (event)=>{
            activePointers.delete(event.pointerId);
            if (isDragging) {
                const x = event.clientX;
                const y = event.clientY;
                // Emit end event
                dragSignal.set({
                    type: "end",
                    x: x - left,
                    y: y - top
                });
            }
            unsubscribeDocument();
        };
        const onPointerLeave = (e)=>{
            activePointers.delete(e.pointerId);
            if (!e.relatedTarget || e.relatedTarget === document.documentElement) onPointerUp(e);
        };
        const onClick = (event)=>{
            if (isDragging) {
                event.stopPropagation();
                event.preventDefault();
            }
        };
        const onTouchMove = (event)=>{
            if (event.defaultPrevented || activePointers.size > 1) return;
            if (isDragging) event.preventDefault();
        };
        document.addEventListener("pointermove", onPointerMove);
        document.addEventListener("pointerup", onPointerUp);
        document.addEventListener("pointerout", onPointerLeave);
        document.addEventListener("pointercancel", onPointerLeave);
        document.addEventListener("touchmove", onTouchMove, {
            passive: false
        });
        document.addEventListener("click", onClick, {
            capture: true
        });
        unsubscribeDocument = ()=>{
            document.removeEventListener("pointermove", onPointerMove);
            document.removeEventListener("pointerup", onPointerUp);
            document.removeEventListener("pointerout", onPointerLeave);
            document.removeEventListener("pointercancel", onPointerLeave);
            document.removeEventListener("touchmove", onTouchMove);
            setTimeout(()=>{
                document.removeEventListener("click", onClick, {
                    capture: true
                });
            }, 10);
        };
    };
    element.addEventListener("pointerdown", onPointerDown);
    const cleanupFn = ()=>{
        unsubscribeDocument();
        element.removeEventListener("pointerdown", onPointerDown);
        activePointers.clear();
        (0, $fndGV.cleanup)(dragSignal);
    };
    return {
        signal: dragSignal,
        cleanup: cleanupFn
    };
}

});
parcelRegister("fndGV", function(module, exports) {

$parcel$export(module.exports, "cleanup", () => $b3139fd24f27a7f4$export$de863c629cb9919d);
/**
 * Event stream utilities for converting DOM events to reactive signals
 *
 * These utilities allow composing event handling using reactive primitives.
 */ 
var $gkUki = parcelRequire("gkUki");
function $b3139fd24f27a7f4$export$a36e16046ae8f1bb(element, eventName) {
    const stream = (0, $gkUki.signal)(null);
    const handler = (event)=>{
        stream.set(event);
    };
    element.addEventListener(eventName, handler);
    stream._cleanup = ()=>{
        element.removeEventListener(eventName, handler);
    };
    return stream;
}
function $b3139fd24f27a7f4$export$871de8747c9eaa88(source, mapper) {
    const result = (0, $gkUki.signal)(mapper(source.value));
    const unsubscribe = source.subscribe((value)=>{
        result.set(mapper(value));
    });
    result._cleanup = unsubscribe;
    return result;
}
function $b3139fd24f27a7f4$export$3dea766d36a8935f(source, predicate) {
    const initialValue = predicate(source.value) ? source.value : null;
    const result = (0, $gkUki.signal)(initialValue);
    const unsubscribe = source.subscribe((value)=>{
        if (predicate(value)) result.set(value);
        else result.set(null);
    });
    result._cleanup = unsubscribe;
    return result;
}
function $b3139fd24f27a7f4$export$61fc7d43ac8f84b0(source, delay) {
    const result = (0, $gkUki.signal)(source.value);
    let timeout;
    const unsubscribe = source.subscribe((value)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            result.set(value);
        }, delay);
    });
    result._cleanup = ()=>{
        clearTimeout(timeout);
        unsubscribe();
    };
    return result;
}
function $b3139fd24f27a7f4$export$de363e709c412c8a(source, delay) {
    const result = (0, $gkUki.signal)(source.value);
    let lastEmit = 0;
    let timeout;
    const unsubscribe = source.subscribe((value)=>{
        const now = Date.now();
        const timeSinceLastEmit = now - lastEmit;
        if (timeSinceLastEmit >= delay) {
            result.set(value);
            lastEmit = now;
        } else {
            // Too soon, schedule for later
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                result.set(value);
                lastEmit = Date.now();
            }, delay - timeSinceLastEmit);
        }
    });
    result._cleanup = ()=>{
        clearTimeout(timeout);
        unsubscribe();
    };
    return result;
}
function $b3139fd24f27a7f4$export$de863c629cb9919d(stream) {
    const cleanupFn = stream._cleanup;
    if (typeof cleanupFn === "function") cleanupFn();
}

});


parcelRegister("e6zf7", function(module, exports) {

$parcel$export(module.exports, "createScrollStream", () => $a44cf6b5dc365307$export$39b348c1ac25b5dd);
/**
 * Reactive scroll stream utilities
 *
 * Provides declarative scroll handling using reactive streams.
 * Automatically handles scroll event optimization and cleanup.
 */ 
var $gkUki = parcelRequire("gkUki");

var $fndGV = parcelRequire("fndGV");
function $a44cf6b5dc365307$export$2d870b98f8da4582(scrollData) {
    const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = scrollData;
    if (scrollWidth === 0) return {
        startX: 0,
        endX: 1
    };
    const startX = scrollLeft / scrollWidth;
    const endX = (scrollLeft + clientWidth) / scrollWidth;
    return {
        startX: Math.max(0, Math.min(1, startX)),
        endX: Math.max(0, Math.min(1, endX))
    };
}
function $a44cf6b5dc365307$export$2ff0b4725276300c(scrollData) {
    return {
        left: scrollData.scrollLeft,
        right: scrollData.scrollLeft + scrollData.clientWidth
    };
}
function $a44cf6b5dc365307$export$39b348c1ac25b5dd(element) {
    // Create signals
    const scrollData = (0, $gkUki.signal)({
        scrollLeft: element.scrollLeft,
        scrollWidth: element.scrollWidth,
        clientWidth: element.clientWidth
    });
    // Computed derived values
    const percentages = (0, $gkUki.computed)(()=>{
        return $a44cf6b5dc365307$export$2d870b98f8da4582(scrollData.value);
    }, [
        scrollData
    ]);
    const bounds = (0, $gkUki.computed)(()=>{
        return $a44cf6b5dc365307$export$2ff0b4725276300c(scrollData.value);
    }, [
        scrollData
    ]);
    // Update scroll data on scroll event
    const onScroll = ()=>{
        scrollData.set({
            scrollLeft: element.scrollLeft,
            scrollWidth: element.scrollWidth,
            clientWidth: element.clientWidth
        });
    };
    // Attach scroll listener
    element.addEventListener("scroll", onScroll, {
        passive: true
    });
    // Cleanup function
    const cleanupFn = ()=>{
        element.removeEventListener("scroll", onScroll);
        (0, $fndGV.cleanup)(scrollData);
    };
    return {
        scrollData: scrollData,
        percentages: percentages,
        bounds: bounds,
        cleanup: cleanupFn
    };
}
function $a44cf6b5dc365307$export$214800893e04d063(element, onScrollChange) {
    const stream = $a44cf6b5dc365307$export$39b348c1ac25b5dd(element);
    // Effect to update external state
    const unsubscribe = (0, $gkUki.effect)(()=>{
        onScrollChange(stream.scrollData.value.scrollLeft);
    }, [
        stream.scrollData
    ]);
    // Wrap cleanup to include effect cleanup
    const originalCleanup = stream.cleanup;
    stream.cleanup = ()=>{
        unsubscribe();
        originalCleanup();
    };
    return stream;
}

});


parcelRegister("5t6GI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fb4d94083f440d2$export$2e2bcd8739ae039);

var $3gKqg = parcelRequire("3gKqg");
class $3fb4d94083f440d2$var$Timer extends (0, $3gKqg.default) {
    constructor(){
        super(...arguments);
        this.animationFrameId = null;
        this.isRunning = false;
    }
    start() {
        // Prevent multiple simultaneous loops
        if (this.isRunning) return;
        this.isRunning = true;
        const tick = ()=>{
            // Only continue if timer is still running
            if (!this.isRunning) return;
            this.emit("tick");
            // Schedule next frame
            this.animationFrameId = requestAnimationFrame(tick);
        };
        // Start the loop
        tick();
    }
    stop() {
        this.isRunning = false;
        // Cancel any pending animation frame
        if (this.animationFrameId !== null) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    }
    destroy() {
        this.stop();
    }
}
var $3fb4d94083f440d2$export$2e2bcd8739ae039 = $3fb4d94083f440d2$var$Timer;

});

parcelRegister("cCKRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $930d618cbf69f55e$export$2e2bcd8739ae039);

var $3gKqg = parcelRequire("3gKqg");
var $930d618cbf69f55e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * A Web Audio buffer player emulating the behavior of an HTML5 Audio element.
 *
 * Note: This class does not manage blob: URLs. If you pass a blob: URL to setSrc(),
 * you are responsible for revoking it when done. The Player class (player.ts) handles
 * blob URL lifecycle management automatically.
 */ class $930d618cbf69f55e$var$WebAudioPlayer extends (0, $3gKqg.default) {
    constructor(audioContext = new AudioContext()){
        super();
        this.bufferNode = null;
        this.playStartTime = 0;
        this.playedDuration = 0;
        this._muted = false;
        this._playbackRate = 1;
        this._duration = undefined;
        this.buffer = null;
        this.currentSrc = "";
        this.paused = true;
        this.crossOrigin = null;
        this.seeking = false;
        this.autoplay = false;
        /** Subscribe to an event. Returns an unsubscribe function. */ this.addEventListener = this.on;
        /** Unsubscribe from an event */ this.removeEventListener = this.un;
        this.audioContext = audioContext;
        this.gainNode = this.audioContext.createGain();
        this.gainNode.connect(this.audioContext.destination);
    }
    load() {
        return $930d618cbf69f55e$var$__awaiter(this, void 0, void 0, function*() {
            return;
        });
    }
    get src() {
        return this.currentSrc;
    }
    set src(value) {
        this.currentSrc = value;
        this._duration = undefined;
        if (!value) {
            this.buffer = null;
            this.emit("emptied");
            return;
        }
        fetch(value).then((response)=>{
            if (response.status >= 400) throw new Error(`Failed to fetch ${value}: ${response.status} (${response.statusText})`);
            return response.arrayBuffer();
        }).then((arrayBuffer)=>{
            if (this.currentSrc !== value) return null;
            return this.audioContext.decodeAudioData(arrayBuffer);
        }).then((audioBuffer)=>{
            if (this.currentSrc !== value) return;
            this.buffer = audioBuffer;
            this.emit("loadedmetadata");
            this.emit("canplay");
            if (this.autoplay) this.play();
        }).catch((err)=>{
            // Emit error for proper error handling
            console.error("WebAudioPlayer load error:", err);
        });
    }
    _play() {
        if (!this.paused) return;
        this.paused = false;
        // Clean up old buffer node completely before creating new one
        if (this.bufferNode) {
            this.bufferNode.onended = null;
            this.bufferNode.disconnect();
        }
        this.bufferNode = this.audioContext.createBufferSource();
        if (this.buffer) this.bufferNode.buffer = this.buffer;
        this.bufferNode.playbackRate.value = this._playbackRate;
        this.bufferNode.connect(this.gainNode);
        let currentPos = this.playedDuration * this._playbackRate;
        if (currentPos >= this.duration || currentPos < 0) {
            currentPos = 0;
            this.playedDuration = 0;
        }
        this.bufferNode.start(this.audioContext.currentTime, currentPos);
        this.playStartTime = this.audioContext.currentTime;
        this.bufferNode.onended = ()=>{
            if (this.currentTime >= this.duration) {
                this.pause();
                this.emit("ended");
            }
        };
    }
    _pause() {
        var _a;
        this.paused = true;
        (_a = this.bufferNode) === null || _a === void 0 || _a.stop();
        this.playedDuration += this.audioContext.currentTime - this.playStartTime;
    }
    play() {
        return $930d618cbf69f55e$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.paused) return;
            this._play();
            this.emit("play");
        });
    }
    pause() {
        if (this.paused) return;
        this._pause();
        this.emit("pause");
    }
    stopAt(timeSeconds) {
        const delay = timeSeconds - this.currentTime;
        const currentBufferNode = this.bufferNode;
        currentBufferNode === null || currentBufferNode === void 0 || currentBufferNode.stop(this.audioContext.currentTime + delay);
        currentBufferNode === null || currentBufferNode === void 0 || currentBufferNode.addEventListener("ended", ()=>{
            if (currentBufferNode === this.bufferNode) {
                this.bufferNode = null;
                this.pause();
            }
        }, {
            once: true
        });
    }
    setSinkId(deviceId) {
        return $930d618cbf69f55e$var$__awaiter(this, void 0, void 0, function*() {
            const ac = this.audioContext;
            return ac.setSinkId(deviceId);
        });
    }
    get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(value) {
        this._playbackRate = value;
        if (this.bufferNode) this.bufferNode.playbackRate.value = value;
    }
    get currentTime() {
        const time = this.paused ? this.playedDuration : this.playedDuration + (this.audioContext.currentTime - this.playStartTime);
        return time * this._playbackRate;
    }
    set currentTime(value) {
        const wasPlaying = !this.paused;
        if (wasPlaying) this._pause();
        this.playedDuration = value / this._playbackRate;
        if (wasPlaying) this._play();
        this.emit("seeking");
        this.emit("timeupdate");
    }
    get duration() {
        var _a, _b;
        return (_a = this._duration) !== null && _a !== void 0 ? _a : ((_b = this.buffer) === null || _b === void 0 ? void 0 : _b.duration) || 0;
    }
    set duration(value) {
        this._duration = value;
    }
    get volume() {
        return this.gainNode.gain.value;
    }
    set volume(value) {
        this.gainNode.gain.value = value;
        this.emit("volumechange");
    }
    get muted() {
        return this._muted;
    }
    set muted(value) {
        if (this._muted === value) return;
        this._muted = value;
        if (this._muted) this.gainNode.disconnect();
        else this.gainNode.connect(this.audioContext.destination);
    }
    canPlayType(mimeType) {
        return /^(audio|video)\//.test(mimeType);
    }
    /** Get the GainNode used to play the audio. Can be used to attach filters. */ getGainNode() {
        return this.gainNode;
    }
    /** Get decoded audio */ getChannelData() {
        const channels = [];
        if (!this.buffer) return channels;
        const numChannels = this.buffer.numberOfChannels;
        for(let i = 0; i < numChannels; i++)channels.push(this.buffer.getChannelData(i));
        return channels;
    }
    /**
     * Imitate `HTMLElement.removeAttribute` for compatibility with `Player`.
     */ removeAttribute(attrName) {
        switch(attrName){
            case "src":
                this.src = "";
                break;
            case "playbackRate":
                this.playbackRate = 0;
                break;
            case "currentTime":
                this.currentTime = 0;
                break;
            case "duration":
                this.duration = 0;
                break;
            case "volume":
                this.volume = 0;
                break;
            case "muted":
                this.muted = false;
                break;
        }
    }
}
var $930d618cbf69f55e$export$2e2bcd8739ae039 = $930d618cbf69f55e$var$WebAudioPlayer;

});

parcelRegister("hAIlD", function(module, exports) {

$parcel$export(module.exports, "createWaveSurferState", () => $cce83307ade6d081$export$db59e96ed790cb58);
/**
 * Centralized reactive state for WaveSurfer
 *
 * This module provides a single source of truth for all WaveSurfer state.
 * State is managed using reactive signals that automatically notify subscribers.
 */ 
var $gkUki = parcelRequire("gkUki");
function $cce83307ade6d081$export$db59e96ed790cb58(playerSignals) {
    var _a, _b, _c, _d, _e, _f;
    // Use Player signals if provided, otherwise create new ones
    const currentTime = (_a = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.currentTime) !== null && _a !== void 0 ? _a : (0, $gkUki.signal)(0);
    const duration = (_b = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.duration) !== null && _b !== void 0 ? _b : (0, $gkUki.signal)(0);
    const isPlaying = (_c = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.isPlaying) !== null && _c !== void 0 ? _c : (0, $gkUki.signal)(false);
    const isSeeking = (_d = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.isSeeking) !== null && _d !== void 0 ? _d : (0, $gkUki.signal)(false);
    const volume = (_e = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.volume) !== null && _e !== void 0 ? _e : (0, $gkUki.signal)(1);
    const playbackRate = (_f = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.playbackRate) !== null && _f !== void 0 ? _f : (0, $gkUki.signal)(1);
    // WaveSurfer-specific signals (not in Player)
    const audioBuffer = (0, $gkUki.signal)(null);
    const peaks = (0, $gkUki.signal)(null);
    const url = (0, $gkUki.signal)("");
    const zoom = (0, $gkUki.signal)(0);
    const scrollPosition = (0, $gkUki.signal)(0);
    // Computed values (derived state)
    const isPaused = (0, $gkUki.computed)(()=>!isPlaying.value, [
        isPlaying
    ]);
    const canPlay = (0, $gkUki.computed)(()=>audioBuffer.value !== null, [
        audioBuffer
    ]);
    const isReady = (0, $gkUki.computed)(()=>{
        return canPlay.value && duration.value > 0;
    }, [
        canPlay,
        duration
    ]);
    const progress = (0, $gkUki.computed)(()=>currentTime.value, [
        currentTime
    ]);
    const progressPercent = (0, $gkUki.computed)(()=>{
        return duration.value > 0 ? currentTime.value / duration.value : 0;
    }, [
        currentTime,
        duration
    ]);
    // Public read-only state
    const state = {
        currentTime: currentTime,
        duration: duration,
        isPlaying: isPlaying,
        isPaused: isPaused,
        isSeeking: isSeeking,
        volume: volume,
        playbackRate: playbackRate,
        audioBuffer: audioBuffer,
        peaks: peaks,
        url: url,
        zoom: zoom,
        scrollPosition: scrollPosition,
        canPlay: canPlay,
        isReady: isReady,
        progress: progress,
        progressPercent: progressPercent
    };
    // Actions that modify state
    const actions = {
        setCurrentTime: (time)=>{
            const clampedTime = Math.max(0, Math.min(duration.value || Infinity, time));
            currentTime.set(clampedTime);
        },
        setDuration: (d)=>{
            duration.set(Math.max(0, d));
        },
        setPlaying: (playing)=>{
            isPlaying.set(playing);
        },
        setSeeking: (seeking)=>{
            isSeeking.set(seeking);
        },
        setVolume: (v)=>{
            const clampedVolume = Math.max(0, Math.min(1, v));
            volume.set(clampedVolume);
        },
        setPlaybackRate: (rate)=>{
            const clampedRate = Math.max(0.1, Math.min(16, rate));
            playbackRate.set(clampedRate);
        },
        setAudioBuffer: (buffer)=>{
            audioBuffer.set(buffer);
            if (buffer) duration.set(buffer.duration);
        },
        setPeaks: (p)=>{
            peaks.set(p);
        },
        setUrl: (u)=>{
            url.set(u);
        },
        setZoom: (z)=>{
            zoom.set(Math.max(0, z));
        },
        setScrollPosition: (pos)=>{
            scrollPosition.set(Math.max(0, pos));
        }
    };
    return {
        state: state,
        actions: actions
    };
}

});

parcelRegister("iZSFu", function(module, exports) {

$parcel$export(module.exports, "setupStateEventEmission", () => $dd48547a7825995b$export$a76f26ef7b2198c1);
/**
 * State-driven event emission utilities
 *
 * Automatically emit events when reactive state changes.
 * Ensures events are always in sync with state and removes manual emit() calls.
 */ 
var $gkUki = parcelRequire("gkUki");
function $dd48547a7825995b$export$a76f26ef7b2198c1(state, emitter) {
    const cleanups = [];
    // ============================================================================
    // Play/Pause Events
    // ============================================================================
    // Emit play/pause events when playing state changes
    cleanups.push((0, $gkUki.effect)(()=>{
        const isPlaying = state.isPlaying.value;
        emitter.emit(isPlaying ? "play" : "pause");
    }, [
        state.isPlaying
    ]));
    // ============================================================================
    // Time Update Events
    // ============================================================================
    // Emit timeupdate when current time changes
    cleanups.push((0, $gkUki.effect)(()=>{
        const currentTime = state.currentTime.value;
        emitter.emit("timeupdate", currentTime);
        // Also emit audioprocess when playing
        if (state.isPlaying.value) emitter.emit("audioprocess", currentTime);
    }, [
        state.currentTime,
        state.isPlaying
    ]));
    // ============================================================================
    // Seeking Events
    // ============================================================================
    // Emit seeking event when seeking state changes to true
    cleanups.push((0, $gkUki.effect)(()=>{
        const isSeeking = state.isSeeking.value;
        if (isSeeking) emitter.emit("seeking", state.currentTime.value);
    }, [
        state.isSeeking,
        state.currentTime
    ]));
    // ============================================================================
    // Ready Event
    // ============================================================================
    // Emit ready when state becomes ready
    let wasReady = false;
    cleanups.push((0, $gkUki.effect)(()=>{
        const isReady = state.isReady.value;
        if (isReady && !wasReady) {
            wasReady = true;
            emitter.emit("ready", state.duration.value);
        }
    }, [
        state.isReady,
        state.duration
    ]));
    // ============================================================================
    // Finish Event
    // ============================================================================
    // Emit finish when playback ends (reached duration and stopped)
    let wasPlayingAtEnd = false;
    cleanups.push((0, $gkUki.effect)(()=>{
        const isPlaying = state.isPlaying.value;
        const currentTime = state.currentTime.value;
        const duration = state.duration.value;
        // Check if we're at the end
        const isAtEnd = duration > 0 && currentTime >= duration;
        // Emit finish when we were playing at end and now stopped
        if (wasPlayingAtEnd && !isPlaying && isAtEnd) emitter.emit("finish");
        // Track if we're playing at the end
        wasPlayingAtEnd = isPlaying && isAtEnd;
    }, [
        state.isPlaying,
        state.currentTime,
        state.duration
    ]));
    // ============================================================================
    // Zoom Events
    // ============================================================================
    // Emit zoom when zoom level changes
    cleanups.push((0, $gkUki.effect)(()=>{
        const zoom = state.zoom.value;
        if (zoom > 0) emitter.emit("zoom", zoom);
    }, [
        state.zoom
    ]));
    // Return cleanup function
    return ()=>{
        cleanups.forEach((cleanup)=>cleanup());
    };
}
function $dd48547a7825995b$export$478d05cd8240f75(signal, emitter, getEventData) {
    return (0, $gkUki.effect)(()=>{
        const value = signal.value;
        const [eventName, ...args] = getEventData(value);
        emitter.emit(eventName, ...args);
    }, [
        signal
    ]);
}
function $dd48547a7825995b$export$380599a071a4cead(signal, emitter, getEventData, debounceMs) {
    let timeoutId = null;
    const cleanup = (0, $gkUki.effect)(()=>{
        const value = signal.value;
        // Clear previous timeout
        if (timeoutId !== null) clearTimeout(timeoutId);
        // Set new timeout
        timeoutId = setTimeout(()=>{
            const [eventName, ...args] = getEventData(value);
            emitter.emit(eventName, ...args);
            timeoutId = null;
        }, debounceMs);
    }, [
        signal
    ]);
    // Return cleanup that also clears pending timeout
    return ()=>{
        if (timeoutId !== null) clearTimeout(timeoutId);
        cleanup();
    };
}
function $dd48547a7825995b$export$5f8bb86fb2808297(signal, emitter, condition, getEventData) {
    return (0, $gkUki.effect)(()=>{
        const value = signal.value;
        if (condition(value)) {
            const [eventName, ...args] = getEventData(value);
            emitter.emit(eventName, ...args);
        }
    }, [
        signal
    ]);
}

});


parcelRegister("kKA2u", function(module, exports) {
"use strict";

var $4iRTc = parcelRequire("4iRTc");
var $hgqF6 = parcelRequire("hgqF6");
var $f1b40f2750464c98$require$Subject = $hgqF6.Subject;
var $f1b40f2750464c98$require$BehaviorSubject = $4iRTc.BehaviorSubject;

var $f6wSa = parcelRequire("f6wSa");
var $f1b40f2750464c98$require$scan = $f6wSa.scan;

var $jjnZg = parcelRequire("jjnZg");
var $f1b40f2750464c98$require$obj = $jjnZg.obj;
let $f1b40f2750464c98$var$pocket;
let $f1b40f2750464c98$var$reducers$ = new $f1b40f2750464c98$require$Subject();
let $f1b40f2750464c98$var$pocket$ = new $f1b40f2750464c98$require$BehaviorSubject({});
$f1b40f2750464c98$var$reducers$.pipe($f1b40f2750464c98$require$scan((pocket, reduce)=>reduce(pocket), {})).subscribe((pocket)=>$f1b40f2750464c98$var$pocket$.next(pocket));
$f1b40f2750464c98$var$pocket$.subscribe((_pocket)=>{
    // console.log({pocket});
    $f1b40f2750464c98$var$pocket = _pocket;
});
const $f1b40f2750464c98$var$put = (path, val)=>$f1b40f2750464c98$var$reducers$.next((pocket)=>$f1b40f2750464c98$require$obj.patch(pocket, path, val));
const $f1b40f2750464c98$var$get = (path)=>$f1b40f2750464c98$require$obj.sub($f1b40f2750464c98$var$pocket, path);
module.exports = {
    put: $f1b40f2750464c98$var$put,
    get: $f1b40f2750464c98$var$get,
    reducers$: $f1b40f2750464c98$var$reducers$,
    stream: $f1b40f2750464c98$var$pocket$
};

});
parcelRegister("4iRTc", function(module, exports) {

$parcel$export(module.exports, "BehaviorSubject", () => $3222a525287186b1$export$cc3d42e6b2b9cf8b);

var $1Znhr = parcelRequire("1Znhr");

var $hgqF6 = parcelRequire("hgqF6");
var $3222a525287186b1$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $1Znhr.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $hgqF6.Subject));

});




parcelRegister("fYMUn", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $ba2265c6af5fe5e7$require$div = $2Z6Kw.div;
var $ba2265c6af5fe5e7$require$img = $2Z6Kw.img;
var $ba2265c6af5fe5e7$require$h2 = $2Z6Kw.h2;
var $ba2265c6af5fe5e7$require$i = $2Z6Kw.i;
var $ba2265c6af5fe5e7$require$span = $2Z6Kw.span;
var $ba2265c6af5fe5e7$require$p = $2Z6Kw.p;
var $ba2265c6af5fe5e7$require$hr = $2Z6Kw.hr;
var $ba2265c6af5fe5e7$require$ul = $2Z6Kw.ul;
var $ba2265c6af5fe5e7$require$li = $2Z6Kw.li;
var $ba2265c6af5fe5e7$require$form = $2Z6Kw.form;
var $ba2265c6af5fe5e7$require$fieldset = $2Z6Kw.fieldset;
var $ba2265c6af5fe5e7$require$label = $2Z6Kw.label;
var $ba2265c6af5fe5e7$require$input = $2Z6Kw.input;
var $ba2265c6af5fe5e7$require$button = $2Z6Kw.button;
var $ba2265c6af5fe5e7$require$select = $2Z6Kw.select;
var $ba2265c6af5fe5e7$require$option = $2Z6Kw.option;
var $ba2265c6af5fe5e7$require$legend = $2Z6Kw.legend;
const $ba2265c6af5fe5e7$var$loop = (times, fn = (i)=>i)=>times > 0 && [].concat($ba2265c6af5fe5e7$var$loop(times - 1, fn), fn(times - 1)) || [];
const $ba2265c6af5fe5e7$var$dropdown = ({ opts: opts, selected: selected, cb: cb })=>$ba2265c6af5fe5e7$require$select({
        on: {
            change: (ev)=>cb(ev)
        }
    }, Object.keys(opts).sort().map((key)=>$ba2265c6af5fe5e7$require$option({
            attrs: {
                selected: String(key) === String(selected),
                value: key
            }
        }, opts[key])));
module.exports = ({ state: state, actions: actions, params: params = {} })=>{
    if (!state.session || !state.session.tracks) return $ba2265c6af5fe5e7$require$div(".session", params, [
        $ba2265c6af5fe5e7$require$div(".header", [
            $ba2265c6af5fe5e7$require$h2([
                $ba2265c6af5fe5e7$require$img('[src="assets/session.svg"][height="20"]', {
                    style: {
                        margin: "9px 7px 9px 0px"
                    }
                }),
                $ba2265c6af5fe5e7$require$span("Session")
            ])
        ]),
        $ba2265c6af5fe5e7$require$div(".body", [
            $ba2265c6af5fe5e7$require$div(".error", "Session tracks not available")
        ])
    ]);
    return $ba2265c6af5fe5e7$require$div(".session", params, [
        $ba2265c6af5fe5e7$require$div(".header", [
            $ba2265c6af5fe5e7$require$h2([
                $ba2265c6af5fe5e7$require$img('[src="assets/session.svg"][height="20"]', {
                    style: {
                        margin: "9px 7px 9px 0px"
                    }
                }),
                $ba2265c6af5fe5e7$require$span("Session")
            ])
        ]),
        $ba2265c6af5fe5e7$require$div(".body", [].concat(state.session.tracks.map((track, trackIndex)=>$ba2265c6af5fe5e7$require$div(".channel", [
                $ba2265c6af5fe5e7$require$ul(".track", [].concat($ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(track.name)), $ba2265c6af5fe5e7$var$loop(4).map((rowIndex)=>{
                    const isSelectedForType = state.session.selection[track.type].join(".") === [
                        trackIndex,
                        rowIndex
                    ].join(".");
                    const isSelectedForInstr = state.session.selection.instr.join(".") === [
                        trackIndex,
                        rowIndex
                    ].join(".");
                    return $ba2265c6af5fe5e7$require$li({
                        class: {
                            measure: track.measures[rowIndex],
                            empty: !track.measures[rowIndex],
                            selected: isSelectedForType,
                            "instr-selected": isSelectedForInstr,
                            active: state.session.active[trackIndex] === rowIndex
                        },
                        on: {
                            click: ()=>actions.session.select(trackIndex, rowIndex),
                            dblclick: ()=>actions.session.activate(trackIndex, rowIndex)
                        }
                    }, $ba2265c6af5fe5e7$require$span([
                        track.measures[rowIndex] ? $ba2265c6af5fe5e7$require$span(track.measures[rowIndex].name || "untitled") : $ba2265c6af5fe5e7$require$span("+"),
                        state.session.active[trackIndex] === rowIndex ? $ba2265c6af5fe5e7$require$span(` [ ${state.studio.tick.tracks[trackIndex].bar || 0} ]`) : ""
                    ]));
                }))),
                $ba2265c6af5fe5e7$require$fieldset(".midi", [
                    $ba2265c6af5fe5e7$require$legend("MIDI"),
                    $ba2265c6af5fe5e7$var$dropdown({
                        opts: {
                            "-1": "All Devices",
                            ...state.midiMap.devices.inputs.reduce((opts, inp, device)=>({
                                    ...opts,
                                    [device]: inp.name
                                }), {})
                        },
                        cb: (ev)=>actions.session.updateTrackInput(trackIndex, "device", Number(ev.target.value)),
                        selected: track.input && track.input.device
                    }),
                    $ba2265c6af5fe5e7$require$input(`[type=number]`, {
                        on: {
                            change: (ev)=>actions.session.updateTrackInput(trackIndex, "channel", ev.target.value)
                        },
                        props: {
                            value: track.input && track.input.channel || (track.type === "seq" ? 10 : 1)
                        }
                    }),
                    $ba2265c6af5fe5e7$var$dropdown({
                        opts: {
                            "-1": "None",
                            ...state.midiMap.devices.outputs.reduce((opts, out, device)=>({
                                    ...opts,
                                    [device]: out.name
                                }), {})
                        },
                        cb: (ev)=>actions.session.updateTrackOutput(trackIndex, "device", Number(ev.target.value)),
                        selected: track.output && track.output.device
                    }),
                    $ba2265c6af5fe5e7$require$input(`[type=number]`, {
                        on: {
                            change: (ev)=>actions.session.updateTrackOutput(trackIndex, "channel", ev.target.value)
                        },
                        props: {
                            value: track.output && track.output.channel || (track.type === "seq" ? 10 : 1)
                        }
                    })
                ]),
                $ba2265c6af5fe5e7$require$ul(".rack", [].concat($ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span([
                    track.type === "seq" ? "Sequencer" : "Synth"
                ])), track.type === "seq" ? [
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`Reverb`)),
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`...`)),
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`...`)),
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`...`))
                ] : [
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`VCF`)),
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`LFO`)),
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`Reverb`)),
                    $ba2265c6af5fe5e7$require$li($ba2265c6af5fe5e7$require$span(`...`))
                ]))
            ]))))
    ]);
};

});

parcelRegister("ll0Ct", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $f88c0a2b1acf87aa$require$div = $2Z6Kw.div;
var $f88c0a2b1acf87aa$require$h2 = $2Z6Kw.h2;
var $f88c0a2b1acf87aa$require$i = $2Z6Kw.i;
var $f88c0a2b1acf87aa$require$span = $2Z6Kw.span;
var $f88c0a2b1acf87aa$require$p = $2Z6Kw.p;
var $f88c0a2b1acf87aa$require$input = $2Z6Kw.input;
var $f88c0a2b1acf87aa$require$label = $2Z6Kw.label;
var $f88c0a2b1acf87aa$require$hr = $2Z6Kw.hr;
var $f88c0a2b1acf87aa$require$button = $2Z6Kw.button;

var $jjnZg = parcelRequire("jjnZg");
var $f88c0a2b1acf87aa$require$obj = $jjnZg.obj;
const $f88c0a2b1acf87aa$var$loop = (times, fn)=>times > 0 && [].concat($f88c0a2b1acf87aa$var$loop(times - 1, fn), fn(times - 1)) || [];
const $f88c0a2b1acf87aa$var$isOn = (pattern, bar, channel, tick)=>pattern[bar] && pattern[bar][channel] && pattern[bar][channel][tick];
const $f88c0a2b1acf87aa$var$velocity = (pattern, bar, channel, tick)=>$f88c0a2b1acf87aa$require$obj.sub(pattern, [
        bar,
        channel,
        tick
    ]) || 0;
const $f88c0a2b1acf87aa$var$cMap = [
    [
        223,
        223,
        223
    ],
    [
        229,
        229,
        229
    ],
    [
        199,
        207,
        212
    ]
];
module.exports = ({ state: state, actions: actions, params: params = {} })=>$f88c0a2b1acf87aa$require$div(".sequencer", params, [
        $f88c0a2b1acf87aa$require$div(".header", [
            $f88c0a2b1acf87aa$require$h2([
                $f88c0a2b1acf87aa$require$i(".fa.fa-braille"),
                " Sequencer"
            ]),
            $f88c0a2b1acf87aa$require$label("LN"),
            $f88c0a2b1acf87aa$require$input(".bars-length", {
                props: {
                    value: state.sequencer.barsLength || 4,
                    size: 3
                },
                on: {
                    input: (ev)=>actions.sequencer.setBarsLength(ev.target.value)
                }
            }),
            $f88c0a2b1acf87aa$require$label("BAR"),
            $f88c0a2b1acf87aa$require$span(".cipher", [
                $f88c0a2b1acf87aa$require$button(".left.fa.fa-caret-left", {
                    on: {
                        click: ()=>actions.studio.prev()
                    }
                }),
                $f88c0a2b1acf87aa$require$input('.bar[type="number"]', {
                    props: {
                        value: state.studio.tick.bar,
                        size: 6
                    }
                }),
                $f88c0a2b1acf87aa$require$button(".right.fa.fa-caret-right", {
                    on: {
                        click: ()=>actions.studio.next()
                    }
                })
            ]),
            $f88c0a2b1acf87aa$require$div(".right", [
                state.sequencer.channel !== -1 ? $f88c0a2b1acf87aa$require$button(".fa.fa-minus", {
                    on: {
                        click: ()=>actions.sequencer.remove(state.sequencer.channel)
                    }
                }) : "",
                state.sequencer.channel !== -1 ? $f88c0a2b1acf87aa$require$button(".fa.fa-eraser", {
                    on: {
                        click: ()=>actions.sequencer.clear(state.sequencer.channel)
                    }
                }) : "",
                $f88c0a2b1acf87aa$require$button(".fa.fa-plus", {
                    on: {
                        click: ()=>actions.sequencer.add()
                    }
                })
            ])
        ]),
        $f88c0a2b1acf87aa$require$div(".body", [].concat(/*
		[div('.head', loop(state.studio.beatLength, c =>
			div('.cell', {
				class: {
					tick: (state.studio.tick.index === c)
				}
			})
		))],
		*/ $f88c0a2b1acf87aa$var$loop(state.sequencer.channels.length, (r)=>$f88c0a2b1acf87aa$require$div(`.row`, {
                style: {
                    minWidth: 142 + 22 * state.studio.beatLength + "px"
                }
            }, [].concat([
                $f88c0a2b1acf87aa$require$div(".channel", {
                    class: {
                        on: state.sequencer.channel === r
                    },
                    on: {
                        click: ()=>actions.sequencer.select(r),
                        dragover: (ev, o)=>(ev.preventDefault(), o.elm.style.borderStyle = "dashed"),
                        dragleave: (ev, o)=>(ev.preventDefault(), o.elm.style.borderStyle = "solid"),
                        dragend: (ev)=>ev.preventDefault()
                    }
                }, [
                    $f88c0a2b1acf87aa$require$span(state.mediaLibrary.files[state.sequencer.channels[r]] ? state.mediaLibrary.files[state.sequencer.channels[r]].replace(".ogg", "") : "")
                ])
            ], $f88c0a2b1acf87aa$var$loop(state.studio.beatLength, (c)=>$f88c0a2b1acf87aa$require$div(`.bar`, {
                    class: {
                        // on: (isOn(state.sequencer.pattern, state.studio.tick.bar, r, c) && state.studio.tick.index !== c),
                        tick: $f88c0a2b1acf87aa$var$isOn(state.sequencer.pattern, state.studio.tick.bar, r, c) && state.studio.tick.index === c
                    },
                    style: {
                        ...state.studio.tick.index !== c ? {
                            background: `rgb(
										${$f88c0a2b1acf87aa$var$cMap[c % 2][0] + ($f88c0a2b1acf87aa$var$cMap[2][0] - $f88c0a2b1acf87aa$var$cMap[c % 2][0]) * $f88c0a2b1acf87aa$var$velocity(state.sequencer.pattern, state.studio.tick.bar, r, c)},
										${$f88c0a2b1acf87aa$var$cMap[c % 2][1] + ($f88c0a2b1acf87aa$var$cMap[2][1] - $f88c0a2b1acf87aa$var$cMap[c % 2][1]) * $f88c0a2b1acf87aa$var$velocity(state.sequencer.pattern, state.studio.tick.bar, r, c)},
										${$f88c0a2b1acf87aa$var$cMap[c % 2][2] + ($f88c0a2b1acf87aa$var$cMap[2][2] - $f88c0a2b1acf87aa$var$cMap[c % 2][2]) * $f88c0a2b1acf87aa$var$velocity(state.sequencer.pattern, state.studio.tick.bar, r, c)}
									)`
                        } : {}
                    },
                    on: {
                        click: (ev)=>actions.sequencer.toggle(state.studio.tick.bar, r, c),
                        wheel: (ev)=>(ev.preventDefault(), actions.sequencer.update(state.studio.tick.bar, r, c, state.sequencer.pattern[state.studio.tick.bar][r][c] - ev.deltaY / 200))
                    }
                })))))))
    ]);

});

parcelRegister("b7zo8", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $8mEVn = parcelRequire("8mEVn");
var $818bcc866cdeb1d6$require$div = $2Z6Kw.div;
var $818bcc866cdeb1d6$require$h2 = $2Z6Kw.h2;
var $818bcc866cdeb1d6$require$span = $2Z6Kw.span;
var $818bcc866cdeb1d6$require$p = $2Z6Kw.p;
var $818bcc866cdeb1d6$require$input = $2Z6Kw.input;
var $818bcc866cdeb1d6$require$fieldset = $2Z6Kw.fieldset;
var $818bcc866cdeb1d6$require$legend = $2Z6Kw.legend;
var $818bcc866cdeb1d6$require$label = $2Z6Kw.label;
var $818bcc866cdeb1d6$require$hr = $2Z6Kw.hr;
var $818bcc866cdeb1d6$require$button = $2Z6Kw.button;
var $818bcc866cdeb1d6$require$i = $2Z6Kw.i;
var $818bcc866cdeb1d6$require$ul = $2Z6Kw.ul;
var $818bcc866cdeb1d6$require$li = $2Z6Kw.li;
var $818bcc866cdeb1d6$require$table = $2Z6Kw.table;
var $818bcc866cdeb1d6$require$thead = $2Z6Kw.thead;
var $818bcc866cdeb1d6$require$tbody = $2Z6Kw.tbody;
var $818bcc866cdeb1d6$require$tr = $2Z6Kw.tr;
var $818bcc866cdeb1d6$require$td = $2Z6Kw.td;
var $818bcc866cdeb1d6$require$th = $2Z6Kw.th;
var $818bcc866cdeb1d6$require$h = $8mEVn.h;
var $818bcc866cdeb1d6$require$img = $2Z6Kw.img;
var $818bcc866cdeb1d6$require$select = $2Z6Kw.select;
var $818bcc866cdeb1d6$require$option = $2Z6Kw.option;
var $818bcc866cdeb1d6$require$br = $2Z6Kw.br;

var $h5Z1H = parcelRequire("h5Z1H");

var $6TsbL = parcelRequire("6TsbL");
const $818bcc866cdeb1d6$var$openDialog = (cb)=>{
    let fileEl = document.createElement("input");
    fileEl.setAttribute("type", "file");
    fileEl.addEventListener("change", (ev)=>{
        console.log(ev.target.files, module.exports);
        cb(ev.target.files);
    });
    fileEl.dispatchEvent(new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: true
    }));
};
const $818bcc866cdeb1d6$var$actionMaps = [];
const $818bcc866cdeb1d6$var$optionList = (list, value, cb)=>$818bcc866cdeb1d6$require$select({
        on: {
            change: (ev)=>cb(ev)
        }
    }, list.map((item)=>$818bcc866cdeb1d6$require$option({
            attrs: {
                value: item
            },
            props: {
                selected: item === value
            }
        }, item)));
module.exports = ({ state: state, actions: actions, params: params = {} })=>$818bcc866cdeb1d6$require$div(".midi-map", params, [
        $818bcc866cdeb1d6$require$div(".header", [
            $818bcc866cdeb1d6$require$h2([
                $818bcc866cdeb1d6$require$img('[src="assets/midi.svg"]'),
                $818bcc866cdeb1d6$require$span("MIDI Map")
            ])
        ]),
        $818bcc866cdeb1d6$require$div(".body", [].concat($818bcc866cdeb1d6$require$fieldset([
            $818bcc866cdeb1d6$require$legend("MIDI Devices"),
            $818bcc866cdeb1d6$require$div(".devices", [
                $818bcc866cdeb1d6$require$h("dl", [
                    $818bcc866cdeb1d6$require$h("dt", "Inputs"),
                    $818bcc866cdeb1d6$require$h("dd", $818bcc866cdeb1d6$require$ul(state.midiMap.devices.inputs.map((inp, index)=>$818bcc866cdeb1d6$require$li([
                            inp.name,
                            $818bcc866cdeb1d6$require$span(".right.fa.fa-code-fork"),
                            $818bcc866cdeb1d6$require$input('.right[type="checkbox"]', {
                                props: {
                                    checked: state.midiMap.data.in.indexOf(index) > -1
                                },
                                on: {
                                    click: ()=>actions.midiMap.toggleData("in", index)
                                }
                            }),
                            $818bcc866cdeb1d6$require$span(".right.fa.fa-clock-o"),
                            $818bcc866cdeb1d6$require$input('.right[type="checkbox"]', {
                                props: {
                                    checked: state.midiMap.clock.in.indexOf(index) > -1
                                },
                                on: {
                                    click: ()=>actions.midiMap.toggleClock("in", index)
                                }
                            })
                        ]))))
                ]),
                $818bcc866cdeb1d6$require$h("dl", [
                    $818bcc866cdeb1d6$require$h("dt", "Outputs"),
                    $818bcc866cdeb1d6$require$h("dd", $818bcc866cdeb1d6$require$ul(state.midiMap.devices.outputs.map((outp, index)=>$818bcc866cdeb1d6$require$li([
                            outp.name,
                            $818bcc866cdeb1d6$require$span(".right.fa.fa-code-fork"),
                            $818bcc866cdeb1d6$require$input('.right[type="checkbox"]', {
                                props: {
                                    checked: state.midiMap.data.out.indexOf(index) > -1
                                },
                                on: {
                                    click: ()=>actions.midiMap.toggleData("out", index)
                                }
                            }),
                            $818bcc866cdeb1d6$require$span(".right.fa.fa-clock-o"),
                            $818bcc866cdeb1d6$require$input('.right[type="checkbox"]', {
                                props: {
                                    checked: state.midiMap.clock.out.indexOf(index) > -1
                                },
                                on: {
                                    click: ()=>actions.midiMap.toggleClock("out", index)
                                }
                            })
                        ]))))
                ]),
                $818bcc866cdeb1d6$require$h("dl", [
                    $818bcc866cdeb1d6$require$h("dt", "Settings"),
                    $818bcc866cdeb1d6$require$h("dd", $818bcc866cdeb1d6$require$ul([
                        $818bcc866cdeb1d6$require$li([
                            "Route midi input data to active tracks",
                            $818bcc866cdeb1d6$require$input('.right[type="checkbox"]', {
                                props: {
                                    checked: state.midiMap.settings.midiRouteToActive
                                },
                                on: {
                                    click: ()=>actions.toggle([
                                            "midiMap",
                                            "settings",
                                            "midiRouteToActive"
                                        ])
                                }
                            })
                        ])
                    ]))
                ])
            ])
        ]), $818bcc866cdeb1d6$require$fieldset([
            $818bcc866cdeb1d6$require$legend("Map"),
            $818bcc866cdeb1d6$require$button({
                on: {
                    click: (ev)=>$6TsbL.save($h5Z1H().format("YYYY-MM-DD-hh-mm[-midiMap.json]"), state.midiMap.map)
                }
            }, "Save Map"),
            $818bcc866cdeb1d6$require$button({
                on: {
                    click: (ev)=>$818bcc866cdeb1d6$var$openDialog((files)=>$6TsbL.load(files[0], "json").subscribe((content)=>actions.set([
                                    "midiMap",
                                    "map"
                                ], content)))
                }
            }, "Load Map"),
            $818bcc866cdeb1d6$require$table([
                $818bcc866cdeb1d6$require$thead($818bcc866cdeb1d6$require$tr([
                    $818bcc866cdeb1d6$require$th("status"),
                    $818bcc866cdeb1d6$require$th("key"),
                    $818bcc866cdeb1d6$require$th("section"),
                    $818bcc866cdeb1d6$require$th("prop"),
                    $818bcc866cdeb1d6$require$th("min"),
                    $818bcc866cdeb1d6$require$th("max"),
                    $818bcc866cdeb1d6$require$th("dg")
                ])),
                $818bcc866cdeb1d6$require$tbody(state.midiMap.map.map((mapping, index)=>$818bcc866cdeb1d6$require$tr([
                        // status
                        $818bcc866cdeb1d6$require$td(mapping[0]),
                        // key
                        $818bcc866cdeb1d6$require$td($818bcc866cdeb1d6$require$input(`[type=number][value=${mapping[1]}][size=3]`, {
                            on: {
                                change: (ev)=>actions.midiMap.modify([
                                        index,
                                        1
                                    ], ev.target.value)
                            },
                            style: {
                                width: "38px"
                            }
                        })),
                        // section
                        $818bcc866cdeb1d6$require$td($818bcc866cdeb1d6$var$optionList([
                            "instrument",
                            "studio"
                        ], mapping[2][0], (ev)=>actions.midiMap.modify([
                                index,
                                2,
                                0
                            ], ev.target.value))),
                        // prop
                        $818bcc866cdeb1d6$require$td($818bcc866cdeb1d6$require$input(`[type=text][value=${mapping[2].slice(1).join(", ")}]`, {
                            on: {
                                change: (ev)=>actions.midiMap.modify([
                                        index,
                                        2
                                    ], [].concat(mapping[2][0], ev.target.value.split(", ")))
                            },
                            style: {
                            }
                        })),
                        // min
                        $818bcc866cdeb1d6$require$td($818bcc866cdeb1d6$require$input(`[type=number][value=${mapping[3] || 0}][size=3]`, {
                            on: {
                                change: (ev)=>actions.midiMap.modify([
                                        index,
                                        3
                                    ], ev.target.value)
                            },
                            style: {
                                width: "38px"
                            }
                        })),
                        // max
                        $818bcc866cdeb1d6$require$td($818bcc866cdeb1d6$require$input(`[type=number][value=${mapping[4] || 1}][size=3]`, {
                            on: {
                                change: (ev)=>actions.midiMap.modify([
                                        index,
                                        4
                                    ], ev.target.value)
                            },
                            style: {
                                width: "38px"
                            }
                        })),
                        // digits
                        $818bcc866cdeb1d6$require$td(mapping[5])
                    ])))
            ])
        ]), $818bcc866cdeb1d6$require$div([].concat($818bcc866cdeb1d6$require$br(), $818bcc866cdeb1d6$require$div(".header", [
            $818bcc866cdeb1d6$require$h2([
                $818bcc866cdeb1d6$require$i(".fa.fa-hand-lizard-o"),
                " Myo Armband"
            ]),
            $818bcc866cdeb1d6$require$button(".fa", {
                class: {
                    "on": state.myo.on,
                    "fa-link": state.myo.on,
                    "fa-unlink": !state.myo.on
                },
                on: {
                    click: ()=>actions.toggle([
                            "myo",
                            "on"
                        ])
                }
            }),
            $818bcc866cdeb1d6$require$button(".fa.fa-arrows-v", {
                class: {
                    on: state.myo.reverse
                },
                on: {
                    click: ()=>actions.toggle([
                            "myo",
                            "reverse"
                        ])
                }
            })
        ]), state.myo.on ? $818bcc866cdeb1d6$require$table([
            $818bcc866cdeb1d6$require$thead([
                $818bcc866cdeb1d6$require$th('[width="30%"]', "data"),
                $818bcc866cdeb1d6$require$th('[width="17%"]', "x"),
                $818bcc866cdeb1d6$require$th('[width="17%"]', "y"),
                $818bcc866cdeb1d6$require$th('[width="17%"]', "z"),
                $818bcc866cdeb1d6$require$th('[width="17%"]', "w")
            ]),
            $818bcc866cdeb1d6$require$tbody([
                $818bcc866cdeb1d6$require$tr([
                    $818bcc866cdeb1d6$require$td("accelerometer"),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.accelerometer && state.myo.osc.accelerometer[0].toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.accelerometer && state.myo.osc.accelerometer[1].toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.accelerometer && state.myo.osc.accelerometer[2].toFixed(2)),
                    $818bcc866cdeb1d6$require$td()
                ]),
                $818bcc866cdeb1d6$require$tr([
                    $818bcc866cdeb1d6$require$td("gyroscope"),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.gyroscope && state.myo.osc.gyroscope[0].toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.gyroscope && state.myo.osc.gyroscope[1].toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.gyroscope && state.myo.osc.gyroscope[2].toFixed(2)),
                    $818bcc866cdeb1d6$require$td()
                ]),
                $818bcc866cdeb1d6$require$tr([
                    $818bcc866cdeb1d6$require$td("orientation"),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.orientation && state.myo.osc.orientation.x.toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.orientation && state.myo.osc.orientation.y.toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.orientation && state.myo.osc.orientation.z.toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.myo.osc.orientation && state.myo.osc.orientation.w.toFixed(2))
                ])
            ])
        ]) : [])), $818bcc866cdeb1d6$require$div([].concat($818bcc866cdeb1d6$require$br(), $818bcc866cdeb1d6$require$div(".header", [].concat($818bcc866cdeb1d6$require$h2([
            $818bcc866cdeb1d6$require$i(".fa.fa-globe"),
            " WRLDS Ball"
        ]), $818bcc866cdeb1d6$require$button(".fa", {
            class: {
                "on": state.wrlds.on,
                "fa-link": state.wrlds.on,
                "fa-unlink": !state.wrlds.on
            },
            on: {
                click: ()=>actions.toggle([
                        "wrlds",
                        "on"
                    ])
            }
        }), // label('PORT'),
        // input(`[type=number]`, {
        // 	on: {
        // 		change: ev => actions.set(['wrlds', 'port'], ev.target.value)
        // 	},
        // 	props: {
        // 		value: state.wrlds.port
        // 	}
        // }),
        $818bcc866cdeb1d6$require$label("Mode"), $818bcc866cdeb1d6$require$button(".fa.fa-clock-o", {
            class: {
                on: state.wrlds.mode === 0
            },
            on: {
                click: ()=>actions.set([
                        "wrlds",
                        "mode"
                    ], 0)
            }
        }), $818bcc866cdeb1d6$require$button(".fa.fa-gavel", {
            class: {
                on: state.wrlds.mode === 1
            },
            on: {
                click: ()=>actions.set([
                        "wrlds",
                        "mode"
                    ], 1)
            }
        }), $818bcc866cdeb1d6$require$button(".fa.fa-dashboard", {
            class: {
                on: state.wrlds.mode === 2
            },
            on: {
                click: ()=>actions.set([
                        "wrlds",
                        "mode"
                    ], 2)
            }
        }), state.wrlds.mode === 1 ? [
            $818bcc866cdeb1d6$require$label("Threshold"),
            $818bcc866cdeb1d6$require$input(`[type=number]`, {
                on: {
                    change: (ev)=>actions.set([
                            "wrlds",
                            "threshold"
                        ], ev.target.value)
                },
                props: {
                    value: state.wrlds.threshold
                }
            })
        ] : [])), state.wrlds.on && state.wrlds.mode === 2 ? $818bcc866cdeb1d6$require$table([
            $818bcc866cdeb1d6$require$thead([
                $818bcc866cdeb1d6$require$th('[width="40%"]', "data"),
                $818bcc866cdeb1d6$require$th('[width="20%"]', "x"),
                $818bcc866cdeb1d6$require$th('[width="20%"]', "y"),
                $818bcc866cdeb1d6$require$th('[width="20%"]', "z")
            ]),
            $818bcc866cdeb1d6$require$tbody([
                $818bcc866cdeb1d6$require$tr([
                    $818bcc866cdeb1d6$require$td("rotation"),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.wrlds.rotation.length > 0 && state.wrlds.rotation[0].toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.wrlds.rotation.length > 0 && state.wrlds.rotation[1].toFixed(2)),
                    $818bcc866cdeb1d6$require$td("[align=right]", state.wrlds.rotation.length > 0 && state.wrlds.rotation[2].toFixed(2)),
                    $818bcc866cdeb1d6$require$td()
                ])
            ])
        ]) : []))))
    ]);

});

parcelRegister("a0RSb", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $74a3b180602bf04b$require$div = $2Z6Kw.div;
var $74a3b180602bf04b$require$h2 = $2Z6Kw.h2;
var $74a3b180602bf04b$require$span = $2Z6Kw.span;
var $74a3b180602bf04b$require$p = $2Z6Kw.p;
var $74a3b180602bf04b$require$input = $2Z6Kw.input;
var $74a3b180602bf04b$require$fieldset = $2Z6Kw.fieldset;
var $74a3b180602bf04b$require$legend = $2Z6Kw.legend;
var $74a3b180602bf04b$require$label = $2Z6Kw.label;
var $74a3b180602bf04b$require$hr = $2Z6Kw.hr;
var $74a3b180602bf04b$require$button = $2Z6Kw.button;
var $74a3b180602bf04b$require$i = $2Z6Kw.i;
var $74a3b180602bf04b$require$img = $2Z6Kw.img;

var $jjnZg = parcelRequire("jjnZg");
var $74a3b180602bf04b$require$fn = $jjnZg.fn;
const $74a3b180602bf04b$var$notes = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
const $74a3b180602bf04b$var$iterate = (value, step, max)=>[].concat([
        value
    ], value + step <= max ? $74a3b180602bf04b$var$iterate(value + step, step, max) : []);
const $74a3b180602bf04b$var$parseKey = (key)=>({
        key: key,
        octave: parseInt(key.slice(key.length - 1), 10),
        note: key.slice(0, key.length - 1),
        isSharp: key.indexOf("#") > 0,
        isFlat: key.indexOf("b") > 0
    });
const $74a3b180602bf04b$var$generateKeys = (start, end)=>[
        {
            start: $74a3b180602bf04b$var$parseKey(start),
            end: $74a3b180602bf04b$var$parseKey(end)
        }
    ].map(({ start: start, end: end })=>$74a3b180602bf04b$var$iterate(start.octave, 1, end.octave).map((octave)=>(octave === start.octave && $74a3b180602bf04b$var$iterate($74a3b180602bf04b$var$notes.indexOf(start.note), 1, $74a3b180602bf04b$var$notes.length - 1) || octave === end.octave && $74a3b180602bf04b$var$iterate(0, 1, $74a3b180602bf04b$var$notes.indexOf(end.note)) || $74a3b180602bf04b$var$notes.map((note, i)=>i)).map((i)=>$74a3b180602bf04b$var$notes[i] + octave))).pop().reduce((a1, a2)=>a1.concat(a2), []);
// console.log(generateKeys('C1', 'C3'));
module.exports = ({ state: state, actions: actions, params: params = {} })=>$74a3b180602bf04b$require$div(".midi-keyboard", params, [
        $74a3b180602bf04b$require$div(".header", []),
        $74a3b180602bf04b$require$div(".body", [
            $74a3b180602bf04b$require$div(".keys", {
                on: {
                }
            }, $74a3b180602bf04b$require$fn.pipe(()=>$74a3b180602bf04b$var$generateKeys("C2", "C6").map($74a3b180602bf04b$var$parseKey), (allKeys)=>({
                    allKeys: allKeys,
                    whiteKeysLength: allKeys.filter((key)=>!key.isSharp && !key.isFlat).length
                }), ({ allKeys: allKeys, whiteKeysLength: whiteKeysLength })=>allKeys.map((key, index)=>$74a3b180602bf04b$require$div(key.isSharp || key.isFlat ? ".black" : ".white", {
                        style: !(key.isSharp || key.isFlat) ? {
                            width: 99.9 / whiteKeysLength + "%",
                            marginLeft: index > 0 && allKeys[index - 1] && (allKeys[index - 1].isSharp || allKeys[index - 1].isBlack) ? -(70 / whiteKeysLength / 2) + "%" : 0
                        } : {
                            width: 70 / whiteKeysLength + "%",
                            marginLeft: -(70 / whiteKeysLength / 2) + "%"
                        },
                        on: {
                            pointerdown: (e)=>(actions.midiMap.noteOn(-1, 1, key.key, 0.7), e.target.releasePointerCapture(e.pointerId)),
                            pointerup: (e)=>(actions.midiMap.noteOn(-1, 1, key.key, 0), e.target.releasePointerCapture(e.pointerId)),
                            pointerenter: (ev)=>ev.buttons === 1 && actions.midiMap.noteOn(-1, 1, key.key, 0.7),
                            pointerleave: (ev)=>ev.buttons === 1 && actions.midiMap.noteOn(-1, 1, key.key, 0)
                        },
                        class: {
                            on: Object.keys(state.midiMap.channels).reduce((pressed, ch)=>Object.assign({}, pressed, state.midiMap.channels[ch]), {})[key.key]
                        }
                    }, key.note === "C" ? [
                        $74a3b180602bf04b$require$span(key.key)
                    ] : [])))())
        ])
    ]);

});

parcelRegister("26ETC", function(module, exports) {
"use strict";

var $2Z6Kw = parcelRequire("2Z6Kw");
var $8mEVn = parcelRequire("8mEVn");
var $188bdd6696e52af6$require$div = $2Z6Kw.div;
var $188bdd6696e52af6$require$h2 = $2Z6Kw.h2;
var $188bdd6696e52af6$require$span = $2Z6Kw.span;
var $188bdd6696e52af6$require$p = $2Z6Kw.p;
var $188bdd6696e52af6$require$input = $2Z6Kw.input;
var $188bdd6696e52af6$require$fieldset = $2Z6Kw.fieldset;
var $188bdd6696e52af6$require$legend = $2Z6Kw.legend;
var $188bdd6696e52af6$require$label = $2Z6Kw.label;
var $188bdd6696e52af6$require$hr = $2Z6Kw.hr;
var $188bdd6696e52af6$require$button = $2Z6Kw.button;
var $188bdd6696e52af6$require$i = $2Z6Kw.i;
var $188bdd6696e52af6$require$ul = $2Z6Kw.ul;
var $188bdd6696e52af6$require$li = $2Z6Kw.li;
var $188bdd6696e52af6$require$table = $2Z6Kw.table;
var $188bdd6696e52af6$require$thead = $2Z6Kw.thead;
var $188bdd6696e52af6$require$tbody = $2Z6Kw.tbody;
var $188bdd6696e52af6$require$tr = $2Z6Kw.tr;
var $188bdd6696e52af6$require$td = $2Z6Kw.td;
var $188bdd6696e52af6$require$th = $2Z6Kw.th;
var $188bdd6696e52af6$require$h = $8mEVn.h;
var $188bdd6696e52af6$require$canvas = $2Z6Kw.canvas;
var $188bdd6696e52af6$require$img = $2Z6Kw.img;
parcelRequire("50gi8");
var $aaOE9 = parcelRequire("aaOE9");
var $188bdd6696e52af6$require$cursor = $aaOE9;
const { iconCodeToDataURL: $188bdd6696e52af6$var$iconCodeToDataURL } = $188bdd6696e52af6$require$cursor;
const $188bdd6696e52af6$var$actionMaps = [];
const $188bdd6696e52af6$var$editTools = [
    {
        name: "pointer",
        icon: "mouse-pointer",
        cursor: "\uF245",
        hotspot: "6 3"
    },
    {
        name: "pencil",
        icon: "pencil",
        cursor: "\uF040",
        hotspot: "5 20"
    },
    {
        name: "eraser",
        icon: "eraser",
        cursor: "\uF12D",
        hotspot: "5 17"
    }
];
console.log($188bdd6696e52af6$var$editTools);
module.exports = ({ state: state, actions: actions, params: params = {} })=>$188bdd6696e52af6$require$div(".piano-roll", params, [
        $188bdd6696e52af6$require$div(".header", [
            $188bdd6696e52af6$require$h2([
                $188bdd6696e52af6$require$img('[src="assets/piano-roll.svg"]'),
                $188bdd6696e52af6$require$span("Piano Roll")
            ]),
            $188bdd6696e52af6$require$label("LN"),
            $188bdd6696e52af6$require$input(".bars-length", {
                props: {
                    value: state.pianoRoll.barsLength || 4,
                    size: 3
                },
                on: {
                    input: (ev)=>actions.set([
                            "pianoRoll",
                            "barsLength"
                        ], ev.target.value)
                }
            }),
            $188bdd6696e52af6$require$label("BAR"),
            $188bdd6696e52af6$require$span(".cipher", [
                $188bdd6696e52af6$require$button(".left.fa.fa-caret-left", {
                    on: {
                        click: ()=>actions.pianoRoll.prev()
                    }
                }),
                $188bdd6696e52af6$require$input('.bar[type="number"]', {
                    props: {
                        value: state.studio.tick.tracks[state.session.selection.piano[0]] && state.studio.tick.tracks[state.session.selection.piano[0]].bar || 0,
                        size: 6
                    }
                }),
                $188bdd6696e52af6$require$button(".right.fa.fa-caret-right", {
                    on: {
                        click: ()=>actions.pianoRoll.next()
                    }
                })
            ]),
            $188bdd6696e52af6$require$div(".edit-tools", $188bdd6696e52af6$var$editTools.map((tool)=>$188bdd6696e52af6$require$button(`.fa.fa-${tool.icon}`, {
                    class: {
                        selected: state.pianoRoll.tool === tool.name
                    },
                    on: {
                        click: ()=>actions.set([
                                "pianoRoll",
                                "tool"
                            ], tool.name)
                    }
                }))),
            $188bdd6696e52af6$require$div(".right", [
                $188bdd6696e52af6$require$button(".fa.fa-close", {
                    on: {
                        click: ()=>actions.pianoRoll.clear()
                    }
                })
            ])
        ]),
        $188bdd6696e52af6$require$div(".body", [
            $188bdd6696e52af6$require$canvas(".grid"),
            $188bdd6696e52af6$require$canvas(".events"),
            $188bdd6696e52af6$require$canvas(".selection"),
            $188bdd6696e52af6$require$canvas(".interaction", {
                style: {
                    cursor: $188bdd6696e52af6$var$editTools.filter((t)=>t.name === state.pianoRoll.tool).map((tool)=>`url(${$188bdd6696e52af6$var$iconCodeToDataURL(tool.cursor)}) ${tool.hotspot}, auto`).pop()
                },
                on: {
                    pointerdown: (ev)=>(console.log("pointerdown", ev), actions.pianoRoll.pointerDown({
                            x: ev.offsetX,
                            y: ev.offsetY
                        })),
                    pointermove: (ev)=>// console.log('pointermove', ev),
                        actions.pianoRoll.pointerMove({
                            x: ev.offsetX,
                            y: ev.offsetY
                        }),
                    pointerup: (ev)=>(console.log("pointerup", ev), actions.pianoRoll.pointerUp({
                            x: ev.offsetX,
                            y: ev.offsetY
                        })),
                    mousewheel: (ev)=>((newPos)=>newPos <= 108 && newPos - parseInt(ev.target.offsetHeight / 12, 10) > 21 ? actions.set([
                                "pianoRoll",
                                "position"
                            ], [
                                state.pianoRoll.position && state.pianoRoll.position[0] || 0,
                                newPos
                            ]) : true)((state.pianoRoll.position && state.pianoRoll.position[1] || 60) + Math.ceil(Math.abs(ev.deltaY / 60)) * (ev.deltaY > 0 ? -1 : 1))
                }
            })
        ])
    ]);

});


parcelRegister("2QuXx", function(module, exports) {

$parcel$export(module.exports, "audit", () => (parcelRequire("a2bcr")).audit);
$parcel$export(module.exports, "auditTime", () => (parcelRequire("1XCf8")).auditTime);
$parcel$export(module.exports, "buffer", () => (parcelRequire("9oKSE")).buffer);
$parcel$export(module.exports, "bufferCount", () => (parcelRequire("fWkHO")).bufferCount);
$parcel$export(module.exports, "bufferTime", () => (parcelRequire("1FLF6")).bufferTime);
$parcel$export(module.exports, "bufferToggle", () => (parcelRequire("4ozPv")).bufferToggle);
$parcel$export(module.exports, "bufferWhen", () => (parcelRequire("fFGEO")).bufferWhen);
$parcel$export(module.exports, "catchError", () => (parcelRequire("g6ewV")).catchError);
$parcel$export(module.exports, "combineAll", () => (parcelRequire("2F9NG")).combineAll);
$parcel$export(module.exports, "combineLatestAll", () => (parcelRequire("6IrYh")).combineLatestAll);
$parcel$export(module.exports, "combineLatest", () => (parcelRequire("a8hWu")).combineLatest);
$parcel$export(module.exports, "combineLatestWith", () => (parcelRequire("cipNe")).combineLatestWith);
$parcel$export(module.exports, "concat", () => (parcelRequire("hs6fE")).concat);
$parcel$export(module.exports, "concatAll", () => (parcelRequire("aFT1q")).concatAll);
$parcel$export(module.exports, "concatMap", () => (parcelRequire("j7Eel")).concatMap);
$parcel$export(module.exports, "concatMapTo", () => (parcelRequire("bFAOq")).concatMapTo);
$parcel$export(module.exports, "concatWith", () => (parcelRequire("gv2NG")).concatWith);
$parcel$export(module.exports, "connect", () => (parcelRequire("1ySFG")).connect);
$parcel$export(module.exports, "count", () => (parcelRequire("7EEKf")).count);
$parcel$export(module.exports, "debounce", () => (parcelRequire("lclmq")).debounce);
$parcel$export(module.exports, "debounceTime", () => (parcelRequire("j1Rp6")).debounceTime);
$parcel$export(module.exports, "defaultIfEmpty", () => (parcelRequire("eDEok")).defaultIfEmpty);
$parcel$export(module.exports, "delay", () => (parcelRequire("diDND")).delay);
$parcel$export(module.exports, "delayWhen", () => (parcelRequire("aggvL")).delayWhen);
$parcel$export(module.exports, "dematerialize", () => (parcelRequire("e69lr")).dematerialize);
$parcel$export(module.exports, "distinct", () => (parcelRequire("W85MW")).distinct);
$parcel$export(module.exports, "distinctUntilChanged", () => (parcelRequire("glUu6")).distinctUntilChanged);
$parcel$export(module.exports, "distinctUntilKeyChanged", () => (parcelRequire("7nozN")).distinctUntilKeyChanged);
$parcel$export(module.exports, "elementAt", () => (parcelRequire("bpoVl")).elementAt);
$parcel$export(module.exports, "endWith", () => (parcelRequire("flSlr")).endWith);
$parcel$export(module.exports, "every", () => (parcelRequire("9p7Bs")).every);
$parcel$export(module.exports, "exhaust", () => (parcelRequire("9yVEh")).exhaust);
$parcel$export(module.exports, "exhaustAll", () => (parcelRequire("8Ht33")).exhaustAll);
$parcel$export(module.exports, "exhaustMap", () => (parcelRequire("7UKKo")).exhaustMap);
$parcel$export(module.exports, "expand", () => (parcelRequire("2VGhV")).expand);
$parcel$export(module.exports, "filter", () => (parcelRequire("lm9of")).filter);
$parcel$export(module.exports, "finalize", () => (parcelRequire("2K4Zz")).finalize);
$parcel$export(module.exports, "find", () => (parcelRequire("id94h")).find);
$parcel$export(module.exports, "findIndex", () => (parcelRequire("kaH4y")).findIndex);
$parcel$export(module.exports, "first", () => (parcelRequire("lt8Rs")).first);
$parcel$export(module.exports, "groupBy", () => (parcelRequire("4IAbc")).groupBy);
$parcel$export(module.exports, "ignoreElements", () => (parcelRequire("6fLz3")).ignoreElements);
$parcel$export(module.exports, "isEmpty", () => (parcelRequire("1mxST")).isEmpty);
$parcel$export(module.exports, "last", () => (parcelRequire("l50cW")).last);
$parcel$export(module.exports, "map", () => (parcelRequire("6SBin")).map);
$parcel$export(module.exports, "mapTo", () => (parcelRequire("dCpCY")).mapTo);
$parcel$export(module.exports, "materialize", () => (parcelRequire("lI8Dq")).materialize);
$parcel$export(module.exports, "max", () => (parcelRequire("jF93r")).max);
$parcel$export(module.exports, "merge", () => (parcelRequire("bVpqG")).merge);
$parcel$export(module.exports, "mergeAll", () => (parcelRequire("8wGrm")).mergeAll);
$parcel$export(module.exports, "flatMap", () => (parcelRequire("bzRF9")).flatMap);
$parcel$export(module.exports, "mergeMap", () => (parcelRequire("drQX9")).mergeMap);
$parcel$export(module.exports, "mergeMapTo", () => (parcelRequire("jZNPZ")).mergeMapTo);
$parcel$export(module.exports, "mergeScan", () => (parcelRequire("lymto")).mergeScan);
$parcel$export(module.exports, "mergeWith", () => (parcelRequire("dDUd7")).mergeWith);
$parcel$export(module.exports, "min", () => (parcelRequire("aDIbX")).min);
$parcel$export(module.exports, "multicast", () => (parcelRequire("ia54s")).multicast);
$parcel$export(module.exports, "observeOn", () => (parcelRequire("jsLpm")).observeOn);
$parcel$export(module.exports, "onErrorResumeNext", () => (parcelRequire("bwfZT")).onErrorResumeNext);
$parcel$export(module.exports, "pairwise", () => (parcelRequire("h1PLz")).pairwise);
$parcel$export(module.exports, "partition", () => (parcelRequire("7sbuv")).partition);
$parcel$export(module.exports, "pluck", () => (parcelRequire("crvTw")).pluck);
$parcel$export(module.exports, "publish", () => (parcelRequire("70Tlj")).publish);
$parcel$export(module.exports, "publishBehavior", () => (parcelRequire("lTzb1")).publishBehavior);
$parcel$export(module.exports, "publishLast", () => (parcelRequire("lbgCD")).publishLast);
$parcel$export(module.exports, "publishReplay", () => (parcelRequire("6yvuu")).publishReplay);
$parcel$export(module.exports, "race", () => (parcelRequire("cHPPF")).race);
$parcel$export(module.exports, "raceWith", () => (parcelRequire("it41X")).raceWith);
$parcel$export(module.exports, "reduce", () => (parcelRequire("euDQb")).reduce);
$parcel$export(module.exports, "repeat", () => (parcelRequire("h7rR7")).repeat);
$parcel$export(module.exports, "repeatWhen", () => (parcelRequire("6edRj")).repeatWhen);
$parcel$export(module.exports, "retry", () => (parcelRequire("3acBG")).retry);
$parcel$export(module.exports, "retryWhen", () => (parcelRequire("9kWsS")).retryWhen);
$parcel$export(module.exports, "refCount", () => (parcelRequire("b9Ccj")).refCount);
$parcel$export(module.exports, "sample", () => (parcelRequire("1JDly")).sample);
$parcel$export(module.exports, "sampleTime", () => (parcelRequire("c1HaV")).sampleTime);
$parcel$export(module.exports, "scan", () => (parcelRequire("f6wSa")).scan);
$parcel$export(module.exports, "sequenceEqual", () => (parcelRequire("kSt33")).sequenceEqual);
$parcel$export(module.exports, "share", () => (parcelRequire("hYBh9")).share);
$parcel$export(module.exports, "shareReplay", () => (parcelRequire("kYhhM")).shareReplay);
$parcel$export(module.exports, "single", () => (parcelRequire("QSmkc")).single);
$parcel$export(module.exports, "skip", () => (parcelRequire("cJyg4")).skip);
$parcel$export(module.exports, "skipLast", () => (parcelRequire("9c6vL")).skipLast);
$parcel$export(module.exports, "skipUntil", () => (parcelRequire("9haIg")).skipUntil);
$parcel$export(module.exports, "skipWhile", () => (parcelRequire("4Nriv")).skipWhile);
$parcel$export(module.exports, "startWith", () => (parcelRequire("aRUkQ")).startWith);
$parcel$export(module.exports, "subscribeOn", () => (parcelRequire("hOWB1")).subscribeOn);
$parcel$export(module.exports, "switchAll", () => (parcelRequire("hXjgq")).switchAll);
$parcel$export(module.exports, "switchMap", () => (parcelRequire("cXeQx")).switchMap);
$parcel$export(module.exports, "switchMapTo", () => (parcelRequire("jNhqV")).switchMapTo);
$parcel$export(module.exports, "switchScan", () => (parcelRequire("7MD3G")).switchScan);
$parcel$export(module.exports, "take", () => (parcelRequire("fFMKM")).take);
$parcel$export(module.exports, "takeLast", () => (parcelRequire("8G22J")).takeLast);
$parcel$export(module.exports, "takeUntil", () => (parcelRequire("5w0HR")).takeUntil);
$parcel$export(module.exports, "takeWhile", () => (parcelRequire("8zrSn")).takeWhile);
$parcel$export(module.exports, "tap", () => (parcelRequire("faIkE")).tap);
$parcel$export(module.exports, "throttle", () => (parcelRequire("cjNL8")).throttle);
$parcel$export(module.exports, "throttleTime", () => (parcelRequire("5UZMn")).throttleTime);
$parcel$export(module.exports, "throwIfEmpty", () => (parcelRequire("cpVrn")).throwIfEmpty);
$parcel$export(module.exports, "timeInterval", () => (parcelRequire("c121k")).timeInterval);
$parcel$export(module.exports, "timeout", () => (parcelRequire("30yBm")).timeout);
$parcel$export(module.exports, "timeoutWith", () => (parcelRequire("1s1wu")).timeoutWith);
$parcel$export(module.exports, "timestamp", () => (parcelRequire("1RNh6")).timestamp);
$parcel$export(module.exports, "toArray", () => (parcelRequire("dO6uG")).toArray);
$parcel$export(module.exports, "window", () => (parcelRequire("1MIIZ")).window);
$parcel$export(module.exports, "windowCount", () => (parcelRequire("3VCv5")).windowCount);
$parcel$export(module.exports, "windowTime", () => (parcelRequire("8tBYU")).windowTime);
$parcel$export(module.exports, "windowToggle", () => (parcelRequire("bccpe")).windowToggle);
$parcel$export(module.exports, "windowWhen", () => (parcelRequire("2yc02")).windowWhen);
$parcel$export(module.exports, "withLatestFrom", () => (parcelRequire("9Jxex")).withLatestFrom);
$parcel$export(module.exports, "zip", () => (parcelRequire("bnKNM")).zip);
$parcel$export(module.exports, "zipAll", () => (parcelRequire("4B7Q6")).zipAll);
$parcel$export(module.exports, "zipWith", () => (parcelRequire("lXhld")).zipWith);

var $a2bcr = parcelRequire("a2bcr");

var $1XCf8 = parcelRequire("1XCf8");

var $9oKSE = parcelRequire("9oKSE");

var $fWkHO = parcelRequire("fWkHO");

var $1FLF6 = parcelRequire("1FLF6");

var $4ozPv = parcelRequire("4ozPv");

var $fFGEO = parcelRequire("fFGEO");

var $g6ewV = parcelRequire("g6ewV");

var $2F9NG = parcelRequire("2F9NG");

var $6IrYh = parcelRequire("6IrYh");

var $a8hWu = parcelRequire("a8hWu");

var $cipNe = parcelRequire("cipNe");

var $hs6fE = parcelRequire("hs6fE");

var $aFT1q = parcelRequire("aFT1q");

var $j7Eel = parcelRequire("j7Eel");

var $bFAOq = parcelRequire("bFAOq");

var $gv2NG = parcelRequire("gv2NG");

var $1ySFG = parcelRequire("1ySFG");

var $7EEKf = parcelRequire("7EEKf");

var $lclmq = parcelRequire("lclmq");

var $j1Rp6 = parcelRequire("j1Rp6");

var $eDEok = parcelRequire("eDEok");

var $diDND = parcelRequire("diDND");

var $aggvL = parcelRequire("aggvL");

var $e69lr = parcelRequire("e69lr");

var $W85MW = parcelRequire("W85MW");

var $glUu6 = parcelRequire("glUu6");

var $7nozN = parcelRequire("7nozN");

var $bpoVl = parcelRequire("bpoVl");

var $flSlr = parcelRequire("flSlr");

var $9p7Bs = parcelRequire("9p7Bs");

var $9yVEh = parcelRequire("9yVEh");

var $8Ht33 = parcelRequire("8Ht33");

var $7UKKo = parcelRequire("7UKKo");

var $2VGhV = parcelRequire("2VGhV");

var $lm9of = parcelRequire("lm9of");

var $2K4Zz = parcelRequire("2K4Zz");

var $id94h = parcelRequire("id94h");

var $kaH4y = parcelRequire("kaH4y");

var $lt8Rs = parcelRequire("lt8Rs");

var $4IAbc = parcelRequire("4IAbc");

var $6fLz3 = parcelRequire("6fLz3");

var $1mxST = parcelRequire("1mxST");

var $l50cW = parcelRequire("l50cW");

var $6SBin = parcelRequire("6SBin");

var $dCpCY = parcelRequire("dCpCY");

var $lI8Dq = parcelRequire("lI8Dq");

var $jF93r = parcelRequire("jF93r");

var $bVpqG = parcelRequire("bVpqG");

var $8wGrm = parcelRequire("8wGrm");

var $bzRF9 = parcelRequire("bzRF9");

var $drQX9 = parcelRequire("drQX9");

var $jZNPZ = parcelRequire("jZNPZ");

var $lymto = parcelRequire("lymto");

var $dDUd7 = parcelRequire("dDUd7");

var $aDIbX = parcelRequire("aDIbX");

var $ia54s = parcelRequire("ia54s");

var $jsLpm = parcelRequire("jsLpm");

var $bwfZT = parcelRequire("bwfZT");

var $h1PLz = parcelRequire("h1PLz");

var $7sbuv = parcelRequire("7sbuv");

var $crvTw = parcelRequire("crvTw");

var $70Tlj = parcelRequire("70Tlj");

var $lTzb1 = parcelRequire("lTzb1");

var $lbgCD = parcelRequire("lbgCD");

var $6yvuu = parcelRequire("6yvuu");

var $cHPPF = parcelRequire("cHPPF");

var $it41X = parcelRequire("it41X");

var $euDQb = parcelRequire("euDQb");

var $h7rR7 = parcelRequire("h7rR7");

var $6edRj = parcelRequire("6edRj");

var $3acBG = parcelRequire("3acBG");

var $9kWsS = parcelRequire("9kWsS");

var $b9Ccj = parcelRequire("b9Ccj");

var $1JDly = parcelRequire("1JDly");

var $c1HaV = parcelRequire("c1HaV");

var $f6wSa = parcelRequire("f6wSa");

var $kSt33 = parcelRequire("kSt33");

var $hYBh9 = parcelRequire("hYBh9");

var $kYhhM = parcelRequire("kYhhM");

var $QSmkc = parcelRequire("QSmkc");

var $cJyg4 = parcelRequire("cJyg4");

var $9c6vL = parcelRequire("9c6vL");

var $9haIg = parcelRequire("9haIg");

var $4Nriv = parcelRequire("4Nriv");

var $aRUkQ = parcelRequire("aRUkQ");

var $hOWB1 = parcelRequire("hOWB1");

var $hXjgq = parcelRequire("hXjgq");

var $cXeQx = parcelRequire("cXeQx");

var $jNhqV = parcelRequire("jNhqV");

var $7MD3G = parcelRequire("7MD3G");

var $fFMKM = parcelRequire("fFMKM");

var $8G22J = parcelRequire("8G22J");

var $5w0HR = parcelRequire("5w0HR");

var $8zrSn = parcelRequire("8zrSn");

var $faIkE = parcelRequire("faIkE");

var $cjNL8 = parcelRequire("cjNL8");

var $5UZMn = parcelRequire("5UZMn");

var $cpVrn = parcelRequire("cpVrn");

var $c121k = parcelRequire("c121k");

var $30yBm = parcelRequire("30yBm");

var $1s1wu = parcelRequire("1s1wu");

var $1RNh6 = parcelRequire("1RNh6");

var $dO6uG = parcelRequire("dO6uG");

var $1MIIZ = parcelRequire("1MIIZ");

var $3VCv5 = parcelRequire("3VCv5");

var $8tBYU = parcelRequire("8tBYU");

var $bccpe = parcelRequire("bccpe");

var $2yc02 = parcelRequire("2yc02");

var $9Jxex = parcelRequire("9Jxex");

var $bnKNM = parcelRequire("bnKNM");

var $4B7Q6 = parcelRequire("4B7Q6");

var $lXhld = parcelRequire("lXhld");

});
parcelRegister("a2bcr", function(module, exports) {

$parcel$export(module.exports, "audit", () => $74e2c74b84b73ad3$export$d779b02e6b68c3e8);

var $iZT3c = parcelRequire("iZT3c");

var $kA4PZ = parcelRequire("kA4PZ");

var $lo1Ce = parcelRequire("lo1Ce");
function $74e2c74b84b73ad3$export$d779b02e6b68c3e8(durationSelector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
            isComplete && subscriber.complete();
        };
        var cleanupDuration = function() {
            durationSubscriber = null;
            isComplete && subscriber.complete();
        };
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
            if (!durationSubscriber) (0, $kA4PZ.innerFrom)(durationSelector(value)).subscribe(durationSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, endDuration, cleanupDuration));
        }, function() {
            isComplete = true;
            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
    });
}

});

parcelRegister("1XCf8", function(module, exports) {

$parcel$export(module.exports, "auditTime", () => $16d8f768b4684355$export$719c70722b10e5ff);

var $lbxJc = parcelRequire("lbxJc");

var $a2bcr = parcelRequire("a2bcr");

var $iZWyy = parcelRequire("iZWyy");
function $16d8f768b4684355$export$719c70722b10e5ff(duration, scheduler) {
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    return (0, $a2bcr.audit)(function() {
        return (0, $iZWyy.timer)(duration, scheduler);
    });
}

});

parcelRegister("9oKSE", function(module, exports) {

$parcel$export(module.exports, "buffer", () => $6d7ab8733aa8f136$export$ab1029bcae9ddb4a);

var $iZT3c = parcelRequire("iZT3c");

var $QfuEL = parcelRequire("QfuEL");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");
function $6d7ab8733aa8f136$export$ab1029bcae9ddb4a(closingNotifier) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return currentBuffer.push(value);
        }, function() {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        (0, $kA4PZ.innerFrom)(closingNotifier).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, (0, $QfuEL.noop)));
        return function() {
            currentBuffer = null;
        };
    });
}

});

parcelRegister("fWkHO", function(module, exports) {

$parcel$export(module.exports, "bufferCount", () => $b9ac557ed7c6a66b$export$8916d2c8119541bb);

var $1Znhr = parcelRequire("1Znhr");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $ebAl1 = parcelRequire("ebAl1");
function $b9ac557ed7c6a66b$export$8916d2c8119541bb(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var buffers = [];
        var count = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a, e_2, _b;
            var toEmit = null;
            if (count++ % startBufferEvery === 0) buffers.push([]);
            try {
                for(var buffers_1 = (0, $1Znhr.__values)(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                    if (bufferSize <= buffer.length) {
                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
                        toEmit.push(buffer);
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (toEmit) try {
                for(var toEmit_1 = (0, $1Znhr.__values)(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()){
                    var buffer = toEmit_1_1.value;
                    (0, $ebAl1.arrRemove)(buffers, buffer);
                    subscriber.next(buffer);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }, function() {
            var e_3, _a;
            try {
                for(var buffers_2 = (0, $1Znhr.__values)(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()){
                    var buffer = buffers_2_1.value;
                    subscriber.next(buffer);
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffers = null;
        }));
    });
}

});

parcelRegister("1FLF6", function(module, exports) {

$parcel$export(module.exports, "bufferTime", () => $137e977160ede14a$export$d6b40c95035461c7);

var $1Znhr = parcelRequire("1Znhr");

var $fgwAY = parcelRequire("fgwAY");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $ebAl1 = parcelRequire("ebAl1");

var $lbxJc = parcelRequire("lbxJc");

var $6kN4i = parcelRequire("6kN4i");

var $aj4TV = parcelRequire("aj4TV");
function $137e977160ede14a$export$d6b40c95035461c7(bufferTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = (0, $6kN4i.popScheduler)(otherArgs)) !== null && _a !== void 0 ? _a : (0, $lbxJc.asyncScheduler);
    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxBufferSize = otherArgs[1] || Infinity;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var bufferRecords = [];
        var restartOnEmit = false;
        var emit = function(record) {
            var buffer = record.buffer, subs = record.subs;
            subs.unsubscribe();
            (0, $ebAl1.arrRemove)(bufferRecords, record);
            subscriber.next(buffer);
            restartOnEmit && startBuffer();
        };
        var startBuffer = function() {
            if (bufferRecords) {
                var subs = new (0, $fgwAY.Subscription)();
                subscriber.add(subs);
                var buffer = [];
                var record_1 = {
                    buffer: buffer,
                    subs: subs
                };
                bufferRecords.push(record_1);
                (0, $aj4TV.executeSchedule)(subs, scheduler, function() {
                    return emit(record_1);
                }, bufferTimeSpan);
            }
        };
        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) (0, $aj4TV.executeSchedule)(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
        else restartOnEmit = true;
        startBuffer();
        var bufferTimeSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            var recordsCopy = bufferRecords.slice();
            try {
                for(var recordsCopy_1 = (0, $1Znhr.__values)(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()){
                    var record = recordsCopy_1_1.value;
                    var buffer = record.buffer;
                    buffer.push(value);
                    maxBufferSize <= buffer.length && emit(record);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length)subscriber.next(bufferRecords.shift().buffer);
            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 || bufferTimeSubscriber.unsubscribe();
            subscriber.complete();
            subscriber.unsubscribe();
        }, undefined, function() {
            return bufferRecords = null;
        });
        source.subscribe(bufferTimeSubscriber);
    });
}

});

parcelRegister("4ozPv", function(module, exports) {

$parcel$export(module.exports, "bufferToggle", () => $3335325d8b8389c3$export$91115bdd8709945f);

var $1Znhr = parcelRequire("1Znhr");

var $fgwAY = parcelRequire("fgwAY");

var $iZT3c = parcelRequire("iZT3c");

var $kA4PZ = parcelRequire("kA4PZ");

var $lo1Ce = parcelRequire("lo1Ce");

var $QfuEL = parcelRequire("QfuEL");

var $ebAl1 = parcelRequire("ebAl1");
function $3335325d8b8389c3$export$91115bdd8709945f(openings, closingSelector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var buffers = [];
        (0, $kA4PZ.innerFrom)(openings).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(openValue) {
            var buffer = [];
            buffers.push(buffer);
            var closingSubscription = new (0, $fgwAY.Subscription)();
            var emitBuffer = function() {
                (0, $ebAl1.arrRemove)(buffers, buffer);
                subscriber.next(buffer);
                closingSubscription.unsubscribe();
            };
            closingSubscription.add((0, $kA4PZ.innerFrom)(closingSelector(openValue)).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, emitBuffer, (0, $QfuEL.noop))));
        }, (0, $QfuEL.noop)));
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var buffers_1 = (0, $1Znhr.__values)(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(buffers.length > 0)subscriber.next(buffers.shift());
            subscriber.complete();
        }));
    });
}

});

parcelRegister("fFGEO", function(module, exports) {

$parcel$export(module.exports, "bufferWhen", () => $b68bc637fd4adc5f$export$9e55760d3282e08c);

var $iZT3c = parcelRequire("iZT3c");

var $QfuEL = parcelRequire("QfuEL");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");
function $b68bc637fd4adc5f$export$9e55760d3282e08c(closingSelector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var buffer = null;
        var closingSubscriber = null;
        var openBuffer = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            var b = buffer;
            buffer = [];
            b && subscriber.next(b);
            (0, $kA4PZ.innerFrom)(closingSelector()).subscribe(closingSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, openBuffer, (0, $QfuEL.noop)));
        };
        openBuffer();
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return buffer === null || buffer === void 0 ? void 0 : buffer.push(value);
        }, function() {
            buffer && subscriber.next(buffer);
            subscriber.complete();
        }, undefined, function() {
            return buffer = closingSubscriber = null;
        }));
    });
}

});

parcelRegister("2F9NG", function(module, exports) {

$parcel$export(module.exports, "combineAll", () => $1f07034690dcd7e2$export$29ae691b7de52fe3);

var $6IrYh = parcelRequire("6IrYh");
var $1f07034690dcd7e2$export$29ae691b7de52fe3 = (0, $6IrYh.combineLatestAll);

});
parcelRegister("6IrYh", function(module, exports) {

$parcel$export(module.exports, "combineLatestAll", () => $4e3c8ca68634c015$export$d0ec5d1c4092e08a);

var $8QuAY = parcelRequire("8QuAY");

var $2LTlf = parcelRequire("2LTlf");
function $4e3c8ca68634c015$export$d0ec5d1c4092e08a(project) {
    return (0, $2LTlf.joinAllInternals)((0, $8QuAY.combineLatest), project);
}

});
parcelRegister("2LTlf", function(module, exports) {

$parcel$export(module.exports, "joinAllInternals", () => $204ae63e5fd67f8f$export$4645c2bc5e323635);

var $hYEnO = parcelRequire("hYEnO");

var $hYp6u = parcelRequire("hYp6u");

var $lrpjn = parcelRequire("lrpjn");

var $drQX9 = parcelRequire("drQX9");

var $dO6uG = parcelRequire("dO6uG");
function $204ae63e5fd67f8f$export$4645c2bc5e323635(joinFn, project) {
    return (0, $lrpjn.pipe)((0, $dO6uG.toArray)(), (0, $drQX9.mergeMap)(function(sources) {
        return joinFn(sources);
    }), project ? (0, $hYp6u.mapOneOrManyArgs)(project) : (0, $hYEnO.identity));
}

});
parcelRegister("dO6uG", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $a0d4fb6e0bfd41f3$export$45b10814cc054894);

var $euDQb = parcelRequire("euDQb");

var $iZT3c = parcelRequire("iZT3c");
var $a0d4fb6e0bfd41f3$var$arrReducer = function(arr, value) {
    return arr.push(value), arr;
};
function $a0d4fb6e0bfd41f3$export$45b10814cc054894() {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $euDQb.reduce)($a0d4fb6e0bfd41f3$var$arrReducer, [])(source).subscribe(subscriber);
    });
}

});




parcelRegister("a8hWu", function(module, exports) {

$parcel$export(module.exports, "combineLatest", () => $760891b61f800f1e$export$77fa7d86f5204e8a);

var $1Znhr = parcelRequire("1Znhr");

var $8QuAY = parcelRequire("8QuAY");

var $iZT3c = parcelRequire("iZT3c");

var $97UFc = parcelRequire("97UFc");

var $hYp6u = parcelRequire("hYp6u");

var $lrpjn = parcelRequire("lrpjn");

var $6kN4i = parcelRequire("6kN4i");
function $760891b61f800f1e$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, $6kN4i.popResultSelector)(args);
    return resultSelector ? (0, $lrpjn.pipe)($760891b61f800f1e$export$77fa7d86f5204e8a.apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(args))), (0, $hYp6u.mapOneOrManyArgs)(resultSelector)) : (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $8QuAY.combineLatestInit)((0, $1Znhr.__spreadArray)([
            source
        ], (0, $1Znhr.__read)((0, $97UFc.argsOrArgArray)(args))))(subscriber);
    });
}

});
parcelRegister("97UFc", function(module, exports) {

$parcel$export(module.exports, "argsOrArgArray", () => $6a50b8b080df9882$export$24e1bb79414042be);
var $6a50b8b080df9882$var$isArray = Array.isArray;
function $6a50b8b080df9882$export$24e1bb79414042be(args) {
    return args.length === 1 && $6a50b8b080df9882$var$isArray(args[0]) ? args[0] : args;
}

});


parcelRegister("cipNe", function(module, exports) {

$parcel$export(module.exports, "combineLatestWith", () => $8f3b2c6b06e74b8f$export$2c346d97ede9fe0c);

var $1Znhr = parcelRequire("1Znhr");

var $a8hWu = parcelRequire("a8hWu");
function $8f3b2c6b06e74b8f$export$2c346d97ede9fe0c() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, $a8hWu.combineLatest).apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(otherSources)));
}

});

parcelRegister("hs6fE", function(module, exports) {

$parcel$export(module.exports, "concat", () => $cb49e692f60237e2$export$ee1b3e54f0441b22);

var $1Znhr = parcelRequire("1Znhr");

var $iZT3c = parcelRequire("iZT3c");

var $aFT1q = parcelRequire("aFT1q");

var $6kN4i = parcelRequire("6kN4i");

var $aIPjU = parcelRequire("aIPjU");
function $cb49e692f60237e2$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(args);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $aFT1q.concatAll)()((0, $aIPjU.from)((0, $1Znhr.__spreadArray)([
            source
        ], (0, $1Znhr.__read)(args)), scheduler)).subscribe(subscriber);
    });
}

});

parcelRegister("j7Eel", function(module, exports) {

$parcel$export(module.exports, "concatMap", () => $debde0a94a59fc2b$export$c28c8388be0ab31a);

var $drQX9 = parcelRequire("drQX9");

var $dFWVS = parcelRequire("dFWVS");
function $debde0a94a59fc2b$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $dFWVS.isFunction)(resultSelector) ? (0, $drQX9.mergeMap)(project, resultSelector, 1) : (0, $drQX9.mergeMap)(project, 1);
}

});

parcelRegister("bFAOq", function(module, exports) {

$parcel$export(module.exports, "concatMapTo", () => $87f014386dd153ba$export$82fbd7a2841d2484);

var $j7Eel = parcelRequire("j7Eel");

var $dFWVS = parcelRequire("dFWVS");
function $87f014386dd153ba$export$82fbd7a2841d2484(innerObservable, resultSelector) {
    return (0, $dFWVS.isFunction)(resultSelector) ? (0, $j7Eel.concatMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, $j7Eel.concatMap)(function() {
        return innerObservable;
    });
}

});

parcelRegister("gv2NG", function(module, exports) {

$parcel$export(module.exports, "concatWith", () => $c031b6b37f0e9ca5$export$6a50f648373d0fa8);

var $1Znhr = parcelRequire("1Znhr");

var $hs6fE = parcelRequire("hs6fE");
function $c031b6b37f0e9ca5$export$6a50f648373d0fa8() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, $hs6fE.concat).apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(otherSources)));
}

});

parcelRegister("1ySFG", function(module, exports) {

$parcel$export(module.exports, "connect", () => $12336004ac419e32$export$64605811ab45167f);

var $hgqF6 = parcelRequire("hgqF6");

var $kA4PZ = parcelRequire("kA4PZ");

var $iZT3c = parcelRequire("iZT3c");

var $ihqVf = parcelRequire("ihqVf");
var $12336004ac419e32$var$DEFAULT_CONFIG = {
    connector: function() {
        return new (0, $hgqF6.Subject)();
    }
};
function $12336004ac419e32$export$64605811ab45167f(selector, config) {
    if (config === void 0) config = $12336004ac419e32$var$DEFAULT_CONFIG;
    var connector = config.connector;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var subject = connector();
        (0, $kA4PZ.innerFrom)(selector((0, $ihqVf.fromSubscribable)(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}

});
parcelRegister("ihqVf", function(module, exports) {

$parcel$export(module.exports, "fromSubscribable", () => $d4eeb2c2e4d14d1f$export$86a55c2f04dd8842);

var $gN3J6 = parcelRequire("gN3J6");
function $d4eeb2c2e4d14d1f$export$86a55c2f04dd8842(subscribable) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        return subscribable.subscribe(subscriber);
    });
}

});


parcelRegister("7EEKf", function(module, exports) {

$parcel$export(module.exports, "count", () => $592bdfefb712773b$export$85b9a36db797e02b);

var $euDQb = parcelRequire("euDQb");
function $592bdfefb712773b$export$85b9a36db797e02b(predicate) {
    return (0, $euDQb.reduce)(function(total, value, i) {
        return !predicate || predicate(value, i) ? total + 1 : total;
    }, 0);
}

});

parcelRegister("lclmq", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $f6eb49bb2551f985$export$61fc7d43ac8f84b0);

var $iZT3c = parcelRequire("iZT3c");

var $QfuEL = parcelRequire("QfuEL");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");
function $f6eb49bb2551f985$export$61fc7d43ac8f84b0(durationSelector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            hasValue = true;
            lastValue = value;
            durationSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, emit, (0, $QfuEL.noop));
            (0, $kA4PZ.innerFrom)(durationSelector(value)).subscribe(durationSubscriber);
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = durationSubscriber = null;
        }));
    });
}

});

parcelRegister("j1Rp6", function(module, exports) {

$parcel$export(module.exports, "debounceTime", () => $dda78935103f1d48$export$7843a4469d64c07e);

var $lbxJc = parcelRequire("lbxJc");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $dda78935103f1d48$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

});

parcelRegister("eDEok", function(module, exports) {

$parcel$export(module.exports, "defaultIfEmpty", () => $aa840a167349fadd$export$e4ca6d7b7a6dcf9b);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $aa840a167349fadd$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}

});

parcelRegister("diDND", function(module, exports) {

$parcel$export(module.exports, "delay", () => $9aebd42557a93f11$export$1391212d75b2ee65);

var $lbxJc = parcelRequire("lbxJc");

var $aggvL = parcelRequire("aggvL");

var $iZWyy = parcelRequire("iZWyy");
function $9aebd42557a93f11$export$1391212d75b2ee65(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    var duration = (0, $iZWyy.timer)(due, scheduler);
    return (0, $aggvL.delayWhen)(function() {
        return duration;
    });
}

});
parcelRegister("aggvL", function(module, exports) {

$parcel$export(module.exports, "delayWhen", () => $778834c9a5317153$export$286ca829307725c9);

var $awcxJ = parcelRequire("awcxJ");

var $fFMKM = parcelRequire("fFMKM");

var $6fLz3 = parcelRequire("6fLz3");

var $dCpCY = parcelRequire("dCpCY");

var $drQX9 = parcelRequire("drQX9");

var $kA4PZ = parcelRequire("kA4PZ");
function $778834c9a5317153$export$286ca829307725c9(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, $awcxJ.concat)(subscriptionDelay.pipe((0, $fFMKM.take)(1), (0, $6fLz3.ignoreElements)()), source.pipe($778834c9a5317153$export$286ca829307725c9(delayDurationSelector)));
    };
    return (0, $drQX9.mergeMap)(function(value, index) {
        return (0, $kA4PZ.innerFrom)(delayDurationSelector(value, index)).pipe((0, $fFMKM.take)(1), (0, $dCpCY.mapTo)(value));
    });
}

});
parcelRegister("fFMKM", function(module, exports) {

$parcel$export(module.exports, "take", () => $b69080cb584f8fb4$export$b7df5d561049483a);

var $dMQAa = parcelRequire("dMQAa");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $b69080cb584f8fb4$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $dMQAa.EMPTY;
    } : (0, $iZT3c.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

});

parcelRegister("6fLz3", function(module, exports) {

$parcel$export(module.exports, "ignoreElements", () => $48d90a16163fe9b2$export$6953b97c7d866605);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $QfuEL = parcelRequire("QfuEL");
function $48d90a16163fe9b2$export$6953b97c7d866605() {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, (0, $QfuEL.noop)));
    });
}

});

parcelRegister("dCpCY", function(module, exports) {

$parcel$export(module.exports, "mapTo", () => $9ea2b4113f3b53ff$export$e0eaf3a86c03b2ad);

var $6SBin = parcelRequire("6SBin");
function $9ea2b4113f3b53ff$export$e0eaf3a86c03b2ad(value) {
    return (0, $6SBin.map)(function() {
        return value;
    });
}

});



parcelRegister("e69lr", function(module, exports) {

$parcel$export(module.exports, "dematerialize", () => $a438dfe3eefa526b$export$ab9a5985b741fa7a);

var $dzCf1 = parcelRequire("dzCf1");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $a438dfe3eefa526b$export$ab9a5985b741fa7a() {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(notification) {
            return (0, $dzCf1.observeNotification)(notification, subscriber);
        }));
    });
}

});
parcelRegister("dzCf1", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $9e1c352c0b0f0887$export$14834abbfce3b8cd);
$parcel$export(module.exports, "observeNotification", () => $9e1c352c0b0f0887$export$b7ed52a57c1cee9e);

var $dMQAa = parcelRequire("dMQAa");

var $a68Z4 = parcelRequire("a68Z4");

var $gj9Jv = parcelRequire("gj9Jv");

var $dFWVS = parcelRequire("dFWVS");
var $9e1c352c0b0f0887$export$f59c804e350a7a80;
(function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})($9e1c352c0b0f0887$export$f59c804e350a7a80 || ($9e1c352c0b0f0887$export$f59c804e350a7a80 = {}));
var $9e1c352c0b0f0887$export$14834abbfce3b8cd = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === "N";
    }
    Notification.prototype.observe = function(observer) {
        return $9e1c352c0b0f0887$export$b7ed52a57c1cee9e(this, observer);
    };
    Notification.prototype.do = function(nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === "N" ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === "E" ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        var _a;
        return (0, $dFWVS.isFunction)((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next) ? this.observe(nextOrObserver) : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === "N" ? (0, $a68Z4.of)(value) : kind === "E" ? (0, $gj9Jv.throwError)(function() {
            return error;
        }) : kind === "C" ? (0, $dMQAa.EMPTY) : 0;
        if (!result) throw new TypeError("Unexpected notification kind " + kind);
        return result;
    };
    Notification.createNext = function(value) {
        return new Notification("N", value);
    };
    Notification.createError = function(err) {
        return new Notification("E", undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification("C");
    return Notification;
}();
function $9e1c352c0b0f0887$export$b7ed52a57c1cee9e(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== "string") throw new TypeError('Invalid notification, missing "kind"');
    kind === "N" ? (_a = observer.next) === null || _a === void 0 || _a.call(observer, value) : kind === "E" ? (_b = observer.error) === null || _b === void 0 || _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 || _c.call(observer);
}

});
parcelRegister("a68Z4", function(module, exports) {

$parcel$export(module.exports, "of", () => $75a16ef51bd88dd7$export$ba255e9e49e00608);

var $6kN4i = parcelRequire("6kN4i");

var $aIPjU = parcelRequire("aIPjU");
function $75a16ef51bd88dd7$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(args);
    return (0, $aIPjU.from)(args, scheduler);
}

});

parcelRegister("gj9Jv", function(module, exports) {

$parcel$export(module.exports, "throwError", () => $bdf5f86f22c94852$export$8bf7aba4a9e09055);

var $gN3J6 = parcelRequire("gN3J6");

var $dFWVS = parcelRequire("dFWVS");
function $bdf5f86f22c94852$export$8bf7aba4a9e09055(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, $dFWVS.isFunction)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, $gN3J6.Observable)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}

});



parcelRegister("W85MW", function(module, exports) {

$parcel$export(module.exports, "distinct", () => $0aebb1de5078d7e6$export$983a3b5fb2f7202e);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $QfuEL = parcelRequire("QfuEL");

var $kA4PZ = parcelRequire("kA4PZ");
function $0aebb1de5078d7e6$export$983a3b5fb2f7202e(keySelector, flushes) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var distinctKeys = new Set();
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var key = keySelector ? keySelector(value) : value;
            if (!distinctKeys.has(key)) {
                distinctKeys.add(key);
                subscriber.next(value);
            }
        }));
        flushes && (0, $kA4PZ.innerFrom)(flushes).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            return distinctKeys.clear();
        }, (0, $QfuEL.noop)));
    });
}

});

parcelRegister("7nozN", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", () => $55edbeb89408ad8b$export$571da16e28367bde);

var $glUu6 = parcelRequire("glUu6");
function $55edbeb89408ad8b$export$571da16e28367bde(key, compare) {
    return (0, $glUu6.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

});

parcelRegister("bpoVl", function(module, exports) {

$parcel$export(module.exports, "elementAt", () => $84e55ce48502618b$export$91d69c7761a17bbc);

var $c3lRd = parcelRequire("c3lRd");

var $lm9of = parcelRequire("lm9of");

var $cpVrn = parcelRequire("cpVrn");

var $eDEok = parcelRequire("eDEok");

var $fFMKM = parcelRequire("fFMKM");
function $84e55ce48502618b$export$91d69c7761a17bbc(index, defaultValue) {
    if (index < 0) throw new (0, $c3lRd.ArgumentOutOfRangeError)();
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe((0, $lm9of.filter)(function(v, i) {
            return i === index;
        }), (0, $fFMKM.take)(1), hasDefaultValue ? (0, $eDEok.defaultIfEmpty)(defaultValue) : (0, $cpVrn.throwIfEmpty)(function() {
            return new (0, $c3lRd.ArgumentOutOfRangeError)();
        }));
    };
}

});
parcelRegister("c3lRd", function(module, exports) {

$parcel$export(module.exports, "ArgumentOutOfRangeError", () => $8c66b843a2e3aa9f$export$630691c4a0cd4093);

var $jaWRE = parcelRequire("jaWRE");
var $8c66b843a2e3aa9f$export$630691c4a0cd4093 = (0, $jaWRE.createErrorClass)(function(_super) {
    return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = "ArgumentOutOfRangeError";
        this.message = "argument out of range";
    };
});

});

parcelRegister("cpVrn", function(module, exports) {

$parcel$export(module.exports, "throwIfEmpty", () => $90a46055b269bfa6$export$c8ea5e9f84346833);

var $76qe6 = parcelRequire("76qe6");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $90a46055b269bfa6$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $90a46055b269bfa6$var$defaultErrorFactory;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $90a46055b269bfa6$var$defaultErrorFactory() {
    return new (0, $76qe6.EmptyError)();
}

});
parcelRegister("76qe6", function(module, exports) {

$parcel$export(module.exports, "EmptyError", () => $52bd6ff56c894fe1$export$78f6d1b1dbcda304);

var $jaWRE = parcelRequire("jaWRE");
var $52bd6ff56c894fe1$export$78f6d1b1dbcda304 = (0, $jaWRE.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
    };
});

});



parcelRegister("flSlr", function(module, exports) {

$parcel$export(module.exports, "endWith", () => $b2d2f8eec34acd7b$export$23c7d6c8dcd743fe);

var $1Znhr = parcelRequire("1Znhr");

var $awcxJ = parcelRequire("awcxJ");

var $a68Z4 = parcelRequire("a68Z4");
function $b2d2f8eec34acd7b$export$23c7d6c8dcd743fe() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return function(source) {
        return (0, $awcxJ.concat)(source, (0, $a68Z4.of).apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(values))));
    };
}

});

parcelRegister("9p7Bs", function(module, exports) {

$parcel$export(module.exports, "every", () => $6d8c58b17db9008d$export$7ecc1a3b11b57dab);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $6d8c58b17db9008d$export$7ecc1a3b11b57dab(predicate, thisArg) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            if (!predicate.call(thisArg, value, index++, source)) {
                subscriber.next(false);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

});

parcelRegister("9yVEh", function(module, exports) {

$parcel$export(module.exports, "exhaust", () => $6f6401d948f59bb8$export$31039f1fbd797b9c);

var $8Ht33 = parcelRequire("8Ht33");
var $6f6401d948f59bb8$export$31039f1fbd797b9c = (0, $8Ht33.exhaustAll);

});
parcelRegister("8Ht33", function(module, exports) {

$parcel$export(module.exports, "exhaustAll", () => $6558df4524d8e00e$export$9d1e39dcd15066cc);

var $7UKKo = parcelRequire("7UKKo");

var $hYEnO = parcelRequire("hYEnO");
function $6558df4524d8e00e$export$9d1e39dcd15066cc() {
    return (0, $7UKKo.exhaustMap)((0, $hYEnO.identity));
}

});
parcelRegister("7UKKo", function(module, exports) {

$parcel$export(module.exports, "exhaustMap", () => $5c32066b34d04fa9$export$d70d492cd31004c0);

var $6SBin = parcelRequire("6SBin");

var $kA4PZ = parcelRequire("kA4PZ");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $5c32066b34d04fa9$export$d70d492cd31004c0(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe($5c32066b34d04fa9$export$d70d492cd31004c0(function(a, i) {
            return (0, $kA4PZ.innerFrom)(project(a, i)).pipe((0, $6SBin.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var index = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(outerValue) {
            if (!innerSub) {
                innerSub = (0, $lo1Ce.createOperatorSubscriber)(subscriber, undefined, function() {
                    innerSub = null;
                    isComplete && subscriber.complete();
                });
                (0, $kA4PZ.innerFrom)(project(outerValue, index++)).subscribe(innerSub);
            }
        }, function() {
            isComplete = true;
            !innerSub && subscriber.complete();
        }));
    });
}

});



parcelRegister("2VGhV", function(module, exports) {

$parcel$export(module.exports, "expand", () => $2221b52bd2884f04$export$9f77e0932fb78f72);

var $iZT3c = parcelRequire("iZT3c");

var $bqdkM = parcelRequire("bqdkM");
function $2221b52bd2884f04$export$9f77e0932fb78f72(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Infinity;
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        return (0, $bqdkM.mergeInternals)(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}

});

parcelRegister("2K4Zz", function(module, exports) {

$parcel$export(module.exports, "finalize", () => $1ff3bffaa9d0737d$export$578723aef62d92f5);

var $iZT3c = parcelRequire("iZT3c");
function $1ff3bffaa9d0737d$export$578723aef62d92f5(callback) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        try {
            source.subscribe(subscriber);
        } finally{
            subscriber.add(callback);
        }
    });
}

});

parcelRegister("id94h", function(module, exports) {

$parcel$export(module.exports, "find", () => $d42079973adf80c4$export$71aa6c912b956294);
$parcel$export(module.exports, "createFind", () => $d42079973adf80c4$export$3e9fb9817efa084f);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $d42079973adf80c4$export$71aa6c912b956294(predicate, thisArg) {
    return (0, $iZT3c.operate)($d42079973adf80c4$export$3e9fb9817efa084f(predicate, thisArg, "value"));
}
function $d42079973adf80c4$export$3e9fb9817efa084f(predicate, thisArg, emit) {
    var findIndex = emit === "index";
    return function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            if (predicate.call(thisArg, value, i, source)) {
                subscriber.next(findIndex ? i : value);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(findIndex ? -1 : undefined);
            subscriber.complete();
        }));
    };
}

});

parcelRegister("kaH4y", function(module, exports) {

$parcel$export(module.exports, "findIndex", () => $eaf6271ae96fc0fa$export$de3a4d4a0d731119);

var $iZT3c = parcelRequire("iZT3c");

var $id94h = parcelRequire("id94h");
function $eaf6271ae96fc0fa$export$de3a4d4a0d731119(predicate, thisArg) {
    return (0, $iZT3c.operate)((0, $id94h.createFind)(predicate, thisArg, "index"));
}

});

parcelRegister("lt8Rs", function(module, exports) {

$parcel$export(module.exports, "first", () => $fa132e14250f7612$export$43128fadae87b74a);

var $76qe6 = parcelRequire("76qe6");

var $lm9of = parcelRequire("lm9of");

var $fFMKM = parcelRequire("fFMKM");

var $eDEok = parcelRequire("eDEok");

var $cpVrn = parcelRequire("cpVrn");

var $hYEnO = parcelRequire("hYEnO");
function $fa132e14250f7612$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $lm9of.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $hYEnO.identity), (0, $fFMKM.take)(1), hasDefaultValue ? (0, $eDEok.defaultIfEmpty)(defaultValue) : (0, $cpVrn.throwIfEmpty)(function() {
            return new (0, $76qe6.EmptyError)();
        }));
    };
}

});

parcelRegister("4IAbc", function(module, exports) {

$parcel$export(module.exports, "groupBy", () => $36f7560703d2d411$export$3f063810d7bf01bd);

var $gN3J6 = parcelRequire("gN3J6");

var $kA4PZ = parcelRequire("kA4PZ");

var $hgqF6 = parcelRequire("hgqF6");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $36f7560703d2d411$export$3f063810d7bf01bd(keySelector, elementOrOptions, duration, connector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var element;
        if (!elementOrOptions || typeof elementOrOptions === "function") element = elementOrOptions;
        else duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector;
        var groups = new Map();
        var notify = function(cb) {
            groups.forEach(cb);
            cb(subscriber);
        };
        var handleError = function(err) {
            return notify(function(consumer) {
                return consumer.error(err);
            });
        };
        var activeGroups = 0;
        var teardownAttempted = false;
        var groupBySourceSubscriber = new (0, $lo1Ce.OperatorSubscriber)(subscriber, function(value) {
            try {
                var key_1 = keySelector(value);
                var group_1 = groups.get(key_1);
                if (!group_1) {
                    groups.set(key_1, group_1 = connector ? connector() : new (0, $hgqF6.Subject)());
                    var grouped = createGroupedObservable(key_1, group_1);
                    subscriber.next(grouped);
                    if (duration) {
                        var durationSubscriber_1 = (0, $lo1Ce.createOperatorSubscriber)(group_1, function() {
                            group_1.complete();
                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 || durationSubscriber_1.unsubscribe();
                        }, undefined, undefined, function() {
                            return groups.delete(key_1);
                        });
                        groupBySourceSubscriber.add((0, $kA4PZ.innerFrom)(duration(grouped)).subscribe(durationSubscriber_1));
                    }
                }
                group_1.next(element ? element(value) : value);
            } catch (err) {
                handleError(err);
            }
        }, function() {
            return notify(function(consumer) {
                return consumer.complete();
            });
        }, handleError, function() {
            return groups.clear();
        }, function() {
            teardownAttempted = true;
            return activeGroups === 0;
        });
        source.subscribe(groupBySourceSubscriber);
        function createGroupedObservable(key, groupSubject) {
            var result = new (0, $gN3J6.Observable)(function(groupSubscriber) {
                activeGroups++;
                var innerSub = groupSubject.subscribe(groupSubscriber);
                return function() {
                    innerSub.unsubscribe();
                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
                };
            });
            result.key = key;
            return result;
        }
    });
}

});

parcelRegister("1mxST", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $0fe2213a0c1526b9$export$dd1bc94b04021eeb);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $0fe2213a0c1526b9$export$dd1bc94b04021eeb() {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            subscriber.next(false);
            subscriber.complete();
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

});

parcelRegister("l50cW", function(module, exports) {

$parcel$export(module.exports, "last", () => $f58a39d693c76e43$export$4c7897fafd92b108);

var $76qe6 = parcelRequire("76qe6");

var $lm9of = parcelRequire("lm9of");

var $8G22J = parcelRequire("8G22J");

var $cpVrn = parcelRequire("cpVrn");

var $eDEok = parcelRequire("eDEok");

var $hYEnO = parcelRequire("hYEnO");
function $f58a39d693c76e43$export$4c7897fafd92b108(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $lm9of.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $hYEnO.identity), (0, $8G22J.takeLast)(1), hasDefaultValue ? (0, $eDEok.defaultIfEmpty)(defaultValue) : (0, $cpVrn.throwIfEmpty)(function() {
            return new (0, $76qe6.EmptyError)();
        }));
    };
}

});
parcelRegister("8G22J", function(module, exports) {

$parcel$export(module.exports, "takeLast", () => $6513d4b1c795917f$export$1b47ad771ce5af5e);

var $1Znhr = parcelRequire("1Znhr");

var $dMQAa = parcelRequire("dMQAa");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $6513d4b1c795917f$export$1b47ad771ce5af5e(count) {
    return count <= 0 ? function() {
        return 0, $dMQAa.EMPTY;
    } : (0, $iZT3c.operate)(function(source, subscriber) {
        var buffer = [];
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            buffer.push(value);
            count < buffer.length && buffer.shift();
        }, function() {
            var e_1, _a;
            try {
                for(var buffer_1 = (0, $1Znhr.__values)(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()){
                    var value = buffer_1_1.value;
                    subscriber.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffer = null;
        }));
    });
}

});


parcelRegister("lI8Dq", function(module, exports) {

$parcel$export(module.exports, "materialize", () => $fce467c062d629ca$export$76dbd6ffd832405d);

var $dzCf1 = parcelRequire("dzCf1");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $fce467c062d629ca$export$76dbd6ffd832405d() {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next((0, $dzCf1.Notification).createNext(value));
        }, function() {
            subscriber.next((0, $dzCf1.Notification).createComplete());
            subscriber.complete();
        }, function(err) {
            subscriber.next((0, $dzCf1.Notification).createError(err));
            subscriber.complete();
        }));
    });
}

});

parcelRegister("jF93r", function(module, exports) {

$parcel$export(module.exports, "max", () => $e508deb1d54e6eb1$export$8960430cfd85939f);

var $euDQb = parcelRequire("euDQb");

var $dFWVS = parcelRequire("dFWVS");
function $e508deb1d54e6eb1$export$8960430cfd85939f(comparer) {
    return (0, $euDQb.reduce)((0, $dFWVS.isFunction)(comparer) ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    });
}

});

parcelRegister("jZNPZ", function(module, exports) {

$parcel$export(module.exports, "mergeMapTo", () => $e8ea5f841e85d3d1$export$bd7cfc9a42b8a412);

var $drQX9 = parcelRequire("drQX9");

var $dFWVS = parcelRequire("dFWVS");
function $e8ea5f841e85d3d1$export$bd7cfc9a42b8a412(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $dFWVS.isFunction)(resultSelector)) return (0, $drQX9.mergeMap)(function() {
        return innerObservable;
    }, resultSelector, concurrent);
    if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $drQX9.mergeMap)(function() {
        return innerObservable;
    }, concurrent);
}

});

parcelRegister("lymto", function(module, exports) {

$parcel$export(module.exports, "mergeScan", () => $fb0e34a847c2af0c$export$c1fc905202bced53);

var $iZT3c = parcelRequire("iZT3c");

var $bqdkM = parcelRequire("bqdkM");
function $fb0e34a847c2af0c$export$c1fc905202bced53(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var state = seed;
        return (0, $bqdkM.mergeInternals)(source, subscriber, function(value, index) {
            return accumulator(state, value, index);
        }, concurrent, function(value) {
            state = value;
        }, false, undefined, function() {
            return state = null;
        });
    });
}

});

parcelRegister("dDUd7", function(module, exports) {

$parcel$export(module.exports, "mergeWith", () => $9eea852251eaf08f$export$2ee76fde9ffe109d);

var $1Znhr = parcelRequire("1Znhr");

var $bVpqG = parcelRequire("bVpqG");
function $9eea852251eaf08f$export$2ee76fde9ffe109d() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, $bVpqG.merge).apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(otherSources)));
}

});

parcelRegister("aDIbX", function(module, exports) {

$parcel$export(module.exports, "min", () => $7befd37d458dd42c$export$96ec731ed4dcb222);

var $euDQb = parcelRequire("euDQb");

var $dFWVS = parcelRequire("dFWVS");
function $7befd37d458dd42c$export$96ec731ed4dcb222(comparer) {
    return (0, $euDQb.reduce)((0, $dFWVS.isFunction)(comparer) ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    });
}

});

parcelRegister("ia54s", function(module, exports) {

$parcel$export(module.exports, "multicast", () => $d38d182346f075fe$export$1364843af8d5a963);

var $kqAeT = parcelRequire("kqAeT");

var $dFWVS = parcelRequire("dFWVS");

var $1ySFG = parcelRequire("1ySFG");
function $d38d182346f075fe$export$1364843af8d5a963(subjectOrSubjectFactory, selector) {
    var subjectFactory = (0, $dFWVS.isFunction)(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function() {
        return subjectOrSubjectFactory;
    };
    if ((0, $dFWVS.isFunction)(selector)) return (0, $1ySFG.connect)(selector, {
        connector: subjectFactory
    });
    return function(source) {
        return new (0, $kqAeT.ConnectableObservable)(source, subjectFactory);
    };
}

});
parcelRegister("kqAeT", function(module, exports) {

$parcel$export(module.exports, "ConnectableObservable", () => $edf258b24570fd7a$export$9038dea0172d3ba9);

var $1Znhr = parcelRequire("1Znhr");

var $gN3J6 = parcelRequire("gN3J6");

var $fgwAY = parcelRequire("fgwAY");

var $b9Ccj = parcelRequire("b9Ccj");

var $lo1Ce = parcelRequire("lo1Ce");

var $iZT3c = parcelRequire("iZT3c");
var $edf258b24570fd7a$export$9038dea0172d3ba9 = function(_super) {
    (0, $1Znhr.__extends)(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if ((0, $iZT3c.hasLift)(source)) _this.lift = source.lift;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function() {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 || _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function() {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new (0, $fgwAY.Subscription)();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subject_1, undefined, function() {
                _this._teardown();
                subject_1.complete();
            }, function(err) {
                _this._teardown();
                subject_1.error(err);
            }, function() {
                return _this._teardown();
            })));
            if (connection.closed) {
                this._connection = null;
                connection = (0, $fgwAY.Subscription).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, $b9Ccj.refCount)()(this);
    };
    return ConnectableObservable;
}((0, $gN3J6.Observable));

});
parcelRegister("b9Ccj", function(module, exports) {

$parcel$export(module.exports, "refCount", () => $81ee2a38c7999ce8$export$18d0766d894cba0c);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $81ee2a38c7999ce8$export$18d0766d894cba0c() {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = (0, $lo1Ce.createOperatorSubscriber)(subscriber, undefined, undefined, undefined, function() {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) sharedConnection.unsubscribe();
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) connection = source.connect();
    });
}

});



parcelRegister("bwfZT", function(module, exports) {

$parcel$export(module.exports, "onErrorResumeNext", () => $862f1794ce8de733$export$5fba66d61591f42);

var $1Znhr = parcelRequire("1Znhr");

var $97UFc = parcelRequire("97UFc");

var $gR3ej = parcelRequire("gR3ej");
function $862f1794ce8de733$export$ef6358c74f2be6ad() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = (0, $97UFc.argsOrArgArray)(sources);
    return function(source) {
        return (0, $gR3ej.onErrorResumeNext).apply(void 0, (0, $1Znhr.__spreadArray)([
            source
        ], (0, $1Znhr.__read)(nextSources)));
    };
}
var $862f1794ce8de733$export$5fba66d61591f42 = $862f1794ce8de733$export$ef6358c74f2be6ad;

});
parcelRegister("gR3ej", function(module, exports) {

$parcel$export(module.exports, "onErrorResumeNext", () => $c45419facd54dca0$export$5fba66d61591f42);

var $gN3J6 = parcelRequire("gN3J6");

var $97UFc = parcelRequire("97UFc");

var $lo1Ce = parcelRequire("lo1Ce");

var $QfuEL = parcelRequire("QfuEL");

var $kA4PZ = parcelRequire("kA4PZ");
function $c45419facd54dca0$export$5fba66d61591f42() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = (0, $97UFc.argsOrArgArray)(sources);
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var sourceIndex = 0;
        var subscribeNext = function() {
            if (sourceIndex < nextSources.length) {
                var nextSource = void 0;
                try {
                    nextSource = (0, $kA4PZ.innerFrom)(nextSources[sourceIndex++]);
                } catch (err) {
                    subscribeNext();
                    return;
                }
                var innerSubscriber = new (0, $lo1Ce.OperatorSubscriber)(subscriber, undefined, (0, $QfuEL.noop), (0, $QfuEL.noop));
                nextSource.subscribe(innerSubscriber);
                innerSubscriber.add(subscribeNext);
            } else subscriber.complete();
        };
        subscribeNext();
    });
}

});


parcelRegister("h1PLz", function(module, exports) {

$parcel$export(module.exports, "pairwise", () => $c65aaf58370b30a7$export$8f9d79d42bff1aac);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $c65aaf58370b30a7$export$8f9d79d42bff1aac() {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}

});

parcelRegister("7sbuv", function(module, exports) {

$parcel$export(module.exports, "partition", () => $56d40fd1bcfab76a$export$b29f828819edca8d);

var $6z3IZ = parcelRequire("6z3IZ");

var $lm9of = parcelRequire("lm9of");
function $56d40fd1bcfab76a$export$b29f828819edca8d(predicate, thisArg) {
    return function(source) {
        return [
            (0, $lm9of.filter)(predicate, thisArg)(source),
            (0, $lm9of.filter)((0, $6z3IZ.not)(predicate, thisArg))(source)
        ];
    };
}

});
parcelRegister("6z3IZ", function(module, exports) {

$parcel$export(module.exports, "not", () => $4c78e69a0c26e866$export$6003a5f097c73977);
function $4c78e69a0c26e866$export$6003a5f097c73977(pred, thisArg) {
    return function(value, index) {
        return !pred.call(thisArg, value, index);
    };
}

});


parcelRegister("crvTw", function(module, exports) {

$parcel$export(module.exports, "pluck", () => $90f0bf3acafb0674$export$c44985b87d605eff);

var $6SBin = parcelRequire("6SBin");
function $90f0bf3acafb0674$export$c44985b87d605eff() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error("list of properties cannot be empty.");
    return (0, $6SBin.map)(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== "undefined") currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}

});

parcelRegister("70Tlj", function(module, exports) {

$parcel$export(module.exports, "publish", () => $51b3766374898516$export$89b472e03be495df);

var $hgqF6 = parcelRequire("hgqF6");

var $ia54s = parcelRequire("ia54s");

var $1ySFG = parcelRequire("1ySFG");
function $51b3766374898516$export$89b472e03be495df(selector) {
    return selector ? function(source) {
        return (0, $1ySFG.connect)(selector)(source);
    } : function(source) {
        return (0, $ia54s.multicast)(new (0, $hgqF6.Subject)())(source);
    };
}

});

parcelRegister("lTzb1", function(module, exports) {

$parcel$export(module.exports, "publishBehavior", () => $ff0a0566c3bac0dd$export$16ae46fda9567053);

var $4iRTc = parcelRequire("4iRTc");

var $kqAeT = parcelRequire("kqAeT");
function $ff0a0566c3bac0dd$export$16ae46fda9567053(initialValue) {
    return function(source) {
        var subject = new (0, $4iRTc.BehaviorSubject)(initialValue);
        return new (0, $kqAeT.ConnectableObservable)(source, function() {
            return subject;
        });
    };
}

});

parcelRegister("lbgCD", function(module, exports) {

$parcel$export(module.exports, "publishLast", () => $f6b784e2217bc54b$export$42d9b6b38c68d989);

var $01ZA6 = parcelRequire("01ZA6");

var $kqAeT = parcelRequire("kqAeT");
function $f6b784e2217bc54b$export$42d9b6b38c68d989() {
    return function(source) {
        var subject = new (0, $01ZA6.AsyncSubject)();
        return new (0, $kqAeT.ConnectableObservable)(source, function() {
            return subject;
        });
    };
}

});
parcelRegister("01ZA6", function(module, exports) {

$parcel$export(module.exports, "AsyncSubject", () => $005fdcdd86abc16a$export$fe960da701faae26);

var $1Znhr = parcelRequire("1Znhr");

var $hgqF6 = parcelRequire("hgqF6");
var $005fdcdd86abc16a$export$fe960da701faae26 = function(_super) {
    (0, $1Znhr.__extends)(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped || _isComplete) {
            _hasValue && subscriber.next(_value);
            subscriber.complete();
        }
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.isStopped) {
            this._value = value;
            this._hasValue = true;
        }
    };
    AsyncSubject.prototype.complete = function() {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
            this._isComplete = true;
            _hasValue && _super.prototype.next.call(this, _value);
            _super.prototype.complete.call(this);
        }
    };
    return AsyncSubject;
}((0, $hgqF6.Subject));

});


parcelRegister("6yvuu", function(module, exports) {

$parcel$export(module.exports, "publishReplay", () => $4c5e58779730332b$export$1f3342bf81d92d52);

var $9jHGG = parcelRequire("9jHGG");

var $ia54s = parcelRequire("ia54s");

var $dFWVS = parcelRequire("dFWVS");
function $4c5e58779730332b$export$1f3342bf81d92d52(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !(0, $dFWVS.isFunction)(selectorOrScheduler)) timestampProvider = selectorOrScheduler;
    var selector = (0, $dFWVS.isFunction)(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function(source) {
        return (0, $ia54s.multicast)(new (0, $9jHGG.ReplaySubject)(bufferSize, windowTime, timestampProvider), selector)(source);
    };
}

});
parcelRegister("9jHGG", function(module, exports) {

$parcel$export(module.exports, "ReplaySubject", () => $6c87c6ce41031553$export$915d2682b0aa0991);

var $1Znhr = parcelRequire("1Znhr");

var $hgqF6 = parcelRequire("hgqF6");

var $ggeIx = parcelRequire("ggeIx");
var $6c87c6ce41031553$export$915d2682b0aa0991 = function(_super) {
    (0, $1Znhr.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $ggeIx.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $hgqF6.Subject));

});


parcelRegister("cHPPF", function(module, exports) {

$parcel$export(module.exports, "race", () => $9401b5066352a3f5$export$236c05de452bec2);

var $1Znhr = parcelRequire("1Znhr");

var $97UFc = parcelRequire("97UFc");

var $it41X = parcelRequire("it41X");
function $9401b5066352a3f5$export$236c05de452bec2() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $it41X.raceWith).apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)((0, $97UFc.argsOrArgArray)(args))));
}

});
parcelRegister("it41X", function(module, exports) {

$parcel$export(module.exports, "raceWith", () => $d71e0fd36c607a45$export$19987dc39c43158d);

var $1Znhr = parcelRequire("1Znhr");

var $aJnEW = parcelRequire("aJnEW");

var $iZT3c = parcelRequire("iZT3c");

var $hYEnO = parcelRequire("hYEnO");
function $d71e0fd36c607a45$export$19987dc39c43158d() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return !otherSources.length ? (0, $hYEnO.identity) : (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $aJnEW.raceInit)((0, $1Znhr.__spreadArray)([
            source
        ], (0, $1Znhr.__read)(otherSources)))(subscriber);
    });
}

});
parcelRegister("aJnEW", function(module, exports) {

$parcel$export(module.exports, "raceInit", () => $7d00759e9e6c87ba$export$903c39bc8627b085);

var $gN3J6 = parcelRequire("gN3J6");

var $kA4PZ = parcelRequire("kA4PZ");

var $97UFc = parcelRequire("97UFc");

var $lo1Ce = parcelRequire("lo1Ce");
function $7d00759e9e6c87ba$export$236c05de452bec2() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    sources = (0, $97UFc.argsOrArgArray)(sources);
    return sources.length === 1 ? (0, $kA4PZ.innerFrom)(sources[0]) : new (0, $gN3J6.Observable)($7d00759e9e6c87ba$export$903c39bc8627b085(sources));
}
function $7d00759e9e6c87ba$export$903c39bc8627b085(sources) {
    return function(subscriber) {
        var subscriptions = [];
        var _loop_1 = function(i) {
            subscriptions.push((0, $kA4PZ.innerFrom)(sources[i]).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
                if (subscriptions) {
                    for(var s = 0; s < subscriptions.length; s++)s !== i && subscriptions[s].unsubscribe();
                    subscriptions = null;
                }
                subscriber.next(value);
            })));
        };
        for(var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++)_loop_1(i);
    };
}

});



parcelRegister("h7rR7", function(module, exports) {

$parcel$export(module.exports, "repeat", () => $c768b2b148374aea$export$76d90c956114f2c2);

var $dMQAa = parcelRequire("dMQAa");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");

var $iZWyy = parcelRequire("iZWyy");
function $c768b2b148374aea$export$76d90c956114f2c2(countOrConfig) {
    var _a;
    var count = Infinity;
    var delay;
    if (countOrConfig != null) {
        if (typeof countOrConfig === "object") _a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay;
        else count = countOrConfig;
    }
    return count <= 0 ? function() {
        return 0, $dMQAa.EMPTY;
    } : (0, $iZT3c.operate)(function(source, subscriber) {
        var soFar = 0;
        var sourceSub;
        var resubscribe = function() {
            sourceSub === null || sourceSub === void 0 || sourceSub.unsubscribe();
            sourceSub = null;
            if (delay != null) {
                var notifier = typeof delay === "number" ? (0, $iZWyy.timer)(delay) : (0, $kA4PZ.innerFrom)(delay(soFar));
                var notifierSubscriber_1 = (0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
                    notifierSubscriber_1.unsubscribe();
                    subscribeToSource();
                });
                notifier.subscribe(notifierSubscriber_1);
            } else subscribeToSource();
        };
        var subscribeToSource = function() {
            var syncUnsub = false;
            sourceSub = source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, undefined, function() {
                if (++soFar < count) {
                    if (sourceSub) resubscribe();
                    else syncUnsub = true;
                } else subscriber.complete();
            }));
            if (syncUnsub) resubscribe();
        };
        subscribeToSource();
    });
}

});

parcelRegister("6edRj", function(module, exports) {

$parcel$export(module.exports, "repeatWhen", () => $488eccfe16f71fd8$export$b39ac5b4ffd1415a);

var $kA4PZ = parcelRequire("kA4PZ");

var $hgqF6 = parcelRequire("hgqF6");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $488eccfe16f71fd8$export$b39ac5b4ffd1415a(notifier) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var checkComplete = function() {
            return isMainComplete && isNotifierComplete && (subscriber.complete(), true);
        };
        var getCompletionSubject = function() {
            if (!completions$) {
                completions$ = new (0, $hgqF6.Subject)();
                (0, $kA4PZ.innerFrom)(notifier(completions$)).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
                    if (innerSub) subscribeForRepeatWhen();
                    else syncResub = true;
                }, function() {
                    isNotifierComplete = true;
                    checkComplete();
                }));
            }
            return completions$;
        };
        var subscribeForRepeatWhen = function() {
            isMainComplete = false;
            innerSub = source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, undefined, function() {
                isMainComplete = true;
                !checkComplete() && getCompletionSubject().next();
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRepeatWhen();
            }
        };
        subscribeForRepeatWhen();
    });
}

});

parcelRegister("3acBG", function(module, exports) {

$parcel$export(module.exports, "retry", () => $24dc15b11375c1ba$export$9369b12211e1fce4);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $hYEnO = parcelRequire("hYEnO");

var $iZWyy = parcelRequire("iZWyy");

var $kA4PZ = parcelRequire("kA4PZ");
function $24dc15b11375c1ba$export$9369b12211e1fce4(configOrCount) {
    if (configOrCount === void 0) configOrCount = Infinity;
    var config;
    if (configOrCount && typeof configOrCount === "object") config = configOrCount;
    else config = {
        count: configOrCount
    };
    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0 ? (0, $hYEnO.identity) : (0, $iZT3c.operate)(function(source, subscriber) {
        var soFar = 0;
        var innerSub;
        var subscribeForRetry = function() {
            var syncUnsub = false;
            innerSub = source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
                if (resetOnSuccess) soFar = 0;
                subscriber.next(value);
            }, undefined, function(err) {
                if (soFar++ < count) {
                    var resub_1 = function() {
                        if (innerSub) {
                            innerSub.unsubscribe();
                            innerSub = null;
                            subscribeForRetry();
                        } else syncUnsub = true;
                    };
                    if (delay != null) {
                        var notifier = typeof delay === "number" ? (0, $iZWyy.timer)(delay) : (0, $kA4PZ.innerFrom)(delay(err, soFar));
                        var notifierSubscriber_1 = (0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
                            notifierSubscriber_1.unsubscribe();
                            resub_1();
                        }, function() {
                            subscriber.complete();
                        });
                        notifier.subscribe(notifierSubscriber_1);
                    } else resub_1();
                } else subscriber.error(err);
            }));
            if (syncUnsub) {
                innerSub.unsubscribe();
                innerSub = null;
                subscribeForRetry();
            }
        };
        subscribeForRetry();
    });
}

});

parcelRegister("9kWsS", function(module, exports) {

$parcel$export(module.exports, "retryWhen", () => $6cc35533207b4713$export$1281551253cfee02);

var $kA4PZ = parcelRequire("kA4PZ");

var $hgqF6 = parcelRequire("hgqF6");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $6cc35533207b4713$export$1281551253cfee02(notifier) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function() {
            innerSub = source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
                if (!errors$) {
                    errors$ = new (0, $hgqF6.Subject)();
                    (0, $kA4PZ.innerFrom)(notifier(errors$)).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
                        return innerSub ? subscribeForRetryWhen() : syncResub = true;
                    }));
                }
                if (errors$) errors$.next(err);
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRetryWhen();
            }
        };
        subscribeForRetryWhen();
    });
}

});

parcelRegister("1JDly", function(module, exports) {

$parcel$export(module.exports, "sample", () => $143883d11b073ec6$export$4812e460280c6ef2);

var $kA4PZ = parcelRequire("kA4PZ");

var $iZT3c = parcelRequire("iZT3c");

var $QfuEL = parcelRequire("QfuEL");

var $lo1Ce = parcelRequire("lo1Ce");
function $143883d11b073ec6$export$4812e460280c6ef2(notifier) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
        }));
        (0, $kA4PZ.innerFrom)(notifier).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        }, (0, $QfuEL.noop)));
    });
}

});

parcelRegister("c1HaV", function(module, exports) {

$parcel$export(module.exports, "sampleTime", () => $8c1711bb29734b43$export$fe33c7b2002d97b0);

var $lbxJc = parcelRequire("lbxJc");

var $1JDly = parcelRequire("1JDly");

var $4BxWH = parcelRequire("4BxWH");
function $8c1711bb29734b43$export$fe33c7b2002d97b0(period, scheduler) {
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    return (0, $1JDly.sample)((0, $4BxWH.interval)(period, scheduler));
}

});

parcelRegister("kSt33", function(module, exports) {

$parcel$export(module.exports, "sequenceEqual", () => $f32f622ee4a43884$export$d0a07e60ae428313);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");
function $f32f622ee4a43884$export$d0a07e60ae428313(compareTo, comparator) {
    if (comparator === void 0) comparator = function(a, b) {
        return a === b;
    };
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var aState = $f32f622ee4a43884$var$createState();
        var bState = $f32f622ee4a43884$var$createState();
        var emit = function(isEqual) {
            subscriber.next(isEqual);
            subscriber.complete();
        };
        var createSubscriber = function(selfState, otherState) {
            var sequenceEqualSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, function(a) {
                var buffer = otherState.buffer, complete = otherState.complete;
                if (buffer.length === 0) complete ? emit(false) : selfState.buffer.push(a);
                else !comparator(a, buffer.shift()) && emit(false);
            }, function() {
                selfState.complete = true;
                var complete = otherState.complete, buffer = otherState.buffer;
                complete && emit(buffer.length === 0);
                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 || sequenceEqualSubscriber.unsubscribe();
            });
            return sequenceEqualSubscriber;
        };
        source.subscribe(createSubscriber(aState, bState));
        (0, $kA4PZ.innerFrom)(compareTo).subscribe(createSubscriber(bState, aState));
    });
}
function $f32f622ee4a43884$var$createState() {
    return {
        buffer: [],
        complete: false
    };
}

});

parcelRegister("hYBh9", function(module, exports) {

$parcel$export(module.exports, "share", () => $d164f4716e54dfe6$export$ed80d9de1d9df928);

var $1Znhr = parcelRequire("1Znhr");

var $kA4PZ = parcelRequire("kA4PZ");

var $hgqF6 = parcelRequire("hgqF6");

var $dUP5u = parcelRequire("dUP5u");

var $iZT3c = parcelRequire("iZT3c");
function $d164f4716e54dfe6$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $hgqF6.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $iZT3c.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $d164f4716e54dfe6$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $dUP5u.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $d164f4716e54dfe6$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $d164f4716e54dfe6$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $kA4PZ.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $d164f4716e54dfe6$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $dUP5u.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $kA4PZ.innerFrom)(on.apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(args)))).subscribe(onSubscriber);
}

});

parcelRegister("kYhhM", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $f446d1dc0b699d35$export$db61d692014e534e);

var $9jHGG = parcelRequire("9jHGG");

var $hYBh9 = parcelRequire("hYBh9");
function $f446d1dc0b699d35$export$db61d692014e534e(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === "object") _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, $hYBh9.share)({
        connector: function() {
            return new (0, $9jHGG.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

});

parcelRegister("QSmkc", function(module, exports) {

$parcel$export(module.exports, "single", () => $09ef0606319439ed$export$863d7ca51b416cee);

var $76qe6 = parcelRequire("76qe6");

var $6NUgf = parcelRequire("6NUgf");

var $eilim = parcelRequire("eilim");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $09ef0606319439ed$export$863d7ca51b416cee(predicate) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var hasValue = false;
        var singleValue;
        var seenValue = false;
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            seenValue = true;
            if (!predicate || predicate(value, index++, source)) {
                hasValue && subscriber.error(new (0, $6NUgf.SequenceError)("Too many matching values"));
                hasValue = true;
                singleValue = value;
            }
        }, function() {
            if (hasValue) {
                subscriber.next(singleValue);
                subscriber.complete();
            } else subscriber.error(seenValue ? new (0, $eilim.NotFoundError)("No matching values") : new (0, $76qe6.EmptyError)());
        }));
    });
}

});
parcelRegister("6NUgf", function(module, exports) {

$parcel$export(module.exports, "SequenceError", () => $4f42f5ef61cab904$export$a0fc65390430a9cd);

var $jaWRE = parcelRequire("jaWRE");
var $4f42f5ef61cab904$export$a0fc65390430a9cd = (0, $jaWRE.createErrorClass)(function(_super) {
    return function SequenceErrorImpl(message) {
        _super(this);
        this.name = "SequenceError";
        this.message = message;
    };
});

});

parcelRegister("eilim", function(module, exports) {

$parcel$export(module.exports, "NotFoundError", () => $a68343ecdaa3e23d$export$78c95b58762d2106);

var $jaWRE = parcelRequire("jaWRE");
var $a68343ecdaa3e23d$export$78c95b58762d2106 = (0, $jaWRE.createErrorClass)(function(_super) {
    return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = "NotFoundError";
        this.message = message;
    };
});

});


parcelRegister("cJyg4", function(module, exports) {

$parcel$export(module.exports, "skip", () => $945442f896b61e87$export$955fc4a6c4be454d);

var $lm9of = parcelRequire("lm9of");
function $945442f896b61e87$export$955fc4a6c4be454d(count) {
    return (0, $lm9of.filter)(function(_, index) {
        return count <= index;
    });
}

});

parcelRegister("9c6vL", function(module, exports) {

$parcel$export(module.exports, "skipLast", () => $6b1a4910f6fc3add$export$635f6273df29ea1c);

var $hYEnO = parcelRequire("hYEnO");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $6b1a4910f6fc3add$export$635f6273df29ea1c(skipCount) {
    return skipCount <= 0 ? (0, $hYEnO.identity) : (0, $iZT3c.operate)(function(source, subscriber) {
        var ring = new Array(skipCount);
        var seen = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var valueIndex = seen++;
            if (valueIndex < skipCount) ring[valueIndex] = value;
            else {
                var index = valueIndex % skipCount;
                var oldValue = ring[index];
                ring[index] = value;
                subscriber.next(oldValue);
            }
        }));
        return function() {
            ring = null;
        };
    });
}

});

parcelRegister("9haIg", function(module, exports) {

$parcel$export(module.exports, "skipUntil", () => $6c0e02f89dc4ee29$export$facc584867c26fde);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");

var $QfuEL = parcelRequire("QfuEL");
function $6c0e02f89dc4ee29$export$facc584867c26fde(notifier) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var taking = false;
        var skipSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            skipSubscriber === null || skipSubscriber === void 0 || skipSubscriber.unsubscribe();
            taking = true;
        }, (0, $QfuEL.noop));
        (0, $kA4PZ.innerFrom)(notifier).subscribe(skipSubscriber);
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return taking && subscriber.next(value);
        }));
    });
}

});

parcelRegister("4Nriv", function(module, exports) {

$parcel$export(module.exports, "skipWhile", () => $37e0e9b83170888a$export$175dedd748069215);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $37e0e9b83170888a$export$175dedd748069215(predicate) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var taking = false;
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return (taking || (taking = !predicate(value, index++))) && subscriber.next(value);
        }));
    });
}

});

parcelRegister("hXjgq", function(module, exports) {

$parcel$export(module.exports, "switchAll", () => $d126e3c213a5bda5$export$6a45284a4b0bf33a);

var $cXeQx = parcelRequire("cXeQx");

var $hYEnO = parcelRequire("hYEnO");
function $d126e3c213a5bda5$export$6a45284a4b0bf33a() {
    return (0, $cXeQx.switchMap)((0, $hYEnO.identity));
}

});
parcelRegister("cXeQx", function(module, exports) {

$parcel$export(module.exports, "switchMap", () => $96e682e6097c57e2$export$9f6ea8e48bc26eab);

var $kA4PZ = parcelRequire("kA4PZ");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $96e682e6097c57e2$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $kA4PZ.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

});


parcelRegister("jNhqV", function(module, exports) {

$parcel$export(module.exports, "switchMapTo", () => $e6901dc9f4d9cf8e$export$a439dc30c845238);

var $cXeQx = parcelRequire("cXeQx");

var $dFWVS = parcelRequire("dFWVS");
function $e6901dc9f4d9cf8e$export$a439dc30c845238(innerObservable, resultSelector) {
    return (0, $dFWVS.isFunction)(resultSelector) ? (0, $cXeQx.switchMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, $cXeQx.switchMap)(function() {
        return innerObservable;
    });
}

});

parcelRegister("7MD3G", function(module, exports) {

$parcel$export(module.exports, "switchScan", () => $5aab5044971e6757$export$70439e4f1e29f3c2);

var $cXeQx = parcelRequire("cXeQx");

var $iZT3c = parcelRequire("iZT3c");
function $5aab5044971e6757$export$70439e4f1e29f3c2(accumulator, seed) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var state = seed;
        (0, $cXeQx.switchMap)(function(value, index) {
            return accumulator(state, value, index);
        }, function(_, innerValue) {
            return state = innerValue, innerValue;
        })(source).subscribe(subscriber);
        return function() {
            state = null;
        };
    });
}

});

parcelRegister("5w0HR", function(module, exports) {

$parcel$export(module.exports, "takeUntil", () => $40407d315c2cba58$export$ac8dfd3a7ad06e80);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");

var $QfuEL = parcelRequire("QfuEL");
function $40407d315c2cba58$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $kA4PZ.innerFrom)(notifier).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, $QfuEL.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

});

parcelRegister("8zrSn", function(module, exports) {

$parcel$export(module.exports, "takeWhile", () => $63d7373b72d018a7$export$9384c7afe4015e42);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $63d7373b72d018a7$export$9384c7afe4015e42(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}

});

parcelRegister("faIkE", function(module, exports) {

$parcel$export(module.exports, "tap", () => $b0ba2d9822618ffe$export$3f23594af5f37336);

var $dFWVS = parcelRequire("dFWVS");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $hYEnO = parcelRequire("hYEnO");
function $b0ba2d9822618ffe$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $dFWVS.isFunction)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $iZT3c.operate)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $hYEnO.identity);
}

});

parcelRegister("cjNL8", function(module, exports) {

$parcel$export(module.exports, "throttle", () => $8f7ddb86af5a0595$export$de363e709c412c8a);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");
function $8f7ddb86af5a0595$export$de363e709c412c8a(durationSelector, config) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var _a = config !== null && config !== void 0 ? config : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function() {
            throttled === null || throttled === void 0 || throttled.unsubscribe();
            throttled = null;
            if (trailing) {
                send();
                isComplete && subscriber.complete();
            }
        };
        var cleanupThrottling = function() {
            throttled = null;
            isComplete && subscriber.complete();
        };
        var startThrottle = function(value) {
            return throttled = (0, $kA4PZ.innerFrom)(durationSelector(value)).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, endThrottling, cleanupThrottling));
        };
        var send = function() {
            if (hasValue) {
                hasValue = false;
                var value = sendValue;
                sendValue = null;
                subscriber.next(value);
                !isComplete && startThrottle(value);
            }
        };
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            sendValue = value;
            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function() {
            isComplete = true;
            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
    });
}

});

parcelRegister("5UZMn", function(module, exports) {

$parcel$export(module.exports, "throttleTime", () => $44f21acad3832b98$export$4efe28f192921dd4);

var $lbxJc = parcelRequire("lbxJc");

var $cjNL8 = parcelRequire("cjNL8");

var $iZWyy = parcelRequire("iZWyy");
function $44f21acad3832b98$export$4efe28f192921dd4(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    var duration$ = (0, $iZWyy.timer)(duration, scheduler);
    return (0, $cjNL8.throttle)(function() {
        return duration$;
    }, config);
}

});

parcelRegister("c121k", function(module, exports) {

$parcel$export(module.exports, "timeInterval", () => $8bf7254125d4cf36$export$1a539c8b2950ab40);

var $lbxJc = parcelRequire("lbxJc");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $8bf7254125d4cf36$export$1a539c8b2950ab40(scheduler) {
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var last = scheduler.now();
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var now = scheduler.now();
            var interval = now - last;
            last = now;
            subscriber.next(new $8bf7254125d4cf36$export$8bb95198b45adaac(value, interval));
        }));
    });
}
var $8bf7254125d4cf36$export$8bb95198b45adaac = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();

});

parcelRegister("30yBm", function(module, exports) {

$parcel$export(module.exports, "timeout", () => $230c365a5b312319$export$83e74882c5df8fe1);

var $lbxJc = parcelRequire("lbxJc");

var $gGn0E = parcelRequire("gGn0E");

var $iZT3c = parcelRequire("iZT3c");

var $kA4PZ = parcelRequire("kA4PZ");

var $jaWRE = parcelRequire("jaWRE");

var $lo1Ce = parcelRequire("lo1Ce");

var $aj4TV = parcelRequire("aj4TV");
var $230c365a5b312319$export$66d311bf29d5c89c = (0, $jaWRE.createErrorClass)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = "Timeout has occurred";
        this.name = "TimeoutError";
        this.info = info;
    };
});
function $230c365a5b312319$export$83e74882c5df8fe1(config, schedulerArg) {
    var _a = (0, $gGn0E.isValidDate)(config) ? {
        first: config
    } : typeof config === "number" ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? $230c365a5b312319$var$timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, $lbxJc.asyncScheduler) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError("No timeout provided.");
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, $kA4PZ.innerFrom)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === "number" ? first : +first - scheduler.now() : each);
    });
}
function $230c365a5b312319$var$timeoutErrorFactory(info) {
    throw new $230c365a5b312319$export$66d311bf29d5c89c(info);
}

});

parcelRegister("1s1wu", function(module, exports) {

$parcel$export(module.exports, "timeoutWith", () => $10e99668e2d5c92b$export$86fe999fba7953f2);

var $lbxJc = parcelRequire("lbxJc");

var $gGn0E = parcelRequire("gGn0E");

var $30yBm = parcelRequire("30yBm");
function $10e99668e2d5c92b$export$86fe999fba7953f2(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : (0, $lbxJc.async);
    if ((0, $gGn0E.isValidDate)(due)) first = due;
    else if (typeof due === "number") each = due;
    if (withObservable) _with = function() {
        return withObservable;
    };
    else throw new TypeError("No observable provided to switch to");
    if (first == null && each == null) throw new TypeError("No timeout provided.");
    return (0, $30yBm.timeout)({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with
    });
}

});

parcelRegister("1RNh6", function(module, exports) {

$parcel$export(module.exports, "timestamp", () => $15c0f6a404ca6d7b$export$fc00ee57782020aa);

var $ggeIx = parcelRequire("ggeIx");

var $6SBin = parcelRequire("6SBin");
function $15c0f6a404ca6d7b$export$fc00ee57782020aa(timestampProvider) {
    if (timestampProvider === void 0) timestampProvider = (0, $ggeIx.dateTimestampProvider);
    return (0, $6SBin.map)(function(value) {
        return {
            value: value,
            timestamp: timestampProvider.now()
        };
    });
}

});

parcelRegister("1MIIZ", function(module, exports) {

$parcel$export(module.exports, "window", () => $14ccf78031d38dbd$export$8291e5b88f90ce4);

var $hgqF6 = parcelRequire("hgqF6");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $QfuEL = parcelRequire("QfuEL");

var $kA4PZ = parcelRequire("kA4PZ");
function $14ccf78031d38dbd$export$8291e5b88f90ce4(windowBoundaries) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var windowSubject = new (0, $hgqF6.Subject)();
        subscriber.next(windowSubject.asObservable());
        var errorHandler = function(err) {
            windowSubject.error(err);
            subscriber.error(err);
        };
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value);
        }, function() {
            windowSubject.complete();
            subscriber.complete();
        }, errorHandler));
        (0, $kA4PZ.innerFrom)(windowBoundaries).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            windowSubject.complete();
            subscriber.next(windowSubject = new (0, $hgqF6.Subject)());
        }, (0, $QfuEL.noop), errorHandler));
        return function() {
            windowSubject === null || windowSubject === void 0 || windowSubject.unsubscribe();
            windowSubject = null;
        };
    });
}

});

parcelRegister("3VCv5", function(module, exports) {

$parcel$export(module.exports, "windowCount", () => $2dc48f56e4ea3ae4$export$f3a19e933f377396);

var $1Znhr = parcelRequire("1Znhr");

var $hgqF6 = parcelRequire("hgqF6");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $2dc48f56e4ea3ae4$export$f3a19e933f377396(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var windows = [
            new (0, $hgqF6.Subject)()
        ];
        var starts = [];
        var count = 0;
        subscriber.next(windows[0].asObservable());
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var windows_1 = (0, $1Znhr.__values)(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()){
                    var window_1 = windows_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var c = count - windowSize + 1;
            if (c >= 0 && c % startEvery === 0) windows.shift().complete();
            if (++count % startEvery === 0) {
                var window_2 = new (0, $hgqF6.Subject)();
                windows.push(window_2);
                subscriber.next(window_2.asObservable());
            }
        }, function() {
            while(windows.length > 0)windows.shift().complete();
            subscriber.complete();
        }, function(err) {
            while(windows.length > 0)windows.shift().error(err);
            subscriber.error(err);
        }, function() {
            starts = null;
            windows = null;
        }));
    });
}

});

parcelRegister("8tBYU", function(module, exports) {

$parcel$export(module.exports, "windowTime", () => $62be7e7957a3bcb9$export$1284415effa79ee0);

var $hgqF6 = parcelRequire("hgqF6");

var $lbxJc = parcelRequire("lbxJc");

var $fgwAY = parcelRequire("fgwAY");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $ebAl1 = parcelRequire("ebAl1");

var $6kN4i = parcelRequire("6kN4i");

var $aj4TV = parcelRequire("aj4TV");
function $62be7e7957a3bcb9$export$1284415effa79ee0(windowTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = (0, $6kN4i.popScheduler)(otherArgs)) !== null && _a !== void 0 ? _a : (0, $lbxJc.asyncScheduler);
    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxWindowSize = otherArgs[1] || Infinity;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var windowRecords = [];
        var restartOnClose = false;
        var closeWindow = function(record) {
            var window = record.window, subs = record.subs;
            window.complete();
            subs.unsubscribe();
            (0, $ebAl1.arrRemove)(windowRecords, record);
            restartOnClose && startWindow();
        };
        var startWindow = function() {
            if (windowRecords) {
                var subs = new (0, $fgwAY.Subscription)();
                subscriber.add(subs);
                var window_1 = new (0, $hgqF6.Subject)();
                var record_1 = {
                    window: window_1,
                    subs: subs,
                    seen: 0
                };
                windowRecords.push(record_1);
                subscriber.next(window_1.asObservable());
                (0, $aj4TV.executeSchedule)(subs, scheduler, function() {
                    return closeWindow(record_1);
                }, windowTimeSpan);
            }
        };
        if (windowCreationInterval !== null && windowCreationInterval >= 0) (0, $aj4TV.executeSchedule)(subscriber, scheduler, startWindow, windowCreationInterval, true);
        else restartOnClose = true;
        startWindow();
        var loop = function(cb) {
            return windowRecords.slice().forEach(cb);
        };
        var terminate = function(cb) {
            loop(function(_a) {
                var window = _a.window;
                return cb(window);
            });
            cb(subscriber);
            subscriber.unsubscribe();
        };
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            loop(function(record) {
                record.window.next(value);
                maxWindowSize <= ++record.seen && closeWindow(record);
            });
        }, function() {
            return terminate(function(consumer) {
                return consumer.complete();
            });
        }, function(err) {
            return terminate(function(consumer) {
                return consumer.error(err);
            });
        }));
        return function() {
            windowRecords = null;
        };
    });
}

});

parcelRegister("bccpe", function(module, exports) {

$parcel$export(module.exports, "windowToggle", () => $826a70460f3a2ea5$export$3182be990e0eeaad);

var $1Znhr = parcelRequire("1Znhr");

var $hgqF6 = parcelRequire("hgqF6");

var $fgwAY = parcelRequire("fgwAY");

var $iZT3c = parcelRequire("iZT3c");

var $kA4PZ = parcelRequire("kA4PZ");

var $lo1Ce = parcelRequire("lo1Ce");

var $QfuEL = parcelRequire("QfuEL");

var $ebAl1 = parcelRequire("ebAl1");
function $826a70460f3a2ea5$export$3182be990e0eeaad(openings, closingSelector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var windows = [];
        var handleError = function(err) {
            while(0 < windows.length)windows.shift().error(err);
            subscriber.error(err);
        };
        (0, $kA4PZ.innerFrom)(openings).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(openValue) {
            var window = new (0, $hgqF6.Subject)();
            windows.push(window);
            var closingSubscription = new (0, $fgwAY.Subscription)();
            var closeWindow = function() {
                (0, $ebAl1.arrRemove)(windows, window);
                window.complete();
                closingSubscription.unsubscribe();
            };
            var closingNotifier;
            try {
                closingNotifier = (0, $kA4PZ.innerFrom)(closingSelector(openValue));
            } catch (err) {
                handleError(err);
                return;
            }
            subscriber.next(window.asObservable());
            closingSubscription.add(closingNotifier.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, closeWindow, (0, $QfuEL.noop), handleError)));
        }, (0, $QfuEL.noop)));
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            var windowsCopy = windows.slice();
            try {
                for(var windowsCopy_1 = (0, $1Znhr.__values)(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()){
                    var window_1 = windowsCopy_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(0 < windows.length)windows.shift().complete();
            subscriber.complete();
        }, handleError, function() {
            while(0 < windows.length)windows.shift().unsubscribe();
        }));
    });
}

});

parcelRegister("2yc02", function(module, exports) {

$parcel$export(module.exports, "windowWhen", () => $1db810a163cd3481$export$6a5dea797879f644);

var $hgqF6 = parcelRequire("hgqF6");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");
function $1db810a163cd3481$export$6a5dea797879f644(closingSelector) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var window;
        var closingSubscriber;
        var handleError = function(err) {
            window.error(err);
            subscriber.error(err);
        };
        var openWindow = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window === null || window === void 0 || window.complete();
            window = new (0, $hgqF6.Subject)();
            subscriber.next(window.asObservable());
            var closingNotifier;
            try {
                closingNotifier = (0, $kA4PZ.innerFrom)(closingSelector());
            } catch (err) {
                handleError(err);
                return;
            }
            closingNotifier.subscribe(closingSubscriber = (0, $lo1Ce.createOperatorSubscriber)(subscriber, openWindow, openWindow, handleError));
        };
        openWindow();
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return window.next(value);
        }, function() {
            window.complete();
            subscriber.complete();
        }, handleError, function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window = null;
        }));
    });
}

});

parcelRegister("bnKNM", function(module, exports) {

$parcel$export(module.exports, "zip", () => $84962598ffee23f9$export$8901015135f2fb22);

var $1Znhr = parcelRequire("1Znhr");

var $8SEJS = parcelRequire("8SEJS");

var $iZT3c = parcelRequire("iZT3c");
function $84962598ffee23f9$export$8901015135f2fb22() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $8SEJS.zip).apply(void 0, (0, $1Znhr.__spreadArray)([
            source
        ], (0, $1Znhr.__read)(sources))).subscribe(subscriber);
    });
}

});
parcelRegister("8SEJS", function(module, exports) {

$parcel$export(module.exports, "zip", () => $6772f7c2267ab5e4$export$8901015135f2fb22);

var $1Znhr = parcelRequire("1Znhr");

var $gN3J6 = parcelRequire("gN3J6");

var $kA4PZ = parcelRequire("kA4PZ");

var $97UFc = parcelRequire("97UFc");

var $dMQAa = parcelRequire("dMQAa");

var $lo1Ce = parcelRequire("lo1Ce");

var $6kN4i = parcelRequire("6kN4i");
function $6772f7c2267ab5e4$export$8901015135f2fb22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, $6kN4i.popResultSelector)(args);
    var sources = (0, $97UFc.argsOrArgArray)(args);
    return sources.length ? new (0, $gN3J6.Observable)(function(subscriber) {
        var buffers = sources.map(function() {
            return [];
        });
        var completed = sources.map(function() {
            return false;
        });
        subscriber.add(function() {
            buffers = completed = null;
        });
        var _loop_1 = function(sourceIndex) {
            (0, $kA4PZ.innerFrom)(sources[sourceIndex]).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
                buffers[sourceIndex].push(value);
                if (buffers.every(function(buffer) {
                    return buffer.length;
                })) {
                    var result = buffers.map(function(buffer) {
                        return buffer.shift();
                    });
                    subscriber.next(resultSelector ? resultSelector.apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(result))) : result);
                    if (buffers.some(function(buffer, i) {
                        return !buffer.length && completed[i];
                    })) subscriber.complete();
                }
            }, function() {
                completed[sourceIndex] = true;
                !buffers[sourceIndex].length && subscriber.complete();
            }));
        };
        for(var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++)_loop_1(sourceIndex);
        return function() {
            buffers = completed = null;
        };
    }) : (0, $dMQAa.EMPTY);
}

});


parcelRegister("4B7Q6", function(module, exports) {

$parcel$export(module.exports, "zipAll", () => $3590b2dae7078ad7$export$adddb6a2fa3864e9);

var $8SEJS = parcelRequire("8SEJS");

var $2LTlf = parcelRequire("2LTlf");
function $3590b2dae7078ad7$export$adddb6a2fa3864e9(project) {
    return (0, $2LTlf.joinAllInternals)((0, $8SEJS.zip), project);
}

});

parcelRegister("lXhld", function(module, exports) {

$parcel$export(module.exports, "zipWith", () => $ffbc8f43085f6dfa$export$b634740ce272acb5);

var $1Znhr = parcelRequire("1Znhr");

var $bnKNM = parcelRequire("bnKNM");
function $ffbc8f43085f6dfa$export$b634740ce272acb5() {
    var otherInputs = [];
    for(var _i = 0; _i < arguments.length; _i++)otherInputs[_i] = arguments[_i];
    return (0, $bnKNM.zip).apply(void 0, (0, $1Znhr.__spreadArray)([], (0, $1Znhr.__read)(otherInputs)));
}

});


// lib

var $2Z6Kw = parcelRequire("2Z6Kw");
/**
 * @module iblokz-state
 * @description Lightweight state management utilities for JavaScript
 * @version 1.0.1
 */ /**
 * State Machine
 * @module core
 */ 
var $4iRTc = parcelRequire("4iRTc");
var $1Znhr = parcelRequire("1Znhr");

var $kA4PZ = parcelRequire("kA4PZ");

var $gN3J6 = parcelRequire("gN3J6");

var $drQX9 = parcelRequire("drQX9");

var $deWbE = parcelRequire("deWbE");

var $dFWVS = parcelRequire("dFWVS");

var $hYp6u = parcelRequire("hYp6u");
var $c04cd9fa17908b59$var$nodeEventEmitterMethods = [
    "addListener",
    "removeListener"
];
var $c04cd9fa17908b59$var$eventTargetMethods = [
    "addEventListener",
    "removeEventListener"
];
var $c04cd9fa17908b59$var$jqueryMethods = [
    "on",
    "off"
];
function $c04cd9fa17908b59$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $dFWVS.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $c04cd9fa17908b59$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $hYp6u.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $1Znhr.__read)($c04cd9fa17908b59$var$isEventTarget(target) ? $c04cd9fa17908b59$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $c04cd9fa17908b59$var$isNodeStyleEventEmitter(target) ? $c04cd9fa17908b59$var$nodeEventEmitterMethods.map($c04cd9fa17908b59$var$toCommonHandlerRegistry(target, eventName)) : $c04cd9fa17908b59$var$isJQueryStyleEventEmitter(target) ? $c04cd9fa17908b59$var$jqueryMethods.map($c04cd9fa17908b59$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $deWbE.isArrayLike)(target)) return (0, $drQX9.mergeMap)(function(subTarget) {
            return $c04cd9fa17908b59$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $kA4PZ.innerFrom)(target));
    }
    if (!add) throw new TypeError("Invalid event target");
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $c04cd9fa17908b59$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $c04cd9fa17908b59$var$isNodeStyleEventEmitter(target) {
    return (0, $dFWVS.isFunction)(target.addListener) && (0, $dFWVS.isFunction)(target.removeListener);
}
function $c04cd9fa17908b59$var$isJQueryStyleEventEmitter(target) {
    return (0, $dFWVS.isFunction)(target.on) && (0, $dFWVS.isFunction)(target.off);
}
function $c04cd9fa17908b59$var$isEventTarget(target) {
    return (0, $dFWVS.isFunction)(target.addEventListener) && (0, $dFWVS.isFunction)(target.removeEventListener);
}


var $6SBin = parcelRequire("6SBin");
var $f6wSa = parcelRequire("f6wSa");
var $aRUkQ = parcelRequire("aRUkQ");
/**
 * Storage utilities for localStorage/sessionStorage
 * @module storage
 */ /**
 * Get item from storage with JSON parsing
 * @memberof module:storage
 * @param {Storage} storage - localStorage or sessionStorage
 * @param {string} key - Storage key
 * @param {*} defaultValue - Default value if not found
 * @return {*} Parsed value or default
 */ const $79ea37aa36b32bc9$export$3988ae62b71be9a3 = (storage, key, defaultValue)=>(storage.getItem(key) && JSON.parse(storage.getItem(key))) ?? defaultValue;
const $79ea37aa36b32bc9$export$adaa4cf7ef1b65be = (storage, key, value)=>storage.setItem(key, JSON.stringify(value));
const $79ea37aa36b32bc9$export$2cd8252107eb640b = (storage)=>storage ? {
        storage: storage,
        get: (key, defaultValue)=>$79ea37aa36b32bc9$export$3988ae62b71be9a3(storage, key, defaultValue),
        set: (key, value)=>$79ea37aa36b32bc9$export$adaa4cf7ef1b65be(storage, key, value)
    } : null;


const $0dd1b25395c80137$export$635e15bbd66f01ea = (change, namespace = "state.changes")=>document.dispatchEvent(new CustomEvent(namespace, {
        detail: change
    }));
const $0dd1b25395c80137$export$bb44f104e3c54dae = (namespace = "state.changes")=>(0, $c04cd9fa17908b59$export$a36e16046ae8f1bb)(document, namespace).pipe((0, $6SBin.map)((ev)=>ev.detail));
const $0dd1b25395c80137$export$2cd8252107eb640b = (initial = {}, namespace = "state.changes", storage = null)=>{
    const storageInstance = (0, $79ea37aa36b32bc9$export$2cd8252107eb640b)(storage);
    const initialState = storageInstance ? storageInstance.get(namespace, initial) : initial;
    const state$ = new (0, $4iRTc.BehaviorSubject)(initialState);
    storageInstance && state$.subscribe((state)=>{
        storageInstance.set(namespace, state);
    });
    $0dd1b25395c80137$export$bb44f104e3c54dae(namespace).pipe((0, $aRUkQ.startWith)(()=>initialState), (0, $f6wSa.scan)((state, change)=>change(state), {})).subscribe(state$);
    return state$;
};



/**
 * Action tree adapter - converts action trees to auto-dispatching APIs
 * @module adapt
 */ 
var $hgqF6 = parcelRequire("hgqF6");

var $jjnZg = parcelRequire("jjnZg");

/**
 * Check if value is a Promise
 * @private
 * @param {*} value - Value to check
 * @return {boolean} True if value is a Promise
 */ const $0b23034ab663e0da$var$isPromise = (value)=>value && typeof value.then === "function";
const $0b23034ab663e0da$export$68acc490bdb30af7 = (tree, namespace = "state.changes", path = [])=>{
    // Create stream for this level (root creates Subject, children reuse parent's)
    const stream = path.length === 0 ? new (0, $hgqF6.Subject)() : null;
    const rootStream = stream || tree._rootStream;
    const adapted = Object.keys(tree).filter((key)=>key !== "initial" && key !== "_rootStream").reduce((acc, key)=>{
        const value = tree[key];
        // Handle functions - wrap to auto-dispatch
        if (typeof value === "function") acc[key] = function(...args) {
            // Call original function to get reducer
            const result = value(...args);
            // Handle async/Promise results
            const handleResult = (reducer)=>{
                // Dispatch the reducer
                (0, $0dd1b25395c80137$export$635e15bbd66f01ea)(reducer, namespace);
                // Emit metadata to stream
                rootStream && rootStream.next({
                    path: [
                        ...path,
                        key
                    ],
                    payload: args,
                    reducer: reducer
                });
            };
            if ($0b23034ab663e0da$var$isPromise(result)) result.then(handleResult);
            else handleResult(result);
        };
        else if (value && typeof value === "object" && !Array.isArray(value)) {
            // Handle nested objects - recurse
            const nested = $0b23034ab663e0da$export$68acc490bdb30af7({
                ...value,
                _rootStream: rootStream
            }, namespace, [
                ...path,
                key
            ]);
            // Merge nested initial into parent
            if (nested.initial) acc.initial = {
                ...acc.initial,
                [key]: nested.initial
            };
            acc[key] = nested;
        } else // Handle other values (primitives, arrays)
        acc[key] = value;
        return acc;
    }, {
        initial: tree.initial || {},
        ...stream ? {
            stream: stream
        } : {}
    });
    return adapted;
};
const $0b23034ab663e0da$export$5ddf9e484e541d6f = (tree, path, node)=>{
    // Normalize path to array
    const pathArray = typeof path === "string" ? path.split(".") : path;
    // Get namespace from tree if available
    const namespace = tree._namespace || "state.changes";
    // Adapt the new node with the tree's root stream
    const adaptedNode = $0b23034ab663e0da$export$68acc490bdb30af7({
        ...node,
        _rootStream: tree.stream
    }, namespace, pathArray);
    // Patch the tree and initial state using iblokz-data
    return {
        ...(0, $jjnZg.obj).patch(tree, pathArray, adaptedNode),
        initial: (0, $jjnZg.obj).patch(tree.initial, pathArray, adaptedNode.initial),
        stream: tree.stream,
        _namespace: namespace
    };
};
const $0b23034ab663e0da$export$e6a0daad8304de = (tree, namespace = "state.changes", storage = null)=>{
    const actions = $0b23034ab663e0da$export$68acc490bdb30af7(tree, namespace);
    // Store namespace for later use (e.g., with attach)
    actions._namespace = namespace;
    const state$ = (0, $0dd1b25395c80137$export$2cd8252107eb640b)(actions.initial, namespace, storage);
    return {
        actions: actions,
        state$: state$
    };
};




var $8f6a480bb40b134f$require$createState = $0b23034ab663e0da$export$e6a0daad8304de;
var $8f6a480bb40b134f$require$attach = $0b23034ab663e0da$export$5ddf9e484e541d6f;

var $cl3AY = parcelRequire("cl3AY");
window.a = $cl3AY;

var $k25bp = parcelRequire("k25bp");

$k25bp.registerPlugin((parcelRequire("2eJo6")));
$k25bp.defaultOptions.className = "vex-theme-top";

// tap tempo
const $8f6a480bb40b134f$var$tapTempo = (parcelRequire("8oAsx"))();

var $8f6a480bb40b134f$require$actionsTree = (parcelRequire("6dWku"));
let { actions: $8f6a480bb40b134f$var$actions, state$: $8f6a480bb40b134f$var$state$ } = $8f6a480bb40b134f$require$createState($8f6a480bb40b134f$require$actionsTree);

var $XfAip = parcelRequire("XfAip");
$8f6a480bb40b134f$var$actions = $8f6a480bb40b134f$require$attach($8f6a480bb40b134f$var$actions, "pianoRoll", $XfAip.actions);
// Expose actions and state for testing (after they're created)
if (typeof window !== "undefined") {
    window.__jamStationActions = $8f6a480bb40b134f$var$actions;
    window.__jamStationState$ = $8f6a480bb40b134f$var$state$;
}

var $8f6a480bb40b134f$require$ui = (parcelRequire("cVcju"));
// util
var $0808a3fd9e18c884$exports = {};
"use strict";

var $0808a3fd9e18c884$require$fromEvent = $c04cd9fa17908b59$export$a36e16046ae8f1bb;
let $0808a3fd9e18c884$var$unhook = ()=>{};

const $0808a3fd9e18c884$var$hook = ({ state$: state$, actions: actions })=>{
    let subs = [];
    // mouse movement
    /*
	$.fromEvent(document, 'mousemove')
		.subscribe(ev => actions.set(['viewport', 'mouse'], {
			x: ev.pageX,
			y: ev.pageY
		}));
	*/ const { startWith: startWith } = (parcelRequire("2QuXx"));
    subs.push($0808a3fd9e18c884$require$fromEvent(window, "resize").pipe(startWith({})).subscribe((ev)=>actions.set([
            "viewport",
            "screen"
        ], {
            width: window.innerWidth,
            height: window.innerHeight,
            size: window.innerWidth >= 1200 ? "xl" : window.innerWidth >= 992 ? "lg" : window.innerWidth >= 768 ? "md" : window.innerWidth >= 576 ? "sm" : "xs"
        })));
    $0808a3fd9e18c884$var$unhook = ()=>subs.forEach((sub)=>sub.unsubscribe());
};
$0808a3fd9e18c884$exports = {
    hook: $0808a3fd9e18c884$var$hook,
    unhook: $0808a3fd9e18c884$var$unhook
};


var $c61ff34229e69da6$exports = {};
"use strict";

var $jjnZg = parcelRequire("jjnZg");
var $c61ff34229e69da6$require$obj = $jjnZg.obj;
var $c61ff34229e69da6$require$fn = $jjnZg.fn;

var $glUu6 = parcelRequire("glUu6");
var $c61ff34229e69da6$require$distinctUntilChanged = $glUu6.distinctUntilChanged;
// TODO: Replace with arr.patchAt from iblokz-data after it is updated
/**
 * Immutably patches an array at a given index.
 * @param {Array} arr - The source array
 * @param {number} index - The index to patch
 * @param {Object|Function} patch - The patch to apply
 * @returns {Array} A new array with the patch applied
 */ const $c61ff34229e69da6$var$arrPatchAt = (arr = [], index, patch)=>[].concat(// if index is greater than 0, slice the array up to the index
    index > 0 ? arr.slice(0, index) : [], // if index is greater than the array length, fill the array with undefined up to the index
    arr.length - 1 < index ? new Array(index - arr.length).fill(undefined) : [], // if patch is a function, call it with the array at the index, otherwise apply the patch directly
    patch instanceof Function ? patch(arr[index] ?? {}) : Object.assign({}, arr[index], patch), // if index is less than the array length - 1, slice the array from the index + 1
    index < arr.length - 1 ? arr.slice(index + 1) : []);
let $c61ff34229e69da6$var$unhook = ()=>{};
const $c61ff34229e69da6$var$hook = ({ state$: state$, actions: actions })=>{
    let subs = [];
    // on selection change update editors
    // on editor change update selected
    // sequencer
    subs.push(state$.pipe($c61ff34229e69da6$require$distinctUntilChanged((prev, curr)=>JSON.stringify(prev.sequencer) === JSON.stringify(curr.sequencer))).subscribe((state)=>$c61ff34229e69da6$require$fn.pipe(([trackNumber, measureRow])=>actions.set([
                "session",
                "tracks"
            ], $c61ff34229e69da6$var$arrPatchAt(state.session.tracks, trackNumber, {
                measures: $c61ff34229e69da6$var$arrPatchAt(state.session.tracks[trackNumber].measures, measureRow, state.sequencer)
            })))(state.session.selection.seq)));
    // piano-roll — sync only musical data to the measure, not UI state
    subs.push(state$.pipe($c61ff34229e69da6$require$distinctUntilChanged((prev, curr)=>JSON.stringify({
            events: prev.pianoRoll && prev.pianoRoll.events,
            barsLength: prev.pianoRoll && prev.pianoRoll.barsLength
        }) === JSON.stringify({
            events: curr.pianoRoll && curr.pianoRoll.events,
            barsLength: curr.pianoRoll && curr.pianoRoll.barsLength
        }))).subscribe((state)=>$c61ff34229e69da6$require$fn.pipe(([trackNumber, measureRow])=>actions.set([
                "session",
                "tracks"
            ], $c61ff34229e69da6$var$arrPatchAt(state.session.tracks, trackNumber, {
                measures: $c61ff34229e69da6$var$arrPatchAt(state.session.tracks[trackNumber].measures, measureRow, (measure)=>Object.assign({}, measure, {
                        events: state.pianoRoll.events,
                        barsLength: state.pianoRoll.barsLength
                    }))
            })))(state.session.selection.piano)));
    // instrument - sync to track based on selection.instr
    subs.push(state$.pipe($c61ff34229e69da6$require$distinctUntilChanged((prev, curr)=>JSON.stringify(prev.instrument) === JSON.stringify(curr.instrument))).subscribe((state)=>$c61ff34229e69da6$require$fn.pipe(([trackNumber, measureRow])=>actions.set([
                "session",
                "tracks"
            ], $c61ff34229e69da6$var$arrPatchAt(state.session.tracks, trackNumber, Object.assign({}, state.session.tracks[trackNumber] || {}, {
                inst: state.instrument
            }))))(state.session.selection.instr)));
    $c61ff34229e69da6$var$unhook = ()=>subs.forEach((sub)=>sub.unsubscribe());
};
$c61ff34229e69da6$exports = {
    hook: $c61ff34229e69da6$var$hook,
    unhook: $c61ff34229e69da6$var$unhook
};


var $8d53476bf4d7eba7$exports = {};
"use strict";

var $cl3AY = parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $fbcJ7 = parcelRequire("fbcJ7");

var $cl3AY = parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $fbcJ7 = parcelRequire("fbcJ7");
var $8d53476bf4d7eba7$require$sampler = $fbcJ7;

var $gsDht = parcelRequire("gsDht");
var $8d53476bf4d7eba7$require$measureToBeatLength = $gsDht.measureToBeatLength;
var $8d53476bf4d7eba7$require$bpmToTime = $gsDht.bpmToTime;

var $jjnZg = parcelRequire("jjnZg");
var $8d53476bf4d7eba7$require$obj = $jjnZg.obj;

var $kKA2u = parcelRequire("kKA2u");

var $hgqF6 = parcelRequire("hgqF6");
var $8d53476bf4d7eba7$require$Subject = $hgqF6.Subject;
const $8d53476bf4d7eba7$var$stream = new $8d53476bf4d7eba7$require$Subject();
const $8d53476bf4d7eba7$var$reverb = $cl3AY.create("reverb", {
    on: true,
    wet: 0.1,
    dry: 0.9
});
$cl3AY.connect($8d53476bf4d7eba7$var$reverb, $ekqew.context.destination);

var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $6SBin = parcelRequire("6SBin");
var $8d53476bf4d7eba7$require$filter = $lm9of.filter;
var $8d53476bf4d7eba7$require$distinctUntilChanged = $glUu6.distinctUntilChanged;
var $8d53476bf4d7eba7$require$map = $6SBin.map;
const $8d53476bf4d7eba7$var$hook = ({ state$: state$, actions: actions })=>{
    const sampleBank$ = $kKA2u.stream.pipe($8d53476bf4d7eba7$require$filter((p)=>p.sampleBank), $8d53476bf4d7eba7$require$distinctUntilChanged((prev, curr)=>{
        const prevBank = prev.sampleBank;
        const currBank = curr.sampleBank;
        return prevBank === currBank;
    }), $8d53476bf4d7eba7$require$map((p)=>p.sampleBank));
    let buffer = [];
    const clearBuffer = ()=>{
        // console.log(buffer);
        buffer.forEach((inst)=>{
            inst.output.disconnect($8d53476bf4d7eba7$var$reverb.input);
            $cl3AY.stop(inst);
        });
        buffer = [];
    };
// state$.distinctUntilChanged(state => state.studio.playing)
// 	.filter(state => !state.studio.playing)
// 	.subscribe(() => clearBuffer());
// state$.distinctUntilChanged(state => state.studio.bpm)
// 	.filter(state => state.studio.playing)
// 	.subscribe(() => clearBuffer());
// state$
// 	.distinctUntilChanged(state => state.studio.tick)
// 	.filter(state => state.studio.playing)
// 	.combineLatest(sampleBank$, (state, sampleBank) => ({state, sampleBank}))
// 	.subscribe(({state: {mediaLibrary, studio, sequencer}, sampleBank}) => {
// 		if (studio.tick.index === studio.beatLength - 1 || buffer.length === 0) {
// 			let start = (studio.tick.index === studio.beatLength - 1) ? 0 : studio.tick.index;
// 			// let start = studio.tick.index;
// 			let offset = buffer.length === 0 ? 0 : 1;
//
// 			for (let i = start; i < studio.beatLength; i++) {
// 				let timepos = studio.tick.time + ((i - start + offset) * bpmToTime(studio.bpm));
// 				// console.log({timepos, start, offset, i});
// 				sequencer.pattern[
// 					(studio.tick.index === studio.beatLength - 1)
// 						? (studio.tick.bar < sequencer.barsLength - 1) ? studio.tick.bar + 1 : 0
// 						: studio.tick.bar
// 				].forEach((row, k) => {
// 					if (row[i]) {
// 						console.log(sequencer.channels[k]);
// 						let inst = sampler.clone(sampleBank[
// 							mediaLibrary.files[
// 								sequencer.channels[k]
// 							]
// 						]);
// 						audio.connect(inst, reverb);
// 						audio.start(inst, timepos);
// 						// inst.trigger({studio}, timepos);
// 						buffer.push(inst);
// 					}
// 				});
// 			}
// 			// }
// 			// next index
// 			/*
// 			for (let i = 0; i < state.studio.beatLength; i++) {
// 				let timepos = now + ((state.studio.beatLength + i - state.studio.tickIndex) * bpmToTime(state.studio.bpm));
// 				state.sequencer.pattern[state.sequencer.bar].forEach((row, k) => {
// 					if (row[i]) {
// 						let inst = kit[state.sequencer.channels[k]].clone();
// 						inst.trigger(state, timepos);
// 						buffer.push(inst);
// 					}
// 				});
// 			}
// 			*/
// 		}
// 		/*
// 		state.pattern.forEach((row, i) => {
// 			(row[state.studio.tickIndex]) && kit[i].play()));
// 		}
// 		*/
// 	});
// let voices = {};
// const notesPattern = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
//
// state$.distinctUntilChanged(state => state.midiMap.channels)
// 	.map(state => ({
// 		state,
// 		pressed: Object.keys(state.midiMap.channels).filter(ch => parseInt(ch, 10) === 10).reduce(
// 			(pressed, ch) => Object.assign({}, pressed, state.midiMap.channels[ch]),
// 			{}
// 		)
// 	}))
// 	.combineLatest(sampleBank$, ({state, pressed}, sampleBank) => ({state, pressed, sampleBank}))
// 	.subscribe(({state, pressed, sampleBank}) => {
// 		// console.log(pressed);
// 		Object.keys(pressed).filter(note => !voices[note])
// 			.forEach(
// 				note => {
// 					const index = notesPattern.indexOf(note.replace(/[0-9]/, ''));
// 					if (index > -1 && state.sequencer.channels[index]) {
// 						let inst = sampler.clone(sampleBank[
// 							state.mediaLibrary.files[
// 								state.sequencer.channels[index]
// 							]
// 						]);
// 						audio.connect(inst, reverb);
// 						setTimeout(() => audio.start(inst));
// 						voices[note] = inst;
// 					}
// 				}
// 			);
// 		Object.keys(voices).filter(note => !pressed[note])
// 			.forEach(
// 				note => {
// 					if (voices[note]) {
// 						setTimeout(() => {
// 							voices[note].output.disconnect(reverb.input);
// 							audio.stop(voices[note]);
// 							voices = obj.filter(voices, key => key !== note);
// 						});
// 					}
// 				}
// 			);
// 	});
};
$8d53476bf4d7eba7$exports = {
    hook: $8d53476bf4d7eba7$var$hook
};


var $b50c4af2ab2cac82$exports = {};
"use strict";

var $4iRTc = parcelRequire("4iRTc");
var $hgqF6 = parcelRequire("hgqF6");
var $b50c4af2ab2cac82$require$Subject = $hgqF6.Subject;
var $b50c4af2ab2cac82$require$BehaviorSubject = $4iRTc.BehaviorSubject;

var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $6SBin = parcelRequire("6SBin");
var $f6wSa = parcelRequire("f6wSa");
var $aRUkQ = parcelRequire("aRUkQ");
var $fFMKM = parcelRequire("fFMKM");
var $9Jxex = parcelRequire("9Jxex");
var $b50c4af2ab2cac82$require$distinctUntilChanged = $glUu6.distinctUntilChanged;
var $b50c4af2ab2cac82$require$filter = $lm9of.filter;
var $b50c4af2ab2cac82$require$map = $6SBin.map;
var $b50c4af2ab2cac82$require$take = $fFMKM.take;
var $b50c4af2ab2cac82$require$scan = $f6wSa.scan;
var $b50c4af2ab2cac82$require$startWith = $aRUkQ.startWith;
var $b50c4af2ab2cac82$require$withLatestFrom = $9Jxex.withLatestFrom;

var $jjnZg = parcelRequire("jjnZg");
var $b50c4af2ab2cac82$require$obj = $jjnZg.obj;
var $b50c4af2ab2cac82$require$fn = $jjnZg.fn;
var $b50c4af2ab2cac82$require$arr = $jjnZg.arr;

var $cl3AY = parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $fbcJ7 = parcelRequire("fbcJ7");

var $kTQ8i = parcelRequire("kTQ8i");

var $cl3AY = parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $fbcJ7 = parcelRequire("fbcJ7");
var $b50c4af2ab2cac82$require$sampler = $fbcJ7;

var $gsDht = parcelRequire("gsDht");
var $b50c4af2ab2cac82$require$measureToBeatLength = $gsDht.measureToBeatLength;
var $b50c4af2ab2cac82$require$bpmToTime = $gsDht.bpmToTime;

var $kKA2u = parcelRequire("kKA2u");

var $cl3AY = parcelRequire("cl3AY");

var $54T0Q = parcelRequire("54T0Q");

var $jjnZg = parcelRequire("jjnZg");
// id -> node
const $57240976e2401e47$var$nodesMap = {};
const $57240976e2401e47$export$3988ae62b71be9a3 = (id)=>$57240976e2401e47$var$nodesMap[id];
const $57240976e2401e47$export$e16d8520af44a096 = (id, node)=>(Object.assign($57240976e2401e47$var$nodesMap, {
        [id]: node
    }), node);
const $57240976e2401e47$export$cd7f480d6b8286c3 = (id)=>delete $57240976e2401e47$var$nodesMap[id];
const $57240976e2401e47$export$185802fd694ee1f5 = (type, prefs = {}, id = (0, $54T0Q.default)())=>$57240976e2401e47$export$e16d8520af44a096(id, Object.assign($cl3AY.create(type, prefs), {
        id: id
    }));
const $57240976e2401e47$export$b1fb4cac938035f7 = (node)=>(0, $jjnZg.fn).pipe(()=>typeof node === "string" ? $57240976e2401e47$export$3988ae62b71be9a3(node) : node, (node)=>node && (node.source && node.source.stop && node.source.stop(), node.input && node.input.disconnect && node.input.disconnect(), node.output && node.output.disconnect && node.output.disconnect(), node.through && node.through.disconnect && node.through.disconnect(), $57240976e2401e47$export$cd7f480d6b8286c3(node.id)))();
const $57240976e2401e47$export$37dfea93db2e14ed = (node)=>(0, $jjnZg.fn).pipe(()=>typeof node === "string" ? $57240976e2401e47$export$3988ae62b71be9a3(node) : node, (node)=>node && // node.input && node.input.disconnect && node.input.disconnect(),
        (node.output && node.output.disconnect && node.output.disconnect(), node.through && node.through.disconnect && node.through.disconnect()))();
const $57240976e2401e47$export$64605811ab45167f = (source, destination)=>(0, $jjnZg.fn).pipe(()=>({
            source: typeof source === "string" ? $57240976e2401e47$export$3988ae62b71be9a3(source) : source,
            destination: typeof destination === "string" ? $57240976e2401e47$export$3988ae62b71be9a3(destination) : destination
        }), ({ source: source, destination: destination })=>source && destination && (source instanceof AudioNode ? source : source.output || source.through).connect(destination instanceof AudioNode ? destination : destination.input || destination.through))();
const $57240976e2401e47$export$e08e3b67e392101e = (...nodes)=>(nodes.forEach((n, i)=>nodes[i + 1] && $57240976e2401e47$export$64605811ab45167f(n, nodes[i + 1])), nodes[0]);


// creates a map of pressed notes for the given track
const $b50c4af2ab2cac82$var$prepPressed = (channels, track)=>track.input.device > -1 ? channels[track.input.device] && channels[track.input.device][track.input.channel] || {} : Object.keys(channels).reduce((cn, d)=>Object.keys(channels[d][track.input.channel] || {}).reduce((cn, note)=>$b50c4af2ab2cac82$require$obj.patch(cn, note, channels[d][track.input.channel][note] || cn[note]), cn), {});
const $b50c4af2ab2cac82$var$globalVolume = $cl3AY.connect($cl3AY.vca({
    gain: 0.4
}), $ekqew.context.destination);
/**
 * The changes$ Subject is used to emit changes to the engine state
 * @type {Subject}
 */ let $b50c4af2ab2cac82$var$changes$ = new $b50c4af2ab2cac82$require$Subject();
/**
 * The engine$ BehaviorSubject is used to emit the current engine state
 * @type {BehaviorSubject}
 */ const $b50c4af2ab2cac82$var$engine$ = new $b50c4af2ab2cac82$require$BehaviorSubject();
/**
 * The buffer of stopped instances
 * @type {Array}
 */ let $b50c4af2ab2cac82$var$buffer = [];
/**
 * Clear the buffer of stopped instances
 */ const $b50c4af2ab2cac82$var$clearBuffer = ()=>{
    // console.log(buffer);
    $b50c4af2ab2cac82$var$buffer.forEach((inst)=>{
        // console.log(inst);
        $cl3AY.disconnect(inst); // .output.disconnect(reverb.input);
        $cl3AY.stop(inst);
    });
    $b50c4af2ab2cac82$var$buffer = [];
};
/**
 * The initial engine state
 * @type {Object}
 */ const $b50c4af2ab2cac82$var$initial = {
    0: {
        // sampler track
        voices: {},
        effectsChain: [],
        volume: $cl3AY.vca({
            gain: 0.3
        }),
        context: $ekqew.context
    },
    1: {
        // an dictionary midikey : vco
        /*
		voice: {
			vco1
			vco2
			adsr1
			adsr2
		}
		*/ voices: {},
        effectsChain: [],
        volume: $cl3AY.vca({
            gain: 0.3
        }),
        context: $ekqew.context
    },
    2: {
        // an dictionary midikey : vco
        /*
		voice: {
			vco1
			vco2
			adsr1
			adsr2
		}
		*/ voices: {},
        effectsChain: [],
        volume: $cl3AY.vca({
            gain: 0.3
        }),
        context: $ekqew.context
    },
    3: {
        // an dictionary midikey : vco
        /*
		voice: {
			vco1
			vco2
			adsr1
			adsr2
		}
		*/ voices: {},
        effectsChain: [],
        volume: $cl3AY.vca({
            gain: 0.3
        }),
        context: $ekqew.context
    }
};
// type:id
const $b50c4af2ab2cac82$var$getEffectChainMap = (effectChain)=>effectChain.filter((effect)=>effect.on).map((effect)=>`${effect.type}:${effect.id}`);
const $b50c4af2ab2cac82$var$getEffectChainDiff = (oldEffectChain, newEffectChain)=>$b50c4af2ab2cac82$require$fn.pipe(()=>({
            oldEffectChainMap: $b50c4af2ab2cac82$var$getEffectChainMap(oldEffectChain),
            newEffectChainMap: $b50c4af2ab2cac82$var$getEffectChainMap(newEffectChain)
        }), ({ oldEffectChainMap: oldEffectChainMap, newEffectChainMap: newEffectChainMap })=>({
            added: newEffectChainMap.filter((effect)=>!oldEffectChainMap.includes(effect)),
            removed: oldEffectChainMap.filter((effect)=>!newEffectChainMap.includes(effect)),
            typeChanged: newEffectChainMap.filter((effect)=>oldEffectChainMap.find((e)=>e.split(":")[1] === effect.split(":")[1] && e.split(":")[0] !== effect.split(":")[0])),
            orderChanged: newEffectChainMap.filter((effect, index)=>oldEffectChainMap.find((e, i)=>e === effect && i !== index))
        }))();
/**
 * Sync the engine's effectsChain with the instrument's effectsChain
 * Handles added, removed, typeChanged, and orderChanged effects
 * @param {Object} instr - The instrument object
 * @param {number} ch - The channel/track number
 */ const $b50c4af2ab2cac82$var$syncEffectsChain = (instr, ch = 1)=>$b50c4af2ab2cac82$var$changes$.next((engine)=>{
        const oldEffectsChain = engine[ch].effectsChain || [];
        const newEffectsChain = instr.effectsChain || [];
        // Convert old nodes to effect-like objects for comparison
        const oldEffects = oldEffectsChain.map((node)=>({
                type: node.type,
                id: node.id,
                on: true // Assume all existing nodes are on for comparison
            }));
        // Get diff between old and new
        const diff = $b50c4af2ab2cac82$var$getEffectChainDiff(oldEffects, newEffectsChain);
        // Create a map of id -> node for old chain
        const oldNodeMap = {};
        oldEffectsChain.forEach((node)=>{
            if (node.id) oldNodeMap[node.id] = node;
        });
        // Build new effectsChain array matching newEffectsChain order
        const newChain = [];
        // Process each effect in the new chain
        newEffectsChain.forEach((effect)=>{
            if (!effect.id) return; // Skip effects without id
            const oldNode = oldNodeMap[effect.id];
            const effectKey = `${effect.type}:${effect.id}`;
            if (oldNode) {
                // Node exists - check if type changed
                if (oldNode.type !== effect.type) {
                    // Type changed - destroy old, create new
                    $57240976e2401e47$export$b1fb4cac938035f7(oldNode);
                    const { type: type, on: on, expanded: expanded, id: id, ...effectProps } = effect;
                    const newNode = $57240976e2401e47$export$185802fd694ee1f5(type, effectProps, id);
                    if (type === "lfo") $cl3AY.start(newNode);
                    newChain.push(newNode);
                } else // Same type - keep node (properties will be updated in updatePrefs)
                newChain.push(oldNode);
            } else if (diff.added.includes(effectKey)) {
                // New effect - create node
                const { type: type, on: on, expanded: expanded, id: id, ...effectProps } = effect;
                const newNode = $57240976e2401e47$export$185802fd694ee1f5(type, effectProps, id);
                if (type === "lfo") $cl3AY.start(newNode);
                newChain.push(newNode);
            } else {
                // Effect exists but wasn't in old chain (shouldn't happen, but handle gracefully)
                const { type: type, on: on, expanded: expanded, id: id, ...effectProps } = effect;
                const newNode = $57240976e2401e47$export$185802fd694ee1f5(type, effectProps, id);
                if (type === "lfo") $cl3AY.start(newNode);
                newChain.push(newNode);
            }
        });
        // Destroy removed nodes
        diff.removed.forEach((effectKey)=>{
            const id = effectKey.split(":")[1];
            const oldNode = oldNodeMap[id];
            if (oldNode) $57240976e2401e47$export$b1fb4cac938035f7(oldNode);
        });
        return $b50c4af2ab2cac82$require$obj.patch(engine, ch, {
            effectsChain: newChain
        });
    });
/**
 * Update the preferences for the instrument on the given channel/track
 * @param {Object} instr - The instrument object
 * @param {number} ch - The channel/track number
 */ const $b50c4af2ab2cac82$var$updatePrefs = (instr, ch = 1)=>$b50c4af2ab2cac82$var$changes$.next((engine)=>$b50c4af2ab2cac82$require$obj.patch(engine, ch, $b50c4af2ab2cac82$require$obj.map(engine[ch], (key, node)=>{
            // Handle source properties (vco1, vco2, vca1, vca2)
            if (instr.source && (key === "vco1" || key === "vco2" || key === "vca1" || key === "vca2")) {
                const sourceProp = instr.source[key];
                if (sourceProp) return $cl3AY.update(node, sourceProp);
            }
            // Handle effectsChain - update each node with matching effect config
            if (key === "effectsChain") return node.map((chainNode)=>{
                // Find matching effect in instrument effectsChain by id
                const effect = instr.effectsChain?.find((e)=>e.id === chainNode.id);
                if (effect) {
                    // Update node with effect properties (excluding 'type', 'on', 'expanded', 'id')
                    const { type: type, on: on, expanded: expanded, id: id, ...effectProps } = effect;
                    return $cl3AY.update(chainNode, effectProps);
                }
                return chainNode;
            });
            // Handle voices
            if (key === "voices") return $b50c4af2ab2cac82$require$obj.map(node, (k, voice)=>$b50c4af2ab2cac82$require$obj.map(voice, (voiceKey, n)=>{
                    // Update vco1, vco2, vca1, vca2 in voices
                    if (instr.source && (voiceKey === "vco1" || voiceKey === "vco2")) {
                        const sourceProp = instr.source[voiceKey];
                        if (sourceProp) return $cl3AY.update(n, sourceProp);
                    }
                    if (instr.source && (voiceKey === "adsr1" || voiceKey === "adsr2")) {
                        // adsr1 maps to vca1, adsr2 maps to vca2
                        const vcaKey = voiceKey === "adsr1" ? "vca1" : "vca2";
                        const sourceProp = instr.source[vcaKey];
                        if (sourceProp) return $cl3AY.update(n, sourceProp);
                    }
                    return n;
                }));
            return node;
        })));
/**
 * Get the first active effect node for a channel (or volume if no effects)
 * @param {Object} engine - The engine state
 * @param {Object} instr - The instrument object
 * @param {number} ch - The channel/track number
 * @returns {Object} The first effect node or volume
 */ const $b50c4af2ab2cac82$var$getFirstEffectNode = (engine, instr, ch)=>{
    const effectsChain = engine[ch].effectsChain || [];
    const effectNodeMap = {};
    effectsChain.forEach((node)=>{
        if (node.id) effectNodeMap[node.id] = node;
    });
    if (instr.effectsChain) {
        for (const effect of instr.effectsChain)if (effect.on && effect.type !== "lfo" && effect.id) {
            const node = effectNodeMap[effect.id];
            if (node) return node;
        }
    }
    return engine[ch].volume;
};
/**
 * Update the connections for the instrument on the given channel/track
 * @param {Object} instr - The instrument object
 * @param {number} ch - The channel/track number
 */ const $b50c4af2ab2cac82$var$updateConnections = (instr, ch = 1)=>$b50c4af2ab2cac82$var$changes$.next((engine)=>{
        // Get source properties (only for synth tracks, ch > 0)
        const source = instr.source || {};
        const vco1On = source.vco1?.on ?? false;
        const vco2On = source.vco2?.on ?? false;
        // Get effectsChain from engine
        const effectsChain = engine[ch].effectsChain || [];
        // Build map of effect id -> node for quick lookup
        const effectNodeMap = {};
        effectsChain.forEach((node)=>{
            if (node.id) effectNodeMap[node.id] = node;
        });
        // Build audio routing chain: filter active effects (excluding LFO which modulates, doesn't route audio)
        const audioEffects = [];
        if (instr.effectsChain) instr.effectsChain.forEach((effect)=>{
            if (effect.on && effect.type !== "lfo" && effect.id) {
                const node = effectNodeMap[effect.id];
                if (node) audioEffects.push(node);
            }
        });
        // Get first active effect node or volume
        const firstEffectNode = audioEffects.length > 0 ? audioEffects[0] : engine[ch].volume;
        // Disconnect ALL effects from each other and from volume
        // This ensures clean reconnection and removes inactive effects from the chain
        effectsChain.forEach((node)=>{
            if (node && node.type !== "lfo") $57240976e2401e47$export$37dfea93db2e14ed(node);
        });
        // Build the audio chain: effect1 → effect2 → ... → volume → globalVolume
        // Connect effects in sequence
        if (audioEffects.length > 0) // Chain effects together
        $57240976e2401e47$export$e08e3b67e392101e(...audioEffects, engine[ch].volume);
        // Connect volume to globalVolume
        $cl3AY.connect(engine[ch].volume, $b50c4af2ab2cac82$var$globalVolume);
        // Handle LFO modulation separately (LFO doesn't route audio)
        const lfoEffects = [];
        if (instr.effectsChain) instr.effectsChain.forEach((effect)=>{
            if (effect.on && effect.type === "lfo" && effect.id) {
                const node = effectNodeMap[effect.id];
                if (node) lfoEffects.push({
                    node: node,
                    effect: effect
                });
            }
        });
        // For synth tracks (ch > 0), update voice connections
        // For sampler track (ch === 0), only update effectsChain and volume
        const patch = {
            effectsChain: effectsChain,
            volume: engine[ch].volume
        };
        if (ch > 0 && engine[ch].voices) patch.voices = $b50c4af2ab2cac82$require$obj.map(engine[ch].voices, (k, voice)=>({
                vco1: $cl3AY.connect(voice.vco1, voice.adsr1),
                vco2: $cl3AY.connect(voice.vco2, voice.adsr2),
                adsr1: !vco1On ? $cl3AY.disconnect(voice.adsr1) : $cl3AY.reroute(voice.adsr1, firstEffectNode),
                adsr2: !vco2On ? $cl3AY.disconnect(voice.adsr2) : $cl3AY.reroute(voice.adsr2, firstEffectNode)
            }));
        return $b50c4af2ab2cac82$require$obj.patch(engine, ch, patch);
    });
/**
 * Note on event handler
 * @param {Object} instr - The instrument object
 * @param {number} ch - The channel/track number
 * @param {string} note - The note to play
 * @param {number} velocity - The velocity of the note
 * @param {number} time - The time to play the note
 */ const $b50c4af2ab2cac82$var$noteOn = (instr, ch = 1, note, velocity, time, mute = false)=>$b50c4af2ab2cac82$var$changes$.next((engine)=>{
        // get the engine state for the channel
        let { voices: voices, effectsChain: effectsChain, volume: volume, context: context } = engine[ch];
        time = time || context.currentTime;
        const freq = $cl3AY.noteToFrequency(note);
        // Get source properties
        const source = instr.source || {};
        const vco1Config = source.vco1 || {};
        const vco2Config = source.vco2 || {};
        const vca1Config = source.vca1 || {};
        const vca2Config = source.vca2 || {};
        const vco1On = vco1Config.on ?? false;
        const vco2On = vco2Config.on ?? false;
        // Build map of effect id -> node
        const effectNodeMap = {};
        effectsChain.forEach((node)=>{
            if (node.id) effectNodeMap[node.id] = node;
        });
        // Get first active effect node (excluding LFO) or volume
        let firstEffectNode = volume;
        if (instr.effectsChain) {
            for (const effect of instr.effectsChain)if (effect.on && effect.type !== "lfo" && effect.id) {
                const node = effectNodeMap[effect.id];
                if (node) {
                    firstEffectNode = node;
                    break;
                }
            }
        }
        let voice = voices[note] || false;
        if (voice.vco1 && $b50c4af2ab2cac82$var$buffer.indexOf(voice.vco1) > -1) {
            $b50c4af2ab2cac82$require$arr.remove($b50c4af2ab2cac82$var$buffer, voice.vco1);
            $cl3AY.stop(voice.vco1);
        }
        let vco1 = $cl3AY.vco(Object.assign({}, vco1Config, {
            freq: freq
        }));
        if (!mute) vco1 = $cl3AY.start(vco1, time);
        let adsr1 = voice ? voice.adsr1 : $cl3AY.adsr(vca1Config);
        vco1 = $cl3AY.connect(vco1, adsr1);
        adsr1 = !vco1On ? $cl3AY.disconnect(adsr1) : $cl3AY.reroute(adsr1, firstEffectNode);
        if (voice.vco2 && $b50c4af2ab2cac82$var$buffer.indexOf(voice.vco2) > -1) {
            $b50c4af2ab2cac82$require$arr.remove($b50c4af2ab2cac82$var$buffer, voice.vco2);
            $cl3AY.stop(voice.vco2);
        }
        let vco2 = $cl3AY.vco(Object.assign({}, vco2Config, {
            freq: freq
        }));
        if (!mute) vco2 = $cl3AY.start(vco2, time);
        let adsr2 = voice ? voice.adsr2 : $cl3AY.adsr(vca2Config);
        vco2 = $cl3AY.connect(vco2, adsr2);
        adsr2 = !vco2On ? $cl3AY.disconnect(adsr2) : $cl3AY.reroute(adsr2, firstEffectNode);
        // Handle LFO modulation - find all active LFO effects
        if (instr.effectsChain) instr.effectsChain.forEach((effect)=>{
            if (effect.on && effect.type === "lfo" && effect.id) {
                const lfoNode = effectNodeMap[effect.id];
                if (lfoNode) {
                    const target = effect.target || "volume";
                    if (target === "pitch") {
                        if (lfoNode.output) {
                            lfoNode.output.connect(vco1.output.detune);
                            lfoNode.output.connect(vco2.output.detune);
                        }
                    } else if (lfoNode.effect) {
                        lfoNode.effect.connect(adsr1.through.gain);
                        lfoNode.effect.connect(adsr2.through.gain);
                    }
                }
            }
        });
        $cl3AY.noteOn(adsr1, velocity, time);
        $cl3AY.noteOn(adsr2, velocity, time);
        if (!mute) {
            $b50c4af2ab2cac82$var$buffer.push(vco1);
            $b50c4af2ab2cac82$var$buffer.push(vco2);
        }
        return $b50c4af2ab2cac82$require$obj.patch(engine, ch, {
            voices: $b50c4af2ab2cac82$require$obj.patch(voices, note, {
                vco1: vco1,
                vco2: vco2,
                adsr1: adsr1,
                adsr2: adsr2
            }),
            context: context
        });
    });
/**
 * Note off event handler
 * @param {Object} instr - The instrument object
 * @param {number} ch - The channel/track number
 * @param {string} note - The note to stop
 * @param {number} time - The time to stop the note
 * @param {boolean} mute - Whether to mute the note
 */ const $b50c4af2ab2cac82$var$noteOff = (instr, ch = 1, note, time, mute = false)=>$b50c4af2ab2cac82$var$changes$.next((engine)=>{
        const { voices: voices, context: context } = engine[ch];
        const now = context.currentTime;
        time = time || now + 0.0001;
        // Get source properties
        const source = instr.source || {};
        const vca1Config = source.vca1 || {};
        const vca2Config = source.vca2 || {};
        const vca1Release = vca1Config.release > 0 ? vca1Config.release : 0.00001;
        const vca2Release = vca2Config.release > 0 ? vca2Config.release : 0.00001;
        let voice = voices[note] || false;
        if (voice) {
            let { vco1: vco1, adsr1: adsr1, vco2: vco2, adsr2: adsr2 } = voice;
            if (!mute) {
                $cl3AY.noteOff(adsr1, time);
                $cl3AY.noteOff(adsr2, time);
                $cl3AY.stop(vco1, time + vca1Release);
                $cl3AY.stop(vco2, time + vca2Release);
            }
            setTimeout(()=>{
                $cl3AY.disconnect(vco1);
                $cl3AY.disconnect(adsr1);
                $cl3AY.disconnect(vco2);
                $cl3AY.disconnect(adsr2);
            }, (time - now + vca1Release) * 1000);
            return $b50c4af2ab2cac82$require$obj.patch(engine, ch, {
                voices: $b50c4af2ab2cac82$require$obj.filter(voices, (key)=>key !== note),
                context: context
            });
        }
        return engine;
    });
const $b50c4af2ab2cac82$var$pitchBend = (instr, pitchValue, ch = 1)=>$b50c4af2ab2cac82$var$changes$.next((engine)=>{
        // Get source properties
        const source = instr.source || {};
        const vco1Detune = source.vco1?.detune || 0;
        const vco2Detune = source.vco2?.detune || 0;
        return $b50c4af2ab2cac82$require$obj.patch(engine, [
            ch,
            "voices"
        ], $b50c4af2ab2cac82$require$obj.map(engine[ch].voices, (key, voice)=>Object.assign({}, voice, {
                vco1: $cl3AY.update(voice.vco1, {
                    detune: vco1Detune + pitchValue * 200
                }),
                vco2: $cl3AY.update(voice.vco2, {
                    detune: vco2Detune + pitchValue * 200
                })
            })));
    });
/**
 * Schedule a MIDI message at an absolute AudioContext time.
 * @param {Object} device - MIDI output device
 * @param {string} note - Note name
 * @param {number} velocity - Velocity 0–1
 * @param {number} audioTime - Absolute AudioContext time
 * @param {number} channel - MIDI channel 1–16
 */ const $b50c4af2ab2cac82$var$sendMIDImsg = (device, note, velocity, audioTime = 0, channel = 1)=>{
    if (!device) return;
    const perfTime = window.performance.now() + (audioTime - $ekqew.context.currentTime) * 1000;
    device.send([
        0x90 + (channel - 1),
        $kTQ8i.noteToNumber(note),
        `0x${parseInt(velocity * 127, 10).toString(16)}`
    ], perfTime);
};
/**
 * The engine$ is a BehaviorSubject that emits the current engine state
 * It holds audio chains for different tracks starting with voices (containing the vcos and adsrs)
 * Next on the chain, depending on the instrument settings, the vcf, reverb, volume and lfo are added.
 */ $b50c4af2ab2cac82$var$changes$.pipe($b50c4af2ab2cac82$require$startWith(()=>$b50c4af2ab2cac82$var$initial), $b50c4af2ab2cac82$require$scan((engine, change)=>change(engine), $b50c4af2ab2cac82$var$initial)).subscribe((engine)=>$b50c4af2ab2cac82$var$engine$.next(engine));
const $b50c4af2ab2cac82$var$hook = ({ state$: state$, actions: actions, studio: studio, tapTempo: tapTempo })=>{
    const sampleBank$ = $kKA2u.stream.pipe($b50c4af2ab2cac82$require$filter((p)=>p.sampleBank), $b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>{
        const prevBank = prev.sampleBank;
        const currBank = curr.sampleBank;
        return prevBank === currBank;
    }), $b50c4af2ab2cac82$require$map((p)=>p.sampleBank));
    // clear buffer when playing is stopped
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>prev.studio.playing === curr.studio.playing), $b50c4af2ab2cac82$require$filter((state)=>!state.studio.playing)).subscribe(()=>$b50c4af2ab2cac82$var$clearBuffer());
    // clear buffer when bpm changes
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>prev.studio.bpm === curr.studio.bpm), $b50c4af2ab2cac82$require$filter((state)=>state.studio.playing)).subscribe(()=>$b50c4af2ab2cac82$var$clearBuffer());
    // sync effects chain when instrument effectsChain changes
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>{
        const prevChains = prev.session.tracks.map((track)=>track.inst?.effectsChain ? track.inst.effectsChain.map((e)=>`${e.type}:${e.id}`).join(",") : "");
        const currChains = curr.session.tracks.map((track)=>track.inst?.effectsChain ? track.inst.effectsChain.map((e)=>`${e.type}:${e.id}`).join(",") : "");
        return JSON.stringify(prevChains) === JSON.stringify(currChains);
    })).subscribe(({ instrument: instrument, session: session })=>session.tracks.forEach((track, ch)=>track.inst && $b50c4af2ab2cac82$var$syncEffectsChain(track.inst, ch)));
    // update connections
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>{
        const prevTracks = prev.session.tracks.map((track, ch)=>{
            if (!track.inst) return null;
            const source = track.inst.source || {};
            const effectsChain = track.inst.effectsChain || [];
            return [
                source.vco1?.on,
                source.vco2?.on,
                ...effectsChain.map((e)=>({
                        type: e.type,
                        on: e.on
                    }))
            ];
        });
        const currTracks = curr.session.tracks.map((track, ch)=>{
            if (!track.inst) return null;
            const source = track.inst.source || {};
            const effectsChain = track.inst.effectsChain || [];
            return [
                source.vco1?.on,
                source.vco2?.on,
                ...effectsChain.map((e)=>({
                        type: e.type,
                        on: e.on
                    }))
            ];
        });
        return JSON.stringify(prevTracks) === JSON.stringify(currTracks);
    })).subscribe(({ instrument: instrument, session: session })=>session.tracks.forEach((track, ch)=>track.inst && $b50c4af2ab2cac82$var$updateConnections(track.inst, ch)));
    // update prefs
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>{
        const prevInsts = prev.session.tracks.map((track)=>track.inst);
        const currInsts = curr.session.tracks.map((track)=>track.inst);
        return JSON.stringify(prevInsts) === JSON.stringify(currInsts);
    })).subscribe(({ instrument: instrument, session: session })=>session.tracks.forEach((track, ch)=>track.inst && $b50c4af2ab2cac82$var$updatePrefs(track.inst, ch)));
    // global volume
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>prev.studio.volume === curr.studio.volume)).subscribe((state)=>$cl3AY.update($b50c4af2ab2cac82$var$globalVolume, {
            gain: state.studio.volume
        }));
    // set up once
    state$.pipe($b50c4af2ab2cac82$require$take(1)).subscribe(({ instrument: instrument, session: session })=>session.tracks.map((track, ch)=>({
                track: track,
                ch: ch
            })).filter(({ track: track })=>track.inst).forEach(({ track: track, ch: ch })=>($b50c4af2ab2cac82$var$syncEffectsChain(track.inst, ch), $b50c4af2ab2cac82$var$updateConnections(Object.assign({}, instrument, track.inst), ch), $b50c4af2ab2cac82$var$updatePrefs(Object.assign({}, instrument, track.inst), ch))));
    // note ons — edge-triggered from MIDI key press/release only (not voice map sync)
    let prevPressed = null;
    const notesPattern = [
        "C",
        "C#",
        "D",
        "D#",
        "E",
        "F",
        "F#",
        "G",
        "G#",
        "A",
        "A#",
        "B"
    ];
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>{
        return JSON.stringify(prev.midiMap.channels) === JSON.stringify(curr.midiMap.channels);
    }), $b50c4af2ab2cac82$require$map((state)=>({
            state: state,
            pressed: state.session.tracks.map((track)=>// console.log(track.input),
                $b50c4af2ab2cac82$var$prepPressed(state.midiMap.channels, track))
        })), $b50c4af2ab2cac82$require$withLatestFrom($b50c4af2ab2cac82$var$engine$, sampleBank$), $b50c4af2ab2cac82$require$map(([{ state: state, pressed: pressed }, engine, sampleBank])=>({
            state: state,
            pressed: pressed,
            engine: engine,
            sampleBank: sampleBank
        }))).subscribe(({ state: state, pressed: pressed, engine: engine, sampleBank: sampleBank })=>{
        Object.keys(pressed).forEach((ch)=>{
            if (ch > 0) // console.log(ch, pressed[ch], engine[ch], state.midiMap.channels);
            {
                if (!state.midiMap.settings.midiRouteToActive || Number(state.session.selection.piano[0]) === Number(ch)) {
                    const prevCh = prevPressed && prevPressed[ch] || {};
                    Object.keys(pressed[ch] || []).filter((note)=>!$b50c4af2ab2cac82$require$obj.sub(prevCh, [
                            note
                        ])).forEach((note)=>state.session.tracks[ch].output && state.session.tracks[ch].output.device > -1 ? // console.log(pressed[ch][note]),
                        (console.log(state.session.tracks[ch].output.device), $b50c4af2ab2cac82$var$sendMIDImsg(state.midiMap.devices.outputs[state.session.tracks[ch].output.device], note, pressed[ch][note] || 1, 0, state.session.tracks[ch].output.channel), $b50c4af2ab2cac82$var$noteOn(state.session.tracks[ch].inst, ch, note, pressed[ch][note], null, true)) : $b50c4af2ab2cac82$var$noteOn(state.session.tracks[ch].inst, ch, note, pressed[ch][note]));
                    Object.keys(prevCh).filter((note)=>!$b50c4af2ab2cac82$require$obj.sub(pressed, [
                            ch,
                            note
                        ])).forEach((note)=>state.session.tracks[ch].output && state.session.tracks[ch].output.device > -1 ? ($b50c4af2ab2cac82$var$sendMIDImsg(state.midiMap.devices.outputs[state.session.tracks[ch].output.device], note, 0, 0, state.session.tracks[ch].output.channel), $b50c4af2ab2cac82$var$noteOff(state.session.tracks[ch].inst, ch, note, null, true)) : $b50c4af2ab2cac82$var$noteOff(state.session.tracks[ch].inst, ch, note));
                }
            } else {
                // Channel 0: sampler track
                const track = state.session.tracks[ch];
                const firstEffectNode = $b50c4af2ab2cac82$var$getFirstEffectNode(engine, track.inst || {}, ch);
                let voices = engine[ch].voices || {};
                const prevCh = prevPressed && prevPressed[ch] || {};
                Object.keys(pressed[ch] || {}).filter((note)=>!prevCh[note]).forEach((note)=>{
                    console.log(note);
                    const index = notesPattern.indexOf(note.replace(/[0-9]/, ""));
                    if (index > -1 && state.sequencer.channels[index]) {
                        if (track.output.device !== -1) {
                            const now = $ekqew.context.currentTime;
                            const gate = $b50c4af2ab2cac82$require$bpmToTime(state.studio.bpm) / 4;
                            $b50c4af2ab2cac82$var$sendMIDImsg(state.midiMap.devices.outputs[track.output.device], note, pressed[ch][note], now + 0.001, track.output.channel);
                            $b50c4af2ab2cac82$var$sendMIDImsg(state.midiMap.devices.outputs[track.output.device], note, 0, now + gate, track.output.channel);
                        } else if (sampleBank[state.mediaLibrary.files[state.sequencer.channels[index]]]) {
                            let inst = $b50c4af2ab2cac82$require$sampler.clone(sampleBank[state.mediaLibrary.files[state.sequencer.channels[index]]], {
                                gain: pressed[ch][note]
                            });
                            $cl3AY.connect(inst, firstEffectNode);
                            $cl3AY.start(inst, $ekqew.context.currentTime + 0.001);
                            voices[note] = inst;
                        }
                    }
                });
                Object.keys(prevCh).filter((note)=>!pressed[ch][note]).forEach((note)=>{
                    if (voices[note]) {
                        let inst = voices[note];
                        voices = $b50c4af2ab2cac82$require$obj.filter(voices, (key)=>key !== note);
                        setTimeout(()=>{
                            $cl3AY.disconnect(inst);
                            $cl3AY.stop(inst);
                        }, 3000);
                    }
                });
            }
        });
        prevPressed = pressed;
    });
    // pitch bend
    state$.pipe($b50c4af2ab2cac82$require$distinctUntilChanged((prev, curr)=>prev.midiMap.pitch === curr.midiMap.pitch)).subscribe((state)=>$b50c4af2ab2cac82$var$pitchBend(Object.assign({}, state.instrument, state.session.tracks[state.session.selection.piano[0]].inst), state.midiMap.pitch, state.session.selection.piano[0]));
};
$b50c4af2ab2cac82$exports = {
    hook: $b50c4af2ab2cac82$var$hook,
    engine$: $b50c4af2ab2cac82$var$engine$,
    clearBuffer: $b50c4af2ab2cac82$var$clearBuffer,
    noteOn: $b50c4af2ab2cac82$var$noteOn,
    noteOff: $b50c4af2ab2cac82$var$noteOff,
    sendMIDImsg: $b50c4af2ab2cac82$var$sendMIDImsg,
    getFirstEffectNode: $b50c4af2ab2cac82$var$getFirstEffectNode,
    pushBuffer: (inst)=>$b50c4af2ab2cac82$var$buffer.push(inst)
};



var $jjnZg = parcelRequire("jjnZg");

var $8QuAY = parcelRequire("8QuAY");

var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $6SBin = parcelRequire("6SBin");
var $9Jxex = parcelRequire("9Jxex");

var $cl3AY = parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $fbcJ7 = parcelRequire("fbcJ7");

var $kTQ8i = parcelRequire("kTQ8i");

var $gN3J6 = parcelRequire("gN3J6");

var $lm9of = parcelRequire("lm9of");
var $6SBin = parcelRequire("6SBin");
var $hYBh9 = parcelRequire("hYBh9");
var $9Jxex = parcelRequire("9Jxex");
const $f134bb0dffae52a3$export$2cef06c20297c17d = (node)=>new (0, $gN3J6.Observable)((obs)=>{
        let id;
        let last = 0;
        const onFrame = (timestamp)=>{
            const dt = last > 0 ? timestamp - last : 0;
            last = timestamp;
            obs.next(dt);
            id = requestAnimationFrame(onFrame);
        };
        id = requestAnimationFrame(onFrame);
        return ()=>cancelAnimationFrame(id);
    }).pipe((0, $lm9of.filter)((dt)=>dt !== 0), (0, $hYBh9.share)());
const $f134bb0dffae52a3$export$f9ef67375ddc185 = (state$, node)=>$f134bb0dffae52a3$export$2cef06c20297c17d(node).pipe((0, $9Jxex.withLatestFrom)(state$), (0, $6SBin.map)(([dt, state])=>({
            dt: dt,
            state: state
        })));
var $f134bb0dffae52a3$export$2e2bcd8739ae039 = {
    frame: $f134bb0dffae52a3$export$2cef06c20297c17d,
    loop: $f134bb0dffae52a3$export$f9ef67375ddc185
};



var $gsDht = parcelRequire("gsDht");
const $9e64ef56ed6915b8$export$b74061472fe7c07 = (startTime, bpm, length, resolution)=>new Array(length).fill(null).map((_, index)=>startTime + (0, $gsDht.bpmToTime)(bpm) * 4 / resolution * index);
var $9e64ef56ed6915b8$export$2e2bcd8739ae039 = {
    projection: $9e64ef56ed6915b8$export$b74061472fe7c07
};



var $gsDht = parcelRequire("gsDht");

var $46DUK = parcelRequire("46DUK");

var $kKA2u = parcelRequire("kKA2u");

let $5c6b5ace1f3a4a56$var$latestScheduledCycle = -1;
let $5c6b5ace1f3a4a56$var$scheduling = false;
const $5c6b5ace1f3a4a56$var$scheduledEventUuids = new Set();
const $5c6b5ace1f3a4a56$export$390bff02e6678e49 = ()=>{
    $5c6b5ace1f3a4a56$var$latestScheduledCycle = -1;
    $5c6b5ace1f3a4a56$var$scheduling = false;
    $5c6b5ace1f3a4a56$var$scheduledEventUuids.clear();
};
const $5c6b5ace1f3a4a56$var$buildPayload = (state, sampleBank, engine)=>{
    const { startTime: startTime, cycleOffset: cycleOffset, bpm: bpm, beatLength: beatLength, cycleBase: cycleBase = 0 } = state.studio;
    const barsLength = state.sequencer.barsLength || 1;
    const segments = beatLength;
    return {
        state: state,
        sampleBank: sampleBank,
        engine: engine,
        startTime: startTime,
        cycleOffset: cycleOffset,
        bpm: bpm,
        beatLength: beatLength,
        barsLength: barsLength,
        cycleBase: cycleBase,
        cycle: (0, $gsDht.calculateCycle)(startTime, $ekqew.context.currentTime, cycleOffset, bpm, segments, (0, $46DUK.MODIFIER)),
        progress: (0, $gsDht.calculateProgress)(startTime, $ekqew.context.currentTime, cycleOffset, bpm, segments, (0, $46DUK.MODIFIER))
    };
};
const $5c6b5ace1f3a4a56$var$dispatchSeqStep = ({ track: track, ch: ch, step: step, patternBar: patternBar, timepos: timepos, bpm: bpm, sequencer: sequencer, mediaLibrary: mediaLibrary, sampleBank: sampleBank, engine: engine, instrument: instrument, midiMap: midiMap })=>{
    const pattern = sequencer.pattern[patternBar];
    if (!pattern) return;
    pattern.forEach((row, k)=>{
        if (!row || !row[step]) return;
        if (track.output.device !== -1) {
            const note = (0, $jjnZg.fn).pipe(()=>$kTQ8i.numberToNote(60 + k), ({ key: key, octave: octave })=>`${key}${octave}`)();
            const stepDur = (0, $gsDht.bpmToTime)(bpm);
            $b50c4af2ab2cac82$exports.sendMIDImsg(midiMap.devices.outputs[track.output.device], note, row[step], timepos, track.output.channel);
            $b50c4af2ab2cac82$exports.sendMIDImsg(midiMap.devices.outputs[track.output.device], note, 0, timepos + stepDur / 4, track.output.channel);
        } else {
            const sampleId = mediaLibrary.files[sequencer.channels[k]];
            if (!sampleBank[sampleId]) return;
            const firstEffectNode = $b50c4af2ab2cac82$exports.getFirstEffectNode(engine, track.inst || {}, ch);
            let inst = (0, $fbcJ7).clone(sampleBank[sampleId], {
                gain: row[step]
            });
            inst = $cl3AY.connect(inst, firstEffectNode);
            $cl3AY.start(inst, timepos);
            $b50c4af2ab2cac82$exports.pushBuffer(inst);
        }
    });
};
const $5c6b5ace1f3a4a56$var$dispatchPianoBar = ({ track: track, ch: ch, patternBar: patternBar, beatLength: beatLength, startSegment: startSegment, segmentCount: segmentCount, scheduleStart: scheduleStart, bpm: bpm, session: session, instrument: instrument, midiMap: midiMap, onlyNew: onlyNew = false, cycleStartTime: cycleStartTime = null })=>{
    const measure = track.measures[session.active[ch]];
    if (!measure || !measure.events) return;
    const barStart = beatLength * patternBar;
    const barEnd = barStart + beatLength;
    const stepDuration = (0, $gsDht.bpmToTime)(bpm);
    const scheduleFrom = barStart + startSegment;
    measure.events.filter((event)=>event.duration > 0).forEach((event)=>{
        if (onlyNew && event.uuid && $5c6b5ace1f3a4a56$var$scheduledEventUuids.has(event.uuid)) return;
        let timepos;
        if (onlyNew && cycleStartTime != null) {
            // Align to transport step on the target cycle (same column next bar)
            const stepInBar = (event.start % beatLength + beatLength) % beatLength;
            timepos = cycleStartTime + stepInBar * stepDuration;
        } else if (event.start >= scheduleFrom && event.start < barEnd) timepos = scheduleStart + (event.start - scheduleFrom) * stepDuration;
        else return;
        if (timepos < $ekqew.context.currentTime - 0.05) return;
        if (event.uuid) $5c6b5ace1f3a4a56$var$scheduledEventUuids.add(event.uuid);
        const inst = Object.assign({}, instrument, track.inst);
        const noteOffTime = timepos + event.duration * stepDuration;
        if (track.output && track.output.device > -1) {
            $b50c4af2ab2cac82$exports.sendMIDImsg(midiMap.devices.outputs[track.output.device], event.note, event.velocity || 1, timepos, track.output.channel);
            $b50c4af2ab2cac82$exports.noteOn(inst, ch, event.note, event.velocity || 0.7, timepos, true);
            $b50c4af2ab2cac82$exports.sendMIDImsg(midiMap.devices.outputs[track.output.device], event.note, 0, noteOffTime, track.output.channel);
            $b50c4af2ab2cac82$exports.noteOff(inst, ch, event.note, noteOffTime, true);
        } else {
            $b50c4af2ab2cac82$exports.noteOn(inst, ch, event.note, event.velocity || 0.7, timepos);
            $b50c4af2ab2cac82$exports.noteOff(inst, ch, event.note, noteOffTime);
        }
    });
};
const $5c6b5ace1f3a4a56$var$schedulePianoCycle = (payload, targetCycle, { startPrc: startPrc = 0, onlyNew: onlyNew = false } = {})=>{
    const { startTime: startTime, cycleOffset: cycleOffset, bpm: bpm, beatLength: beatLength, cycleBase: cycleBase, state: state } = payload;
    const segmentCount = startPrc > 0 ? beatLength - Math.ceil(beatLength * startPrc) : beatLength;
    const startSegment = beatLength - segmentCount;
    const stepDuration = (0, $gsDht.bpmToTime)(bpm);
    const cycleStart = startTime - cycleOffset * beatLength * stepDuration + targetCycle * beatLength * stepDuration;
    const scheduleStart = cycleStart + (startPrc > 0 ? startSegment * stepDuration : 0);
    const { session: session, instrument: instrument, midiMap: midiMap } = state;
    session.tracks.forEach((track, ch)=>{
        if (track.type !== "piano") return;
        const trackBarsLength = parseInt(track.measures[session.active[ch]] && track.measures[session.active[ch]].barsLength || 1, 10);
        const pianoBar = (0, $46DUK.barIndex)(targetCycle + cycleBase, trackBarsLength);
        $5c6b5ace1f3a4a56$var$dispatchPianoBar({
            track: track,
            ch: ch,
            patternBar: pianoBar,
            beatLength: beatLength,
            startSegment: startSegment,
            segmentCount: segmentCount,
            scheduleStart: scheduleStart,
            bpm: bpm,
            session: session,
            instrument: instrument,
            midiMap: midiMap,
            onlyNew: onlyNew,
            cycleStartTime: onlyNew ? cycleStart : null
        });
    });
};
const $5c6b5ace1f3a4a56$var$scheduleBar = (payload)=>{
    const { cycle: cycle, startTime: startTime, cycleOffset: cycleOffset, bpm: bpm, beatLength: beatLength, barsLength: barsLength, cycleBase: cycleBase, startPrc: startPrc, state: state, sampleBank: sampleBank, engine: engine } = payload;
    $5c6b5ace1f3a4a56$var$latestScheduledCycle = cycle;
    const segmentCount = startPrc > 0 ? beatLength - Math.ceil(beatLength * startPrc) : beatLength;
    const startSegment = beatLength - segmentCount;
    const stepDuration = (0, $gsDht.bpmToTime)(bpm);
    const cycleStart = startTime - cycleOffset * beatLength * stepDuration + cycle * beatLength * stepDuration;
    const partialCycleOffset = startPrc > 0 ? startSegment * stepDuration : 0;
    const scheduleStart = cycleStart + partialCycleOffset;
    const patternBar = (0, $46DUK.barIndex)(cycle + cycleBase, barsLength);
    const { session: session, sequencer: sequencer, mediaLibrary: mediaLibrary, instrument: instrument, midiMap: midiMap } = state;
    session.tracks.forEach((track, ch)=>{
        if (track.type === "seq") {
            const times = (0, $9e64ef56ed6915b8$export$b74061472fe7c07)(scheduleStart, bpm, segmentCount, 4);
            times.forEach((timepos, index)=>{
                if (startPrc > 0 && index === 0) return;
                const step = startSegment + index;
                $5c6b5ace1f3a4a56$var$dispatchSeqStep({
                    track: track,
                    ch: ch,
                    step: step,
                    patternBar: patternBar,
                    timepos: timepos,
                    bpm: bpm,
                    sequencer: sequencer,
                    mediaLibrary: mediaLibrary,
                    sampleBank: sampleBank,
                    engine: engine,
                    instrument: instrument,
                    midiMap: midiMap
                });
            });
        } else if (track.type === "piano") {
            const trackBarsLength = parseInt(track.measures[session.active[ch]] && track.measures[session.active[ch]].barsLength || 1, 10);
            const pianoBar = (0, $46DUK.barIndex)(cycle + cycleBase, trackBarsLength);
            $5c6b5ace1f3a4a56$var$dispatchPianoBar({
                track: track,
                ch: ch,
                patternBar: pianoBar,
                beatLength: beatLength,
                startSegment: startSegment,
                segmentCount: segmentCount,
                scheduleStart: scheduleStart,
                bpm: bpm,
                session: session,
                instrument: instrument,
                midiMap: midiMap,
                onlyNew: false
            });
        }
    });
    $5c6b5ace1f3a4a56$var$scheduling = false;
};
let $5c6b5ace1f3a4a56$var$subs = [];
const $5c6b5ace1f3a4a56$export$1062a250c78723ea = ({ state$: state$, actions: actions })=>{
    $5c6b5ace1f3a4a56$var$subs = [];
    const sampleBank$ = (0, (/*@__PURE__*/$parcel$interopDefault($kKA2u))).stream.pipe((0, $lm9of.filter)((p)=>p.sampleBank), (0, $glUu6.distinctUntilChanged)((prev, curr)=>prev.sampleBank === curr.sampleBank), (0, $6SBin.map)((p)=>p.sampleBank));
    $5c6b5ace1f3a4a56$var$subs.push(state$.pipe((0, $glUu6.distinctUntilChanged)((prev, curr)=>prev.studio.playing === curr.studio.playing)).subscribe((state)=>{
        if (state.studio.playing) $5c6b5ace1f3a4a56$export$390bff02e6678e49();
        else {
            $b50c4af2ab2cac82$exports.clearBuffer();
            $5c6b5ace1f3a4a56$export$390bff02e6678e49();
        }
    }));
    $5c6b5ace1f3a4a56$var$subs.push(state$.pipe((0, $lm9of.filter)((state)=>state.studio.playing), (0, $glUu6.distinctUntilChanged)((prev, curr)=>prev.studio.bpm === curr.studio.bpm && prev.studio.beatLength === curr.studio.beatLength && prev.studio.measure === curr.studio.measure)).subscribe(()=>{
        $b50c4af2ab2cac82$exports.clearBuffer();
        $5c6b5ace1f3a4a56$export$390bff02e6678e49();
    }));
    $5c6b5ace1f3a4a56$var$subs.push(state$.pipe((0, $lm9of.filter)((state)=>state.studio.playing && state.studio.startTime != null), (0, $glUu6.distinctUntilChanged)((prev, curr)=>{
        const completed = (events)=>(events || []).filter((e)=>e.duration > 0).map((e)=>`${e.uuid}:${e.start}:${e.duration}:${e.note}`);
        return JSON.stringify(completed(prev.pianoRoll && prev.pianoRoll.events)) === JSON.stringify(completed(curr.pianoRoll && curr.pianoRoll.events));
    })).subscribe((state)=>{
        const payload = $5c6b5ace1f3a4a56$var$buildPayload(state, null, null);
        $5c6b5ace1f3a4a56$var$schedulePianoCycle(payload, payload.cycle + 1, {
            onlyNew: true
        });
    }));
    $5c6b5ace1f3a4a56$var$subs.push($f134bb0dffae52a3$export$2cef06c20297c17d().pipe((0, $9Jxex.withLatestFrom)((0, $8QuAY.combineLatest)([
        state$,
        sampleBank$,
        $b50c4af2ab2cac82$exports.engine$
    ]), (t, combined)=>combined), (0, $lm9of.filter)(([state])=>state.studio.playing && state.studio.startTime != null), (0, $6SBin.map)(([state, sampleBank, engine])=>$5c6b5ace1f3a4a56$var$buildPayload(state, sampleBank, engine))).subscribe((payload)=>{
        if ($5c6b5ace1f3a4a56$var$scheduling) return;
        const { cycle: cycle, progress: progress, cycleOffset: cycleOffset } = payload;
        if (cycle === 0 && $5c6b5ace1f3a4a56$var$latestScheduledCycle === -1 && cycleOffset === 0) {
            $5c6b5ace1f3a4a56$var$scheduling = true;
            $5c6b5ace1f3a4a56$var$scheduleBar(Object.assign({}, payload, {
                cycle: cycle,
                startPrc: 0
            }));
        } else if ($5c6b5ace1f3a4a56$var$latestScheduledCycle === cycle - 1) {
            $5c6b5ace1f3a4a56$var$scheduling = true;
            $5c6b5ace1f3a4a56$var$scheduleBar(Object.assign({}, payload, {
                cycle: cycle,
                startPrc: progress
            }));
        } else if (cycle === $5c6b5ace1f3a4a56$var$latestScheduledCycle && progress > 0.7) {
            $5c6b5ace1f3a4a56$var$scheduling = true;
            $5c6b5ace1f3a4a56$var$scheduleBar(Object.assign({}, payload, {
                cycle: cycle + 1,
                startPrc: 0
            }));
        }
    }));
};
let $5c6b5ace1f3a4a56$export$762f7ab90da36b1a = ()=>$5c6b5ace1f3a4a56$var$subs.forEach((sub)=>sub.unsubscribe());
var $5c6b5ace1f3a4a56$export$2e2bcd8739ae039 = {
    hook: $5c6b5ace1f3a4a56$export$1062a250c78723ea,
    unhook: $5c6b5ace1f3a4a56$export$762f7ab90da36b1a
};



var $1XCf8 = parcelRequire("1XCf8");
var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $9Jxex = parcelRequire("9Jxex");


var $46DUK = parcelRequire("46DUK");
let $f80ea5df78ea6eb5$var$subs = [];
const $f80ea5df78ea6eb5$export$1062a250c78723ea = ({ state$: state$, actions: actions })=>{
    $f80ea5df78ea6eb5$var$subs = [];
    // sync playhead while playing (~30fps; tighter during recording)
    $f80ea5df78ea6eb5$var$subs.push($f134bb0dffae52a3$export$2cef06c20297c17d().pipe((0, $9Jxex.withLatestFrom)(state$, (t, state)=>state), (0, $lm9of.filter)((state)=>state.studio.playing && state.studio.startTime != null), (0, $1XCf8.auditTime)(32)).subscribe((state)=>{
        const tick = (0, $46DUK.derivePosition)(state.studio, state.sequencer, state.session);
        actions.studio.syncTick(tick);
    }));
    // freeze playhead on pause
    $f80ea5df78ea6eb5$var$subs.push(state$.pipe((0, $glUu6.distinctUntilChanged)((prev, curr)=>prev.studio.playing === curr.studio.playing), (0, $lm9of.filter)((state)=>!state.studio.playing && state.studio.cycleOffset > 0)).subscribe((state)=>{
        const tick = (0, $46DUK.derivePosition)(Object.assign({}, state.studio, {
            playing: true
        }), state.sequencer, state.session, state.studio.startTime);
        actions.studio.syncTick(tick);
    }));
};
let $f80ea5df78ea6eb5$export$762f7ab90da36b1a = ()=>$f80ea5df78ea6eb5$var$subs.forEach((sub)=>sub.unsubscribe());
var $f80ea5df78ea6eb5$export$2e2bcd8739ae039 = {
    hook: $f80ea5df78ea6eb5$export$1062a250c78723ea,
    unhook: $f80ea5df78ea6eb5$export$762f7ab90da36b1a
};


var $3e0be88d82a1101f$exports = {};
"use strict";

var $jjnZg = parcelRequire("jjnZg");
var $3e0be88d82a1101f$require$obj = $jjnZg.obj;
var $3e0be88d82a1101f$require$fn = $jjnZg.fn;

var $fWkHO = parcelRequire("fWkHO");
var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $6SBin = parcelRequire("6SBin");
var $hYBh9 = parcelRequire("hYBh9");
var $5UZMn = parcelRequire("5UZMn");
var $9Jxex = parcelRequire("9Jxex");
var $3e0be88d82a1101f$require$filter = $lm9of.filter;
var $3e0be88d82a1101f$require$distinctUntilChanged = $glUu6.distinctUntilChanged;
var $3e0be88d82a1101f$require$map = $6SBin.map;
var $3e0be88d82a1101f$require$share = $hYBh9.share;
var $3e0be88d82a1101f$require$withLatestFrom = $9Jxex.withLatestFrom;
var $3e0be88d82a1101f$require$throttleTime = $5UZMn.throttleTime;
var $3e0be88d82a1101f$require$bufferCount = $fWkHO.bufferCount;

var $kTQ8i = parcelRequire("kTQ8i");


var $46DUK = parcelRequire("46DUK");
var $3e0be88d82a1101f$require$derivePosition = $46DUK.derivePosition;
var $3e0be88d82a1101f$require$stepIndex = $46DUK.stepIndex;
var $3e0be88d82a1101f$require$MODIFIER = $46DUK.MODIFIER;

var $gsDht = parcelRequire("gsDht");
var $3e0be88d82a1101f$require$calculateProgress = $gsDht.calculateProgress;
parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
const $3e0be88d82a1101f$var$indexAt = (a, k, v)=>a.reduce((index, e, i)=>$3e0be88d82a1101f$require$obj.sub(e, k) === v ? i : index, -1);
const $3e0be88d82a1101f$var$prepVal = (min = 0, max = 1, digits = 3)=>(val)=>[
            (min + val * max - val * min).toFixed(digits)
        ].map((val)=>digits === 0 ? parseInt(val, 10) : parseFloat(val)).pop();
let $3e0be88d82a1101f$var$unhook = ()=>{};
const $3e0be88d82a1101f$var$clockMsg = [
    248
];
const $3e0be88d82a1101f$var$hook = ({ state$: state$, actions: actions, tapTempo: tapTempo })=>{
    let subs = [];
    const { devices$: devices$, msg$: msg$ } = $kTQ8i.init();
    subs.push(devices$.subscribe((data)=>actions.midiMap.connect(data)));
    const parsedMidiMsg$ = msg$.pipe($3e0be88d82a1101f$require$map((raw)=>({
            msg: $kTQ8i.parseMidiMsg(raw.msg),
            raw: raw
        })), $3e0be88d82a1101f$require$share());
    const getIds = (inputs, indexes)=>inputs.map((inp)=>inp.id).filter((id, i)=>indexes.indexOf(i) > -1);
    const midiState$ = parsedMidiMsg$.pipe($3e0be88d82a1101f$require$withLatestFrom(state$), $3e0be88d82a1101f$require$map(([data, state])=>({
            data: data,
            state: state
        })), $3e0be88d82a1101f$require$filter(({ data: data, state: state })=>getIds(state.midiMap.devices.inputs, state.midiMap.data.in).indexOf(data.raw.input.id) > -1), $3e0be88d82a1101f$require$share());
    subs.push(parsedMidiMsg$.pipe($3e0be88d82a1101f$require$filter(({ msg: msg })=>[
            "noteOn",
            "noteOff"
        ].indexOf(msg.state) > -1), $3e0be88d82a1101f$require$withLatestFrom(state$), $3e0be88d82a1101f$require$map(([midiData, state])=>Object.assign({}, midiData, {
            state: state
        })), $3e0be88d82a1101f$require$filter(({ raw: raw, state: state })=>getIds(state.midiMap.devices.inputs, state.midiMap.data.in).indexOf(raw.input.id) > -1)).subscribe(({ raw: raw, msg: msg, state: state })=>{
        const deviceIndex = state.midiMap.devices.inputs.indexOf(raw.input);
        actions.midiMap.noteOn(deviceIndex, msg.channel, msg.note.key + msg.note.octave, msg.velocity || 0);
        if (msg.state === "noteOn" && [
            -1,
            deviceIndex
        ].indexOf(state.session.tracks[0].input.device) > -1 && msg.channel === state.session.tracks[0].input.channel && state.studio.playing && state.studio.recording && state.studio.startTime != null) {
            const { startTime: startTime, cycleOffset: cycleOffset, bpm: bpm, beatLength: beatLength } = state.studio;
            const progress = $3e0be88d82a1101f$require$calculateProgress(startTime, $ekqew.context.currentTime, cycleOffset, bpm, beatLength, $3e0be88d82a1101f$require$MODIFIER);
            const step = $3e0be88d82a1101f$require$stepIndex(progress, beatLength);
            const bar = $3e0be88d82a1101f$require$derivePosition(state.studio, state.sequencer, state.session).bar;
            actions.sequencer.update(bar, msg.note.number - 60, step, msg.velocity);
        }
    }));
    subs.push(parsedMidiMsg$.pipe($3e0be88d82a1101f$require$filter(({ msg: msg })=>[
            "pitchBend"
        ].indexOf(msg.state) > -1), $3e0be88d82a1101f$require$throttleTime(1)).subscribe(({ msg: msg })=>actions.set([
            "midiMap",
            "pitch"
        ], msg.pitchValue)));
    subs.push(parsedMidiMsg$.pipe($3e0be88d82a1101f$require$filter(({ msg: msg })=>msg.state === "bankSelect"), $3e0be88d82a1101f$require$filter(({ msg: msg })=>msg.bank >= 0 && msg.bank < 16)).subscribe(({ msg: msg })=>$3e0be88d82a1101f$require$fn.pipe(()=>({
                track: msg.bank % 4,
                row: parseInt((msg.bank >= 4 && msg.bank < 8 || msg.bank >= 12 && msg.bank < 16 ? msg.bank - 4 : msg.bank + 4) / 4, 10)
            }), ({ track: track, row: row })=>(actions.session.activate(track, row), actions.session.select(track, row)))()));
    subs.push(midiState$.pipe($3e0be88d82a1101f$require$filter(({ data: data })=>data.msg.state === "controller"), $3e0be88d82a1101f$require$distinctUntilChanged((prev, curr)=>prev.data.msg.value === curr.data.msg.value), $3e0be88d82a1101f$require$throttleTime(10)).subscribe(({ data: data, state: state })=>{
        let mmap = state.midiMap.map.find((m)=>m[0] === data.msg.state && m[1] === data.msg.controller);
        if (mmap) {
            let [msgType, msgVal, propPath, ...valMods] = mmap;
            if (propPath[0] === "instrument" && propPath[1] === "eg") propPath = [
                "instrument",
                `vca${state.instrument.vcaOn + 1}`,
                propPath[2]
            ];
            let val = $3e0be88d82a1101f$var$prepVal(...valMods)(data.msg.value);
            actions.change(propPath[0], propPath.slice(1), val);
        }
    }));
    // MIDI clock out — 6 pulses per 16th note (24 per quarter)
    subs.push($f134bb0dffae52a3$export$2cef06c20297c17d().pipe($3e0be88d82a1101f$require$withLatestFrom(state$), $3e0be88d82a1101f$require$filter(([, state])=>state.studio.playing && state.studio.startTime != null), $3e0be88d82a1101f$require$filter(([, state])=>state.midiMap.clock.out.length > 0 && state.midiMap.clock.out.filter((out)=>state.midiMap.devices.outputs[out]).length > 0), $3e0be88d82a1101f$require$map(([, state])=>{
        const { startTime: startTime, cycleOffset: cycleOffset, bpm: bpm, beatLength: beatLength } = state.studio;
        const progress = $3e0be88d82a1101f$require$calculateProgress(startTime, $ekqew.context.currentTime, cycleOffset, bpm, beatLength, $3e0be88d82a1101f$require$MODIFIER);
        return {
            pulse: Math.floor(progress * beatLength * 6),
            state: state
        };
    }), $3e0be88d82a1101f$require$distinctUntilChanged((prev, curr)=>prev.pulse === curr.pulse)).subscribe(({ state: state })=>{
        state.midiMap.clock.out.forEach((out)=>state.midiMap.devices.outputs[out].send($3e0be88d82a1101f$var$clockMsg));
    }));
    subs.push(midiState$.pipe($3e0be88d82a1101f$require$filter(({ data: data })=>data.msg.binary === "11111000"), $3e0be88d82a1101f$require$filter(({ data: data, state: state })=>state.midiMap.clock.in === $3e0be88d82a1101f$var$indexAt(state.midiMap.devices.inputs, "name", data.raw.input.name)), $3e0be88d82a1101f$require$bufferCount(24, 1)).subscribe(()=>tapTempo.tap()));
    $3e0be88d82a1101f$var$unhook = ()=>subs.forEach((sub)=>sub.unsubscribe());
};
$3e0be88d82a1101f$exports = {
    hook: $3e0be88d82a1101f$var$hook,
    unhook: $3e0be88d82a1101f$var$unhook
};


var $22a3da1c73d1a3ee$exports = {};
"use strict";

var $4BxWH = parcelRequire("4BxWH");
var $hgqF6 = parcelRequire("hgqF6");
var $22a3da1c73d1a3ee$require$Subject = $hgqF6.Subject;

var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $bzRF9 = parcelRequire("bzRF9");
var $6SBin = parcelRequire("6SBin");
var $5UZMn = parcelRequire("5UZMn");
var $9Jxex = parcelRequire("9Jxex");
var $22a3da1c73d1a3ee$require$distinctUntilChanged = $glUu6.distinctUntilChanged;
var $22a3da1c73d1a3ee$require$filter = $lm9of.filter;
var $22a3da1c73d1a3ee$require$flatMap = $bzRF9.flatMap;
var $22a3da1c73d1a3ee$require$withLatestFrom = $9Jxex.withLatestFrom;
var $22a3da1c73d1a3ee$require$map = $6SBin.map;
var $22a3da1c73d1a3ee$require$throttleTime = $5UZMn.throttleTime;

var $4BxWH = parcelRequire("4BxWH");
var $hgqF6 = parcelRequire("hgqF6");
var $22a3da1c73d1a3ee$require$interval = $4BxWH.interval;
var $8f02931950fe0178$exports = {};
"use strict";

var $4BxWH = parcelRequire("4BxWH");
var $gN3J6 = parcelRequire("gN3J6");
var $8f02931950fe0178$require$interval = $4BxWH.interval;
var $8f02931950fe0178$require$Observable = $gN3J6.Observable;

var $glUu6 = parcelRequire("glUu6");
var $lm9of = parcelRequire("lm9of");
var $bzRF9 = parcelRequire("bzRF9");
var $f6wSa = parcelRequire("f6wSa");
var $8f02931950fe0178$require$scan = $f6wSa.scan;
var $8f02931950fe0178$require$distinctUntilChanged = $glUu6.distinctUntilChanged;
var $8f02931950fe0178$require$filter = $lm9of.filter;
var $8f02931950fe0178$require$flatMap = $bzRF9.flatMap;

var $jjnZg = parcelRequire("jjnZg");
var $8f02931950fe0178$require$fn = $jjnZg.fn;
const $8f02931950fe0178$var$connect = ({ port: port, retry: retry = false, suffix: suffix = "/" })=>$8f02931950fe0178$require$interval(5000).pipe($8f02931950fe0178$require$scan((ws)=>(!ws || ws.readyState === 3) && (retry === true || ws === false) ? $8f02931950fe0178$require$fn.pipe(()=>new WebSocket(`ws://localhost:${port}${suffix}`), (ws)=>(ws.onopen = ()=>console.log("wrlds connected"), ws))() : ws, false), $8f02931950fe0178$require$distinctUntilChanged((prev, curr)=>prev === curr), $8f02931950fe0178$require$filter((ws)=>ws), $8f02931950fe0178$require$flatMap((ws)=>new $8f02931950fe0178$require$Observable((observer)=>{
            ws.onmessage = (msg)=>observer.next(msg);
            ws.onerror = (err)=>observer.error(err);
            ws.onclose = ()=>observer.complete();
            return ()=>{
                ws.onmessage = null;
                ws.onerror = null;
                ws.onclose = null;
            };
        })));
$8f02931950fe0178$exports = {
    connect: $8f02931950fe0178$var$connect
};


//
// let osc = require('osc/src/osc.js');
// window.osc = osc;
// require('osc/src/osc-transports.js');
// require('osc/src/platforms/osc-websocket-client.js');
// const WebSocket = require('ws')
const $22a3da1c73d1a3ee$var$myoWs = new WebSocket("ws://127.0.0.1:10138/myo/3?appid=com.myojs.diagnostics");
const $22a3da1c73d1a3ee$var$wrldsWs = new WebSocket("ws://127.0.0.1:8888");
let $22a3da1c73d1a3ee$var$unhook = ()=>{};
const $22a3da1c73d1a3ee$var$hook = ({ state$: state$, actions: actions, tapTempo: tapTempo })=>{
    let subs = [];
    // let oscPort = new osc.WebSocketPort({
    // 	url: "ws://127.0.0.1:10138/myo/3?appid=com.myojs.diagnostics", // URL to your Web Socket server.
    // 	metadata: true
    // });
    //
    // oscPort.open();
    // // Listening for incoming OSC messages:
    // oscPort.on("message", function(oscMsg) {
    // 	console.log("An OSC message just arrived!", oscMsg);
    // });
    $22a3da1c73d1a3ee$var$myoWs.onopen = ()=>console.log("myo osc connected");
    const myoMsg$ = new $22a3da1c73d1a3ee$require$Subject();
    $22a3da1c73d1a3ee$var$myoWs.onmessage = (data)=>myoMsg$.next(JSON.parse(data.data));
    // wrldsWs.onopen = () => console.log('wrlds osc connected');
    const wrldsMsg$ = state$.pipe($22a3da1c73d1a3ee$require$distinctUntilChanged((prev, curr)=>prev.wrlds.on === curr.wrlds.on), $22a3da1c73d1a3ee$require$filter((state)=>state.wrlds.on), $22a3da1c73d1a3ee$require$flatMap(()=>$8f02931950fe0178$exports.connect({
            port: 8888,
            retry: true
        })));
    // wrldsWs.onmessage = data => wrldsMsg$.onNext(JSON.parse(data.data));
    subs.push(myoMsg$.pipe($22a3da1c73d1a3ee$require$withLatestFrom(state$), $22a3da1c73d1a3ee$require$map(([data, state])=>({
            data: data,
            state: state
        })), $22a3da1c73d1a3ee$require$filter(({ data: data })=>data[1].type === "orientation"), // map(data => (console.log(data), data))
    $22a3da1c73d1a3ee$require$throttleTime(100)).subscribe(({ data: data, state: state })=>{
        actions.set([
            "myo",
            "osc"
        ], data[1]);
        // orientation
        if (state.myo.on) {
            actions.change("instrument", [
                "vcf",
                "cutoff"
            ], state.myo.reverse ? 1 - (data[1].orientation.y + 1).toFixed(2) / 2 : (data[1].orientation.y + 1).toFixed(2) / 2);
            actions.change("instrument", [
                "vcf",
                "resonance"
            ], state.myo.reverse ? 1 - (data[1].orientation.x + 1).toFixed(2) / 2 : (data[1].orientation.x + 1).toFixed(2) / 2);
        }
    }));
    subs.push(wrldsMsg$.pipe($22a3da1c73d1a3ee$require$map((data)=>JSON.parse(data.data)), $22a3da1c73d1a3ee$require$map((data)=>data[0]), // map(data => (console.log(data), data))
    $22a3da1c73d1a3ee$require$withLatestFrom(state$), $22a3da1c73d1a3ee$require$map(([data, state])=>({
            data: data,
            state: state
        }))).subscribe(({ state: state, data: data })=>{
        // console.log(state.wrlds);
        if (state.wrlds.on) {
            if (data.type === "wrldsBounce") {
                if (state.wrlds.mode === 0) tapTempo.tap();
                if (state.wrlds.mode === 1) {
                    if (data.acc < state.wrlds.threshold) {
                        actions.midiMap.noteOn(-1, 10, "C1", 7);
                        actions.midiMap.noteOn(-1, 10, "C1", 0);
                    } else {
                        actions.midiMap.noteOn(-1, 10, "D1", 7);
                        actions.midiMap.noteOn(-1, 10, "D1", 0);
                    }
                }
            }
            if (data.type === "wrldsRotate") {
                actions.set([
                    "wrlds",
                    "rotation"
                ], data.rotation);
                if (state.wrlds.mode === 2) {
                    let cutoff = Number((state.instrument.vcf.cutoff + data.rotation[0] / 10000).toFixed(2));
                    let resonance = Number((state.instrument.vcf.resonance + data.rotation[1] / 10000).toFixed(2));
                    if (cutoff > 0 && cutoff < 1) actions.set([
                        "instrument",
                        "vcf",
                        "cutoff"
                    ], cutoff);
                    if (resonance > 0 && resonance < 1) actions.set([
                        "instrument",
                        "vcf",
                        "resonance"
                    ], resonance);
                }
            }
        }
    // console.log(data);
    }));
    // ws.onmessage = data => console.log(JSON.parse(data.data));
    $22a3da1c73d1a3ee$var$unhook = ()=>subs.forEach((sub)=>sub.unsubscribe());
};
$22a3da1c73d1a3ee$exports = {
    hook: $22a3da1c73d1a3ee$var$hook,
    unhook: $22a3da1c73d1a3ee$var$unhook
};


var $ffd2ff9f3441b269$exports = {};
"use strict";
var $437ab7261fe498d8$exports = {};
"use strict";


var $glUu6 = parcelRequire("glUu6");
var $6SBin = parcelRequire("6SBin");
var $hYBh9 = parcelRequire("hYBh9");
var $437ab7261fe498d8$require$map = $6SBin.map;
var $437ab7261fe498d8$require$distinctUntilChanged = $glUu6.distinctUntilChanged;
var $437ab7261fe498d8$require$share = $hYBh9.share;
const $437ab7261fe498d8$var$parsePad = (pad)=>pad && {
        axes: pad.axes,
        buttons: pad.buttons.map((button)=>({
                pressed: button.pressed,
                value: button.value
            })),
        connected: pad.connected,
        id: pad.id,
        index: pad.index,
        mapping: pad.mapping,
        timestamp: pad.timestamp
    } || pad;
const $437ab7261fe498d8$var$list = ()=>Array.from(navigator.getGamepads() || navigator.webkitGetGamepads() || []).map($437ab7261fe498d8$var$parsePad);
const $437ab7261fe498d8$var$changes = ()=>$f134bb0dffae52a3$export$2cef06c20297c17d().pipe($437ab7261fe498d8$require$map($437ab7261fe498d8$var$list), $437ab7261fe498d8$require$distinctUntilChanged((prev, curr)=>JSON.stringify(prev) === JSON.stringify(curr))).pipe($437ab7261fe498d8$require$share());
$437ab7261fe498d8$exports = {
    list: $437ab7261fe498d8$var$list,
    changes: $437ab7261fe498d8$var$changes
};


const $ffd2ff9f3441b269$var$hook = ({ state$: state$, actions: actions })=>{
    // gamepad
    $437ab7261fe498d8$exports.changes()// .withLatestFrom(pressedKeys$, (pads, keys) => ({pads, keys}))
    .subscribe((pads)=>{
        // console.log(pads[0]);
        if (pads[0]) {
            if (pads[0].buttons[8].pressed === true) actions.studio.play();
            if (pads[0].buttons[9].pressed === true) actions.studio.record();
            if (pads[0].buttons[3].pressed === true) actions.studio.stop();
            // channels
            if (pads[0].buttons[0].pressed === true) actions.sequencer.add();
            if (pads[0].buttons[2].pressed === true) actions.sequencer.clear();
            if (pads[0].buttons[1].pressed === true) actions.sequencer.remove();
            if (pads[0].axes[1] < 0) actions.sequencer.prev();
            if (pads[0].axes[1] > 0) actions.sequencer.next();
        }
    });
    // keyboard
    document.addEventListener("keydown", (ev)=>{
        // console.log(ev.code, ev.target.tagName, ev.target.contentEditable);
        if (ev.code === "Escape") {
            ev.target.blur();
            window.getSelection().removeAllRanges();
        }
        if ([
            "INPUT",
            "TEXTAREA"
        ].indexOf(ev.target.tagName) > -1 || ev.target.contentEditable === true) return;
        // console.log(e);
        if (ev.code === "Space") {
            actions.studio.play();
            ev.preventDefault();
        }
        if (ev.key === "r") actions.studio.record();
        if (ev.key === "t") actions.studio.stop();
        // channels
        if (ev.key === "Enter") actions.sequencer.add();
        if (ev.key === "Delete" || ev.key === "Backspace") actions.sequencer.clear();
        if (ev.key === "ArrowUp") actions.sequencer.prev();
        if (ev.key === "ArrowDown") actions.sequencer.next();
        if (ev.key === "c") actions.pianoRoll.clear();
    });
};
$ffd2ff9f3441b269$exports = {
    hook: $ffd2ff9f3441b269$var$hook
};


var $cf78cb0ee72a7ca5$exports = {};
"use strict";

var $awcxJ = parcelRequire("awcxJ");
var $aIPjU = parcelRequire("aIPjU");
var $cf78cb0ee72a7ca5$require$from = $aIPjU.from;

var $j7Eel = parcelRequire("j7Eel");
var $6SBin = parcelRequire("6SBin");
var $cf78cb0ee72a7ca5$require$concatMap = $j7Eel.concatMap;

var $6TsbL = parcelRequire("6TsbL");
parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
const $cf78cb0ee72a7ca5$var$kits = [
    "samples/openpathmusic.zip",
    "samples/junk-drum-kit.zip"
];

var $awcxJ = parcelRequire("awcxJ");
var $aIPjU = parcelRequire("aIPjU");
var $cf78cb0ee72a7ca5$require$concat = $awcxJ.concat;

var $j7Eel = parcelRequire("j7Eel");
var $6SBin = parcelRequire("6SBin");
var $cf78cb0ee72a7ca5$require$map = $6SBin.map;
const $cf78cb0ee72a7ca5$var$hook = ({ state$: state$, actions: actions, studio: studio })=>{
    $cf78cb0ee72a7ca5$require$from($cf78cb0ee72a7ca5$var$kits).pipe($cf78cb0ee72a7ca5$require$concatMap($6TsbL.loadZip)).subscribe((opm)=>{
        let opmSamples = Object.keys(opm);
        // console.log(opmSamples);
        $cf78cb0ee72a7ca5$require$concat(...opmSamples.map((key)=>$cf78cb0ee72a7ca5$require$from(new Promise((resolve, reject)=>{
                $ekqew.context.decodeAudioData(opm[key], resolve, reject);
            })).pipe($cf78cb0ee72a7ca5$require$map((buffer)=>({
                    key: key,
                    buffer: buffer
                }))))).subscribe(({ key: key, buffer: buffer })=>studio.addSample(key, buffer));
        actions.mediaLibrary.loadSamples(opmSamples);
    });
};
$cf78cb0ee72a7ca5$exports = {
    hook: $cf78cb0ee72a7ca5$var$hook
};


var $315f75571347d536$exports = {};
"use strict";

var $awcxJ = parcelRequire("awcxJ");
var $dMQAa = parcelRequire("dMQAa");
var $aIPjU = parcelRequire("aIPjU");
var $hgqF6 = parcelRequire("hgqF6");
var $315f75571347d536$require$Subject = $hgqF6.Subject;
var $315f75571347d536$require$concat = $awcxJ.concat;
var $315f75571347d536$require$from = $aIPjU.from;
var $315f75571347d536$require$EMPTY = $dMQAa.EMPTY;

const { concatMap: $315f75571347d536$var$concatMap, mergeMap: $315f75571347d536$var$mergeMap, map: $315f75571347d536$var$map, filter: $315f75571347d536$var$filter, catchError: $315f75571347d536$var$catchError } = (parcelRequire("2QuXx"));

var $jjnZg = parcelRequire("jjnZg");
var $315f75571347d536$require$obj = $jjnZg.obj;
var $315f75571347d536$require$fn = $jjnZg.fn;

var $6TsbL = parcelRequire("6TsbL");
parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $fbcJ7 = parcelRequire("fbcJ7");
var $315f75571347d536$require$context = $ekqew.context;
parcelRequire("cl3AY");
var $ekqew = parcelRequire("ekqew");
var $fbcJ7 = parcelRequire("fbcJ7");
var $315f75571347d536$require$sampler = $fbcJ7;

var $gsDht = parcelRequire("gsDht");
var $315f75571347d536$require$measureToBeatLength = $gsDht.measureToBeatLength;
var $315f75571347d536$require$bpmToTime = $gsDht.bpmToTime;

var $kKA2u = parcelRequire("kKA2u");
const $315f75571347d536$var$baseKit = [
    "samples/kick01.ogg",
    "samples/kick02.ogg",
    "samples/kick03.ogg",
    "samples/kick_hiphop01.ogg",
    "samples/hihat_opened02.ogg",
    "samples/hihat_opened03.ogg",
    "samples/ride02.ogg",
    "samples/rim01.ogg",
    "samples/snare01.ogg",
    "samples/snare02.ogg",
    "samples/snare03.ogg",
    "samples/snare04.ogg",
    "samples/snare05.ogg",
    "samples/clap01.ogg",
    "samples/clap02.ogg",
    "samples/clap03.ogg",
    "samples/clap04.ogg",
    "samples/shaker01.ogg",
    "samples/shaker02.ogg"
];
const $315f75571347d536$var$kits = [
    "samples/openpathmusic.zip",
    "samples/junk-drum-kit.zip"
];
let $315f75571347d536$var$sampleBank$ = new $315f75571347d536$require$Subject();
let $315f75571347d536$var$unhook = ()=>{};

const $315f75571347d536$var$hook = ({ state$: state$, actions: actions })=>{
    let subs = [];
    const { share: share } = (parcelRequire("2QuXx"));
    const samples$ = $315f75571347d536$require$concat($315f75571347d536$require$from($315f75571347d536$var$baseKit).pipe($315f75571347d536$var$concatMap((url)=>$315f75571347d536$require$from(fetch(url)).pipe($315f75571347d536$var$concatMap((res)=>{
            if (!res.ok) {
                console.warn(`Failed to fetch ${url}: ${res.status} ${res.statusText}`);
                return $315f75571347d536$require$EMPTY;
            }
            return $315f75571347d536$require$from(res.arrayBuffer());
        }), $315f75571347d536$var$concatMap((buffer)=>$315f75571347d536$require$from($315f75571347d536$require$context.decodeAudioData(buffer)).pipe($315f75571347d536$var$map((buffer)=>({
                    name: url,
                    node: $315f75571347d536$require$sampler.create(url, buffer)
                })), $315f75571347d536$var$catchError((err)=>{
                console.warn(`Failed to decode ${url}:`, err);
                return $315f75571347d536$require$EMPTY;
            }))), $315f75571347d536$var$catchError((err)=>{
            console.warn(`Failed to load ${url}:`, err);
            return $315f75571347d536$require$EMPTY;
        })))), $315f75571347d536$require$from($315f75571347d536$var$kits).pipe($315f75571347d536$var$concatMap($6TsbL.loadZip), $315f75571347d536$var$concatMap((opm)=>$315f75571347d536$require$from(Object.keys(opm)).pipe($315f75571347d536$var$filter((key)=>key.match(/.(wav|ogg|opus|mp3|aif)$/)), $315f75571347d536$var$concatMap((key)=>$315f75571347d536$require$from($315f75571347d536$require$context.decodeAudioData(opm[key])).pipe($315f75571347d536$var$map((buffer)=>({
                    name: key,
                    node: $315f75571347d536$require$sampler.create(key, buffer)
                })), $315f75571347d536$var$catchError((err)=>{
                console.warn(`Failed to decode ${key}:`, err);
                return $315f75571347d536$require$EMPTY;
            }))))))).pipe(share());
    subs.push(samples$.subscribe((sample)=>actions.mediaLibrary.loadSamples([
            sample.name
        ])));
    subs.push(samples$.subscribe((sample)=>$kKA2u.put([
            "sampleBank",
            sample.name
        ], sample.node)));
    $315f75571347d536$var$unhook = ()=>subs.forEach((sub)=>sub.unsubscribe());
};
$315f75571347d536$exports = {
    hook: $315f75571347d536$var$hook,
    unhook: $315f75571347d536$var$unhook,
    sampleBank$: $315f75571347d536$var$sampleBank$
};



var $XfAip = parcelRequire("XfAip");
var $72fa18a9fc449c8e$exports = {};
"use strict";
/**
 * Legacy clock service — MIDI clock output is handled in midi.js via time.frame().
 * Kept as a no-op hook for compatibility.
 */ const $72fa18a9fc449c8e$var$hook = ()=>()=>{};
$72fa18a9fc449c8e$exports = {
    hook: $72fa18a9fc449c8e$var$hook,
    unhook: ()=>{}
};


const $3835cd20c9583e03$export$1062a250c78723ea = ({ state$: state$, actions: actions, tapTempo: tapTempo })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($0808a3fd9e18c884$exports))).hook({
        state$: state$,
        actions: actions
    });
    $72fa18a9fc449c8e$exports.hook({
        state$: state$,
        actions: actions
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($c61ff34229e69da6$exports))).hook({
        state$: state$,
        actions: actions
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8d53476bf4d7eba7$exports))).hook({
        state$: state$,
        actions: actions
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3e0be88d82a1101f$exports))).hook({
        state$: state$,
        actions: actions,
        tapTempo: tapTempo
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($22a3da1c73d1a3ee$exports))).hook({
        state$: state$,
        actions: actions,
        tapTempo: tapTempo
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($b50c4af2ab2cac82$exports))).hook({
        state$: state$,
        actions: actions,
        studio: (/*@__PURE__*/$parcel$interopDefault($8d53476bf4d7eba7$exports)),
        tapTempo: tapTempo
    });
    (0, $5c6b5ace1f3a4a56$export$2e2bcd8739ae039).hook({
        state$: state$,
        actions: actions
    });
    (0, $f80ea5df78ea6eb5$export$2e2bcd8739ae039).hook({
        state$: state$,
        actions: actions
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($315f75571347d536$exports))).hook({
        state$: state$,
        actions: actions
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($ffd2ff9f3441b269$exports))).hook({
        state$: state$,
        actions: actions
    });
    (0, $XfAip.default).hook({
        state$: state$,
        actions: actions
    });
};
const $3835cd20c9583e03$export$762f7ab90da36b1a = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($0808a3fd9e18c884$exports))).unhook();
    $72fa18a9fc449c8e$exports.unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($c61ff34229e69da6$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($8d53476bf4d7eba7$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($3e0be88d82a1101f$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($22a3da1c73d1a3ee$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($b50c4af2ab2cac82$exports))).unhook();
    (0, $5c6b5ace1f3a4a56$export$2e2bcd8739ae039).unhook();
    (0, $f80ea5df78ea6eb5$export$2e2bcd8739ae039).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($315f75571347d536$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($ffd2ff9f3441b269$exports))).unhook();
    (0, $XfAip.default).unhook();
};
var $3835cd20c9583e03$export$2e2bcd8739ae039 = {
    hook: $3835cd20c9583e03$export$1062a250c78723ea,
    unhook: $3835cd20c9583e03$export$762f7ab90da36b1a
};




// hot reloading
if (null) {
    // actions
    null.accept("./actions", function() {
        $8f6a480bb40b134f$require$actionsTree = (parcelRequire("6dWku"));
        const result = $8f6a480bb40b134f$require$createState($8f6a480bb40b134f$require$actionsTree);
        $8f6a480bb40b134f$var$actions = result.actions;
        // Trigger a re-render with current state
        $8f6a480bb40b134f$var$actions.stream.next({
            path: [
                "_reload"
            ],
            payload: []
        });
    });
    // ui
    null.accept("./ui", function() {
        $8f6a480bb40b134f$require$ui = (parcelRequire("cVcju"));
        // Trigger a re-render with current state
        $8f6a480bb40b134f$var$actions.stream.next({
            path: [
                "_reload"
            ],
            payload: []
        });
    });
    // services
    null.accept("./services", function() {
    // services = require('./services');
    // services.hook({state$, actions, tapTempo});
    });
}

var $6SBin = parcelRequire("6SBin");
var $8f6a480bb40b134f$require$map = $6SBin.map;
const $8f6a480bb40b134f$var$ui$ = $8f6a480bb40b134f$var$state$.pipe($8f6a480bb40b134f$require$map((state)=>$8f6a480bb40b134f$require$ui({
        state: state,
        actions: $8f6a480bb40b134f$var$actions,
        tapTempo: $8f6a480bb40b134f$var$tapTempo,
        context: $cl3AY.context
    })));
// services
$3835cd20c9583e03$export$1062a250c78723ea({
    state$: $8f6a480bb40b134f$var$state$,
    actions: $8f6a480bb40b134f$var$actions,
    tapTempo: $8f6a480bb40b134f$var$tapTempo
});
// Request permissions on page load - browser will show native prompts
// Audio context resume
if ($cl3AY.context.state === "suspended") $cl3AY.context.resume().catch((err)=>{
    console.error("Failed to resume audio context:", err);
});
// MIDI access
if (navigator.requestMIDIAccess) navigator.requestMIDIAccess().catch((err)=>{
    console.error("Failed to request MIDI access:", err);
});
// patch stream to dom
$2Z6Kw.patchStream($8f6a480bb40b134f$var$ui$, "#ui");
// services
// services.init({actions});
// state$.map(state => services.refresh({state, actions})).subscribe();
// debug
// state$.distinctUntilChanged(state => state.mediaLibrary)
// 	.subscribe(state => console.log(state.mediaLibrary));
// tap tempo
$8f6a480bb40b134f$var$tapTempo.on("tempo", (tempo)=>$8f6a480bb40b134f$var$actions.studio.change("bpm", tempo.toPrecision(5)));
// state$.connect();
// livereload impl.
// if (module.hot) {
// 	document.write(`<script src="http://${(location.host || 'localhost').split(':')[0]}` +
// 	`:35729/livereload.js?snipver=1"></script>`);
// }
const $8f6a480bb40b134f$var$testEvents = [
    {
        uuid: "event-1",
        note: "C3",
        start: 2,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    },
    {
        uuid: "event-2",
        note: "E3",
        start: 2.3,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    },
    {
        uuid: "event-3",
        note: "D3",
        start: 4,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    },
    {
        uuid: "event-4",
        note: "G3",
        start: 6.7,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    },
    {
        uuid: "event-5",
        note: "A3",
        start: 8,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    },
    {
        uuid: "event-6",
        note: "B3",
        start: 10.2,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    },
    {
        uuid: "event-7",
        note: "C3",
        start: 12,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    },
    {
        uuid: "event-8",
        note: "F3",
        start: 14.5,
        duration: 1,
        velocity: 0.8,
        startTime: 0
    } // Column 14, F3 (unsnapped)
]; // setTimeout(() => {
 // 	actions.pianoRoll.clear();
 // 	actions.set('pianoRoll', {events: testEvents});
 // }, 4000);


//# sourceMappingURL=index.1ddb1cb2.js.map
